import { myApi as api } from "../common/redux/my-api";
export const addTagTypes = [
  "Organization",
  "Document",
  "Ai",
  "Assessment",
  "Misc",
  "Agent",
  "Espd",
  "SourcingEvent",
  "Upload",
  "BidV2",
  "Doffin",
  "FrameworkAgreement",
  "Contract",
  "Product",
  "TextDocument",
  "ContributingEntity",
  "CPV",
  "Industry",
  "LibraryElement",
  "MarketDialogue",
  "Notification",
  "Home",
  "Need",
  "EmailInvite",
  "Me",
  "Project",
  "SavedReport",
  "Scim",
  "Search",
  "SourcingEventTemplate",
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      adminListAllEntities: build.query<
        AdminListAllEntitiesApiResponse,
        AdminListAllEntitiesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/all-entities`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            entityType: queryArg.entityType,
          },
        }),
        providesTags: ["Organization"],
      }),
      adminMigrateFencyDocuments: build.mutation<
        AdminMigrateFencyDocumentsApiResponse,
        AdminMigrateFencyDocumentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/migrate-fency`,
          method: "POST",
          body: queryArg.adminMigrateFencyRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      adminRestampFencyAccess: build.mutation<
        AdminRestampFencyAccessApiResponse,
        AdminRestampFencyAccessApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/migrate-fency/access`,
          method: "POST",
          body: queryArg.adminRestampFencyAccessRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      adminMigrateFencyContractMetadata: build.mutation<
        AdminMigrateFencyContractMetadataApiResponse,
        AdminMigrateFencyContractMetadataApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/migrate-fency/contract-metadata`,
          method: "POST",
          body: queryArg.adminMigrateFencyContractMetadataRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      adminGetFencyMigrationStats: build.query<
        AdminGetFencyMigrationStatsApiResponse,
        AdminGetFencyMigrationStatsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/migrate-fency/stats`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            targetOrganizationId: queryArg.targetOrganizationId,
          },
        }),
        providesTags: ["Organization"],
      }),
      adminListOrganizations: build.query<
        AdminListOrganizationsApiResponse,
        AdminListOrganizationsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/orgs`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            skip: queryArg.skip,
            limit: queryArg.limit,
            name: queryArg.name,
          },
        }),
        providesTags: ["Organization"],
      }),
      adminUpdateOrganization: build.mutation<
        AdminUpdateOrganizationApiResponse,
        AdminUpdateOrganizationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/orgs/${queryArg.orgId}`,
          method: "PATCH",
          body: queryArg.adminUpdateOrganizationRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      adminGetOrganizationAiUsage: build.query<
        AdminGetOrganizationAiUsageApiResponse,
        AdminGetOrganizationAiUsageApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/orgs/${queryArg.orgId}/ai-usage`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Organization"],
      }),
      adminChangeOrganizationOwner: build.mutation<
        AdminChangeOrganizationOwnerApiResponse,
        AdminChangeOrganizationOwnerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/orgs/${queryArg.orgId}/owner`,
          method: "PUT",
          body: queryArg.adminChangeOrganizationOwnerRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      sendAiChatMessage: build.mutation<
        SendAiChatMessageApiResponse,
        SendAiChatMessageApiArg
      >({
        query: (queryArg) => ({
          url: `/api/ai/chat`,
          method: "POST",
          body: queryArg.aiChatRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Document"],
      }),
      createAiCompletion: build.mutation<
        CreateAiCompletionApiResponse,
        CreateAiCompletionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/ai/completions`,
          method: "POST",
          body: queryArg.createAiCompletionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Ai"],
      }),
      recordAiSuggestionInserted: build.mutation<
        RecordAiSuggestionInsertedApiResponse,
        RecordAiSuggestionInsertedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/ai/suggestions/inserted`,
          method: "POST",
          body: queryArg.aiSuggestionInsertedRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Ai"],
      }),
      createAssessmentTemplate: build.mutation<
        CreateAssessmentTemplateApiResponse,
        CreateAssessmentTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/assessment-templates`,
          method: "POST",
          body: queryArg.createAssessmentTemplateRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Assessment"],
      }),
      getAssessmentTemplate: build.query<
        GetAssessmentTemplateApiResponse,
        GetAssessmentTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/assessment-templates/${queryArg.id}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Assessment"],
      }),
      createAssessment: build.mutation<
        CreateAssessmentApiResponse,
        CreateAssessmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/assessments`,
          method: "POST",
          body: queryArg.createAssessmentRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Assessment"],
      }),
      getAssessment: build.query<GetAssessmentApiResponse, GetAssessmentApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/assessments/${queryArg.id}`,
            headers: {
              cookie: queryArg.cookie,
              organizationId: queryArg.organizationId,
              personId: queryArg.personId,
            },
          }),
          providesTags: ["Assessment"],
        },
      ),
      getBaseData: build.query<GetBaseDataApiResponse, GetBaseDataApiArg>({
        query: () => ({ url: `/api/base-data` }),
        providesTags: ["Misc"],
      }),
      getTypes: build.query<GetTypesApiResponse, GetTypesApiArg>({
        query: () => ({ url: `/api/base-data/types` }),
        providesTags: ["Misc"],
      }),
      recordAgentAuditEntry: build.mutation<
        RecordAgentAuditEntryApiResponse,
        RecordAgentAuditEntryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/audit`,
          method: "POST",
          body: queryArg.agentAuditEntryDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Agent"],
      }),
      readConversationFile: build.query<
        ReadConversationFileApiResponse,
        ReadConversationFileApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/conversation-file-text`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            documentId: queryArg.documentId,
            fromPart: queryArg.fromPart,
          },
        }),
        providesTags: ["Agent"],
      }),
      createConversationFileUpload: build.mutation<
        CreateConversationFileUploadApiResponse,
        CreateConversationFileUploadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/conversation-files/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Agent"],
      }),
      getConversationFileStatus: build.query<
        GetConversationFileStatusApiResponse,
        GetConversationFileStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/conversation-files/${queryArg.uploadId}/status`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Agent"],
      }),
      listAgentConversations: build.query<
        ListAgentConversationsApiResponse,
        ListAgentConversationsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/conversations`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            limit: queryArg.limit,
            before: queryArg.before,
          },
        }),
        providesTags: ["Agent"],
      }),
      createAgentConversation: build.mutation<
        CreateAgentConversationApiResponse,
        CreateAgentConversationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/conversations`,
          method: "POST",
          body: queryArg.createAgentConversationRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Agent"],
      }),
      deleteAgentConversation: build.mutation<
        DeleteAgentConversationApiResponse,
        DeleteAgentConversationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/conversations/${queryArg.conversationId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Agent"],
      }),
      getAgentConversation: build.query<
        GetAgentConversationApiResponse,
        GetAgentConversationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/conversations/${queryArg.conversationId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Agent"],
      }),
      updateAgentConversation: build.mutation<
        UpdateAgentConversationApiResponse,
        UpdateAgentConversationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/conversations/${queryArg.conversationId}`,
          method: "PUT",
          body: queryArg.updateAgentConversationRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Agent"],
      }),
      createAgentDocumentSearchSession: build.mutation<
        CreateAgentDocumentSearchSessionApiResponse,
        CreateAgentDocumentSearchSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/document-search-sessions`,
          method: "POST",
          body: queryArg.createAgentDocumentSearchSessionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Agent"],
      }),
      resolveAgentDocumentSources: build.mutation<
        ResolveAgentDocumentSourcesApiResponse,
        ResolveAgentDocumentSourcesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/document-sources`,
          method: "POST",
          body: queryArg.resolveAgentDocumentSourcesRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Agent"],
      }),
      readDocumentText: build.query<
        ReadDocumentTextApiResponse,
        ReadDocumentTextApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/document-text`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            documentId: queryArg.documentId,
            signedDocumentId: queryArg.signedDocumentId,
            fromPart: queryArg.fromPart,
          },
        }),
        providesTags: ["Agent"],
      }),
      getAgentModels: build.query<
        GetAgentModelsApiResponse,
        GetAgentModelsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/models`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Agent"],
      }),
      planAgentTurn: build.mutation<
        PlanAgentTurnApiResponse,
        PlanAgentTurnApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/plan`,
          method: "POST",
          body: queryArg.agentPlanRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Agent"],
      }),
      removeContactPerson: build.mutation<
        RemoveContactPersonApiResponse,
        RemoveContactPersonApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/contact-persons/${queryArg.subjectType}/${queryArg.subjectId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            email: queryArg.email,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      listContactPersons: build.query<
        ListContactPersonsApiResponse,
        ListContactPersonsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/contact-persons/${queryArg.subjectType}/${queryArg.subjectId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            name: queryArg.name,
            limit: queryArg.limit,
          },
        }),
        providesTags: ["Organization"],
      }),
      addContactPerson: build.mutation<
        AddContactPersonApiResponse,
        AddContactPersonApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/contact-persons/${queryArg.subjectType}/${queryArg.subjectId}`,
          method: "POST",
          body: queryArg.addContactPersonRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      editContactPerson: build.mutation<
        EditContactPersonApiResponse,
        EditContactPersonApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/contact-persons/${queryArg.subjectType}/${queryArg.subjectId}`,
          method: "PUT",
          body: queryArg.editContactPersonRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      getExclusionGroundsTaxonomy: build.query<
        GetExclusionGroundsTaxonomyApiResponse,
        GetExclusionGroundsTaxonomyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/espd/taxonomy`,
          params: {
            regulation: queryArg.regulation,
            buyerLegalType: queryArg.buyerLegalType,
          },
        }),
        providesTags: ["Espd"],
      }),
      createSourcingEvent: build.mutation<
        CreateSourcingEventApiResponse,
        CreateSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events`,
          method: "POST",
          body: queryArg.createSourcingEventRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      deleteSourcingEvent: build.mutation<
        DeleteSourcingEventApiResponse,
        DeleteSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            unsavedInterviewOnly: queryArg.unsavedInterviewOnly,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      getSourcingEvent: build.query<
        GetSourcingEventApiResponse,
        GetSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            recordView: queryArg.recordView,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      updateSourcingEvent: build.mutation<
        UpdateSourcingEventApiResponse,
        UpdateSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}`,
          method: "PUT",
          body: queryArg.sourcingEventPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            dryRun: queryArg.dryRun,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      createUploadForSeAnnouncementAttachment: build.mutation<
        CreateUploadForSeAnnouncementAttachmentApiResponse,
        CreateUploadForSeAnnouncementAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/announcement-attachment-uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      getBuyerSeAttachmentUpload: build.query<
        GetBuyerSeAttachmentUploadApiResponse,
        GetBuyerSeAttachmentUploadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/attachment-uploads/${queryArg.uploadId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Upload"],
      }),
      awardSourcingEvent: build.mutation<
        AwardSourcingEventApiResponse,
        AwardSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/award`,
          method: "POST",
          body: queryArg.awardSourcingEventRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "SourcingEvent"],
      }),
      getAwardLetters: build.query<
        GetAwardLettersApiResponse,
        GetAwardLettersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/award-letters`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      dispatchAwardLetters: build.mutation<
        DispatchAwardLettersApiResponse,
        DispatchAwardLettersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/award-letters/dispatch`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      updateAwardLetter: build.mutation<
        UpdateAwardLetterApiResponse,
        UpdateAwardLetterApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/award-letters/${queryArg.letterId}`,
          method: "PATCH",
          body: queryArg.awardLetterPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      approveAwardLetter: build.mutation<
        ApproveAwardLetterApiResponse,
        ApproveAwardLetterApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/award-letters/${queryArg.letterId}/approve`,
          method: "POST",
          body: queryArg.awardLetterPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      reopenAwardLetter: build.mutation<
        ReopenAwardLetterApiResponse,
        ReopenAwardLetterApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/award-letters/${queryArg.letterId}/reopen`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      awardWithoutCompetition: build.mutation<
        AwardWithoutCompetitionApiResponse,
        AwardWithoutCompetitionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/award-without-competition`,
          method: "POST",
          body: queryArg.awardWithoutCompetitionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "SourcingEvent"],
      }),
      recordWinnerDocumentationChecked: build.mutation<
        RecordWinnerDocumentationCheckedApiResponse,
        RecordWinnerDocumentationCheckedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/award/winner-documentation-checked`,
          method: "POST",
          body: queryArg.recordWinnerDocumentationCheckRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      beginEvaluation: build.mutation<
        BeginEvaluationApiResponse,
        BeginEvaluationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/begin-evaluation`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      getBidInsight: build.query<GetBidInsightApiResponse, GetBidInsightApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/buyer/events/${queryArg.eventId}/bids/${queryArg.bidId}/ai-insight`,
            headers: {
              cookie: queryArg.cookie,
              organizationId: queryArg.organizationId,
              personId: queryArg.personId,
            },
          }),
          providesTags: ["BidV2"],
        },
      ),
      requestBidInsight: build.mutation<
        RequestBidInsightApiResponse,
        RequestBidInsightApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/bids/${queryArg.bidId}/ai-insight`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            model: queryArg.model,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      cancelSourcingEvent: build.mutation<
        CancelSourcingEventApiResponse,
        CancelSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/cancellation`,
          method: "POST",
          body: queryArg.cancelSourcingEventRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      getCancellationScope: build.query<
        GetCancellationScopeApiResponse,
        GetCancellationScopeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/cancellation-scope`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      createEventChange: build.mutation<
        CreateEventChangeApiResponse,
        CreateEventChangeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/changes`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      updateEventChange: build.mutation<
        UpdateEventChangeApiResponse,
        UpdateEventChangeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/changes/${queryArg.revisionId}`,
          method: "PATCH",
          body: queryArg.eventRevisionPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      cancelEventChange: build.mutation<
        CancelEventChangeApiResponse,
        CancelEventChangeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/changes/${queryArg.revisionId}/cancel`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      submitEventChange: build.mutation<
        SubmitEventChangeApiResponse,
        SubmitEventChangeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/changes/${queryArg.revisionId}/submit`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Doffin", "SourcingEvent"],
      }),
      startSeClarification: build.mutation<
        StartSeClarificationApiResponse,
        StartSeClarificationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/clarifications`,
          method: "POST",
          body: queryArg.createSeClarificationRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      closeSourcingEvent: build.mutation<
        CloseSourcingEventApiResponse,
        CloseSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/closure`,
          method: "POST",
          body: queryArg.closeSourcingEventRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      completeSourcingEvent: build.mutation<
        CompleteSourcingEventApiResponse,
        CompleteSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/completion`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            proceedDespiteFlaggedEntries: queryArg.proceedDespiteFlaggedEntries,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      confirmAward: build.mutation<ConfirmAwardApiResponse, ConfirmAwardApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/buyer/events/${queryArg.eventId}/confirm-award`,
            method: "POST",
            headers: {
              cookie: queryArg.cookie,
              organizationId: queryArg.organizationId,
              personId: queryArg.personId,
            },
          }),
          invalidatesTags: ["SourcingEvent"],
        },
      ),
      confirmSourcingEventClassification: build.mutation<
        ConfirmSourcingEventClassificationApiResponse,
        ConfirmSourcingEventClassificationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/confirm-classification`,
          method: "POST",
          body: queryArg.confirmClassificationRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      recordContractConcluded: build.mutation<
        RecordContractConcludedApiResponse,
        RecordContractConcludedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/contract-concluded`,
          method: "POST",
          body: queryArg.contractConcludedRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      copySourcingEvent: build.mutation<
        CopySourcingEventApiResponse,
        CopySourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/copies`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      flagIdentifyingEntry: build.mutation<
        FlagIdentifyingEntryApiResponse,
        FlagIdentifyingEntryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/design-contest/entry-flags`,
          method: "POST",
          body: queryArg.flagEntryRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      startDesignContestFollowUp: build.mutation<
        StartDesignContestFollowUpApiResponse,
        StartDesignContestFollowUpApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/design-contest/follow-up`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      removeJuryLink: build.mutation<
        RemoveJuryLinkApiResponse,
        RemoveJuryLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/design-contest/jury-links/removals`,
          method: "POST",
          body: queryArg.removeJuryLinkRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      listStrandedJuryMembers: build.query<
        ListStrandedJuryMembersApiResponse,
        ListStrandedJuryMembersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/design-contest/jury-links/stranded`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      writeJuryReport: build.mutation<
        WriteJuryReportApiResponse,
        WriteJuryReportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/design-contest/jury-report`,
          method: "PUT",
          body: queryArg.writeJuryReportRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      confirmJuryReport: build.mutation<
        ConfirmJuryReportApiResponse,
        ConfirmJuryReportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/design-contest/jury-report/confirmations`,
          method: "POST",
          body: queryArg.confirmJuryReportRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      getDpsCompetitions: build.query<
        GetDpsCompetitionsApiResponse,
        GetDpsCompetitionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/dps/competitions`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      createDpsCompetition: build.mutation<
        CreateDpsCompetitionApiResponse,
        CreateDpsCompetitionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/dps/competitions`,
          method: "POST",
          body: queryArg.createDpsCompetitionRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      addEmailInviteToPrivateSourcingEvent: build.mutation<
        AddEmailInviteToPrivateSourcingEventApiResponse,
        AddEmailInviteToPrivateSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/email-invites`,
          method: "POST",
          body: queryArg.addEmailInviteRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      removeEmailInviteFromPrivateSourcingEvent: build.mutation<
        RemoveEmailInviteFromPrivateSourcingEventApiResponse,
        RemoveEmailInviteFromPrivateSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/email-invites/${queryArg.inviteId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      createEmailInviteReminderForPrivateSourcingEvent: build.mutation<
        CreateEmailInviteReminderForPrivateSourcingEventApiResponse,
        CreateEmailInviteReminderForPrivateSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/email-invites/${queryArg.inviteId}/reminders`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      getEvaluation: build.query<GetEvaluationApiResponse, GetEvaluationApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/buyer/events/${queryArg.eventId}/evaluation`,
            headers: {
              cookie: queryArg.cookie,
              organizationId: queryArg.organizationId,
              personId: queryArg.personId,
            },
            params: {
              round: queryArg.round,
            },
          }),
          providesTags: ["SourcingEvent"],
        },
      ),
      upsertPriceOverride: build.mutation<
        UpsertPriceOverrideApiResponse,
        UpsertPriceOverrideApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/evaluation/price`,
          method: "PUT",
          body: queryArg.upsertPriceOverrideRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      getPriceDevelopment: build.query<
        GetPriceDevelopmentApiResponse,
        GetPriceDevelopmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/evaluation/price-development`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      setCriterionRationale: build.mutation<
        SetCriterionRationaleApiResponse,
        SetCriterionRationaleApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/evaluation/rationale`,
          method: "PUT",
          body: queryArg.setRationaleRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      upsertCriterionScore: build.mutation<
        UpsertCriterionScoreApiResponse,
        UpsertCriterionScoreApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/evaluation/score`,
          method: "PUT",
          body: queryArg.upsertScoreRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      setEvaluationSelection: build.mutation<
        SetEvaluationSelectionApiResponse,
        SetEvaluationSelectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/evaluation/selection`,
          method: "PUT",
          body: queryArg.setEvaluationSelectionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            round: queryArg.round,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      updateSourcingEventValue: build.mutation<
        UpdateSourcingEventValueApiResponse,
        UpdateSourcingEventValueApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/event-value`,
          method: "PUT",
          body: queryArg.updateSourcingEventValueRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      listSourcingEventFieldSources: build.query<
        ListSourcingEventFieldSourcesApiResponse,
        ListSourcingEventFieldSourcesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/field-sources`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      reviewSourcingEventFieldSources: build.mutation<
        ReviewSourcingEventFieldSourcesApiResponse,
        ReviewSourcingEventFieldSourcesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/field-sources/reviews`,
          method: "POST",
          body: queryArg.reviewSourcingEventFieldSourcesRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      createFrameworkAgreement: build.mutation<
        CreateFrameworkAgreementApiResponse,
        CreateFrameworkAgreementApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/framework-agreement`,
          method: "POST",
          body: queryArg.createFrameworkAgreementRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["FrameworkAgreement"],
      }),
      getMiniCompetitionPanel: build.query<
        GetMiniCompetitionPanelApiResponse,
        GetMiniCompetitionPanelApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/framework-panel`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      setHomeDepartment: build.mutation<
        SetHomeDepartmentApiResponse,
        SetHomeDepartmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/home-department`,
          method: "PUT",
          body: queryArg.setHomeDepartmentRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      inviteToConfirmInterest: build.mutation<
        InviteToConfirmInterestApiResponse,
        InviteToConfirmInterestApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/interest-invitation`,
          method: "POST",
          body: queryArg.interestInvitationRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      addInternalMessageToSe: build.mutation<
        AddInternalMessageToSeApiResponse,
        AddInternalMessageToSeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/internal-messages`,
          method: "POST",
          body: queryArg.addInternalMessageRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      saveInterviewDraft: build.mutation<
        SaveInterviewDraftApiResponse,
        SaveInterviewDraftApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/interview/save`,
          method: "POST",
          body: queryArg.saveInterviewDraftRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      confirmInvitation: build.mutation<
        ConfirmInvitationApiResponse,
        ConfirmInvitationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/invitation`,
          method: "POST",
          body: queryArg.confirmInvitationRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "SourcingEvent"],
      }),
      lookUpInviteEmailAccount: build.query<
        LookUpInviteEmailAccountApiResponse,
        LookUpInviteEmailAccountApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/invite-email-account`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            email: queryArg.email,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      listNegotiationRounds: build.query<
        ListNegotiationRoundsApiResponse,
        ListNegotiationRoundsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-rounds`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      createNegotiationRound: build.mutation<
        CreateNegotiationRoundApiResponse,
        CreateNegotiationRoundApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-rounds`,
          method: "POST",
          body: queryArg.createNegotiationRoundRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      patchNegotiationRound: build.mutation<
        PatchNegotiationRoundApiResponse,
        PatchNegotiationRoundApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}`,
          method: "PATCH",
          body: queryArg.negotiationRoundPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      completeNegotiationRound: build.mutation<
        CompleteNegotiationRoundApiResponse,
        CompleteNegotiationRoundApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}/completion`,
          method: "PUT",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      addNegotiationRoundInvite: build.mutation<
        AddNegotiationRoundInviteApiResponse,
        AddNegotiationRoundInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}/invites`,
          method: "POST",
          body: queryArg.addNegotiationRoundInviteRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      removeNegotiationRoundInvite: build.mutation<
        RemoveNegotiationRoundInviteApiResponse,
        RemoveNegotiationRoundInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}/invites/${queryArg.pathOrganizationId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.headerOrganizationId,
            personId: queryArg.personId,
          },
          params: {
            selectionJustification: queryArg.selectionJustification,
            reductionReason: queryArg.reductionReason,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      updateNegotiationRoundInviteMessage: build.mutation<
        UpdateNegotiationRoundInviteMessageApiResponse,
        UpdateNegotiationRoundInviteMessageApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}/invites/${queryArg.pathOrganizationId}`,
          method: "PUT",
          body: queryArg.updateNegotiationRoundInviteMessageRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.headerOrganizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      selectNegotiationRoundProductBids: build.mutation<
        SelectNegotiationRoundProductBidsApiResponse,
        SelectNegotiationRoundProductBidsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}/product-bids`,
          method: "PUT",
          body: queryArg.selectProductBidsRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      publishNegotiationRound: build.mutation<
        PublishNegotiationRoundApiResponse,
        PublishNegotiationRoundApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}/publication`,
          method: "PUT",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      reopenNegotiationRound: build.mutation<
        ReopenNegotiationRoundApiResponse,
        ReopenNegotiationRoundApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}/reopening`,
          method: "PUT",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      createUploadForNegotiationRound: build.mutation<
        CreateUploadForNegotiationRoundApiResponse,
        CreateUploadForNegotiationRoundApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      getNegotiationWithoutNotice: build.query<
        GetNegotiationWithoutNoticeApiResponse,
        GetNegotiationWithoutNoticeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-without-notice`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      openNegotiationWithoutNotice: build.mutation<
        OpenNegotiationWithoutNoticeApiResponse,
        OpenNegotiationWithoutNoticeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/open-without-notice`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      addOrganizationInviteToPrivateSourcingEvent: build.mutation<
        AddOrganizationInviteToPrivateSourcingEventApiResponse,
        AddOrganizationInviteToPrivateSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/organization-invites`,
          method: "POST",
          body: queryArg.addOrganizationInviteRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      removeOrganizationInviteFromPrivateSourcingEvent: build.mutation<
        RemoveOrganizationInviteFromPrivateSourcingEventApiResponse,
        RemoveOrganizationInviteFromPrivateSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/organization-invites/${queryArg.pathOrganizationId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.headerOrganizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      addOrganizationInviteRecipients: build.mutation<
        AddOrganizationInviteRecipientsApiResponse,
        AddOrganizationInviteRecipientsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/organization-invites/${queryArg.pathOrganizationId}/recipients`,
          method: "POST",
          body: queryArg.addOrganizationInviteRecipientsRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.headerOrganizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      restoreOrganizationInviteRemovedInChange: build.mutation<
        RestoreOrganizationInviteRemovedInChangeApiResponse,
        RestoreOrganizationInviteRemovedInChangeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/organization-invites/${queryArg.pathOrganizationId}/restoration`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.headerOrganizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      listParticipationRequestsForBuyer: build.query<
        ListParticipationRequestsForBuyerApiResponse,
        ListParticipationRequestsForBuyerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/participation-requests`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      getParticipationRequestForBuyer: build.query<
        GetParticipationRequestForBuyerApiResponse,
        GetParticipationRequestForBuyerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/participation-requests/${queryArg.requestId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      extendDpsAssessmentWindow: build.mutation<
        ExtendDpsAssessmentWindowApiResponse,
        ExtendDpsAssessmentWindowApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/participation-requests/${queryArg.requestId}/assessment-window`,
          method: "PATCH",
          body: queryArg.extendAssessmentRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      setQualificationSchemeMemberCategories: build.mutation<
        SetQualificationSchemeMemberCategoriesApiResponse,
        SetQualificationSchemeMemberCategoriesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/participation-requests/${queryArg.requestId}/categories`,
          method: "PUT",
          body: queryArg.schemeMemberCategoriesRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      updateParticipationRequestReview: build.mutation<
        UpdateParticipationRequestReviewApiResponse,
        UpdateParticipationRequestReviewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/participation-requests/${queryArg.requestId}/qualification-review`,
          method: "PATCH",
          body: queryArg.buyerQualificationReviewPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      getParticipationRequestRejectionDocuments: build.query<
        GetParticipationRequestRejectionDocumentsApiResponse,
        GetParticipationRequestRejectionDocumentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/participation-requests/${queryArg.requestId}/rejection-documents`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      createUploadForParticipationRequestRejection: build.mutation<
        CreateUploadForParticipationRequestRejectionApiResponse,
        CreateUploadForParticipationRequestRejectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/participation-requests/${queryArg.requestId}/rejection-uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "Upload"],
      }),
      withdrawSchemeRemoval: build.mutation<
        WithdrawSchemeRemovalApiResponse,
        WithdrawSchemeRemovalApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/participation-requests/${queryArg.requestId}/removal`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      removeFromDpsScheme: build.mutation<
        RemoveFromDpsSchemeApiResponse,
        RemoveFromDpsSchemeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/participation-requests/${queryArg.requestId}/removal`,
          method: "POST",
          body: queryArg.removeFromSchemeRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      updateParticipationRequestNotes: build.mutation<
        UpdateParticipationRequestNotesApiResponse,
        UpdateParticipationRequestNotesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/participation-requests/${queryArg.requestId}/review-notes`,
          method: "PATCH",
          body: queryArg.buyerReviewNotesPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      updateParticipationRequestSelectionDraft: build.mutation<
        UpdateParticipationRequestSelectionDraftApiResponse,
        UpdateParticipationRequestSelectionDraftApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/participation-requests/${queryArg.requestId}/selection-draft`,
          method: "PATCH",
          body: queryArg.selectionDraftPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      setQualificationVerdict: build.mutation<
        SetQualificationVerdictApiResponse,
        SetQualificationVerdictApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/participation-requests/${queryArg.requestId}/verdict`,
          method: "PUT",
          body: queryArg.setQualificationVerdictRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      listPortalLinkShares: build.query<
        ListPortalLinkSharesApiResponse,
        ListPortalLinkSharesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/portal-link-shares`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      sharePortalLink: build.mutation<
        SharePortalLinkApiResponse,
        SharePortalLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/portal-link-shares`,
          method: "POST",
          body: queryArg.sharePortalLinkRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      selectSourcingEventProductBids: build.mutation<
        SelectSourcingEventProductBidsApiResponse,
        SelectSourcingEventProductBidsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/product-bid-selection`,
          method: "PUT",
          body: queryArg.selectProductBidsRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      getProtocolDraft: build.query<
        GetProtocolDraftApiResponse,
        GetProtocolDraftApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/protocol/draft`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      patchProtocolNarrative: build.mutation<
        PatchProtocolNarrativeApiResponse,
        PatchProtocolNarrativeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/protocol/draft`,
          method: "PATCH",
          body: queryArg.protocolDraftPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      finaliseProtocol: build.mutation<
        FinaliseProtocolApiResponse,
        FinaliseProtocolApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/protocol/finalise`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      listProtocolVersions: build.query<
        ListProtocolVersionsApiResponse,
        ListProtocolVersionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/protocol/versions`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      downloadProtocolVersion: build.query<
        DownloadProtocolVersionApiResponse,
        DownloadProtocolVersionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/protocol/versions/${queryArg.versionId}/pdf`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      listBidsForEvent: build.query<
        ListBidsForEventApiResponse,
        ListBidsForEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/public-bids`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      getBidForBuyer: build.query<
        GetBidForBuyerApiResponse,
        GetBidForBuyerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/public-bids/${queryArg.bidId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      createContractFromBid: build.mutation<
        CreateContractFromBidApiResponse,
        CreateContractFromBidApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/public-bids/${queryArg.bidId}/contract`,
          method: "POST",
          body: queryArg.createContractFromBidRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "Contract", "SourcingEvent"],
      }),
      updateBuyerMinimumRequirementReview: build.mutation<
        UpdateBuyerMinimumRequirementReviewApiResponse,
        UpdateBuyerMinimumRequirementReviewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/public-bids/${queryArg.bidId}/minimum-requirement-review`,
          method: "PATCH",
          body: queryArg.buyerMinimumRequirementReviewPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      setBidQualification: build.mutation<
        SetBidQualificationApiResponse,
        SetBidQualificationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/public-bids/${queryArg.bidId}/qualification`,
          method: "PUT",
          body: queryArg.setBidQualificationRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      updateBuyerQualificationReview: build.mutation<
        UpdateBuyerQualificationReviewApiResponse,
        UpdateBuyerQualificationReviewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/public-bids/${queryArg.bidId}/qualification-review`,
          method: "PATCH",
          body: queryArg.buyerQualificationReviewPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      rejectBid: build.mutation<RejectBidApiResponse, RejectBidApiArg>({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/public-bids/${queryArg.bidId}/reject`,
          method: "POST",
          body: queryArg.rejectBidRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "SourcingEvent"],
      }),
      getBidRejectionDocuments: build.query<
        GetBidRejectionDocumentsApiResponse,
        GetBidRejectionDocumentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/public-bids/${queryArg.bidId}/rejection-documents`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      createUploadForBidRejection: build.mutation<
        CreateUploadForBidRejectionApiResponse,
        CreateUploadForBidRejectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/public-bids/${queryArg.bidId}/rejection-uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "Upload"],
      }),
      revokeBidRejection: build.mutation<
        RevokeBidRejectionApiResponse,
        RevokeBidRejectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/public-bids/${queryArg.bidId}/revoke-rejection`,
          method: "POST",
          body: queryArg.revokeBidRejectionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "SourcingEvent"],
      }),
      publishDpsCompetition: build.mutation<
        PublishDpsCompetitionApiResponse,
        PublishDpsCompetitionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/publish-dps-competition`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      publishPrivateSourcingEvent: build.mutation<
        PublishPrivateSourcingEventApiResponse,
        PublishPrivateSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/publish-private`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            openInSupplierPortal: queryArg.openInSupplierPortal,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      publishQualificationSchemeCompetition: build.mutation<
        PublishQualificationSchemeCompetitionApiResponse,
        PublishQualificationSchemeCompetitionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/publish-qualification-scheme-competition`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      downloadSeQaReport: build.query<
        DownloadSeQaReportApiResponse,
        DownloadSeQaReportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/qa-report`,
        }),
        providesTags: ["SourcingEvent"],
      }),
      getQualificationSchemeCompetitions: build.query<
        GetQualificationSchemeCompetitionsApiResponse,
        GetQualificationSchemeCompetitionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/qualification-scheme/competitions`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      createQualificationSchemeCompetition: build.mutation<
        CreateQualificationSchemeCompetitionApiResponse,
        CreateQualificationSchemeCompetitionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/qualification-scheme/competitions`,
          method: "POST",
          body: queryArg.createQualificationSchemeCompetitionRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      getQualificationSchemeInvitees: build.query<
        GetQualificationSchemeInviteesApiResponse,
        GetQualificationSchemeInviteesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/qualification-scheme/invitees`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      getBuyerSeQuestions: build.query<
        GetBuyerSeQuestionsApiResponse,
        GetBuyerSeQuestionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/questions`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      answerSeQuestion: build.mutation<
        AnswerSeQuestionApiResponse,
        AnswerSeQuestionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/questions/${queryArg.questionId}`,
          method: "PATCH",
          body: queryArg.seQuestionPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      createUploadForSeAnswerAttachment: build.mutation<
        CreateUploadForSeAnswerAttachmentApiResponse,
        CreateUploadForSeAnswerAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/questions/${queryArg.questionId}/answer-attachment-uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      sendSeClarificationMessageAsBuyer: build.mutation<
        SendSeClarificationMessageAsBuyerApiResponse,
        SendSeClarificationMessageAsBuyerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/questions/${queryArg.questionId}/messages`,
          method: "POST",
          body: queryArg.createSeQuestionMessageRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      getSourcingEventReadiness: build.query<
        GetSourcingEventReadinessApiResponse,
        GetSourcingEventReadinessApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/readiness`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      reopenCompletedSourcingEvent: build.mutation<
        ReopenCompletedSourcingEventApiResponse,
        ReopenCompletedSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/reopening`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      setResponsiblePerson: build.mutation<
        SetResponsiblePersonApiResponse,
        SetResponsiblePersonApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/responsible-person`,
          method: "PUT",
          body: queryArg.setResponsiblePersonRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      declineResultNotice: build.mutation<
        DeclineResultNoticeApiResponse,
        DeclineResultNoticeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/result-notice/decline`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      revokeAward: build.mutation<RevokeAwardApiResponse, RevokeAwardApiArg>({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/revoke-award`,
          method: "POST",
          body: queryArg.revokeAwardRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "SourcingEvent"],
      }),
      getEventShares: build.query<
        GetEventSharesApiResponse,
        GetEventSharesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/shares`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      shareEvent: build.mutation<ShareEventApiResponse, ShareEventApiArg>({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/shares`,
          method: "POST",
          body: queryArg.shareEventRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      unshareEvent: build.mutation<UnshareEventApiResponse, UnshareEventApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/buyer/events/${queryArg.eventId}/shares/${queryArg.pathPersonId}`,
            method: "DELETE",
            headers: {
              cookie: queryArg.cookie,
              organizationId: queryArg.organizationId,
              personId: queryArg.headerPersonId,
            },
          }),
          invalidatesTags: ["SourcingEvent"],
        },
      ),
      getBuyerSupplierInformation: build.query<
        GetBuyerSupplierInformationApiResponse,
        GetBuyerSupplierInformationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/supplier-information`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      publishInformation: build.mutation<
        PublishInformationApiResponse,
        PublishInformationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/supplier-information`,
          method: "POST",
          body: queryArg.createInformationRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      createUploadForSourcingEvent: build.mutation<
        CreateUploadForSourcingEventApiResponse,
        CreateUploadForSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      listFrameworkAgreements: build.query<
        ListFrameworkAgreementsApiResponse,
        ListFrameworkAgreementsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/framework-agreements`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["FrameworkAgreement"],
      }),
      registerFrameworkAgreement: build.mutation<
        RegisterFrameworkAgreementApiResponse,
        RegisterFrameworkAgreementApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/framework-agreements`,
          method: "POST",
          body: queryArg.registerFrameworkAgreementRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["FrameworkAgreement"],
      }),
      getFrameworkAgreement: build.query<
        GetFrameworkAgreementApiResponse,
        GetFrameworkAgreementApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/framework-agreements/${queryArg.frameworkAgreementId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["FrameworkAgreement"],
      }),
      updateFrameworkAgreement: build.mutation<
        UpdateFrameworkAgreementApiResponse,
        UpdateFrameworkAgreementApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/framework-agreements/${queryArg.frameworkAgreementId}`,
          method: "PATCH",
          body: queryArg.frameworkAgreementPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["FrameworkAgreement"],
      }),
      listFrameworkCallOffs: build.query<
        ListFrameworkCallOffsApiResponse,
        ListFrameworkCallOffsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/framework-agreements/${queryArg.frameworkAgreementId}/call-offs`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            supplierOrganizationId: queryArg.supplierOrganizationId,
          },
        }),
        providesTags: ["FrameworkAgreement"],
      }),
      createDirectCallOff: build.mutation<
        CreateDirectCallOffApiResponse,
        CreateDirectCallOffApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/framework-agreements/${queryArg.frameworkAgreementId}/call-offs`,
          method: "POST",
          body: queryArg.createDirectCallOffRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["FrameworkAgreement"],
      }),
      listMiniCompetitions: build.query<
        ListMiniCompetitionsApiResponse,
        ListMiniCompetitionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/framework-agreements/${queryArg.frameworkAgreementId}/mini-competitions`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["FrameworkAgreement"],
      }),
      openMiniCompetition: build.mutation<
        OpenMiniCompetitionApiResponse,
        OpenMiniCompetitionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/framework-agreements/${queryArg.frameworkAgreementId}/mini-competitions`,
          method: "POST",
          body: queryArg.openMiniCompetitionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["FrameworkAgreement"],
      }),
      addFrameworkSupplier: build.mutation<
        AddFrameworkSupplierApiResponse,
        AddFrameworkSupplierApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/framework-agreements/${queryArg.frameworkAgreementId}/panel`,
          method: "POST",
          body: queryArg.addFrameworkSupplierRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["FrameworkAgreement"],
      }),
      terminateFrameworkAgreement: build.mutation<
        TerminateFrameworkAgreementApiResponse,
        TerminateFrameworkAgreementApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/framework-agreements/${queryArg.frameworkAgreementId}/termination`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["FrameworkAgreement"],
      }),
      getFrameworkOverview: build.query<
        GetFrameworkOverviewApiResponse,
        GetFrameworkOverviewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/framework-overview`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            projectId: queryArg.projectId,
            allFollowUp: queryArg.allFollowUp,
          },
        }),
        providesTags: ["FrameworkAgreement"],
      }),
      getProductGroupsForSourcingEvent: build.query<
        GetProductGroupsForSourcingEventApiResponse,
        GetProductGroupsForSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/products/sourcing/groups/${queryArg.sourcingEventId}`,
        }),
        providesTags: ["Product"],
      }),
      listCombinedEventsWithSupplier: build.query<
        ListCombinedEventsWithSupplierApiResponse,
        ListCombinedEventsWithSupplierApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/${queryArg.orgId}/combined-events/with-supplier`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            supplierOrganizationId: queryArg.supplierOrganizationId,
            supplierEntryId: queryArg.supplierEntryId,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      listBuyerEvents: build.query<
        ListBuyerEventsApiResponse,
        ListBuyerEventsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/${queryArg.orgId}/events`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            needsSentFrom: queryArg.needsSentFrom,
            needsSentTo: queryArg.needsSentTo,
            statuses: queryArg.statuses,
            active: queryArg.active,
            projectIds: queryArg.projectIds,
            name: queryArg.name,
            tableSearchTerm: queryArg.tableSearchTerm,
            responsiblePersons: queryArg.responsiblePersons,
            contractTypes: queryArg.contractTypes,
            deadlinePassed: queryArg.deadlinePassed,
            publishedFrom: queryArg.publishedFrom,
            publishedTo: queryArg.publishedTo,
            awardedFrom: queryArg.awardedFrom,
            awardedTo: queryArg.awardedTo,
            bidDeadlineFrom: queryArg.bidDeadlineFrom,
            bidDeadlineTo: queryArg.bidDeadlineTo,
            deadlineFrom: queryArg.deadlineFrom,
            deadlineTo: queryArg.deadlineTo,
            deadlinePreset: queryArg.deadlinePreset,
            minDeliveredBids: queryArg.minDeliveredBids,
            maxDeliveredBids: queryArg.maxDeliveredBids,
            procedureTypes: queryArg.procedureTypes,
            regulationBuckets: queryArg.regulationBuckets,
            limit: queryArg.limit,
            skip: queryArg.skip,
            sortBy: queryArg.sortBy,
            sortDirection: queryArg.sortDirection,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      listBuyerEventFilterOptions: build.query<
        ListBuyerEventFilterOptionsApiResponse,
        ListBuyerEventFilterOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/${queryArg.orgId}/events/filter-options`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      downloadProcurementList: build.mutation<
        DownloadProcurementListApiResponse,
        DownloadProcurementListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/${queryArg.orgId}/events/list-export`,
          method: "POST",
          body: queryArg.listExportRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            format: queryArg.format,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      getProcurementOverview: build.query<
        GetProcurementOverviewApiResponse,
        GetProcurementOverviewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/${queryArg.orgId}/events/overview`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            from: queryArg["from"],
            to: queryArg.to,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      getProcurementClimateWeightingList: build.query<
        GetProcurementClimateWeightingListApiResponse,
        GetProcurementClimateWeightingListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/${queryArg.orgId}/events/overview/climate-weighting`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            group: queryArg.group,
            from: queryArg["from"],
            to: queryArg.to,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      getProcurementPhaseList: build.query<
        GetProcurementPhaseListApiResponse,
        GetProcurementPhaseListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/${queryArg.orgId}/events/overview/phase`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            phase: queryArg.phase,
            from: queryArg["from"],
            to: queryArg.to,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      getProcurementPlan: build.query<
        GetProcurementPlanApiResponse,
        GetProcurementPlanApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/${queryArg.orgId}/events/plan`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            from: queryArg["from"],
            to: queryArg.to,
            department: queryArg.department,
            responsible: queryArg.responsible,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      downloadProcurementPlan: build.mutation<
        DownloadProcurementPlanApiResponse,
        DownloadProcurementPlanApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/${queryArg.orgId}/events/plan/list-export`,
          method: "POST",
          body: queryArg.listExportRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            format: queryArg.format,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      countBuyerEventsByStatus: build.query<
        CountBuyerEventsByStatusApiResponse,
        CountBuyerEventsByStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/${queryArg.orgId}/events/status-counts`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      listBuyerEventsWithSupplier: build.query<
        ListBuyerEventsWithSupplierApiResponse,
        ListBuyerEventsWithSupplierApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/${queryArg.orgId}/events/with-supplier`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            supplierOrganizationId: queryArg.supplierOrganizationId,
            supplierEntryId: queryArg.supplierEntryId,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      getProcurementWorkload: build.query<
        GetProcurementWorkloadApiResponse,
        GetProcurementWorkloadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/${queryArg.orgId}/events/workload`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      listProcurementWorkloadDeadlines: build.query<
        ListProcurementWorkloadDeadlinesApiResponse,
        ListProcurementWorkloadDeadlinesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/${queryArg.orgId}/events/workload/${queryArg.pathPersonId}/deadlines`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.headerPersonId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      listContractReports: build.query<
        ListContractReportsApiResponse,
        ListContractReportsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract-reports`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            q: queryArg.q,
            sortBy: queryArg.sortBy,
            sortDirection: queryArg.sortDirection,
            sortByCustomField: queryArg.sortByCustomField,
          },
        }),
        providesTags: ["Contract"],
      }),
      listContractReportOptions: build.query<
        ListContractReportOptionsApiResponse,
        ListContractReportOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract-reports/options`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            q: queryArg.q,
            parameterName: queryArg.parameterName,
            optionValues: queryArg.optionValues,
            optionSearchTerm: queryArg.optionSearchTerm,
          },
        }),
        providesTags: ["Contract"],
      }),
      getContractOverview: build.query<
        GetContractOverviewApiResponse,
        GetContractOverviewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract-reports/overview`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            q: queryArg.q,
          },
        }),
        providesTags: ["Contract"],
      }),
      getContractSavings: build.query<
        GetContractSavingsApiResponse,
        GetContractSavingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract-reports/savings`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            orgId: queryArg.orgId,
            from: queryArg["from"],
            to: queryArg.to,
            list: queryArg.list,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["Contract"],
      }),
      getContractSigning: build.query<
        GetContractSigningApiResponse,
        GetContractSigningApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract-reports/signing`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            q: queryArg.q,
          },
        }),
        providesTags: ["Contract"],
      }),
      downloadContractTaskList: build.mutation<
        DownloadContractTaskListApiResponse,
        DownloadContractTaskListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract-tasks/list-export`,
          method: "POST",
          body: queryArg.listExportRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            format: queryArg.format,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      deleteCustomContractDataField: build.mutation<
        DeleteCustomContractDataFieldApiResponse,
        DeleteCustomContractDataFieldApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/organization/custom-field/${queryArg.orgId}`,
          method: "DELETE",
          body: queryArg.deleteCustomFieldDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract", "Organization"],
      }),
      upsertCustomContractDataField: build.mutation<
        UpsertCustomContractDataFieldApiResponse,
        UpsertCustomContractDataFieldApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/organization/custom-field/${queryArg.orgId}`,
          method: "PUT",
          body: queryArg.upsertCustomContractFieldDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      markSupplierFilterContractField: build.mutation<
        MarkSupplierFilterContractFieldApiResponse,
        MarkSupplierFilterContractFieldApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/organization/custom-field/${queryArg.orgId}/supplier-filter`,
          method: "PUT",
          body: queryArg.markSupplierFilterFieldDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      markSupplierFilterContractEndDate: build.mutation<
        MarkSupplierFilterContractEndDateApiResponse,
        MarkSupplierFilterContractEndDateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/organization/custom-field/${queryArg.orgId}/supplier-filter/end-date`,
          method: "PUT",
          body: queryArg.markSupplierFilterEndDateDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      upsertContractDataFieldsSection: build.mutation<
        UpsertContractDataFieldsSectionApiResponse,
        UpsertContractDataFieldsSectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/organization/fields-section/${queryArg.orgId}`,
          method: "POST",
          body: queryArg.contractDataFieldSectionDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      contractReportQueryDummy: build.mutation<
        ContractReportQueryDummyApiResponse,
        ContractReportQueryDummyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/report-query-dummy`,
          method: "POST",
          body: queryArg.contractReportQueryDto,
        }),
        invalidatesTags: ["Contract"],
      }),
      signatureWebhook: build.mutation<
        SignatureWebhookApiResponse,
        SignatureWebhookApiArg
      >({
        query: () => ({
          url: `/api/contract/signature/events`,
          method: "POST",
        }),
        invalidatesTags: ["Contract"],
      }),
      deleteContractTaskComment: build.mutation<
        DeleteContractTaskCommentApiResponse,
        DeleteContractTaskCommentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/task/comments/${queryArg.commentId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      updateContractTaskComment: build.mutation<
        UpdateContractTaskCommentApiResponse,
        UpdateContractTaskCommentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/task/comments/${queryArg.commentId}`,
          method: "PATCH",
          body: queryArg.updateContractTaskCommentRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      deleteContractTask: build.mutation<
        DeleteContractTaskApiResponse,
        DeleteContractTaskApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/tasks/${queryArg.taskId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      updateContractTask: build.mutation<
        UpdateContractTaskApiResponse,
        UpdateContractTaskApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/tasks/${queryArg.taskId}`,
          method: "PATCH",
          body: queryArg.updateTaskRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      listChangesForContractTask: build.query<
        ListChangesForContractTaskApiResponse,
        ListChangesForContractTaskApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/tasks/${queryArg.taskId}/changes`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      listCommentsForContractTask: build.query<
        ListCommentsForContractTaskApiResponse,
        ListCommentsForContractTaskApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/tasks/${queryArg.taskId}/comments`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      createContractTaskComment: build.mutation<
        CreateContractTaskCommentApiResponse,
        CreateContractTaskCommentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/tasks/${queryArg.taskId}/comments`,
          method: "POST",
          body: queryArg.createContractTaskCommentRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      createContractTextDocument: build.mutation<
        CreateContractTextDocumentApiResponse,
        CreateContractTextDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/text-documents`,
          method: "POST",
          body: queryArg.createContractTextDocumentRequest,
        }),
        invalidatesTags: ["Contract", "TextDocument"],
      }),
      listTextDocumentsForContract: build.query<
        ListTextDocumentsForContractApiResponse,
        ListTextDocumentsForContractApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/text-documents/${queryArg.contractId}`,
        }),
        providesTags: ["Contract", "TextDocument"],
      }),
      createFencyConversation: build.mutation<
        CreateFencyConversationApiResponse,
        CreateFencyConversationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/conversation`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      createExploreMemoriesSession: build.mutation<
        CreateExploreMemoriesSessionApiResponse,
        CreateExploreMemoriesSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/explore-memories-session`,
          method: "POST",
          body: queryArg.createExploreMemoriesSessionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      createFencyFileDownloadSession: build.mutation<
        CreateFencyFileDownloadSessionApiResponse,
        CreateFencyFileDownloadSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/file-download-session`,
          method: "POST",
          body: queryArg.createFencyFileDownloadSessionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      downloadMultiIfrsReport: build.query<
        DownloadMultiIfrsReportApiResponse,
        DownloadMultiIfrsReportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/ifrs-report`,
          params: {
            contractIds: queryArg.contractIds,
          },
        }),
        providesTags: ["Contract"],
      }),
      downloadChosenIfrsReport: build.mutation<
        DownloadChosenIfrsReportApiResponse,
        DownloadChosenIfrsReportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/ifrs-report/chosen`,
          method: "POST",
          body: queryArg.chosenIfrsReportRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      downloadFilteredIfrsReport: build.query<
        DownloadFilteredIfrsReportApiResponse,
        DownloadFilteredIfrsReportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/ifrs-report/filtered`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            q: queryArg.q,
            periodFrom: queryArg.periodFrom,
            periodTo: queryArg.periodTo,
          },
        }),
        providesTags: ["Contract"],
      }),
      getFilteredIfrsReportPreview: build.query<
        GetFilteredIfrsReportPreviewApiResponse,
        GetFilteredIfrsReportPreviewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/ifrs-report/filtered/preview`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            q: queryArg.q,
            periodFrom: queryArg.periodFrom,
            periodTo: queryArg.periodTo,
          },
        }),
        providesTags: ["Contract"],
      }),
      downloadContractList: build.mutation<
        DownloadContractListApiResponse,
        DownloadContractListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/list-export`,
          method: "POST",
          body: queryArg.listExportRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            format: queryArg.format,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      createMemoryChatSession: build.mutation<
        CreateMemoryChatSessionApiResponse,
        CreateMemoryChatSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/memory-chat-session`,
          method: "POST",
          body: queryArg.createMemoryChatSessionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      createMemoryDownloadLink: build.mutation<
        CreateMemoryDownloadLinkApiResponse,
        CreateMemoryDownloadLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/memory-download-link`,
          method: "POST",
          body: queryArg.createMemoryDownloadLinkRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      createContractSearchSession: build.mutation<
        CreateContractSearchSessionApiResponse,
        CreateContractSearchSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/memory-search-session`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      getContractStatistics: build.query<
        GetContractStatisticsApiResponse,
        GetContractStatisticsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/orgs/${queryArg.orgId}/statistics`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      getContractAutofillContext: build.query<
        GetContractAutofillContextApiResponse,
        GetContractAutofillContextApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/autofill-context`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      cancelSignedDocument: build.mutation<
        CancelSignedDocumentApiResponse,
        CancelSignedDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/cancel-signed-document`,
          method: "POST",
          body: queryArg.cancelSignedDocumentRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      createUploadForContractDescription: build.mutation<
        CreateUploadForContractDescriptionApiResponse,
        CreateUploadForContractDescriptionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/description/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      downloadIfrsReport: build.query<
        DownloadIfrsReportApiResponse,
        DownloadIfrsReportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/ifrs-report`,
        }),
        providesTags: ["Contract"],
      }),
      getContractMessageAttachmentUpload: build.query<
        GetContractMessageAttachmentUploadApiResponse,
        GetContractMessageAttachmentUploadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/message-attachment-uploads/${queryArg.uploadId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Upload"],
      }),
      createUploadForContractMessageAttachment: build.mutation<
        CreateUploadForContractMessageAttachmentApiResponse,
        CreateUploadForContractMessageAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/message-attachment-uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      listContractMessages: build.query<
        ListContractMessagesApiResponse,
        ListContractMessagesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/messages`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      createContractMessage: build.mutation<
        CreateContractMessageApiResponse,
        CreateContractMessageApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/messages`,
          method: "POST",
          body: queryArg.createContractMessageRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      saveContractMessageAttachment: build.mutation<
        SaveContractMessageAttachmentApiResponse,
        SaveContractMessageAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/messages/save-attachment`,
          method: "POST",
          body: queryArg.saveMessageAttachmentRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      getContractOriginCommunication: build.query<
        GetContractOriginCommunicationApiResponse,
        GetContractOriginCommunicationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/origin-communication`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      deleteContractParticipant: build.mutation<
        DeleteContractParticipantApiResponse,
        DeleteContractParticipantApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/participant`,
          method: "DELETE",
          body: queryArg.deleteContractParticipantRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      listParticipantsForContracts: build.query<
        ListParticipantsForContractsApiResponse,
        ListParticipantsForContractsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/participants`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      createContractParticipant: build.mutation<
        CreateContractParticipantApiResponse,
        CreateContractParticipantApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/participants`,
          method: "POST",
          body: queryArg.createContractParticipantRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      deleteSignedDocument: build.mutation<
        DeleteSignedDocumentApiResponse,
        DeleteSignedDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/signed-documents/${queryArg.signedDocumentId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      changeSignedDocumentDeadline: build.mutation<
        ChangeSignedDocumentDeadlineApiResponse,
        ChangeSignedDocumentDeadlineApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/signed-documents/${queryArg.signedDocumentId}/deadline`,
          method: "PUT",
          body: queryArg.changeSignedDocumentDeadlineRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      getContractTaskDelegation: build.query<
        GetContractTaskDelegationApiResponse,
        GetContractTaskDelegationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/task-delegation`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            responsiblePersonId: queryArg.responsiblePersonId,
            taskId: queryArg.taskId,
          },
        }),
        providesTags: ["Contract"],
      }),
      createContractTask: build.mutation<
        CreateContractTaskApiResponse,
        CreateContractTaskApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/tasks`,
          method: "POST",
          body: queryArg.createContractTaskRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      createUploadForContract: build.mutation<
        CreateUploadForContractApiResponse,
        CreateUploadForContractApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      getContributingEntityInvite: build.query<
        GetContributingEntityInviteApiResponse,
        GetContributingEntityInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contributing-entities/invites/${queryArg.inviteId}`,
          params: {
            secret: queryArg.secret,
          },
        }),
        providesTags: ["ContributingEntity"],
      }),
      acceptContributingEntityInvite: build.mutation<
        AcceptContributingEntityInviteApiResponse,
        AcceptContributingEntityInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contributing-entities/invites/${queryArg.inviteId}/acceptance`,
          method: "PUT",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            secret: queryArg.secret,
          },
        }),
        invalidatesTags: ["ContributingEntity"],
      }),
      declineContributingEntityInvite: build.mutation<
        DeclineContributingEntityInviteApiResponse,
        DeclineContributingEntityInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contributing-entities/invites/${queryArg.inviteId}/decline`,
          method: "PUT",
          body: queryArg.declineContributingEntityInviteRequestDto,
          params: {
            secret: queryArg.secret,
          },
        }),
        invalidatesTags: ["ContributingEntity"],
      }),
      getCpvCodes: build.query<GetCpvCodesApiResponse, GetCpvCodesApiArg>({
        query: () => ({ url: `/api/cpv/codes` }),
        providesTags: ["CPV"],
      }),
      listContractFilterOptions: build.query<
        ListContractFilterOptionsApiResponse,
        ListContractFilterOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/deps/${queryArg.orgId}/contract/filter-options`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      listContracts: build.query<ListContractsApiResponse, ListContractsApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/deps/${queryArg.orgId}/contracts`,
            headers: {
              cookie: queryArg.cookie,
              organizationId: queryArg.organizationId,
              personId: queryArg.personId,
            },
            params: {
              title: queryArg.title,
              state: queryArg.state,
              statuses: queryArg.statuses,
              counterparties: queryArg.counterparties,
              owners: queryArg.owners,
              templates: queryArg.templates,
              internalparties: queryArg.internalparties,
              projects: queryArg.projects,
              limit: queryArg.limit,
              skip: queryArg.skip,
            },
          }),
          providesTags: ["Contract"],
        },
      ),
      forceDeliverBid: build.mutation<
        ForceDeliverBidApiResponse,
        ForceDeliverBidApiArg
      >({
        query: (queryArg) => ({
          url: `/api/dev/bids/${queryArg.bidId}/force-deliver`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "SourcingEvent"],
      }),
      forcePublishEvent: build.mutation<
        ForcePublishEventApiResponse,
        ForcePublishEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/dev/events/${queryArg.eventId}/force-publish`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      skipPastGate: build.mutation<SkipPastGateApiResponse, SkipPastGateApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/dev/events/${queryArg.eventId}/skip-past-gate`,
            method: "POST",
            body: queryArg.skipPastGateRequestDto,
            headers: {
              cookie: queryArg.cookie,
              organizationId: queryArg.organizationId,
              personId: queryArg.personId,
            },
          }),
          invalidatesTags: ["BidV2", "SourcingEvent"],
        },
      ),
      startDocumentChat: build.mutation<
        StartDocumentChatApiResponse,
        StartDocumentChatApiArg
      >({
        query: (queryArg) => ({
          url: `/api/docs/start-chat`,
          method: "POST",
          body: queryArg.startDocumentChatRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Document"],
      }),
      updateDocumentMeta: build.mutation<
        UpdateDocumentMetaApiResponse,
        UpdateDocumentMetaApiArg
      >({
        query: (queryArg) => ({
          url: `/api/docs/${queryArg.docId}`,
          method: "PUT",
          body: queryArg.updateDocumentMetaRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Document"],
      }),
      getDownloadLink: build.query<
        GetDownloadLinkApiResponse,
        GetDownloadLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/docs/${queryArg.docId}/link`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Document"],
      }),
      listDocumentTemplates: build.query<
        ListDocumentTemplatesApiResponse,
        ListDocumentTemplatesApiArg
      >({
        query: () => ({ url: `/api/document-template/text-documents` }),
        providesTags: ["TextDocument"],
      }),
      createDocumentTemplate: build.mutation<
        CreateDocumentTemplateApiResponse,
        CreateDocumentTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-template/text-documents`,
          method: "POST",
          body: queryArg.createDocumentTemplateRequest,
        }),
        invalidatesTags: ["TextDocument"],
      }),
      createFencyStreamSession: build.mutation<
        CreateFencyStreamSessionApiResponse,
        CreateFencyStreamSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/documents/stream-sessions`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Document"],
      }),
      submitCancellationNotice: build.mutation<
        SubmitCancellationNoticeApiResponse,
        SubmitCancellationNoticeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/doffin/${queryArg.sourcingEventId}/cancellation-notice`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Doffin", "SourcingEvent"],
      }),
      submitContractAwardNotice: build.mutation<
        SubmitContractAwardNoticeApiResponse,
        SubmitContractAwardNoticeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/doffin/${queryArg.sourcingEventId}/contract-award`,
          method: "POST",
          body: queryArg.submitContractAwardNoticeRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Doffin", "SourcingEvent"],
      }),
      previewContractAwardNotice: build.query<
        PreviewContractAwardNoticeApiResponse,
        PreviewContractAwardNoticeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/doffin/${queryArg.sourcingEventId}/contract-award/preview`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Doffin", "SourcingEvent"],
      }),
      submitContractModificationNotice: build.mutation<
        SubmitContractModificationNoticeApiResponse,
        SubmitContractModificationNoticeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/doffin/${queryArg.sourcingEventId}/contract-modification`,
          method: "POST",
          body: queryArg.submitContractModificationNoticeRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Doffin", "SourcingEvent"],
      }),
      previewContractModificationNotice: build.query<
        PreviewContractModificationNoticeApiResponse,
        PreviewContractModificationNoticeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/doffin/${queryArg.sourcingEventId}/contract-modification/preview`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Doffin", "SourcingEvent"],
      }),
      submitIntentionNotice: build.mutation<
        SubmitIntentionNoticeApiResponse,
        SubmitIntentionNoticeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/doffin/${queryArg.sourcingEventId}/intention`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Doffin", "SourcingEvent"],
      }),
      submitNoWinnerNotice: build.mutation<
        SubmitNoWinnerNoticeApiResponse,
        SubmitNoWinnerNoticeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/doffin/${queryArg.sourcingEventId}/no-winner`,
          method: "POST",
          body: queryArg.submitNoWinnerNoticeRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Doffin", "SourcingEvent"],
      }),
      submitQualificationSchemeEndNotice: build.mutation<
        SubmitQualificationSchemeEndNoticeApiResponse,
        SubmitQualificationSchemeEndNoticeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/doffin/${queryArg.sourcingEventId}/qualification-scheme-end`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Doffin", "SourcingEvent"],
      }),
      submitDoffinNotice: build.mutation<
        SubmitDoffinNoticeApiResponse,
        SubmitDoffinNoticeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/doffin/${queryArg.sourcingEventId}/submit`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Doffin", "SourcingEvent"],
      }),
      validateDoffinNotice: build.mutation<
        ValidateDoffinNoticeApiResponse,
        ValidateDoffinNoticeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/doffin/${queryArg.sourcingEventId}/validate`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Doffin"],
      }),
      downloadTextDocument: build.mutation<
        DownloadTextDocumentApiResponse,
        DownloadTextDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/download/text-documents`,
          method: "POST",
          body: queryArg.downloadTextDocumentRequest,
        }),
        invalidatesTags: ["TextDocument"],
      }),
      updateEmailStatus: build.mutation<
        UpdateEmailStatusApiResponse,
        UpdateEmailStatusApiArg
      >({
        query: () => ({ url: `/api/email/status/events`, method: "POST" }),
        invalidatesTags: ["Misc"],
      }),
      getSeAttachmentDownloadLink: build.query<
        GetSeAttachmentDownloadLinkApiResponse,
        GetSeAttachmentDownloadLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/events/${queryArg.eventId}/qa-attachments/${queryArg.documentId}/link`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      confirmFencyEvent: build.mutation<
        ConfirmFencyEventApiResponse,
        ConfirmFencyEventApiArg
      >({
        query: () => ({ url: `/api/fency/events`, method: "POST" }),
        invalidatesTags: ["Document"],
      }),
      markUploadFailed: build.mutation<
        MarkUploadFailedApiResponse,
        MarkUploadFailedApiArg
      >({
        query: () => ({
          url: `/api/file-uploads/failed-upload-webhook`,
          method: "POST",
        }),
        invalidatesTags: ["Upload"],
      }),
      confirmUpload: build.mutation<
        ConfirmUploadApiResponse,
        ConfirmUploadApiArg
      >({
        query: () => ({
          url: `/api/file-uploads/successful-upload-webhook`,
          method: "POST",
        }),
        invalidatesTags: ["Upload"],
      }),
      searchIndustries: build.query<
        SearchIndustriesApiResponse,
        SearchIndustriesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/industries`,
          params: {
            name: queryArg.name,
          },
        }),
        providesTags: ["Industry"],
      }),
      listLibraryElements: build.query<
        ListLibraryElementsApiResponse,
        ListLibraryElementsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/library-element`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["LibraryElement"],
      }),
      createLibraryElement: build.mutation<
        CreateLibraryElementApiResponse,
        CreateLibraryElementApiArg
      >({
        query: (queryArg) => ({
          url: `/api/library-element`,
          method: "POST",
          body: queryArg.createLibraryElementRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["LibraryElement"],
      }),
      updateLibraryElement: build.mutation<
        UpdateLibraryElementApiResponse,
        UpdateLibraryElementApiArg
      >({
        query: (queryArg) => ({
          url: `/api/library-element`,
          method: "PUT",
          body: queryArg.updateLibraryElementRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["LibraryElement"],
      }),
      deleteLibraryElement: build.mutation<
        DeleteLibraryElementApiResponse,
        DeleteLibraryElementApiArg
      >({
        query: (queryArg) => ({
          url: `/api/library-element/${queryArg.id}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["LibraryElement"],
      }),
      getMarketDialogueInvite: build.query<
        GetMarketDialogueInviteApiResponse,
        GetMarketDialogueInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogue-invites/${queryArg.inviteId}`,
          params: {
            secret: queryArg.secret,
          },
        }),
        providesTags: ["MarketDialogue"],
      }),
      listMarketDialogues: build.query<
        ListMarketDialoguesApiResponse,
        ListMarketDialoguesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["MarketDialogue"],
      }),
      createMarketDialogue: build.mutation<
        CreateMarketDialogueApiResponse,
        CreateMarketDialogueApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues`,
          method: "POST",
          body: queryArg.createMarketDialogueRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      deleteMarketDialogue: build.mutation<
        DeleteMarketDialogueApiResponse,
        DeleteMarketDialogueApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      getMarketDialogue: build.query<
        GetMarketDialogueApiResponse,
        GetMarketDialogueApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["MarketDialogue"],
      }),
      updateMarketDialogue: build.mutation<
        UpdateMarketDialogueApiResponse,
        UpdateMarketDialogueApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}`,
          method: "PUT",
          body: queryArg.updateMarketDialogueRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      listMarketDialogueAnswers: build.query<
        ListMarketDialogueAnswersApiResponse,
        ListMarketDialogueAnswersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}/answers`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["MarketDialogue"],
      }),
      commentOnMarketDialogueAnswer: build.mutation<
        CommentOnMarketDialogueAnswerApiResponse,
        CommentOnMarketDialogueAnswerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}/answers/${queryArg.answerId}/comments`,
          method: "POST",
          body: queryArg.addMarketDialogueAnswerCommentRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      startCompetitionFromMarketDialogue: build.mutation<
        StartCompetitionFromMarketDialogueApiResponse,
        StartCompetitionFromMarketDialogueApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}/competition`,
          method: "POST",
          body: queryArg.startCompetitionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      getCompetitionPlan: build.query<
        GetCompetitionPlanApiResponse,
        GetCompetitionPlanApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}/competition-plan`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["MarketDialogue"],
      }),
      removeMarketDialogueDocument: build.mutation<
        RemoveMarketDialogueDocumentApiResponse,
        RemoveMarketDialogueDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}/documents/${queryArg.documentId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      markMarketDialogueAnswer: build.mutation<
        MarkMarketDialogueAnswerApiResponse,
        MarkMarketDialogueAnswerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}/insights/marks`,
          method: "PUT",
          body: queryArg.markMarketDialogueAnswerRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      summariseMarketDialogue: build.mutation<
        SummariseMarketDialogueApiResponse,
        SummariseMarketDialogueApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}/insights/summary`,
          method: "PUT",
          body: queryArg.summariseMarketDialogueRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      inviteEmailToMarketDialogue: build.mutation<
        InviteEmailToMarketDialogueApiResponse,
        InviteEmailToMarketDialogueApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}/invitations/emails`,
          method: "POST",
          body: queryArg.inviteEmailToMarketDialogueRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      inviteOrganizationToMarketDialogue: build.mutation<
        InviteOrganizationToMarketDialogueApiResponse,
        InviteOrganizationToMarketDialogueApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}/invitations/organizations`,
          method: "POST",
          body: queryArg.inviteOrganizationToMarketDialogueRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      withdrawMarketDialogueInvitation: build.mutation<
        WithdrawMarketDialogueInvitationApiResponse,
        WithdrawMarketDialogueInvitationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}/invitations/${queryArg.invitationId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      linkMarketDialogueToNeed: build.mutation<
        LinkMarketDialogueToNeedApiResponse,
        LinkMarketDialogueToNeedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}/need`,
          method: "PUT",
          body: queryArg.linkMarketDialogueNeedRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      publishMarketDialogue: build.mutation<
        PublishMarketDialogueApiResponse,
        PublishMarketDialogueApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}/publish`,
          method: "POST",
          body: queryArg.publishMarketDialogueRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      listMarketDialogueQuestions: build.query<
        ListMarketDialogueQuestionsApiResponse,
        ListMarketDialogueQuestionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}/questions`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["MarketDialogue"],
      }),
      replyToMarketDialogueQuestion: build.mutation<
        ReplyToMarketDialogueQuestionApiResponse,
        ReplyToMarketDialogueQuestionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}/questions/${queryArg.answerId}/${queryArg.questionId}/reply`,
          method: "POST",
          body: queryArg.replyToSupplierQuestionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      shareWithMarketDialogueParticipants: build.mutation<
        ShareWithMarketDialogueParticipantsApiResponse,
        ShareWithMarketDialogueParticipantsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}/shared`,
          method: "POST",
          body: queryArg.shareWithParticipantsRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      listMarketDialogueSupplierSuggestions: build.query<
        ListMarketDialogueSupplierSuggestionsApiResponse,
        ListMarketDialogueSupplierSuggestionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}/supplier-suggestions`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["MarketDialogue"],
      }),
      getMarketDialogueTeam: build.query<
        GetMarketDialogueTeamApiResponse,
        GetMarketDialogueTeamApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}/team`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["MarketDialogue"],
      }),
      addMarketDialogueTeamMember: build.mutation<
        AddMarketDialogueTeamMemberApiResponse,
        AddMarketDialogueTeamMemberApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}/team`,
          method: "POST",
          body: queryArg.addMarketDialogueTeamMemberRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      removeMarketDialogueTeamMember: build.mutation<
        RemoveMarketDialogueTeamMemberApiResponse,
        RemoveMarketDialogueTeamMemberApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}/team/${queryArg.pathPersonId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.headerPersonId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      createUploadForMarketDialogue: build.mutation<
        CreateUploadForMarketDialogueApiResponse,
        CreateUploadForMarketDialogueApiArg
      >({
        query: (queryArg) => ({
          url: `/api/market-dialogues/${queryArg.marketDialogueId}/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      dismissNotifications: build.mutation<
        DismissNotificationsApiResponse,
        DismissNotificationsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/me/dismiss/notifications`,
          method: "POST",
          body: queryArg.markNotificationsRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Notification"],
      }),
      getMyNeedsWaiting: build.query<
        GetMyNeedsWaitingApiResponse,
        GetMyNeedsWaitingApiArg
      >({
        query: (queryArg) => ({
          url: `/api/me/needs-waiting`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Home"],
      }),
      listMyNotifications: build.query<
        ListMyNotificationsApiResponse,
        ListMyNotificationsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/me/notifications`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
            unseen: queryArg.unseen,
            unread: queryArg.unread,
          },
        }),
        providesTags: ["Notification"],
      }),
      listOrganizationUsers: build.query<
        ListOrganizationUsersApiResponse,
        ListOrganizationUsersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/me/organization-users`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            name: queryArg.name,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["Organization"],
      }),
      listOrganizationsForMe: build.query<
        ListOrganizationsForMeApiResponse,
        ListOrganizationsForMeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/me/orgs`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Organization"],
      }),
      createOrganizationForMe: build.mutation<
        CreateOrganizationForMeApiResponse,
        CreateOrganizationForMeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/me/orgs`,
          method: "POST",
          body: queryArg.createOrgRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      markNotificationsAsPeeked: build.mutation<
        MarkNotificationsAsPeekedApiResponse,
        MarkNotificationsAsPeekedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/me/peek/notifications`,
          method: "POST",
          body: queryArg.markNotificationsRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Notification"],
      }),
      listMyRecentlyViewedContracts: build.query<
        ListMyRecentlyViewedContractsApiResponse,
        ListMyRecentlyViewedContractsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/me/recently-viewed/contracts`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            limit: queryArg.limit,
          },
        }),
        providesTags: ["Home"],
      }),
      listMyRecentlyViewedSourcingEvents: build.query<
        ListMyRecentlyViewedSourcingEventsApiResponse,
        ListMyRecentlyViewedSourcingEventsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/me/recently-viewed/sourcing-events`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            limit: queryArg.limit,
          },
        }),
        providesTags: ["Home"],
      }),
      listMyUpcomingDeadlines: build.query<
        ListMyUpcomingDeadlinesApiResponse,
        ListMyUpcomingDeadlinesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/me/upcoming-deadlines`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            withinDays: queryArg.withinDays,
            overdueDays: queryArg.overdueDays,
            upcomingLimit: queryArg.upcomingLimit,
            subjects: queryArg.subjects,
            overdueLimit: queryArg.overdueLimit,
            upcomingAfter: queryArg.upcomingAfter,
            overdueAfter: queryArg.overdueAfter,
          },
        }),
        providesTags: ["Home"],
      }),
      markNotificationsAsViewed: build.mutation<
        MarkNotificationsAsViewedApiResponse,
        MarkNotificationsAsViewedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/me/view/notifications`,
          method: "POST",
          body: queryArg.markNotificationsRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Notification"],
      }),
      createNeed: build.mutation<CreateNeedApiResponse, CreateNeedApiArg>({
        query: (queryArg) => ({
          url: `/api/need`,
          method: "POST",
          body: queryArg.createNeedRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Need"],
      }),
      createNeedTextDocument: build.mutation<
        CreateNeedTextDocumentApiResponse,
        CreateNeedTextDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/need/text-documents`,
          method: "POST",
          body: queryArg.createNeedTextDocumentRequest,
        }),
        invalidatesTags: ["Need", "TextDocument"],
      }),
      listTextDocumentsForNeed: build.query<
        ListTextDocumentsForNeedApiResponse,
        ListTextDocumentsForNeedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/need/text-documents/${queryArg.needId}`,
        }),
        providesTags: ["Need", "TextDocument"],
      }),
      deleteNeedDraft: build.mutation<
        DeleteNeedDraftApiResponse,
        DeleteNeedDraftApiArg
      >({
        query: (queryArg) => ({
          url: `/api/need/${queryArg.needId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Need"],
      }),
      getNeed: build.query<GetNeedApiResponse, GetNeedApiArg>({
        query: (queryArg) => ({
          url: `/api/need/${queryArg.needId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Need"],
      }),
      updateNeed: build.mutation<UpdateNeedApiResponse, UpdateNeedApiArg>({
        query: (queryArg) => ({
          url: `/api/need/${queryArg.needId}`,
          method: "PATCH",
          body: queryArg.needPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Need"],
      }),
      startCallOffForNeed: build.mutation<
        StartCallOffForNeedApiResponse,
        StartCallOffForNeedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/need/${queryArg.needId}/call-off`,
          method: "POST",
          body: queryArg.startCallOffForNeedRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Need"],
      }),
      createProcurementForNeed: build.mutation<
        CreateProcurementForNeedApiResponse,
        CreateProcurementForNeedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/need/${queryArg.needId}/create-procurement`,
          method: "POST",
          body: queryArg.createProcurementForNeedRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Need"],
      }),
      startMiniCompetitionForNeed: build.mutation<
        StartMiniCompetitionForNeedApiResponse,
        StartMiniCompetitionForNeedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/need/${queryArg.needId}/mini-competition`,
          method: "POST",
          body: queryArg.startMiniCompetitionForNeedRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Need"],
      }),
      submitNeed: build.mutation<SubmitNeedApiResponse, SubmitNeedApiArg>({
        query: (queryArg) => ({
          url: `/api/need/${queryArg.needId}/submit`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Need"],
      }),
      listNeeds: build.query<ListNeedsApiResponse, ListNeedsApiArg>({
        query: (queryArg) => ({
          url: `/api/needs`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            status: queryArg.status,
            waiting: queryArg.waiting,
            figure: queryArg.figure,
            from: queryArg["from"],
            to: queryArg.to,
            department: queryArg.department,
            responsible: queryArg.responsible,
          },
        }),
        providesTags: ["Need"],
      }),
      getNeedForProcurement: build.query<
        GetNeedForProcurementApiResponse,
        GetNeedForProcurementApiArg
      >({
        query: (queryArg) => ({
          url: `/api/needs/by-procurement/${queryArg.sourcingEventId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Need"],
      }),
      getNeedOverview: build.query<
        GetNeedOverviewApiResponse,
        GetNeedOverviewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/needs/overview`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            from: queryArg["from"],
            to: queryArg.to,
          },
        }),
        providesTags: ["Need"],
      }),
      createMarketDialogueForNeed: build.mutation<
        CreateMarketDialogueForNeedApiResponse,
        CreateMarketDialogueForNeedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/needs/${queryArg.needId}/market-dialogue`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      createUploadForNeed: build.mutation<
        CreateUploadForNeedApiResponse,
        CreateUploadForNeedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/needs/${queryArg.needId}/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      getAccessToken: build.mutation<
        GetAccessTokenApiResponse,
        GetAccessTokenApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/access-token`,
          method: "POST",
          body: queryArg.getAccessTokenRequest,
        }),
        invalidatesTags: ["Organization"],
      }),
      searchBrregOrgsByName: build.query<
        SearchBrregOrgsByNameApiResponse,
        SearchBrregOrgsByNameApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/brreg/search`,
          params: {
            query: queryArg.query,
            limit: queryArg.limit,
          },
        }),
        providesTags: ["Organization"],
      }),
      lookupBrregOrg: build.query<
        LookupBrregOrgApiResponse,
        LookupBrregOrgApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/brreg/${queryArg.organizationNumber}`,
        }),
        providesTags: ["Organization"],
      }),
      listContractsForOrg: build.query<
        ListContractsForOrgApiResponse,
        ListContractsForOrgApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/contracts`,
          params: {
            title: queryArg.title,
            state: queryArg.state,
            statuses: queryArg.statuses,
            counterparties: queryArg.counterparties,
            owners: queryArg.owners,
            templates: queryArg.templates,
            internalparties: queryArg.internalparties,
            projects: queryArg.projects,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["Contract"],
      }),
      createApiClient: build.mutation<
        CreateApiClientApiResponse,
        CreateApiClientApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/create-api-client`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      createOrganizationEntry: build.mutation<
        CreateOrganizationEntryApiResponse,
        CreateOrganizationEntryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/entries`,
          method: "POST",
          body: queryArg.createOrganizationEntryRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      getOrganizationEntry: build.query<
        GetOrganizationEntryApiResponse,
        GetOrganizationEntryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/entries/${queryArg.entryId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Organization"],
      }),
      updateOrganizationEntry: build.mutation<
        UpdateOrganizationEntryApiResponse,
        UpdateOrganizationEntryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/entries/${queryArg.entryId}`,
          method: "PUT",
          body: queryArg.updateOrganizationEntryRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      linkOrganizationEntry: build.mutation<
        LinkOrganizationEntryApiResponse,
        LinkOrganizationEntryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/entries/${queryArg.entryId}/link`,
          method: "PUT",
          body: queryArg.linkOrganizationEntryRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      getSupplierEmailInvite: build.query<
        GetSupplierEmailInviteApiResponse,
        GetSupplierEmailInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/supplier-invites/${queryArg.inviteId}`,
          params: {
            secret: queryArg.secret,
          },
        }),
        providesTags: ["EmailInvite"],
      }),
      getOrgUserEmailInvite: build.query<
        GetOrgUserEmailInviteApiResponse,
        GetOrgUserEmailInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/user-invites/${queryArg.inviteId}`,
          params: {
            secret: queryArg.secret,
          },
        }),
        providesTags: ["EmailInvite"],
      }),
      acceptOrgUserEmailInvite: build.mutation<
        AcceptOrgUserEmailInviteApiResponse,
        AcceptOrgUserEmailInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/user-invites/${queryArg.inviteId}/acceptance`,
          method: "PUT",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            secret: queryArg.secret,
          },
        }),
        invalidatesTags: ["EmailInvite"],
      }),
      listAssessmentTemplates: build.query<
        ListAssessmentTemplatesApiResponse,
        ListAssessmentTemplatesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/assessment-templates`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Assessment"],
      }),
      updateAssessment: build.mutation<
        UpdateAssessmentApiResponse,
        UpdateAssessmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/assessments/${queryArg.id}`,
          method: "PUT",
          body: queryArg.updateAssessmentRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Assessment"],
      }),
      listAssessments: build.query<
        ListAssessmentsApiResponse,
        ListAssessmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/assessments/${queryArg.orgId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Assessment"],
      }),
      listOrgsByNumber: build.query<
        ListOrgsByNumberApiResponse,
        ListOrgsByNumberApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/by-number`,
          params: {
            country: queryArg.country,
            number: queryArg["number"],
          },
        }),
        providesTags: ["Organization"],
      }),
      updateOrganization: build.mutation<
        UpdateOrganizationApiResponse,
        UpdateOrganizationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}`,
          method: "PATCH",
          body: queryArg.editOrganizationRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      listAccessGrants: build.query<
        ListAccessGrantsApiResponse,
        ListAccessGrantsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/access-grants`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.headerPersonId,
          },
          params: {
            personId: queryArg.queryPersonId,
            departmentId: queryArg.departmentId,
          },
        }),
        providesTags: ["Organization"],
      }),
      getOrganizationAiSkills: build.query<
        GetOrganizationAiSkillsApiResponse,
        GetOrganizationAiSkillsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/ai-skills`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Organization"],
      }),
      requestOrganizationAiSkillAccess: build.mutation<
        RequestOrganizationAiSkillAccessApiResponse,
        RequestOrganizationAiSkillAccessApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/ai-skills/${queryArg.skill}/access-requests`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      listAuditLog: build.query<ListAuditLogApiResponse, ListAuditLogApiArg>({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/audit-log`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            from: queryArg["from"],
            to: queryArg.to,
            person: queryArg.person,
            eventType: queryArg.eventType,
            after: queryArg.after,
            limit: queryArg.limit,
          },
        }),
        providesTags: ["Organization"],
      }),
      getAuditLogFilters: build.query<
        GetAuditLogFiltersApiResponse,
        GetAuditLogFiltersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/audit-log/filters`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Organization"],
      }),
      downloadAuditLog: build.mutation<
        DownloadAuditLogApiResponse,
        DownloadAuditLogApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/audit-log/list-export`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            format: queryArg.format,
            from: queryArg["from"],
            to: queryArg.to,
            person: queryArg.person,
            eventType: queryArg.eventType,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      listDepartments: build.query<
        ListDepartmentsApiResponse,
        ListDepartmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/departments`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Organization"],
      }),
      createDepartment: build.mutation<
        CreateDepartmentApiResponse,
        CreateDepartmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/departments`,
          method: "POST",
          body: queryArg.departmentNameRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      renameDepartment: build.mutation<
        RenameDepartmentApiResponse,
        RenameDepartmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/departments/${queryArg.departmentId}`,
          method: "PATCH",
          body: queryArg.departmentNameRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      activateDepartment: build.mutation<
        ActivateDepartmentApiResponse,
        ActivateDepartmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/departments/${queryArg.departmentId}/activate`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      deactivateDepartment: build.mutation<
        DeactivateDepartmentApiResponse,
        DeactivateDepartmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/departments/${queryArg.departmentId}/deactivate`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      assignDepartmentRole: build.mutation<
        AssignDepartmentRoleApiResponse,
        AssignDepartmentRoleApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/departments/${queryArg.departmentId}/roles`,
          method: "POST",
          body: queryArg.departmentRoleRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      revokeDepartmentRole: build.mutation<
        RevokeDepartmentRoleApiResponse,
        RevokeDepartmentRoleApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/departments/${queryArg.departmentId}/roles/revoke`,
          method: "POST",
          body: queryArg.departmentRoleRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      listDuplicateOrganizations: build.query<
        ListDuplicateOrganizationsApiResponse,
        ListDuplicateOrganizationsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/duplicates`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Organization"],
      }),
      listEntraConnections: build.query<
        ListEntraConnectionsApiResponse,
        ListEntraConnectionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/entra/connections`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Organization"],
      }),
      createEntraConnection: build.mutation<
        CreateEntraConnectionApiResponse,
        CreateEntraConnectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/entra/connections`,
          method: "POST",
          body: queryArg.createEntraConnectionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      deleteEntraConnection: build.mutation<
        DeleteEntraConnectionApiResponse,
        DeleteEntraConnectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/entra/connections/${queryArg.connectionId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      updateEntraConnection: build.mutation<
        UpdateEntraConnectionApiResponse,
        UpdateEntraConnectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/entra/connections/${queryArg.connectionId}`,
          method: "PUT",
          body: queryArg.updateEntraConnectionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      saveEntraGroupMapping: build.mutation<
        SaveEntraGroupMappingApiResponse,
        SaveEntraGroupMappingApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/entra/connections/${queryArg.connectionId}/mappings`,
          method: "PUT",
          body: queryArg.saveEntraGroupMappingRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      deleteEntraGroupMapping: build.mutation<
        DeleteEntraGroupMappingApiResponse,
        DeleteEntraGroupMappingApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/entra/connections/${queryArg.connectionId}/mappings/${queryArg.mappingId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      requestOrganizationMerge: build.mutation<
        RequestOrganizationMergeApiResponse,
        RequestOrganizationMergeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/merge-requests`,
          method: "POST",
          body: queryArg.requestOrganizationMergeRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      acceptOrganizationMerge: build.mutation<
        AcceptOrganizationMergeApiResponse,
        AcceptOrganizationMergeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/merge-requests/${queryArg.requestId}/accept`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      declineOrganizationMerge: build.mutation<
        DeclineOrganizationMergeApiResponse,
        DeclineOrganizationMergeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/merge-requests/${queryArg.requestId}/decline`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      getOrganization: build.query<
        GetOrganizationApiResponse,
        GetOrganizationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/public-profile`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Organization"],
      }),
      listSupplierEmailInvites: build.query<
        ListSupplierEmailInvitesApiResponse,
        ListSupplierEmailInvitesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/supplier-invites`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["EmailInvite"],
      }),
      createSupplierEmailInvite: build.mutation<
        CreateSupplierEmailInviteApiResponse,
        CreateSupplierEmailInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/supplier-invites`,
          method: "POST",
          body: queryArg.createEmailInviteRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["EmailInvite"],
      }),
      deleteSupplierEmailInvite: build.mutation<
        DeleteSupplierEmailInviteApiResponse,
        DeleteSupplierEmailInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/supplier-invites/${queryArg.inviteId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["EmailInvite"],
      }),
      createSupplierEmailInviteReminder: build.mutation<
        CreateSupplierEmailInviteReminderApiResponse,
        CreateSupplierEmailInviteReminderApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/supplier-invites/${queryArg.inviteId}/reminders`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["EmailInvite"],
      }),
      listOrgUserEmailInvites: build.query<
        ListOrgUserEmailInvitesApiResponse,
        ListOrgUserEmailInvitesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/user-invites`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["EmailInvite"],
      }),
      createOrgUserEmailInvite: build.mutation<
        CreateOrgUserEmailInviteApiResponse,
        CreateOrgUserEmailInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/user-invites`,
          method: "POST",
          body: queryArg.createOrgUserEmailInviteRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["EmailInvite"],
      }),
      deleteOrgUserEmailInvite: build.mutation<
        DeleteOrgUserEmailInviteApiResponse,
        DeleteOrgUserEmailInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/user-invites/${queryArg.inviteId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["EmailInvite"],
      }),
      deleteOrgUser: build.mutation<
        DeleteOrgUserApiResponse,
        DeleteOrgUserApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/users/${queryArg.userId}`,
          method: "PUT",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      updateOrgUserRole: build.mutation<
        UpdateOrgUserRoleApiResponse,
        UpdateOrgUserRoleApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/users/${queryArg.userId}/role`,
          method: "PUT",
          body: queryArg.updateOrgUserRoleRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      getContractTaskWorkload: build.query<
        GetContractTaskWorkloadApiResponse,
        GetContractTaskWorkloadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/owner/contract/orgs/${queryArg.orgId}/task-workload`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      listContractTasksForOrganization: build.query<
        ListContractTasksForOrganizationApiResponse,
        ListContractTasksForOrganizationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/owner/contract/orgs/${queryArg.orgId}/tasks`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            limit: queryArg.limit,
            after: queryArg.after,
            statuses: queryArg.statuses,
            personIds: queryArg.personIds,
            contractIds: queryArg.contractIds,
            dueBefore: queryArg.dueBefore,
            changedSince: queryArg.changedSince,
            sortBy: queryArg.sortBy,
            withCount: queryArg.withCount,
          },
        }),
        providesTags: ["Contract"],
      }),
      listContractTemplates: build.query<
        ListContractTemplatesApiResponse,
        ListContractTemplatesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/owner/contract/orgs/${queryArg.orgId}/templates`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            contractId: queryArg.contractId,
          },
        }),
        providesTags: ["Contract"],
      }),
      createContractTemplate: build.mutation<
        CreateContractTemplateApiResponse,
        CreateContractTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/owner/contract/orgs/${queryArg.orgId}/templates`,
          method: "POST",
          body: queryArg.upsertContractTemplateRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      getTask: build.query<GetTaskApiResponse, GetTaskApiArg>({
        query: (queryArg) => ({
          url: `/api/owner/contract/tasks/${queryArg.taskId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      updateContractTemplate: build.mutation<
        UpdateContractTemplateApiResponse,
        UpdateContractTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/owner/contract/templates/${queryArg.templateId}`,
          method: "PATCH",
          body: queryArg.upsertContractTemplateRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      deleteContractDraft: build.mutation<
        DeleteContractDraftApiResponse,
        DeleteContractDraftApiArg
      >({
        query: (queryArg) => ({
          url: `/api/owner/contracts/${queryArg.contractId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      getContract: build.query<GetContractApiResponse, GetContractApiArg>({
        query: (queryArg) => ({
          url: `/api/owner/contracts/${queryArg.contractId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      updateContract: build.mutation<
        UpdateContractApiResponse,
        UpdateContractApiArg
      >({
        query: (queryArg) => ({
          url: `/api/owner/contracts/${queryArg.contractId}`,
          method: "POST",
          body: queryArg.updateContractRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      copyContract: build.mutation<CopyContractApiResponse, CopyContractApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/owner/contracts/${queryArg.contractId}/copy`,
            method: "POST",
            headers: {
              cookie: queryArg.cookie,
              organizationId: queryArg.organizationId,
              personId: queryArg.personId,
            },
          }),
          invalidatesTags: ["Contract"],
        },
      ),
      publishContract: build.mutation<
        PublishContractApiResponse,
        PublishContractApiArg
      >({
        query: (queryArg) => ({
          url: `/api/owner/contracts/${queryArg.contractId}/publishing`,
          method: "PUT",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      createSignedDocument: build.mutation<
        CreateSignedDocumentApiResponse,
        CreateSignedDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/owner/contracts/${queryArg.contractId}/signed-documents`,
          method: "POST",
          body: queryArg.createSignedDocumentRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      createSignedTextDocument: build.mutation<
        CreateSignedTextDocumentApiResponse,
        CreateSignedTextDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/owner/contracts/${queryArg.contractId}/signed-text-documents`,
          method: "POST",
          body: queryArg.createSignedTextDocumentRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      listContractTasks: build.query<
        ListContractTasksApiResponse,
        ListContractTasksApiArg
      >({
        query: (queryArg) => ({
          url: `/api/owner/contracts/${queryArg.contractId}/tasks`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      createContract: build.mutation<
        CreateContractApiResponse,
        CreateContractApiArg
      >({
        query: (queryArg) => ({
          url: `/api/owner/deps/${queryArg.depId}/contracts`,
          method: "POST",
          body: queryArg.createContractRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      listPersons: build.query<ListPersonsApiResponse, ListPersonsApiArg>({
        query: (queryArg) => ({
          url: `/api/persons`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            orgIds: queryArg.orgIds,
            name: queryArg.name,
            capability: queryArg.capability,
            roles: queryArg.roles,
            departmentId: queryArg.departmentId,
            unplaced: queryArg.unplaced,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["Organization"],
      }),
      getPersonsByIds: build.query<
        GetPersonsByIdsApiResponse,
        GetPersonsByIdsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/persons-by-ids`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            personIds: queryArg.personIds,
          },
        }),
        providesTags: ["Organization"],
      }),
      getMe: build.query<GetMeApiResponse, GetMeApiArg>({
        query: (queryArg) => ({
          url: `/api/persons/me`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Me"],
      }),
      updateMe: build.mutation<UpdateMeApiResponse, UpdateMeApiArg>({
        query: (queryArg) => ({
          url: `/api/persons/me`,
          method: "PATCH",
          body: queryArg.editMeRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Me"],
      }),
      getBid: build.query<GetBidApiResponse, GetBidApiArg>({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      updateBid: build.mutation<UpdateBidApiResponse, UpdateBidApiArg>({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}`,
          method: "PUT",
          body: queryArg.bidPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      listContributingEntities: build.query<
        ListContributingEntitiesApiResponse,
        ListContributingEntitiesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/contributing-entities`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["ContributingEntity"],
      }),
      addContributingEntity: build.mutation<
        AddContributingEntityApiResponse,
        AddContributingEntityApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/contributing-entities`,
          method: "POST",
          body: queryArg.addContributingEntityRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["ContributingEntity"],
      }),
      removeContributingEntity: build.mutation<
        RemoveContributingEntityApiResponse,
        RemoveContributingEntityApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/contributing-entities/${queryArg.entityId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["ContributingEntity"],
      }),
      getContributingEntityResponse: build.query<
        GetContributingEntityResponseApiResponse,
        GetContributingEntityResponseApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/contributing-entities/${queryArg.entityId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["ContributingEntity"],
      }),
      updateContributingEntity: build.mutation<
        UpdateContributingEntityApiResponse,
        UpdateContributingEntityApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/contributing-entities/${queryArg.entityId}`,
          method: "PUT",
          body: queryArg.updateContributingEntityRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["ContributingEntity"],
      }),
      resendContributingEntityInvitation: build.mutation<
        ResendContributingEntityInvitationApiResponse,
        ResendContributingEntityInvitationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/contributing-entities/${queryArg.entityId}/reminders`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["ContributingEntity"],
      }),
      reopenContributingEntityResponse: build.mutation<
        ReopenContributingEntityResponseApiResponse,
        ReopenContributingEntityResponseApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/contributing-entities/${queryArg.entityId}/reopen`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["ContributingEntity"],
      }),
      previewBidReport: build.query<
        PreviewBidReportApiResponse,
        PreviewBidReportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/report`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      startBidSigning: build.mutation<
        StartBidSigningApiResponse,
        StartBidSigningApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/signing`,
          method: "POST",
          body: queryArg.startBidSigningRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      cancelBidSigning: build.mutation<
        CancelBidSigningApiResponse,
        CancelBidSigningApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/signing/cancel`,
          method: "POST",
          body: queryArg.cancelBidSigningRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      getBidSigningPreflight: build.query<
        GetBidSigningPreflightApiResponse,
        GetBidSigningPreflightApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/signing/preflight`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      acceptBidTerms: build.mutation<
        AcceptBidTermsApiResponse,
        AcceptBidTermsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/terms`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      createUploadForBid: build.mutation<
        CreateUploadForBidApiResponse,
        CreateUploadForBidApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      withdrawBid: build.mutation<WithdrawBidApiResponse, WithdrawBidApiArg>({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/withdraw`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      getContributingEntity: build.query<
        GetContributingEntityApiResponse,
        GetContributingEntityApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/contributing-entities/${queryArg.entityId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["ContributingEntity"],
      }),
      updateContributingEntityResponse: build.mutation<
        UpdateContributingEntityResponseApiResponse,
        UpdateContributingEntityResponseApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/contributing-entities/${queryArg.entityId}`,
          method: "PUT",
          body: queryArg.updateContributingEntityResponseRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["ContributingEntity"],
      }),
      updateContributingEntityCommitment: build.mutation<
        UpdateContributingEntityCommitmentApiResponse,
        UpdateContributingEntityCommitmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/contributing-entities/${queryArg.entityId}/commitment`,
          method: "PUT",
          body: queryArg.updateContributingEntityCommitmentRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["ContributingEntity"],
      }),
      updateContributingEntityQualificationResponses: build.mutation<
        UpdateContributingEntityQualificationResponsesApiResponse,
        UpdateContributingEntityQualificationResponsesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/contributing-entities/${queryArg.entityId}/qualification-responses`,
          method: "PUT",
          body: queryArg.updateContributingEntityQualificationResponsesRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["ContributingEntity"],
      }),
      submitContributingEntityResponse: build.mutation<
        SubmitContributingEntityResponseApiResponse,
        SubmitContributingEntityResponseApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/contributing-entities/${queryArg.entityId}/response`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["ContributingEntity"],
      }),
      getPortalSourcingEvents: build.query<
        GetPortalSourcingEventsApiResponse,
        GetPortalSourcingEventsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events`,
          params: {
            cursor: queryArg.cursor,
            limit: queryArg.limit,
            q: queryArg.q,
            lifecycle: queryArg.lifecycle,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      getPortalSourcingEvent: build.query<
        GetPortalSourcingEventApiResponse,
        GetPortalSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}`,
        }),
        providesTags: ["SourcingEvent"],
      }),
      getPortalSeAttachmentUpload: build.query<
        GetPortalSeAttachmentUploadApiResponse,
        GetPortalSeAttachmentUploadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/attachment-uploads/${queryArg.uploadId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Upload"],
      }),
      getPortalAwardLetter: build.query<
        GetPortalAwardLetterApiResponse,
        GetPortalAwardLetterApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/award-letter`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      createBid: build.mutation<CreateBidApiResponse, CreateBidApiArg>({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/bids`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      getPortalDocumentDownloadLink: build.query<
        GetPortalDocumentDownloadLinkApiResponse,
        GetPortalDocumentDownloadLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/documents/${queryArg.documentId}/link`,
        }),
        providesTags: ["SourcingEvent"],
      }),
      getPortalMyBidDocuments: build.query<
        GetPortalMyBidDocumentsApiResponse,
        GetPortalMyBidDocumentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/my-bid-documents`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      createParticipationRequest: build.mutation<
        CreateParticipationRequestApiResponse,
        CreateParticipationRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/participation-requests`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      getMyParticipation: build.query<
        GetMyParticipationApiResponse,
        GetMyParticipationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/participation-requests/mine`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      createUploadForSeQuestionAttachment: build.mutation<
        CreateUploadForSeQuestionAttachmentApiResponse,
        CreateUploadForSeQuestionAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/question-attachment-uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      getPortalSeQuestions: build.query<
        GetPortalSeQuestionsApiResponse,
        GetPortalSeQuestionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/questions`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      askSeQuestion: build.mutation<
        AskSeQuestionApiResponse,
        AskSeQuestionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/questions`,
          method: "POST",
          body: queryArg.createSeQuestionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      sendSeClarificationMessageAsSupplier: build.mutation<
        SendSeClarificationMessageAsSupplierApiResponse,
        SendSeClarificationMessageAsSupplierApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/questions/${queryArg.questionId}/messages`,
          method: "POST",
          body: queryArg.createSeQuestionMessageRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      registerPortalInterest: build.mutation<
        RegisterPortalInterestApiResponse,
        RegisterPortalInterestApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/register-interest`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      getPortalRegistrationStatus: build.query<
        GetPortalRegistrationStatusApiResponse,
        GetPortalRegistrationStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/registration-status`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      getPortalSupplierInformation: build.query<
        GetPortalSupplierInformationApiResponse,
        GetPortalSupplierInformationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/supplier-information`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      getPortalMarketDialogue: build.query<
        GetPortalMarketDialogueApiResponse,
        GetPortalMarketDialogueApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/market-dialogues/${queryArg.marketDialogueId}`,
        }),
        providesTags: ["MarketDialogue"],
      }),
      getPortalMarketDialogueDocumentDownloadLink: build.query<
        GetPortalMarketDialogueDocumentDownloadLinkApiResponse,
        GetPortalMarketDialogueDocumentDownloadLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/market-dialogues/${queryArg.marketDialogueId}/documents/${queryArg.documentId}/link`,
        }),
        providesTags: ["MarketDialogue"],
      }),
      getAuthenticatedPortalSourcingEvents: build.query<
        GetAuthenticatedPortalSourcingEventsApiResponse,
        GetAuthenticatedPortalSourcingEventsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/events`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            cursor: queryArg.cursor,
            limit: queryArg.limit,
            q: queryArg.q,
            context: queryArg.context,
            scope: queryArg.scope,
            lifecycle: queryArg.lifecycle,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      getAuthenticatedPortalSourcingEvent: build.query<
        GetAuthenticatedPortalSourcingEventApiResponse,
        GetAuthenticatedPortalSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/events/${queryArg.eventId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      acceptPortalInvite: build.mutation<
        AcceptPortalInviteApiResponse,
        AcceptPortalInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/events/${queryArg.eventId}/accept-invite`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      createPortalInitialBid: build.mutation<
        CreatePortalInitialBidApiResponse,
        CreatePortalInitialBidApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/events/${queryArg.eventId}/bids`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      submitPortalPrivateBid: build.mutation<
        SubmitPortalPrivateBidApiResponse,
        SubmitPortalPrivateBidApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/events/${queryArg.eventId}/bids/${queryArg.bidId}/submission`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "SourcingEvent"],
      }),
      withdrawPortalPrivateBid: build.mutation<
        WithdrawPortalPrivateBidApiResponse,
        WithdrawPortalPrivateBidApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/events/${queryArg.eventId}/bids/${queryArg.bidId}/withdrawal`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "SourcingEvent"],
      }),
      declinePortalInvite: build.mutation<
        DeclinePortalInviteApiResponse,
        DeclinePortalInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/events/${queryArg.eventId}/decline-invite`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      getPortalNegotiationRounds: build.query<
        GetPortalNegotiationRoundsApiResponse,
        GetPortalNegotiationRoundsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/events/${queryArg.eventId}/negotiation-rounds`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      createPortalRoundBid: build.mutation<
        CreatePortalRoundBidApiResponse,
        CreatePortalRoundBidApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}/bids`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      withdrawPortalNegotiationRoundDecline: build.mutation<
        WithdrawPortalNegotiationRoundDeclineApiResponse,
        WithdrawPortalNegotiationRoundDeclineApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}/declination`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      declinePortalNegotiationRound: build.mutation<
        DeclinePortalNegotiationRoundApiResponse,
        DeclinePortalNegotiationRoundApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}/declination`,
          method: "PUT",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      confirmPortalStandingBid: build.mutation<
        ConfirmPortalStandingBidApiResponse,
        ConfirmPortalStandingBidApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}/standing-bid-confirmation`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      getPortalFrameworkAgreements: build.query<
        GetPortalFrameworkAgreementsApiResponse,
        GetPortalFrameworkAgreementsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/framework-agreements`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["FrameworkAgreement"],
      }),
      acceptMarketDialogueInvite: build.mutation<
        AcceptMarketDialogueInviteApiResponse,
        AcceptMarketDialogueInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/market-dialogue-invites/${queryArg.inviteId}/acceptance`,
          method: "PUT",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            secret: queryArg.secret,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      getSupplierMarketDialogue: build.query<
        GetSupplierMarketDialogueApiResponse,
        GetSupplierMarketDialogueApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/market-dialogues/${queryArg.marketDialogueId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["MarketDialogue"],
      }),
      saveMarketDialogueAnswer: build.mutation<
        SaveMarketDialogueAnswerApiResponse,
        SaveMarketDialogueAnswerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/market-dialogues/${queryArg.marketDialogueId}/answer`,
          method: "PUT",
          body: queryArg.saveMarketDialogueAnswerRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      removeMarketDialogueAnswerDocument: build.mutation<
        RemoveMarketDialogueAnswerDocumentApiResponse,
        RemoveMarketDialogueAnswerDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/market-dialogues/${queryArg.marketDialogueId}/answer/documents/${queryArg.documentId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      sendMarketDialogueAnswer: build.mutation<
        SendMarketDialogueAnswerApiResponse,
        SendMarketDialogueAnswerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/market-dialogues/${queryArg.marketDialogueId}/answer/send`,
          method: "POST",
          body: queryArg.saveMarketDialogueAnswerRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      createUploadForMarketDialogueAnswer: build.mutation<
        CreateUploadForMarketDialogueAnswerApiResponse,
        CreateUploadForMarketDialogueAnswerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/market-dialogues/${queryArg.marketDialogueId}/answer/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createMarketDialogueAnswerUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      getSupplierMarketDialogueDocumentDownloadLink: build.query<
        GetSupplierMarketDialogueDocumentDownloadLinkApiResponse,
        GetSupplierMarketDialogueDocumentDownloadLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/market-dialogues/${queryArg.marketDialogueId}/documents/${queryArg.documentId}/link`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["MarketDialogue"],
      }),
      askMarketDialogueQuestion: build.mutation<
        AskMarketDialogueQuestionApiResponse,
        AskMarketDialogueQuestionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/market-dialogues/${queryArg.marketDialogueId}/questions`,
          method: "POST",
          body: queryArg.askSupplierQuestionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      getPortalMyBids: build.query<
        GetPortalMyBidsApiResponse,
        GetPortalMyBidsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/my-bids`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      listMyContributions: build.query<
        ListMyContributionsApiResponse,
        ListMyContributionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/my-contributions`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["ContributingEntity"],
      }),
      listMyParticipationRequests: build.query<
        ListMyParticipationRequestsApiResponse,
        ListMyParticipationRequestsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/participation-requests`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      getParticipationRequest: build.query<
        GetParticipationRequestApiResponse,
        GetParticipationRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/participation-requests/${queryArg.requestId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      updateParticipationRequest: build.mutation<
        UpdateParticipationRequestApiResponse,
        UpdateParticipationRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/participation-requests/${queryArg.requestId}`,
          method: "PUT",
          body: queryArg.participationRequestPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      submitParticipationRequest: build.mutation<
        SubmitParticipationRequestApiResponse,
        SubmitParticipationRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/participation-requests/${queryArg.requestId}/submit`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      withdrawParticipationRequest: build.mutation<
        WithdrawParticipationRequestApiResponse,
        WithdrawParticipationRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/participation-requests/${queryArg.requestId}/withdraw`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      editProductGroup: build.mutation<
        EditProductGroupApiResponse,
        EditProductGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/api/products/group`,
          method: "PATCH",
          body: queryArg.editProductGroupDto,
        }),
        invalidatesTags: ["Product", "SourcingEvent"],
      }),
      createProductGroup: build.mutation<
        CreateProductGroupApiResponse,
        CreateProductGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/api/products/group`,
          method: "POST",
          body: queryArg.createProductGroupDto,
        }),
        invalidatesTags: ["Product", "SourcingEvent"],
      }),
      deleteProductGroup: build.mutation<
        DeleteProductGroupApiResponse,
        DeleteProductGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/api/products/group/${queryArg.productGroupId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Product", "SourcingEvent"],
      }),
      getProductGroupsForProject: build.query<
        GetProductGroupsForProjectApiResponse,
        GetProductGroupsForProjectApiArg
      >({
        query: (queryArg) => ({
          url: `/api/products/project/groups/${queryArg.projectId}`,
        }),
        providesTags: ["Product", "Project"],
      }),
      getProductTemplates: build.query<
        GetProductTemplatesApiResponse,
        GetProductTemplatesApiArg
      >({
        query: () => ({ url: `/api/products/templates` }),
        providesTags: ["Product"],
      }),
      createProject: build.mutation<
        CreateProjectApiResponse,
        CreateProjectApiArg
      >({
        query: (queryArg) => ({
          url: `/api/project`,
          method: "POST",
          body: queryArg.createProjectRequest,
        }),
        invalidatesTags: ["Project"],
      }),
      createProjectTextDocument: build.mutation<
        CreateProjectTextDocumentApiResponse,
        CreateProjectTextDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/project/text-document`,
          method: "POST",
          body: queryArg.createProjectTextDocumentRequest,
        }),
        invalidatesTags: ["Project", "TextDocument"],
      }),
      listTextDocumentsForProject: build.query<
        ListTextDocumentsForProjectApiResponse,
        ListTextDocumentsForProjectApiArg
      >({
        query: (queryArg) => ({
          url: `/api/project/text-documents/${queryArg.projectId}`,
        }),
        providesTags: ["Project", "TextDocument"],
      }),
      getProject: build.query<GetProjectApiResponse, GetProjectApiArg>({
        query: (queryArg) => ({ url: `/api/project/${queryArg.projectId}` }),
        providesTags: ["Project"],
      }),
      updateProject: build.mutation<
        UpdateProjectApiResponse,
        UpdateProjectApiArg
      >({
        query: (queryArg) => ({
          url: `/api/project/${queryArg.projectId}`,
          method: "PATCH",
          body: queryArg.projectPatchDto,
        }),
        invalidatesTags: ["Project"],
      }),
      getProjects: build.query<GetProjectsApiResponse, GetProjectsApiArg>({
        query: (queryArg) => ({
          url: `/api/projects`,
          params: {
            name: queryArg.name,
            status: queryArg.status,
            limit: queryArg.limit,
            skip: queryArg.skip,
            withCount: queryArg.withCount,
          },
        }),
        providesTags: ["Project"],
      }),
      getProjectsByIds: build.query<
        GetProjectsByIdsApiResponse,
        GetProjectsByIdsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects-by-ids`,
          params: {
            projectIds: queryArg.projectIds,
          },
        }),
        providesTags: ["Project"],
      }),
      getProjectOverview: build.query<
        GetProjectOverviewApiResponse,
        GetProjectOverviewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/overview`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            scope: queryArg.scope,
            projectTypeId: queryArg.projectTypeId,
          },
        }),
        providesTags: ["Project"],
      }),
      createUploadForProjectDescription: build.mutation<
        CreateUploadForProjectDescriptionApiResponse,
        CreateUploadForProjectDescriptionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${queryArg.projectId}/description/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      getProjectProcurementSummary: build.query<
        GetProjectProcurementSummaryApiResponse,
        GetProjectProcurementSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${queryArg.projectId}/procurement-summary`,
        }),
        providesTags: ["Project"],
      }),
      downloadProjectProcurementSummaryPdf: build.query<
        DownloadProjectProcurementSummaryPdfApiResponse,
        DownloadProjectProcurementSummaryPdfApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${queryArg.projectId}/procurement-summary/pdf`,
        }),
        providesTags: ["Project"],
      }),
      createUploadForProject: build.mutation<
        CreateUploadForProjectApiResponse,
        CreateUploadForProjectApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${queryArg.projectId}/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      listSavedReports: build.query<
        ListSavedReportsApiResponse,
        ListSavedReportsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/saved-reports`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SavedReport"],
      }),
      createSavedReport: build.mutation<
        CreateSavedReportApiResponse,
        CreateSavedReportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/saved-reports`,
          method: "POST",
          body: queryArg.createSavedReportRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SavedReport"],
      }),
      deleteSavedReport: build.mutation<
        DeleteSavedReportApiResponse,
        DeleteSavedReportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/saved-reports/${queryArg.savedReportId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SavedReport"],
      }),
      renameSavedReport: build.mutation<
        RenameSavedReportApiResponse,
        RenameSavedReportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/saved-reports/${queryArg.savedReportId}`,
          method: "PUT",
          body: queryArg.renameSavedReportRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SavedReport"],
      }),
      replaceSavedReportQuery: build.mutation<
        ReplaceSavedReportQueryApiResponse,
        ReplaceSavedReportQueryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/saved-reports/${queryArg.savedReportId}/query`,
          method: "PUT",
          body: queryArg.replaceSavedReportQueryRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SavedReport"],
      }),
      shareSavedReport: build.mutation<
        ShareSavedReportApiResponse,
        ShareSavedReportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/saved-reports/${queryArg.savedReportId}/shares`,
          method: "POST",
          body: queryArg.shareSavedReportRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SavedReport"],
      }),
      stopSharingSavedReport: build.mutation<
        StopSharingSavedReportApiResponse,
        StopSharingSavedReportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/saved-reports/${queryArg.savedReportId}/shares/${queryArg.pathPersonId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.headerPersonId,
          },
        }),
        invalidatesTags: ["SavedReport"],
      }),
      getGroups: build.query<GetGroupsApiResponse, GetGroupsApiArg>({
        query: (queryArg) => ({
          url: `/api/scim/Groups`,
          headers: {
            authorization: queryArg.authorization,
          },
        }),
        providesTags: ["Scim"],
      }),
      createGroup: build.mutation<CreateGroupApiResponse, CreateGroupApiArg>({
        query: (queryArg) => ({
          url: `/api/scim/Groups`,
          method: "POST",
          body: queryArg.createGroupDto,
          headers: {
            authorization: queryArg.authorization,
          },
        }),
        invalidatesTags: ["Scim"],
      }),
      deleteGroup: build.mutation<DeleteGroupApiResponse, DeleteGroupApiArg>({
        query: (queryArg) => ({
          url: `/api/scim/Groups/${queryArg.groupId}`,
          method: "DELETE",
          headers: {
            authorization: queryArg.authorization,
          },
        }),
        invalidatesTags: ["Scim"],
      }),
      getGroup: build.query<GetGroupApiResponse, GetGroupApiArg>({
        query: (queryArg) => ({
          url: `/api/scim/Groups/${queryArg.groupId}`,
          headers: {
            authorization: queryArg.authorization,
          },
          params: {
            count: queryArg.count,
            startIndex: queryArg.startIndex,
          },
        }),
        providesTags: ["Scim"],
      }),
      updateGroup: build.mutation<UpdateGroupApiResponse, UpdateGroupApiArg>({
        query: (queryArg) => ({
          url: `/api/scim/Groups/${queryArg.groupId}`,
          method: "PATCH",
          body: queryArg.updateGroupRequest,
          headers: {
            authorization: queryArg.authorization,
          },
        }),
        invalidatesTags: ["Scim"],
      }),
      getSchemas: build.query<GetSchemasApiResponse, GetSchemasApiArg>({
        query: () => ({ url: `/api/scim/Schemas` }),
        providesTags: ["Scim"],
      }),
      getToken: build.query<GetTokenApiResponse, GetTokenApiArg>({
        query: (queryArg) => ({
          url: `/api/scim/Token`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
            authorization: queryArg.authorization,
          },
        }),
        providesTags: ["Scim"],
      }),
      getTokenForConnection: build.query<
        GetTokenForConnectionApiResponse,
        GetTokenForConnectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/scim/Token/${queryArg.connectionId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
            authorization: queryArg.authorization,
          },
        }),
        providesTags: ["Scim"],
      }),
      getUsers: build.query<GetUsersApiResponse, GetUsersApiArg>({
        query: (queryArg) => ({
          url: `/api/scim/Users`,
          headers: {
            authorization: queryArg.authorization,
          },
        }),
        providesTags: ["Scim"],
      }),
      createUser: build.mutation<CreateUserApiResponse, CreateUserApiArg>({
        query: (queryArg) => ({
          url: `/api/scim/Users`,
          method: "POST",
          body: queryArg.createUserDto,
          headers: {
            authorization: queryArg.authorization,
          },
        }),
        invalidatesTags: ["Scim"],
      }),
      deleteUser: build.mutation<DeleteUserApiResponse, DeleteUserApiArg>({
        query: (queryArg) => ({
          url: `/api/scim/Users/${queryArg.userId}`,
          method: "DELETE",
          headers: {
            authorization: queryArg.authorization,
          },
        }),
        invalidatesTags: ["Scim"],
      }),
      getUser: build.query<GetUserApiResponse, GetUserApiArg>({
        query: (queryArg) => ({
          url: `/api/scim/Users/${queryArg.userId}`,
          headers: {
            authorization: queryArg.authorization,
          },
        }),
        providesTags: ["Scim"],
      }),
      updateUser: build.mutation<UpdateUserApiResponse, UpdateUserApiArg>({
        query: (queryArg) => ({
          url: `/api/scim/Users/${queryArg.userId}`,
          method: "PATCH",
          headers: {
            authorization: queryArg.authorization,
          },
        }),
        invalidatesTags: ["Scim"],
      }),
      searchOrganizationsAndEntries: build.query<
        SearchOrganizationsAndEntriesApiResponse,
        SearchOrganizationsAndEntriesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/search/orgs`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            name: queryArg.name,
            organizationNumber: queryArg.organizationNumber,
            limit: queryArg.limit,
            skip: queryArg.skip,
            type: queryArg["type"],
            excludeLinkedEntries: queryArg.excludeLinkedEntries,
            counties: queryArg.counties,
            municipalities: queryArg.municipalities,
            naceCodes: queryArg.naceCodes,
            relations: queryArg.relations,
            withRelations: queryArg.withRelations,
            withoutRelations: queryArg.withoutRelations,
            withFacets: queryArg.withFacets,
            excludeOwnOrganization: queryArg.excludeOwnOrganization,
            contractField: queryArg.contractField,
            contractFieldAtLeast: queryArg.contractFieldAtLeast,
            contractFieldPeriod: queryArg.contractFieldPeriod,
            contractEndDateFrom: queryArg.contractEndDateFrom,
            contractEndDateTo: queryArg.contractEndDateTo,
          },
        }),
        providesTags: ["Organization", "Search"],
      }),
      updateSignedDocumentMeta: build.mutation<
        UpdateSignedDocumentMetaApiResponse,
        UpdateSignedDocumentMetaApiArg
      >({
        query: (queryArg) => ({
          url: `/api/signed/docs/${queryArg.docId}`,
          method: "PUT",
          body: queryArg.updateSignedDocumentMetaRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Document"],
      }),
      getSignedDocumentDownloadLink: build.query<
        GetSignedDocumentDownloadLinkApiResponse,
        GetSignedDocumentDownloadLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/signed/docs/${queryArg.docId}/link`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Document"],
      }),
      getSignedAttachmentDownloadLink: build.query<
        GetSignedAttachmentDownloadLinkApiResponse,
        GetSignedAttachmentDownloadLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/signed/docs/${queryArg.docId}/link/${queryArg.attachmentId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Document"],
      }),
      listSourcingEventTemplates: build.query<
        ListSourcingEventTemplatesApiResponse,
        ListSourcingEventTemplatesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/sourcing-event-template`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEventTemplate"],
      }),
      createSourcingEventTemplate: build.mutation<
        CreateSourcingEventTemplateApiResponse,
        CreateSourcingEventTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/sourcing-event-template`,
          method: "POST",
          body: queryArg.createSourcingEventTemplateRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEventTemplate"],
      }),
      updateSourcingEventTemplate: build.mutation<
        UpdateSourcingEventTemplateApiResponse,
        UpdateSourcingEventTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/sourcing-event-template`,
          method: "PUT",
          body: queryArg.updateSourcingEventTemplateRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEventTemplate"],
      }),
      deleteSourcingEventTemplate: build.mutation<
        DeleteSourcingEventTemplateApiResponse,
        DeleteSourcingEventTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/sourcing-event-template/${queryArg.id}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEventTemplate"],
      }),
      createSourcingEventTextDocument: build.mutation<
        CreateSourcingEventTextDocumentApiResponse,
        CreateSourcingEventTextDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/sourcing-event-v2/text-documents`,
          method: "POST",
          body: queryArg.createSourcingEventTextDocumentRequest,
        }),
        invalidatesTags: ["SourcingEvent", "TextDocument"],
      }),
      listTextDocumentsForSourcingEvent: build.query<
        ListTextDocumentsForSourcingEventApiResponse,
        ListTextDocumentsForSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/sourcing-event-v2/text-documents/${queryArg.eventId}`,
        }),
        providesTags: ["SourcingEvent", "TextDocument"],
      }),
      getProcurementCommentRounds: build.query<
        GetProcurementCommentRoundsApiResponse,
        GetProcurementCommentRoundsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/sourcing-events/${queryArg.sourcingEventId}/comment-rounds`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["MarketDialogue"],
      }),
      sendProcurementForComment: build.mutation<
        SendProcurementForCommentApiResponse,
        SendProcurementForCommentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/sourcing-events/${queryArg.sourcingEventId}/comment-rounds`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["MarketDialogue"],
      }),
      getSeEmailInvite: build.query<
        GetSeEmailInviteApiResponse,
        GetSeEmailInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/event/invites/${queryArg.inviteId}`,
          params: {
            secret: queryArg.secret,
          },
        }),
        providesTags: ["EmailInvite"],
      }),
      acceptSeEmailInvite: build.mutation<
        AcceptSeEmailInviteApiResponse,
        AcceptSeEmailInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/event/invites/${queryArg.inviteId}/acceptance`,
          method: "PUT",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            secret: queryArg.secret,
          },
        }),
        invalidatesTags: ["EmailInvite"],
      }),
      getProductGroupsAsSupplier: build.query<
        GetProductGroupsAsSupplierApiResponse,
        GetProductGroupsAsSupplierApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/products/sourcing/groups/${queryArg.sourcingEventId}`,
        }),
        providesTags: ["Product", "SourcingEvent"],
      }),
      createUploadForBidAwardCriterionAttachment: build.mutation<
        CreateUploadForBidAwardCriterionAttachmentApiResponse,
        CreateUploadForBidAwardCriterionAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/public/bids/${queryArg.bidId}/award-criterion-attachments/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createBidAwardCriterionAttachmentUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      createUploadForBidMinimumRequirementAttachment: build.mutation<
        CreateUploadForBidMinimumRequirementAttachmentApiResponse,
        CreateUploadForBidMinimumRequirementAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/public/bids/${queryArg.bidId}/minimum-requirement-attachments/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createBidMinimumRequirementAttachmentUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      createUploadForBidQualificationEvidence: build.mutation<
        CreateUploadForBidQualificationEvidenceApiResponse,
        CreateUploadForBidQualificationEvidenceApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/public/bids/${queryArg.bidId}/qualification-evidence/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createBidQualificationEvidenceUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      updateTextDocument: build.mutation<
        UpdateTextDocumentApiResponse,
        UpdateTextDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/text-documents`,
          method: "PUT",
          body: queryArg.updateTextDocumentRequest,
        }),
        invalidatesTags: ["TextDocument"],
      }),
      deleteTextDocument: build.mutation<
        DeleteTextDocumentApiResponse,
        DeleteTextDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/text-documents/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["TextDocument"],
      }),
      getTextDocumentUploadStatus: build.query<
        GetTextDocumentUploadStatusApiResponse,
        GetTextDocumentUploadStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/text-documents/${queryArg.textDocumentId}/uploads/${queryArg.uploadId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Upload"],
      }),
      createUploadForTextDocument: build.mutation<
        CreateUploadForTextDocumentApiResponse,
        CreateUploadForTextDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/text-documents/${queryArg.textDocumentId}/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      deleteUpload: build.mutation<DeleteUploadApiResponse, DeleteUploadApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/uploads/${queryArg.uploadId}`,
            method: "DELETE",
            headers: {
              cookie: queryArg.cookie,
              organizationId: queryArg.organizationId,
              personId: queryArg.personId,
            },
          }),
          invalidatesTags: ["Upload"],
        },
      ),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as bffApi };
export type AdminListAllEntitiesApiResponse = /** status 200 OK */ String;
export type AdminListAllEntitiesApiArg = {
  entityType: AdminEntityType;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type AdminMigrateFencyDocumentsApiResponse =
  /** status 200 OK */ AdminMigrateFencyResponse;
export type AdminMigrateFencyDocumentsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  adminMigrateFencyRequest: AdminMigrateFencyRequest;
};
export type AdminRestampFencyAccessApiResponse =
  /** status 200 OK */ AdminMigrateFencyResponse;
export type AdminRestampFencyAccessApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  adminRestampFencyAccessRequest: AdminRestampFencyAccessRequest;
};
export type AdminMigrateFencyContractMetadataApiResponse =
  /** status 200 OK */ AdminMigrateFencyResponse;
export type AdminMigrateFencyContractMetadataApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  adminMigrateFencyContractMetadataRequest: AdminMigrateFencyContractMetadataRequest;
};
export type AdminGetFencyMigrationStatsApiResponse =
  /** status 200 OK */ AdminFencyMigrationStatsResponse;
export type AdminGetFencyMigrationStatsApiArg = {
  targetOrganizationId?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type AdminListOrganizationsApiResponse =
  /** status 200 OK */ AdminListOrganizationsResponse;
export type AdminListOrganizationsApiArg = {
  skip?: number;
  limit?: number;
  name?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type AdminUpdateOrganizationApiResponse = /** status 200 OK */ OrgDto;
export type AdminUpdateOrganizationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  adminUpdateOrganizationRequest: AdminUpdateOrganizationRequest;
};
export type AdminGetOrganizationAiUsageApiResponse =
  /** status 200 OK */ AdminAiUsageDto;
export type AdminGetOrganizationAiUsageApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type AdminChangeOrganizationOwnerApiResponse =
  /** status 200 OK */ OrgDto;
export type AdminChangeOrganizationOwnerApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  adminChangeOrganizationOwnerRequest: AdminChangeOrganizationOwnerRequest;
};
export type SendAiChatMessageApiResponse = /** status 200 OK */ AiChatResponse;
export type SendAiChatMessageApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  aiChatRequest: AiChatRequest;
};
export type CreateAiCompletionApiResponse =
  /** status 200 OK */ AiCompletionDto;
export type CreateAiCompletionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createAiCompletionRequest: CreateAiCompletionRequest;
};
export type RecordAiSuggestionInsertedApiResponse = unknown;
export type RecordAiSuggestionInsertedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  aiSuggestionInsertedRequest: AiSuggestionInsertedRequest;
};
export type CreateAssessmentTemplateApiResponse =
  /** status 201 Created */ AssessmentTemplateDto;
export type CreateAssessmentTemplateApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createAssessmentTemplateRequestDto: CreateAssessmentTemplateRequestDto;
};
export type GetAssessmentTemplateApiResponse =
  /** status 200 OK */ AssessmentTemplateDto;
export type GetAssessmentTemplateApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  id: string;
};
export type CreateAssessmentApiResponse =
  /** status 201 Created */ AssessmentDto;
export type CreateAssessmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createAssessmentRequestDto: CreateAssessmentRequestDto;
};
export type GetAssessmentApiResponse = /** status 200 OK */ AssessmentDto;
export type GetAssessmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  id: string;
};
export type GetBaseDataApiResponse = /** status 200 OK */ BaseDataDto;
export type GetBaseDataApiArg = void;
export type GetTypesApiResponse = /** status 200 OK */ AllTypes;
export type GetTypesApiArg = void;
export type RecordAgentAuditEntryApiResponse = unknown;
export type RecordAgentAuditEntryApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  agentAuditEntryDto: AgentAuditEntryDto;
};
export type ReadConversationFileApiResponse =
  /** status 200 OK */ AgentDocumentTextDto;
export type ReadConversationFileApiArg = {
  /** The document id of a file in this conversation */
  documentId: string;
  /** The part to start reading at: 1, or nextPart */
  fromPart?: number;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type CreateConversationFileUploadApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateConversationFileUploadApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type GetConversationFileStatusApiResponse =
  /** status 200 OK */ ConversationFileStatusDto;
export type GetConversationFileStatusApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  uploadId: string;
};
export type ListAgentConversationsApiResponse =
  /** status 200 OK */ ListAgentConversationsResponse;
export type ListAgentConversationsApiArg = {
  limit?: number;
  before?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type CreateAgentConversationApiResponse =
  /** status 201 Created */ AgentConversationDto;
export type CreateAgentConversationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createAgentConversationRequest: CreateAgentConversationRequest;
};
export type DeleteAgentConversationApiResponse = unknown;
export type DeleteAgentConversationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  conversationId: string;
};
export type GetAgentConversationApiResponse =
  /** status 200 OK */ AgentConversationDto;
export type GetAgentConversationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  conversationId: string;
};
export type UpdateAgentConversationApiResponse =
  /** status 200 OK */ AgentConversationDto;
export type UpdateAgentConversationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  conversationId: string;
  updateAgentConversationRequest: UpdateAgentConversationRequest;
};
export type CreateAgentDocumentSearchSessionApiResponse =
  /** status 200 OK */ AgentDocumentSearchSessionDto;
export type CreateAgentDocumentSearchSessionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createAgentDocumentSearchSessionRequest: CreateAgentDocumentSearchSessionRequest;
};
export type ResolveAgentDocumentSourcesApiResponse =
  /** status 200 OK */ AgentDocumentSourcesDto;
export type ResolveAgentDocumentSourcesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  resolveAgentDocumentSourcesRequest: ResolveAgentDocumentSourcesRequest;
};
export type ReadDocumentTextApiResponse =
  /** status 200 OK */ AgentDocumentTextDto;
export type ReadDocumentTextApiArg = {
  /** The uploaded document's id */
  documentId?: string;
  /** The signed document's id */
  signedDocumentId?: string;
  /** The part to start reading at: 1, or nextPart */
  fromPart?: number;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type GetAgentModelsApiResponse = /** status 200 OK */ AgentModelsDto;
export type GetAgentModelsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type PlanAgentTurnApiResponse =
  /** status 200 OK */ AgentPlanResponseDto;
export type PlanAgentTurnApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  agentPlanRequestDto: AgentPlanRequestDto;
};
export type RemoveContactPersonApiResponse =
  /** status 200 OK */ ListContactPersonsResponse;
export type RemoveContactPersonApiArg = {
  email: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  subjectType: ContactSubjectType;
  subjectId: string;
};
export type ListContactPersonsApiResponse =
  /** status 200 OK */ ListContactPersonsResponse;
export type ListContactPersonsApiArg = {
  name?: string;
  limit?: number;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  subjectType: ContactSubjectType;
  subjectId: string;
};
export type AddContactPersonApiResponse =
  /** status 200 OK */ ListContactPersonsResponse;
export type AddContactPersonApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  subjectType: ContactSubjectType;
  subjectId: string;
  addContactPersonRequest: AddContactPersonRequest;
};
export type EditContactPersonApiResponse =
  /** status 200 OK */ ListContactPersonsResponse;
export type EditContactPersonApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  subjectType: ContactSubjectType;
  subjectId: string;
  editContactPersonRequest: EditContactPersonRequest;
};
export type GetExclusionGroundsTaxonomyApiResponse =
  /** status 200 OK */ ExclusionGroundsTaxonomyResponse;
export type GetExclusionGroundsTaxonomyApiArg = {
  regulation?: Regulation;
  buyerLegalType?: BuyerLegalType;
};
export type CreateSourcingEventApiResponse =
  /** status 201 Created */ SourcingEventDto;
export type CreateSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createSourcingEventRequest: CreateSourcingEventRequest;
};
export type DeleteSourcingEventApiResponse = unknown;
export type DeleteSourcingEventApiArg = {
  /** Discard the procurement only while its creation interview is unsaved; refuses with InterviewAlreadySaved otherwise. */
  unsavedInterviewOnly?: boolean;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type GetSourcingEventApiResponse = /** status 200 OK */ SourcingEventDto;
export type GetSourcingEventApiArg = {
  /** Defaults to true. False reads the event without adding it to the person's recently viewed list. */
  recordView?: boolean;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type UpdateSourcingEventApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type UpdateSourcingEventApiArg = {
  /** Runs every check and answers as the save would, but saves nothing. */
  dryRun?: boolean;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  sourcingEventPatchDto: SourcingEventPatchDto;
};
export type CreateUploadForSeAnnouncementAttachmentApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForSeAnnouncementAttachmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type GetBuyerSeAttachmentUploadApiResponse =
  /** status 200 OK */ SeAttachmentUploadDto;
export type GetBuyerSeAttachmentUploadApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  uploadId: string;
};
export type AwardSourcingEventApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type AwardSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  awardSourcingEventRequest: AwardSourcingEventRequest;
};
export type GetAwardLettersApiResponse = /** status 200 OK */ AwardLettersDto;
export type GetAwardLettersApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type DispatchAwardLettersApiResponse =
  /** status 200 OK */ AwardLettersDto;
export type DispatchAwardLettersApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type UpdateAwardLetterApiResponse = /** status 200 OK */ AwardLetterDto;
export type UpdateAwardLetterApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  letterId: string;
  awardLetterPatchDto: AwardLetterPatchDto;
};
export type ApproveAwardLetterApiResponse =
  /** status 200 OK */ AwardLettersDto;
export type ApproveAwardLetterApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  letterId: string;
  awardLetterPatchDto: AwardLetterPatchDto;
};
export type ReopenAwardLetterApiResponse = /** status 200 OK */ AwardLettersDto;
export type ReopenAwardLetterApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  letterId: string;
};
export type AwardWithoutCompetitionApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type AwardWithoutCompetitionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  awardWithoutCompetitionRequest: AwardWithoutCompetitionRequest;
};
export type RecordWinnerDocumentationCheckedApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type RecordWinnerDocumentationCheckedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  recordWinnerDocumentationCheckRequest: RecordWinnerDocumentationCheckRequest;
};
export type BeginEvaluationApiResponse = /** status 200 OK */ SourcingEventDto;
export type BeginEvaluationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type GetBidInsightApiResponse =
  /** status 200 OK */ BidInsightResponseDto;
export type GetBidInsightApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
};
export type RequestBidInsightApiResponse =
  /** status 200 OK */ BidInsightResponseDto;
export type RequestBidInsightApiArg = {
  /** Development only: the Bedrock model to make this insight with, instead of the configured one */
  model?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
};
export type CancelSourcingEventApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type CancelSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  cancelSourcingEventRequest: CancelSourcingEventRequest;
};
export type GetCancellationScopeApiResponse =
  /** status 200 OK */ CancellationScopeDto;
export type GetCancellationScopeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CreateEventChangeApiResponse =
  /** status 201 Created */ EventRevisionDto;
export type CreateEventChangeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type UpdateEventChangeApiResponse =
  /** status 200 OK */ EventRevisionDto;
export type UpdateEventChangeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  revisionId: string;
  eventRevisionPatchDto: EventRevisionPatchDto;
};
export type CancelEventChangeApiResponse =
  /** status 200 OK */ EventRevisionDto;
export type CancelEventChangeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  revisionId: string;
};
export type SubmitEventChangeApiResponse =
  /** status 200 OK */ EventRevisionDto;
export type SubmitEventChangeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  revisionId: string;
};
export type StartSeClarificationApiResponse =
  /** status 201 Created */ SeQuestionDto;
export type StartSeClarificationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  createSeClarificationRequest: CreateSeClarificationRequest;
};
export type CloseSourcingEventApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type CloseSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  closeSourcingEventRequest: CloseSourcingEventRequest;
};
export type CompleteSourcingEventApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type CompleteSourcingEventApiArg = {
  proceedDespiteFlaggedEntries?: boolean;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type ConfirmAwardApiResponse = /** status 200 OK */ SourcingEventDto;
export type ConfirmAwardApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type ConfirmSourcingEventClassificationApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type ConfirmSourcingEventClassificationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  confirmClassificationRequest: ConfirmClassificationRequest;
};
export type RecordContractConcludedApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type RecordContractConcludedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  contractConcludedRequest: ContractConcludedRequest;
};
export type CopySourcingEventApiResponse =
  /** status 201 Created */ CopiedSourcingEventDto;
export type CopySourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type FlagIdentifyingEntryApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type FlagIdentifyingEntryApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  flagEntryRequest: FlagEntryRequest;
};
export type StartDesignContestFollowUpApiResponse =
  /** status 201 Created */ SourcingEventDto;
export type StartDesignContestFollowUpApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type RemoveJuryLinkApiResponse = /** status 200 OK */ SourcingEventDto;
export type RemoveJuryLinkApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  removeJuryLinkRequest: RemoveJuryLinkRequest;
};
export type ListStrandedJuryMembersApiResponse =
  /** status 200 OK */ StrandedJuryMembersDto;
export type ListStrandedJuryMembersApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type WriteJuryReportApiResponse = /** status 200 OK */ SourcingEventDto;
export type WriteJuryReportApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  writeJuryReportRequest: WriteJuryReportRequest;
};
export type ConfirmJuryReportApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type ConfirmJuryReportApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  confirmJuryReportRequest: ConfirmJuryReportRequest;
};
export type GetDpsCompetitionsApiResponse =
  /** status 200 OK */ DpsCompetitionsDto;
export type GetDpsCompetitionsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CreateDpsCompetitionApiResponse =
  /** status 201 Created */ SourcingEventDto;
export type CreateDpsCompetitionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  createDpsCompetitionRequestDto: CreateDpsCompetitionRequestDto;
};
export type AddEmailInviteToPrivateSourcingEventApiResponse =
  /** status 201 Created */ SourcingEventDto;
export type AddEmailInviteToPrivateSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  addEmailInviteRequest: AddEmailInviteRequest;
};
export type RemoveEmailInviteFromPrivateSourcingEventApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type RemoveEmailInviteFromPrivateSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  inviteId: string;
};
export type CreateEmailInviteReminderForPrivateSourcingEventApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type CreateEmailInviteReminderForPrivateSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  inviteId: string;
};
export type GetEvaluationApiResponse = /** status 200 OK */ EvaluationDto;
export type GetEvaluationApiArg = {
  round?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type UpsertPriceOverrideApiResponse = /** status 200 OK */ EvaluationDto;
export type UpsertPriceOverrideApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  upsertPriceOverrideRequest: UpsertPriceOverrideRequest;
};
export type GetPriceDevelopmentApiResponse =
  /** status 200 OK */ PriceDevelopmentDto;
export type GetPriceDevelopmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type SetCriterionRationaleApiResponse =
  /** status 200 OK */ EvaluationDto;
export type SetCriterionRationaleApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  setRationaleRequest: SetRationaleRequest;
};
export type UpsertCriterionScoreApiResponse =
  /** status 200 OK */ EvaluationDto;
export type UpsertCriterionScoreApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  upsertScoreRequest: UpsertScoreRequest;
};
export type SetEvaluationSelectionApiResponse =
  /** status 200 OK */ EvaluationDto;
export type SetEvaluationSelectionApiArg = {
  round?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  setEvaluationSelectionRequest: SetEvaluationSelectionRequest;
};
export type UpdateSourcingEventValueApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type UpdateSourcingEventValueApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  updateSourcingEventValueRequest: UpdateSourcingEventValueRequest;
};
export type ListSourcingEventFieldSourcesApiResponse =
  /** status 200 OK */ SourcingEventFieldSourcesDto;
export type ListSourcingEventFieldSourcesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type ReviewSourcingEventFieldSourcesApiResponse =
  /** status 200 OK */ SourcingEventFieldSourcesDto;
export type ReviewSourcingEventFieldSourcesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  reviewSourcingEventFieldSourcesRequest: ReviewSourcingEventFieldSourcesRequest;
};
export type CreateFrameworkAgreementApiResponse =
  /** status 201 Created */ FrameworkAgreementDto;
export type CreateFrameworkAgreementApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  createFrameworkAgreementRequest: CreateFrameworkAgreementRequest;
};
export type GetMiniCompetitionPanelApiResponse =
  /** status 200 OK */ MiniCompetitionPanelDto;
export type GetMiniCompetitionPanelApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type SetHomeDepartmentApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type SetHomeDepartmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  setHomeDepartmentRequest: SetHomeDepartmentRequest;
};
export type InviteToConfirmInterestApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type InviteToConfirmInterestApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  interestInvitationRequestDto: InterestInvitationRequestDto;
};
export type AddInternalMessageToSeApiResponse =
  /** status 201 Created */ SourcingEventDto;
export type AddInternalMessageToSeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  addInternalMessageRequest: AddInternalMessageRequest;
};
export type SaveInterviewDraftApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type SaveInterviewDraftApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  saveInterviewDraftRequest: SaveInterviewDraftRequest;
};
export type ConfirmInvitationApiResponse =
  /** status 200 OK */ InvitationResultDto;
export type ConfirmInvitationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  confirmInvitationRequestDto: ConfirmInvitationRequestDto;
};
export type LookUpInviteEmailAccountApiResponse =
  /** status 200 OK */ InviteEmailAccountDto;
export type LookUpInviteEmailAccountApiArg = {
  email?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type ListNegotiationRoundsApiResponse =
  /** status 200 OK */ ListNegotiationRoundsResponse;
export type ListNegotiationRoundsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CreateNegotiationRoundApiResponse =
  /** status 201 Created */ NegotiationRoundDto;
export type CreateNegotiationRoundApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  createNegotiationRoundRequest: CreateNegotiationRoundRequest;
};
export type PatchNegotiationRoundApiResponse =
  /** status 200 OK */ NegotiationRoundDto;
export type PatchNegotiationRoundApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
  negotiationRoundPatchDto: NegotiationRoundPatchDto;
};
export type CompleteNegotiationRoundApiResponse =
  /** status 200 OK */ NegotiationRoundDto;
export type CompleteNegotiationRoundApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
};
export type AddNegotiationRoundInviteApiResponse =
  /** status 201 Created */ NegotiationRoundDto;
export type AddNegotiationRoundInviteApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
  addNegotiationRoundInviteRequest: AddNegotiationRoundInviteRequest;
};
export type RemoveNegotiationRoundInviteApiResponse =
  /** status 200 OK */ NegotiationRoundDto;
export type RemoveNegotiationRoundInviteApiArg = {
  /** Why a live FOA Part II round may leave this tenderer out (§ 9-3 (2)), when the round has no reason yet */
  selectionJustification?: string;
  /** Why the supplier is taken out of the negotiation, on the award criteria, when the notice reserved reduction in successive stages (FOA § 23-11, forsyningsforskriften § 19-12) */
  reductionReason?: string;
  cookie?: string;
  headerOrganizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
  pathOrganizationId: string;
};
export type UpdateNegotiationRoundInviteMessageApiResponse =
  /** status 200 OK */ NegotiationRoundDto;
export type UpdateNegotiationRoundInviteMessageApiArg = {
  cookie?: string;
  headerOrganizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
  pathOrganizationId: string;
  updateNegotiationRoundInviteMessageRequest: UpdateNegotiationRoundInviteMessageRequest;
};
export type SelectNegotiationRoundProductBidsApiResponse =
  /** status 200 OK */ NegotiationRoundDto;
export type SelectNegotiationRoundProductBidsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
  selectProductBidsRequest: SelectProductBidsRequest;
};
export type PublishNegotiationRoundApiResponse =
  /** status 200 OK */ NegotiationRoundDto;
export type PublishNegotiationRoundApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
};
export type ReopenNegotiationRoundApiResponse =
  /** status 200 OK */ NegotiationRoundDto;
export type ReopenNegotiationRoundApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
};
export type CreateUploadForNegotiationRoundApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForNegotiationRoundApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type GetNegotiationWithoutNoticeApiResponse =
  /** status 200 OK */ NegotiationWithoutNoticeOverviewDto;
export type GetNegotiationWithoutNoticeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type OpenNegotiationWithoutNoticeApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type OpenNegotiationWithoutNoticeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type AddOrganizationInviteToPrivateSourcingEventApiResponse =
  /** status 201 Created */ SourcingEventDto;
export type AddOrganizationInviteToPrivateSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  addOrganizationInviteRequest: AddOrganizationInviteRequest;
};
export type RemoveOrganizationInviteFromPrivateSourcingEventApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type RemoveOrganizationInviteFromPrivateSourcingEventApiArg = {
  cookie?: string;
  headerOrganizationId?: string;
  personId?: string;
  eventId: string;
  pathOrganizationId: string;
};
export type AddOrganizationInviteRecipientsApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type AddOrganizationInviteRecipientsApiArg = {
  cookie?: string;
  headerOrganizationId?: string;
  personId?: string;
  eventId: string;
  pathOrganizationId: string;
  addOrganizationInviteRecipientsRequest: AddOrganizationInviteRecipientsRequest;
};
export type RestoreOrganizationInviteRemovedInChangeApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type RestoreOrganizationInviteRemovedInChangeApiArg = {
  cookie?: string;
  headerOrganizationId?: string;
  personId?: string;
  eventId: string;
  pathOrganizationId: string;
};
export type ListParticipationRequestsForBuyerApiResponse =
  /** status 200 OK */ BuyerParticipationRequestsDto;
export type ListParticipationRequestsForBuyerApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type GetParticipationRequestForBuyerApiResponse =
  /** status 200 OK */ BuyerParticipationRequestDetailDto;
export type GetParticipationRequestForBuyerApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  requestId: string;
};
export type ExtendDpsAssessmentWindowApiResponse =
  /** status 200 OK */ BuyerParticipationRequestDto;
export type ExtendDpsAssessmentWindowApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  requestId: string;
  extendAssessmentRequestDto: ExtendAssessmentRequestDto;
};
export type SetQualificationSchemeMemberCategoriesApiResponse =
  /** status 200 OK */ BuyerParticipationRequestDto;
export type SetQualificationSchemeMemberCategoriesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  requestId: string;
  schemeMemberCategoriesRequestDto: SchemeMemberCategoriesRequestDto;
};
export type UpdateParticipationRequestReviewApiResponse =
  /** status 200 OK */ BuyerParticipationRequestDetailDto;
export type UpdateParticipationRequestReviewApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  requestId: string;
  buyerQualificationReviewPatchDto: BuyerQualificationReviewPatchDto;
};
export type GetParticipationRequestRejectionDocumentsApiResponse =
  /** status 200 OK */ ParticipationRequestRejectionDocumentsDto;
export type GetParticipationRequestRejectionDocumentsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  requestId: string;
};
export type CreateUploadForParticipationRequestRejectionApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForParticipationRequestRejectionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  requestId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type WithdrawSchemeRemovalApiResponse =
  /** status 200 OK */ BuyerParticipationRequestDto;
export type WithdrawSchemeRemovalApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  requestId: string;
};
export type RemoveFromDpsSchemeApiResponse =
  /** status 200 OK */ BuyerParticipationRequestDto;
export type RemoveFromDpsSchemeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  requestId: string;
  removeFromSchemeRequestDto: RemoveFromSchemeRequestDto;
};
export type UpdateParticipationRequestNotesApiResponse =
  /** status 200 OK */ BuyerParticipationRequestDetailDto;
export type UpdateParticipationRequestNotesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  requestId: string;
  buyerReviewNotesPatchDto: BuyerReviewNotesPatchDto;
};
export type UpdateParticipationRequestSelectionDraftApiResponse =
  /** status 200 OK */ BuyerParticipationRequestDto;
export type UpdateParticipationRequestSelectionDraftApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  requestId: string;
  selectionDraftPatchDto: SelectionDraftPatchDto;
};
export type SetQualificationVerdictApiResponse =
  /** status 200 OK */ BuyerParticipationRequestDto;
export type SetQualificationVerdictApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  requestId: string;
  setQualificationVerdictRequestDto: SetQualificationVerdictRequestDto;
};
export type ListPortalLinkSharesApiResponse =
  /** status 200 OK */ PortalLinkSharesDto;
export type ListPortalLinkSharesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type SharePortalLinkApiResponse =
  /** status 200 OK */ PortalLinkSharesDto;
export type SharePortalLinkApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  sharePortalLinkRequest: SharePortalLinkRequest;
};
export type SelectSourcingEventProductBidsApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type SelectSourcingEventProductBidsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  selectProductBidsRequest: SelectProductBidsRequest;
};
export type GetProtocolDraftApiResponse =
  /** status 200 OK */ ProtocolDocumentDto;
export type GetProtocolDraftApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type PatchProtocolNarrativeApiResponse =
  /** status 200 OK */ ProtocolDocumentDto;
export type PatchProtocolNarrativeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  protocolDraftPatchDto: ProtocolDraftPatchDto;
};
export type FinaliseProtocolApiResponse =
  /** status 200 OK */ ProtocolVersionDto;
export type FinaliseProtocolApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type ListProtocolVersionsApiResponse =
  /** status 200 OK */ ProtocolVersionListDto;
export type ListProtocolVersionsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type DownloadProtocolVersionApiResponse = unknown;
export type DownloadProtocolVersionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  versionId: string;
};
export type ListBidsForEventApiResponse = /** status 200 OK */ ListBidsResponse;
export type ListBidsForEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type GetBidForBuyerApiResponse = /** status 200 OK */ BuyerBidDetailDto;
export type GetBidForBuyerApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
};
export type CreateContractFromBidApiResponse = /** status 200 OK */ ContractDto;
export type CreateContractFromBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
  createContractFromBidRequest: CreateContractFromBidRequest;
};
export type UpdateBuyerMinimumRequirementReviewApiResponse =
  /** status 200 OK */ BuyerBidDetailDto;
export type UpdateBuyerMinimumRequirementReviewApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
  buyerMinimumRequirementReviewPatchDto: BuyerMinimumRequirementReviewPatchDto;
};
export type SetBidQualificationApiResponse =
  /** status 200 OK */ BuyerBidDetailDto;
export type SetBidQualificationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
  setBidQualificationRequestDto: SetBidQualificationRequestDto;
};
export type UpdateBuyerQualificationReviewApiResponse =
  /** status 200 OK */ BuyerBidDetailDto;
export type UpdateBuyerQualificationReviewApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
  buyerQualificationReviewPatchDto: BuyerQualificationReviewPatchDto;
};
export type RejectBidApiResponse = /** status 200 OK */ BuyerBidDetailDto;
export type RejectBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
  rejectBidRequestDto: RejectBidRequestDto;
};
export type GetBidRejectionDocumentsApiResponse =
  /** status 200 OK */ BidRejectionDocumentsDto;
export type GetBidRejectionDocumentsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
};
export type CreateUploadForBidRejectionApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForBidRejectionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type RevokeBidRejectionApiResponse =
  /** status 200 OK */ BuyerBidDetailDto;
export type RevokeBidRejectionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
  revokeBidRejectionRequest: RevokeBidRejectionRequest;
};
export type PublishDpsCompetitionApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type PublishDpsCompetitionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type PublishPrivateSourcingEventApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type PublishPrivateSourcingEventApiArg = {
  openInSupplierPortal?: boolean;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type PublishQualificationSchemeCompetitionApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type PublishQualificationSchemeCompetitionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type DownloadSeQaReportApiResponse = unknown;
export type DownloadSeQaReportApiArg = {
  eventId: string;
};
export type GetQualificationSchemeCompetitionsApiResponse =
  /** status 200 OK */ QualificationSchemeCompetitionsDto;
export type GetQualificationSchemeCompetitionsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CreateQualificationSchemeCompetitionApiResponse =
  /** status 201 Created */ SourcingEventDto;
export type CreateQualificationSchemeCompetitionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  createQualificationSchemeCompetitionRequestDto: CreateQualificationSchemeCompetitionRequestDto;
};
export type GetQualificationSchemeInviteesApiResponse =
  /** status 200 OK */ QualificationSchemeInviteesDto;
export type GetQualificationSchemeInviteesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type GetBuyerSeQuestionsApiResponse =
  /** status 200 OK */ ListSeQuestionsResponse;
export type GetBuyerSeQuestionsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type AnswerSeQuestionApiResponse = /** status 200 OK */ SeQuestionDto;
export type AnswerSeQuestionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  questionId: string;
  seQuestionPatchDto: SeQuestionPatchDto;
};
export type CreateUploadForSeAnswerAttachmentApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForSeAnswerAttachmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  questionId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type SendSeClarificationMessageAsBuyerApiResponse =
  /** status 201 Created */ SeQuestionDto;
export type SendSeClarificationMessageAsBuyerApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  questionId: string;
  createSeQuestionMessageRequest: CreateSeQuestionMessageRequest;
};
export type GetSourcingEventReadinessApiResponse =
  /** status 200 OK */ ValidationReadinessDto;
export type GetSourcingEventReadinessApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type ReopenCompletedSourcingEventApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type ReopenCompletedSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type SetResponsiblePersonApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type SetResponsiblePersonApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  setResponsiblePersonRequest: SetResponsiblePersonRequest;
};
export type DeclineResultNoticeApiResponse =
  /** status 200 OK */ SourcingEventDto;
export type DeclineResultNoticeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type RevokeAwardApiResponse = /** status 200 OK */ SourcingEventDto;
export type RevokeAwardApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  revokeAwardRequest: RevokeAwardRequest;
};
export type GetEventSharesApiResponse = /** status 200 OK */ EventSharesDto;
export type GetEventSharesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type ShareEventApiResponse = /** status 200 OK */ EventShareDto;
export type ShareEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  shareEventRequest: ShareEventRequest;
};
export type UnshareEventApiResponse = unknown;
export type UnshareEventApiArg = {
  cookie?: string;
  organizationId?: string;
  headerPersonId?: string;
  eventId: string;
  pathPersonId: string;
};
export type GetBuyerSupplierInformationApiResponse =
  /** status 200 OK */ ListSupplierInformationResponse;
export type GetBuyerSupplierInformationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type PublishInformationApiResponse =
  /** status 201 Created */ SupplierInformationDto;
export type PublishInformationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  createInformationRequest: CreateInformationRequest;
};
export type CreateUploadForSourcingEventApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type ListFrameworkAgreementsApiResponse =
  /** status 200 OK */ FrameworkAgreementsDto;
export type ListFrameworkAgreementsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type RegisterFrameworkAgreementApiResponse =
  /** status 201 Created */ FrameworkAgreementDto;
export type RegisterFrameworkAgreementApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  registerFrameworkAgreementRequest: RegisterFrameworkAgreementRequest;
};
export type GetFrameworkAgreementApiResponse =
  /** status 200 OK */ FrameworkAgreementDto;
export type GetFrameworkAgreementApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  frameworkAgreementId: string;
};
export type UpdateFrameworkAgreementApiResponse =
  /** status 200 OK */ FrameworkAgreementDto;
export type UpdateFrameworkAgreementApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  frameworkAgreementId: string;
  frameworkAgreementPatchDto: FrameworkAgreementPatchDto;
};
export type ListFrameworkCallOffsApiResponse =
  /** status 200 OK */ FrameworkCallOffsDto;
export type ListFrameworkCallOffsApiArg = {
  supplierOrganizationId?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  frameworkAgreementId: string;
};
export type CreateDirectCallOffApiResponse =
  /** status 201 Created */ ContractDto;
export type CreateDirectCallOffApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  frameworkAgreementId: string;
  createDirectCallOffRequest: CreateDirectCallOffRequest;
};
export type ListMiniCompetitionsApiResponse =
  /** status 200 OK */ MiniCompetitionsDto;
export type ListMiniCompetitionsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  frameworkAgreementId: string;
};
export type OpenMiniCompetitionApiResponse =
  /** status 201 Created */ SourcingEventDto;
export type OpenMiniCompetitionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  frameworkAgreementId: string;
  openMiniCompetitionRequest: OpenMiniCompetitionRequest;
};
export type AddFrameworkSupplierApiResponse =
  /** status 201 Created */ FrameworkAgreementDto;
export type AddFrameworkSupplierApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  frameworkAgreementId: string;
  addFrameworkSupplierRequest: AddFrameworkSupplierRequest;
};
export type TerminateFrameworkAgreementApiResponse =
  /** status 200 OK */ FrameworkAgreementDto;
export type TerminateFrameworkAgreementApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  frameworkAgreementId: string;
};
export type GetFrameworkOverviewApiResponse =
  /** status 200 OK */ FrameworkOverviewDto;
export type GetFrameworkOverviewApiArg = {
  projectId?: string;
  /** Every call-off that needs follow-up, up to 500, instead of the newest 50. */
  allFollowUp?: boolean;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type GetProductGroupsForSourcingEventApiResponse =
  /** status 200 OK */ ProductGroupsDto;
export type GetProductGroupsForSourcingEventApiArg = {
  sourcingEventId: string;
};
export type ListCombinedEventsWithSupplierApiResponse =
  /** status 200 OK */ ListBuyerEventsWithSupplierResponse;
export type ListCombinedEventsWithSupplierApiArg = {
  /** A registered supplier. Self-registered companies linked to it are included. */
  supplierOrganizationId?: string;
  /** A self-registered company, matched through its e-mail invitations. */
  supplierEntryId?: string;
  /** Page size: 10 when omitted, at most 100 */
  limit?: number;
  skip?: number;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type ListBuyerEventsApiResponse =
  /** status 200 OK */ ListBuyerEventsResponse;
export type ListBuyerEventsApiArg = {
  /** Only procurements created from needs first sent on or after this date, among the needs the caller may take, as counted on Oversikt › Behov. Needs `needsSentTo`. The response then says in `notVisible` how many of those procurements, in the statuses asked for, the caller may not see. Refused to an organization whose plan has no needs. */
  needsSentFrom?: string;
  /** Only procurements created from needs first sent on or before this date. Needs `needsSentFrom`. */
  needsSentTo?: string;
  /** Filtrer på status. */
  statuses?: (
    | "DRAFT"
    | "PUBLICATION_PENDING"
    | "PUBLISHED"
    | "PUBLICATION_FAILED"
    | "EVALUATION"
    | "EVALUATED"
    | "AWARD_DECISION"
    | "AWARDED"
    | "CANCELLED"
    | "CLOSED"
    | "COMPLETED"
  )[];
  /** Only procurements under way: past drafting and not yet awarded, cancelled or closed. */
  active?: boolean;
  /** Filtrer på tilknyttet prosjekt. */
  projectIds?: string[];
  /** Filtrer på navn (delstreng) */
  name?: string;
  /** Only procurements whose title, internal reference or responsible person's name contains this text, in any case. `%`, `_` and `\` stand for themselves. */
  tableSearchTerm?: string;
  responsiblePersons?: string[];
  /** Filtrer på kontraktstype. */
  contractTypes?: ("WORKS" | "SUPPLIES" | "SERVICES" | "COMBINED")[];
  /** Bare anskaffelser der fristen allerede har gått ut. */
  deadlinePassed?: boolean;
  /** Only procurements published on or after this date. */
  publishedFrom?: string;
  /** Only procurements published on or before this date. */
  publishedTo?: string;
  /** Only procurements awarded on or after this date. */
  awardedFrom?: string;
  /** Only procurements awarded on or before this date. */
  awardedTo?: string;
  /** Only competitions (published, taking competing bids) whose bid deadline is on or after this date. */
  bidDeadlineFrom?: string;
  /** Only competitions (published, taking competing bids) whose bid deadline is on or before this date. */
  bidDeadlineTo?: string;
  /** Only procurements whose deadline in force, as the list shows it, is on or after this date. */
  deadlineFrom?: string;
  /** Only procurements whose deadline in force, as the list shows it, is on or before this date. */
  deadlineTo?: string;
  /** A deadline period counted from today, the same choices as the contract list's date filters. Overrides deadlineFrom and deadlineTo. */
  deadlinePreset?: ContractDatePresetDto;
  /** Only procurements with at least this many delivered bids. */
  minDeliveredBids?: number;
  /** Only procurements with at most this many delivered bids. */
  maxDeliveredBids?: number;
  /** Only public procurements run under one of these procedures. */
  procedureTypes?: (
    | "ANNOUNCED_COMPETITION"
    | "OPEN"
    | "OPEN_TENDER_COMPETITION"
    | "RESTRICTED"
    | "RESTRICTED_TENDER_COMPETITION"
    | "NEGOTIATED_WITH_PRIOR_CALL"
    | "NEGOTIATED_WITHOUT_PRIOR_CALL"
    | "COMPETITIVE_DIALOGUE"
    | "INNOVATION_PARTNERSHIP"
    | "COMPETITIVE_NEGOTIATION"
    | "OTHER_SINGLE_STAGE"
    | "DYNAMIC_PURCHASING_SYSTEM"
    | "DPS_COMPETITION"
    | "QUALIFICATION_SCHEME"
    | "WITHOUT_COMPETITION"
    | "DESIGN_CONTEST_OPEN"
    | "DESIGN_CONTEST_RESTRICTED"
  )[];
  /** Only procurements under one of these regulations and parts. */
  regulationBuckets?: (
    | "FOA_PART_I"
    | "FOA_PART_II"
    | "FOA_PART_III"
    | "FOA_PART_IV"
    | "UTILITIES"
    | "CONCESSIONS"
    | "OUTSIDE_REGULATION"
    | "NOT_STATED"
    | "NOT_CLASSIFIED"
    | "PRIVATE"
  )[];
  limit?: number;
  skip?: number;
  sortBy?: SourcingEventSortField;
  sortDirection?: SortDirection;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type ListBuyerEventFilterOptionsApiResponse =
  /** status 200 OK */ BuyerEventFilterOptionsResponse;
export type ListBuyerEventFilterOptionsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type DownloadProcurementListApiResponse = unknown;
export type DownloadProcurementListApiArg = {
  /** The file to write: XLSX (default), CSV (semicolon-separated, UTF-8) or PDF (with the selection and date on top). */
  format?: ListExportFormat;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  listExportRequest: ListExportRequest;
};
export type GetProcurementOverviewApiResponse =
  /** status 200 OK */ ProcurementOverviewDto;
export type GetProcurementOverviewApiArg = {
  /** First day of the period. */
  from: string;
  /** Last day of the period. */
  to: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type GetProcurementClimateWeightingListApiResponse =
  /** status 200 OK */ ClimateWeightingListDto;
export type GetProcurementClimateWeightingListApiArg = {
  /** The climate and environment group. */
  group: ClimateWeightingGroup;
  /** First day of the publication period. */
  from: string;
  /** Last day of the publication period. */
  to: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type GetProcurementPhaseListApiResponse =
  /** status 200 OK */ CyclePhaseListDto;
export type GetProcurementPhaseListApiArg = {
  /** The phase the procurements left. */
  phase: CyclePhase;
  /** First day of the period the phase ended in. */
  from: string;
  /** Last day of the period the phase ended in. */
  to: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type GetProcurementPlanApiResponse =
  /** status 200 OK */ ProcurementPlanDto;
export type GetProcurementPlanApiArg = {
  /** First day of the period. Undated procurements are kept. */
  from?: string;
  /** Last day of the period. */
  to?: string;
  /** Only procurements owned by this department. */
  department?: string;
  /** Only procurements this person is responsible for. */
  responsible?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type DownloadProcurementPlanApiResponse = unknown;
export type DownloadProcurementPlanApiArg = {
  /** The file to write: XLSX (default), CSV (semicolon-separated, UTF-8) or PDF (with the selection and date on top). */
  format?: ListExportFormat;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  listExportRequest: ListExportRequest;
};
export type CountBuyerEventsByStatusApiResponse =
  /** status 200 OK */ BuyerEventStatusCountsResponse;
export type CountBuyerEventsByStatusApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type ListBuyerEventsWithSupplierApiResponse =
  /** status 200 OK */ ListBuyerEventsWithSupplierResponse;
export type ListBuyerEventsWithSupplierApiArg = {
  /** A registered supplier. Self-registered companies linked to it are included. */
  supplierOrganizationId?: string;
  /** A self-registered company, matched through its e-mail invitations. */
  supplierEntryId?: string;
  /** Page size: 10 when omitted, at most 100 */
  limit?: number;
  skip?: number;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type GetProcurementWorkloadApiResponse =
  /** status 200 OK */ ProcurementWorkloadDto;
export type GetProcurementWorkloadApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type ListProcurementWorkloadDeadlinesApiResponse =
  /** status 200 OK */ ProcurementWorkloadDeadlinesDto;
export type ListProcurementWorkloadDeadlinesApiArg = {
  cookie?: string;
  organizationId?: string;
  headerPersonId?: string;
  orgId: string;
  pathPersonId: string;
};
export type ListContractReportsApiResponse =
  /** status 200 OK */ ListContractReportsResponseDto;
export type ListContractReportsApiArg = {
  q: string;
  sortBy?: ContractReportSortColumn;
  sortDirection?: string;
  sortByCustomField?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type ListContractReportOptionsApiResponse =
  /** status 200 OK */ ListContractReportOptionsResponseDto;
export type ListContractReportOptionsApiArg = {
  q: string;
  parameterName: ContractReportOptionParameter;
  optionValues?: string[];
  optionSearchTerm?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type GetContractOverviewApiResponse =
  /** status 200 OK */ ContractOverviewDto;
export type GetContractOverviewApiArg = {
  q: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type GetContractSavingsApiResponse =
  /** status 200 OK */ ContractSavingsDto;
export type GetContractSavingsApiArg = {
  /** The organisation whose contracts are measured. */
  orgId: string;
  /** First day of the period. */
  from: string;
  /** Last day of the period. */
  to: string;
  /** The list whose contracts to return, one page at a time. Without it, only the figures are returned. */
  list?: SavingsList;
  /** Contracts per page of the list, 10 by default, at most 100. */
  limit?: number;
  /** Contracts of the list to skip. */
  skip?: number;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type GetContractSigningApiResponse =
  /** status 200 OK */ ContractSigningDto;
export type GetContractSigningApiArg = {
  q: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type DownloadContractTaskListApiResponse = unknown;
export type DownloadContractTaskListApiArg = {
  /** The file to write: XLSX (default), CSV (semicolon-separated, UTF-8) or PDF (with the selection and date on top). */
  format?: ListExportFormat;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  listExportRequest: ListExportRequest;
};
export type DeleteCustomContractDataFieldApiResponse = unknown;
export type DeleteCustomContractDataFieldApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  deleteCustomFieldDto: DeleteCustomFieldDto;
};
export type UpsertCustomContractDataFieldApiResponse = unknown;
export type UpsertCustomContractDataFieldApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  upsertCustomContractFieldDto: UpsertCustomContractFieldDto;
};
export type MarkSupplierFilterContractFieldApiResponse = unknown;
export type MarkSupplierFilterContractFieldApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  markSupplierFilterFieldDto: MarkSupplierFilterFieldDto;
};
export type MarkSupplierFilterContractEndDateApiResponse = unknown;
export type MarkSupplierFilterContractEndDateApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  markSupplierFilterEndDateDto: MarkSupplierFilterEndDateDto;
};
export type UpsertContractDataFieldsSectionApiResponse = unknown;
export type UpsertContractDataFieldsSectionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  contractDataFieldSectionDto: ContractDataFieldSectionDto;
};
export type ContractReportQueryDummyApiResponse = unknown;
export type ContractReportQueryDummyApiArg = {
  contractReportQueryDto: ContractReportQueryDto;
};
export type SignatureWebhookApiResponse = unknown;
export type SignatureWebhookApiArg = void;
export type DeleteContractTaskCommentApiResponse =
  /** status 200 OK */ ContractTaskCommentDto;
export type DeleteContractTaskCommentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  commentId: string;
};
export type UpdateContractTaskCommentApiResponse =
  /** status 200 OK */ ContractTaskCommentDto;
export type UpdateContractTaskCommentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  commentId: string;
  updateContractTaskCommentRequest: UpdateContractTaskCommentRequest;
};
export type DeleteContractTaskApiResponse = /** status 200 OK */ ContractDto;
export type DeleteContractTaskApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  taskId: string;
};
export type UpdateContractTaskApiResponse =
  /** status 200 OK */ ContractTaskDto;
export type UpdateContractTaskApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  taskId: string;
  updateTaskRequest: UpdateTaskRequest;
};
export type ListChangesForContractTaskApiResponse =
  /** status 200 OK */ ListChangesForContractTaskResponse;
export type ListChangesForContractTaskApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  taskId: string;
};
export type ListCommentsForContractTaskApiResponse =
  /** status 200 OK */ ListCommentsForContractTaskResponse;
export type ListCommentsForContractTaskApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  taskId: string;
};
export type CreateContractTaskCommentApiResponse =
  /** status 200 OK */ ContractTaskCommentDto;
export type CreateContractTaskCommentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  taskId: string;
  createContractTaskCommentRequest: CreateContractTaskCommentRequest;
};
export type CreateContractTextDocumentApiResponse =
  /** status 201 Created */ TextDocumentDto;
export type CreateContractTextDocumentApiArg = {
  createContractTextDocumentRequest: CreateContractTextDocumentRequest;
};
export type ListTextDocumentsForContractApiResponse =
  /** status 200 OK */ TextDocumentsDto;
export type ListTextDocumentsForContractApiArg = {
  contractId: string;
};
export type CreateFencyConversationApiResponse =
  /** status 200 OK */ FencyConversationResponse;
export type CreateFencyConversationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type CreateExploreMemoriesSessionApiResponse =
  /** status 200 OK */ FencySessionResponse;
export type CreateExploreMemoriesSessionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createExploreMemoriesSessionRequest: CreateExploreMemoriesSessionRequest;
};
export type CreateFencyFileDownloadSessionApiResponse =
  /** status 200 OK */ FencySessionResponse;
export type CreateFencyFileDownloadSessionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createFencyFileDownloadSessionRequest: CreateFencyFileDownloadSessionRequest;
};
export type DownloadMultiIfrsReportApiResponse = unknown;
export type DownloadMultiIfrsReportApiArg = {
  contractIds: string;
};
export type DownloadChosenIfrsReportApiResponse = unknown;
export type DownloadChosenIfrsReportApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  chosenIfrsReportRequest: ChosenIfrsReportRequest;
};
export type DownloadFilteredIfrsReportApiResponse = unknown;
export type DownloadFilteredIfrsReportApiArg = {
  q: string;
  /** First month of the report, as YYYY-MM. Needs periodTo. */
  periodFrom?: string;
  /** Last month of the report, as YYYY-MM. Needs periodFrom. */
  periodTo?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type GetFilteredIfrsReportPreviewApiResponse =
  /** status 200 OK */ IfrsReportPreviewDto;
export type GetFilteredIfrsReportPreviewApiArg = {
  q: string;
  /** First month of the report, as YYYY-MM. Needs periodTo. */
  periodFrom?: string;
  /** Last month of the report, as YYYY-MM. Needs periodFrom. */
  periodTo?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type DownloadContractListApiResponse = unknown;
export type DownloadContractListApiArg = {
  /** The file to write: XLSX (default), CSV (semicolon-separated, UTF-8) or PDF (with the selection and date on top). */
  format?: ListExportFormat;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  listExportRequest: ListExportRequest;
};
export type CreateMemoryChatSessionApiResponse =
  /** status 200 OK */ FencySessionResponse;
export type CreateMemoryChatSessionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createMemoryChatSessionRequest: CreateMemoryChatSessionRequest;
};
export type CreateMemoryDownloadLinkApiResponse =
  /** status 200 OK */ FencyDownloadLinkResponse;
export type CreateMemoryDownloadLinkApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createMemoryDownloadLinkRequest: CreateMemoryDownloadLinkRequest;
};
export type CreateContractSearchSessionApiResponse =
  /** status 200 OK */ FencySessionResponse;
export type CreateContractSearchSessionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type GetContractStatisticsApiResponse =
  /** status 200 OK */ ContractStatisticsDto;
export type GetContractStatisticsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type GetContractAutofillContextApiResponse =
  /** status 200 OK */ ContractAutofillContextDto;
export type GetContractAutofillContextApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
};
export type CancelSignedDocumentApiResponse = unknown;
export type CancelSignedDocumentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  cancelSignedDocumentRequest: CancelSignedDocumentRequest;
};
export type CreateUploadForContractDescriptionApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForContractDescriptionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type DownloadIfrsReportApiResponse = unknown;
export type DownloadIfrsReportApiArg = {
  contractId: string;
};
export type GetContractMessageAttachmentUploadApiResponse =
  /** status 200 OK */ ContractMessageAttachmentUploadDto;
export type GetContractMessageAttachmentUploadApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  uploadId: string;
};
export type CreateUploadForContractMessageAttachmentApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForContractMessageAttachmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type ListContractMessagesApiResponse =
  /** status 200 OK */ ListContractMessagesResponse;
export type ListContractMessagesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
};
export type CreateContractMessageApiResponse =
  /** status 200 OK */ ContractMessageDto;
export type CreateContractMessageApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  createContractMessageRequest: CreateContractMessageRequest;
};
export type SaveContractMessageAttachmentApiResponse =
  /** status 200 OK */ SaveMessageAttachmentResponse;
export type SaveContractMessageAttachmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  saveMessageAttachmentRequest: SaveMessageAttachmentRequest;
};
export type GetContractOriginCommunicationApiResponse =
  /** status 200 OK */ ContractOriginCommunicationDto;
export type GetContractOriginCommunicationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
};
export type DeleteContractParticipantApiResponse = unknown;
export type DeleteContractParticipantApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  deleteContractParticipantRequest: DeleteContractParticipantRequest;
};
export type ListParticipantsForContractsApiResponse =
  /** status 200 OK */ ListParticipantsForContractResponse;
export type ListParticipantsForContractsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
};
export type CreateContractParticipantApiResponse =
  /** status 200 OK */ ContractDto;
export type CreateContractParticipantApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  createContractParticipantRequest: CreateContractParticipantRequest;
};
export type DeleteSignedDocumentApiResponse = unknown;
export type DeleteSignedDocumentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  signedDocumentId: string;
};
export type ChangeSignedDocumentDeadlineApiResponse = unknown;
export type ChangeSignedDocumentDeadlineApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  signedDocumentId: string;
  changeSignedDocumentDeadlineRequest: ChangeSignedDocumentDeadlineRequest;
};
export type GetContractTaskDelegationApiResponse =
  /** status 200 OK */ TaskDelegationDto;
export type GetContractTaskDelegationApiArg = {
  responsiblePersonId: string;
  /** The task being reassigned. Leave out for a task not yet created. */
  taskId?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
};
export type CreateContractTaskApiResponse = /** status 200 OK */ ContractDto;
export type CreateContractTaskApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  createContractTaskRequest: CreateContractTaskRequest;
};
export type CreateUploadForContractApiResponse = /** status 200 OK */ UploadDto;
export type CreateUploadForContractApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type GetContributingEntityInviteApiResponse =
  /** status 200 OK */ ContributingEntityInviteDto;
export type GetContributingEntityInviteApiArg = {
  secret: string;
  inviteId: string;
};
export type AcceptContributingEntityInviteApiResponse =
  /** status 200 OK */ ContributingEntityDetailDto;
export type AcceptContributingEntityInviteApiArg = {
  secret: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  inviteId: string;
};
export type DeclineContributingEntityInviteApiResponse =
  /** status 200 OK */ ContributingEntityDto;
export type DeclineContributingEntityInviteApiArg = {
  secret: string;
  inviteId: string;
  declineContributingEntityInviteRequestDto: DeclineContributingEntityInviteRequestDto;
};
export type GetCpvCodesApiResponse = /** status 200 OK */ GetCpvCodesResponse;
export type GetCpvCodesApiArg = void;
export type ListContractFilterOptionsApiResponse =
  /** status 200 OK */ ContractFilterOptionsDto;
export type ListContractFilterOptionsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type ListContractsApiResponse =
  /** status 200 OK */ ListContractsResponseDto;
export type ListContractsApiArg = {
  title?: string;
  state?: ContractStateDto;
  statuses?: string;
  counterparties?: string;
  owners?: string;
  templates?: string;
  internalparties?: string;
  projects?: string;
  limit: number;
  skip?: number;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type ForceDeliverBidApiResponse =
  /** status 200 OK */ ForceDeliverBidResponseDto;
export type ForceDeliverBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
};
export type ForcePublishEventApiResponse =
  /** status 200 OK */ ForcePublishResponseDto;
export type ForcePublishEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type SkipPastGateApiResponse =
  /** status 200 OK */ SkipPastGateResponseDto;
export type SkipPastGateApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  skipPastGateRequestDto: SkipPastGateRequestDto;
};
export type StartDocumentChatApiResponse = /** status 200 OK */ AiChatResponse;
export type StartDocumentChatApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  startDocumentChatRequest: StartDocumentChatRequest;
};
export type UpdateDocumentMetaApiResponse =
  /** status 200 OK */ ViewDocumentAsOwnerDto;
export type UpdateDocumentMetaApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  docId: string;
  updateDocumentMetaRequest: UpdateDocumentMetaRequest;
};
export type GetDownloadLinkApiResponse =
  /** status 200 OK */ GetDownloadLinkResponse;
export type GetDownloadLinkApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  docId: string;
};
export type ListDocumentTemplatesApiResponse =
  /** status 200 OK */ TextDocumentsDto;
export type ListDocumentTemplatesApiArg = void;
export type CreateDocumentTemplateApiResponse =
  /** status 201 Created */ TextDocumentDto;
export type CreateDocumentTemplateApiArg = {
  createDocumentTemplateRequest: CreateDocumentTemplateRequest;
};
export type CreateFencyStreamSessionApiResponse =
  /** status 200 OK */ FencySessionResponse;
export type CreateFencyStreamSessionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type SubmitCancellationNoticeApiResponse =
  /** status 201 Created */ DoffinSubmissionResponseDto;
export type SubmitCancellationNoticeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  sourcingEventId: string;
};
export type SubmitContractAwardNoticeApiResponse =
  /** status 201 Created */ DoffinSubmissionResponseDto;
export type SubmitContractAwardNoticeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  sourcingEventId: string;
  submitContractAwardNoticeRequest: SubmitContractAwardNoticeRequest;
};
export type PreviewContractAwardNoticeApiResponse =
  /** status 200 OK */ ContractAwardNoticePreviewDto;
export type PreviewContractAwardNoticeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  sourcingEventId: string;
};
export type SubmitContractModificationNoticeApiResponse =
  /** status 201 Created */ DoffinSubmissionResponseDto;
export type SubmitContractModificationNoticeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  sourcingEventId: string;
  submitContractModificationNoticeRequest: SubmitContractModificationNoticeRequest;
};
export type PreviewContractModificationNoticeApiResponse =
  /** status 200 OK */ ContractModificationPreviewDto;
export type PreviewContractModificationNoticeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  sourcingEventId: string;
};
export type SubmitIntentionNoticeApiResponse =
  /** status 201 Created */ DoffinSubmissionResponseDto;
export type SubmitIntentionNoticeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  sourcingEventId: string;
};
export type SubmitNoWinnerNoticeApiResponse =
  /** status 201 Created */ DoffinSubmissionResponseDto;
export type SubmitNoWinnerNoticeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  sourcingEventId: string;
  submitNoWinnerNoticeRequest: SubmitNoWinnerNoticeRequest;
};
export type SubmitQualificationSchemeEndNoticeApiResponse =
  /** status 201 Created */ DoffinSubmissionResponseDto;
export type SubmitQualificationSchemeEndNoticeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  sourcingEventId: string;
};
export type SubmitDoffinNoticeApiResponse =
  /** status 201 Created */ DoffinSubmissionResponseDto;
export type SubmitDoffinNoticeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  sourcingEventId: string;
};
export type ValidateDoffinNoticeApiResponse = unknown;
export type ValidateDoffinNoticeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  sourcingEventId: string;
};
export type DownloadTextDocumentApiResponse = unknown;
export type DownloadTextDocumentApiArg = {
  downloadTextDocumentRequest: DownloadTextDocumentRequest;
};
export type UpdateEmailStatusApiResponse = unknown;
export type UpdateEmailStatusApiArg = void;
export type GetSeAttachmentDownloadLinkApiResponse =
  /** status 200 OK */ SeAttachmentDownloadLinkResponse;
export type GetSeAttachmentDownloadLinkApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  documentId: string;
};
export type ConfirmFencyEventApiResponse = unknown;
export type ConfirmFencyEventApiArg = void;
export type MarkUploadFailedApiResponse = unknown;
export type MarkUploadFailedApiArg = void;
export type ConfirmUploadApiResponse = unknown;
export type ConfirmUploadApiArg = void;
export type SearchIndustriesApiResponse =
  /** status 200 OK */ SearchIndustriesResponse;
export type SearchIndustriesApiArg = {
  name?: string;
};
export type ListLibraryElementsApiResponse =
  /** status 200 OK */ LibraryElementsDto;
export type ListLibraryElementsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type CreateLibraryElementApiResponse =
  /** status 201 Created */ LibraryElementDto;
export type CreateLibraryElementApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createLibraryElementRequest: CreateLibraryElementRequest;
};
export type UpdateLibraryElementApiResponse =
  /** status 200 OK */ LibraryElementDto;
export type UpdateLibraryElementApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  updateLibraryElementRequest: UpdateLibraryElementRequest;
};
export type DeleteLibraryElementApiResponse = unknown;
export type DeleteLibraryElementApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  id: string;
};
export type GetMarketDialogueInviteApiResponse =
  /** status 200 OK */ MarketDialogueInviteDto;
export type GetMarketDialogueInviteApiArg = {
  secret: string;
  inviteId: string;
};
export type ListMarketDialoguesApiResponse =
  /** status 200 OK */ MarketDialogueListDto;
export type ListMarketDialoguesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type CreateMarketDialogueApiResponse =
  /** status 201 Created */ MarketDialogueDto;
export type CreateMarketDialogueApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createMarketDialogueRequest: CreateMarketDialogueRequest;
};
export type DeleteMarketDialogueApiResponse = unknown;
export type DeleteMarketDialogueApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
};
export type GetMarketDialogueApiResponse =
  /** status 200 OK */ MarketDialogueDto;
export type GetMarketDialogueApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
};
export type UpdateMarketDialogueApiResponse =
  /** status 200 OK */ MarketDialogueDto;
export type UpdateMarketDialogueApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
  updateMarketDialogueRequest: UpdateMarketDialogueRequest;
};
export type ListMarketDialogueAnswersApiResponse =
  /** status 200 OK */ ReceivedMarketDialogueAnswersDto;
export type ListMarketDialogueAnswersApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
};
export type CommentOnMarketDialogueAnswerApiResponse =
  /** status 200 OK */ MarketDialogueAnswerCommentDto;
export type CommentOnMarketDialogueAnswerApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
  answerId: string;
  addMarketDialogueAnswerCommentRequest: AddMarketDialogueAnswerCommentRequest;
};
export type StartCompetitionFromMarketDialogueApiResponse =
  /** status 201 Created */ SourcingEventDto;
export type StartCompetitionFromMarketDialogueApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
  startCompetitionRequest: StartCompetitionRequest;
};
export type GetCompetitionPlanApiResponse =
  /** status 200 OK */ CompetitionPlanDto;
export type GetCompetitionPlanApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
};
export type RemoveMarketDialogueDocumentApiResponse =
  /** status 200 OK */ MarketDialogueDto;
export type RemoveMarketDialogueDocumentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
  documentId: string;
};
export type MarkMarketDialogueAnswerApiResponse =
  /** status 200 OK */ ReceivedMarketDialogueAnswersDto;
export type MarkMarketDialogueAnswerApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
  markMarketDialogueAnswerRequest: MarkMarketDialogueAnswerRequest;
};
export type SummariseMarketDialogueApiResponse =
  /** status 200 OK */ ReceivedMarketDialogueAnswersDto;
export type SummariseMarketDialogueApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
  summariseMarketDialogueRequest: SummariseMarketDialogueRequest;
};
export type InviteEmailToMarketDialogueApiResponse =
  /** status 200 OK */ MarketDialogueDto;
export type InviteEmailToMarketDialogueApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
  inviteEmailToMarketDialogueRequest: InviteEmailToMarketDialogueRequest;
};
export type InviteOrganizationToMarketDialogueApiResponse =
  /** status 200 OK */ MarketDialogueDto;
export type InviteOrganizationToMarketDialogueApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
  inviteOrganizationToMarketDialogueRequest: InviteOrganizationToMarketDialogueRequest;
};
export type WithdrawMarketDialogueInvitationApiResponse =
  /** status 200 OK */ MarketDialogueDto;
export type WithdrawMarketDialogueInvitationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
  invitationId: string;
};
export type LinkMarketDialogueToNeedApiResponse =
  /** status 200 OK */ MarketDialogueDto;
export type LinkMarketDialogueToNeedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
  linkMarketDialogueNeedRequest: LinkMarketDialogueNeedRequest;
};
export type PublishMarketDialogueApiResponse =
  /** status 200 OK */ MarketDialogueDto;
export type PublishMarketDialogueApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
  publishMarketDialogueRequest: PublishMarketDialogueRequest;
};
export type ListMarketDialogueQuestionsApiResponse =
  /** status 200 OK */ SupplierQuestionsDto;
export type ListMarketDialogueQuestionsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
};
export type ReplyToMarketDialogueQuestionApiResponse =
  /** status 200 OK */ SupplierQuestionsDto;
export type ReplyToMarketDialogueQuestionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
  answerId: string;
  questionId: string;
  replyToSupplierQuestionRequest: ReplyToSupplierQuestionRequest;
};
export type ShareWithMarketDialogueParticipantsApiResponse =
  /** status 200 OK */ MarketDialogueDto;
export type ShareWithMarketDialogueParticipantsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
  shareWithParticipantsRequest: ShareWithParticipantsRequest;
};
export type ListMarketDialogueSupplierSuggestionsApiResponse =
  /** status 200 OK */ SuggestedSuppliersDto;
export type ListMarketDialogueSupplierSuggestionsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
};
export type GetMarketDialogueTeamApiResponse =
  /** status 200 OK */ MarketDialogueTeamDto;
export type GetMarketDialogueTeamApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
};
export type AddMarketDialogueTeamMemberApiResponse =
  /** status 200 OK */ MarketDialogueTeamDto;
export type AddMarketDialogueTeamMemberApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
  addMarketDialogueTeamMemberRequest: AddMarketDialogueTeamMemberRequest;
};
export type RemoveMarketDialogueTeamMemberApiResponse =
  /** status 200 OK */ MarketDialogueTeamDto;
export type RemoveMarketDialogueTeamMemberApiArg = {
  cookie?: string;
  organizationId?: string;
  headerPersonId?: string;
  marketDialogueId: string;
  pathPersonId: string;
};
export type CreateUploadForMarketDialogueApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForMarketDialogueApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type DismissNotificationsApiResponse = unknown;
export type DismissNotificationsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  markNotificationsRequest: MarkNotificationsRequest;
};
export type GetMyNeedsWaitingApiResponse = /** status 200 OK */ NeedsWaitingDto;
export type GetMyNeedsWaitingApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type ListMyNotificationsApiResponse =
  /** status 200 OK */ ListNotificationsResponse;
export type ListMyNotificationsApiArg = {
  limit?: number;
  offset?: number;
  unseen?: boolean;
  /** Only unread notifications. Unlike unseen, opening the list does not clear them. Without a limit, all are returned. */
  unread?: boolean;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type ListOrganizationUsersApiResponse =
  /** status 200 OK */ ListOrganizationUsersResponse;
export type ListOrganizationUsersApiArg = {
  name?: string;
  limit: number;
  skip?: number;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type ListOrganizationsForMeApiResponse =
  /** status 200 OK */ ListOrganizationsForMeResponse;
export type ListOrganizationsForMeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type CreateOrganizationForMeApiResponse = /** status 200 OK */ OrgDto;
export type CreateOrganizationForMeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createOrgRequest: CreateOrgRequest;
};
export type MarkNotificationsAsPeekedApiResponse = unknown;
export type MarkNotificationsAsPeekedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  markNotificationsRequest: MarkNotificationsRequest;
};
export type ListMyRecentlyViewedContractsApiResponse =
  /** status 200 OK */ ListRecentlyViewedContractsResponse;
export type ListMyRecentlyViewedContractsApiArg = {
  limit?: number;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type ListMyRecentlyViewedSourcingEventsApiResponse =
  /** status 200 OK */ ListRecentlyViewedEventsResponse;
export type ListMyRecentlyViewedSourcingEventsApiArg = {
  limit?: number;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type ListMyUpcomingDeadlinesApiResponse =
  /** status 200 OK */ ListUpcomingDeadlinesResponse;
export type ListMyUpcomingDeadlinesApiArg = {
  withinDays?: number;
  overdueDays?: number;
  /** Upcoming deadlines per page, at most 50. */
  upcomingLimit?: number;
  subjects?: DeadlineSubjects;
  /** Overdue deadlines per page, at most 50. */
  overdueLimit?: number;
  /** The nextUpcomingPosition of the previous page. That page then runs on past withinDays. */
  upcomingAfter?: string;
  /** The nextOverduePosition of the previous page. That page then runs on past overdueDays. */
  overdueAfter?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type MarkNotificationsAsViewedApiResponse = unknown;
export type MarkNotificationsAsViewedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  markNotificationsRequest: MarkNotificationsRequest;
};
export type CreateNeedApiResponse = /** status 201 Created */ NeedDto;
export type CreateNeedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createNeedRequest: CreateNeedRequest;
};
export type CreateNeedTextDocumentApiResponse =
  /** status 201 Created */ TextDocumentDto;
export type CreateNeedTextDocumentApiArg = {
  createNeedTextDocumentRequest: CreateNeedTextDocumentRequest;
};
export type ListTextDocumentsForNeedApiResponse =
  /** status 200 OK */ TextDocumentsDto;
export type ListTextDocumentsForNeedApiArg = {
  needId: string;
};
export type DeleteNeedDraftApiResponse = unknown;
export type DeleteNeedDraftApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  needId: string;
};
export type GetNeedApiResponse = /** status 200 OK */ NeedDto;
export type GetNeedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  needId: string;
};
export type UpdateNeedApiResponse = /** status 200 OK */ NeedDto;
export type UpdateNeedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  needId: string;
  needPatchDto: NeedPatchDto;
};
export type StartCallOffForNeedApiResponse = /** status 200 OK */ NeedDto;
export type StartCallOffForNeedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  needId: string;
  startCallOffForNeedRequest: StartCallOffForNeedRequest;
};
export type CreateProcurementForNeedApiResponse = /** status 200 OK */ NeedDto;
export type CreateProcurementForNeedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  needId: string;
  createProcurementForNeedRequest: CreateProcurementForNeedRequest;
};
export type StartMiniCompetitionForNeedApiResponse =
  /** status 200 OK */ NeedDto;
export type StartMiniCompetitionForNeedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  needId: string;
  startMiniCompetitionForNeedRequest: StartMiniCompetitionForNeedRequest;
};
export type SubmitNeedApiResponse = /** status 200 OK */ NeedDto;
export type SubmitNeedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  needId: string;
};
export type ListNeedsApiResponse = /** status 200 OK */ ListNeedsResponse;
export type ListNeedsApiArg = {
  /** Filtrer på status, kommaseparert: DRAFT, REPORTED, SENT_BACK, APPROVED, PLANNED, FRAMEWORK_RECOMMENDED, PROCUREMENT_CREATED, UNDER_PROCUREMENT, UNDER_CALL_OFF, COMPLETED, REJECTED, WITHDRAWN. */
  status?: string;
  /** The needs waiting for innkjøp, by the same rule as the home page: Queue is what the caller may take, oldest first; Mine is what the caller is responsible for with nothing started. Status is ignored. */
  waiting?: NeedWaitingListDto;
  /** The needs behind a figure on Oversikt › Behov, by the same rule as the figure, for the period in `from` and `to`, narrowed to `status` and `department` when given. The queue figure is listed with `waiting=Queue`. */
  figure?: NeedFigureListDto;
  /** First day of the figure's period. */
  from?: string;
  /** Last day of the figure's period. */
  to?: string;
  /** With figure: only the figure's needs in this department. */
  department?: string;
  /** With waiting=Mine: the responsible buyer whose needs to list instead of the caller's. */
  responsible?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type GetNeedForProcurementApiResponse =
  /** status 200 OK */ ProcurementNeedDto;
export type GetNeedForProcurementApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  sourcingEventId: string;
};
export type GetNeedOverviewApiResponse = /** status 200 OK */ NeedOverviewDto;
export type GetNeedOverviewApiArg = {
  /** First day of the period. */
  from: string;
  /** Last day of the period. */
  to: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type CreateMarketDialogueForNeedApiResponse =
  /** status 201 Created */ MarketDialogueDto;
export type CreateMarketDialogueForNeedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  needId: string;
};
export type CreateUploadForNeedApiResponse = /** status 200 OK */ UploadDto;
export type CreateUploadForNeedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  needId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type GetAccessTokenApiResponse = /** status 200 OK */ AccessTokenDto;
export type GetAccessTokenApiArg = {
  getAccessTokenRequest: GetAccessTokenRequest;
};
export type SearchBrregOrgsByNameApiResponse =
  /** status 200 OK */ SearchBrregOrgsByNameResponse;
export type SearchBrregOrgsByNameApiArg = {
  query: string;
  limit?: number;
};
export type LookupBrregOrgApiResponse = /** status 200 OK */ BrregOrgDto;
export type LookupBrregOrgApiArg = {
  organizationNumber: string;
};
export type ListContractsForOrgApiResponse =
  /** status 200 OK */ ListContractsResponseDto;
export type ListContractsForOrgApiArg = {
  title?: string;
  state?: ContractStateDto;
  statuses?: string;
  counterparties?: string;
  owners?: string;
  templates?: string;
  internalparties?: string;
  projects?: string;
  limit: number;
  skip?: number;
};
export type CreateApiClientApiResponse =
  /** status 200 OK */ CreateApiClientResponse;
export type CreateApiClientApiArg = {
  cookie?: string;
};
export type CreateOrganizationEntryApiResponse =
  /** status 200 OK */ OrganizationEntryDto;
export type CreateOrganizationEntryApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createOrganizationEntryRequest: CreateOrganizationEntryRequest;
};
export type GetOrganizationEntryApiResponse =
  /** status 200 OK */ OrganizationEntryDto;
export type GetOrganizationEntryApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  entryId: string;
};
export type UpdateOrganizationEntryApiResponse =
  /** status 200 OK */ OrganizationEntryDto;
export type UpdateOrganizationEntryApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  entryId: string;
  updateOrganizationEntryRequest: UpdateOrganizationEntryRequest;
};
export type LinkOrganizationEntryApiResponse =
  /** status 200 OK */ OrganizationEntryDto;
export type LinkOrganizationEntryApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  entryId: string;
  linkOrganizationEntryRequest: LinkOrganizationEntryRequest;
};
export type GetSupplierEmailInviteApiResponse =
  /** status 200 OK */ SupplierEmailInviteDto;
export type GetSupplierEmailInviteApiArg = {
  secret: string;
  inviteId: string;
};
export type GetOrgUserEmailInviteApiResponse =
  /** status 200 OK */ OrgUserEmailInviteDto;
export type GetOrgUserEmailInviteApiArg = {
  secret: string;
  inviteId: string;
};
export type AcceptOrgUserEmailInviteApiResponse = /** status 200 OK */ OrgDto;
export type AcceptOrgUserEmailInviteApiArg = {
  secret: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  inviteId: string;
};
export type ListAssessmentTemplatesApiResponse =
  /** status 200 OK */ AssessmentTemplatesDto;
export type ListAssessmentTemplatesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type UpdateAssessmentApiResponse =
  /** status 200 Updated assessment */ AssessmentDto;
export type UpdateAssessmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  id: string;
  updateAssessmentRequestDto: UpdateAssessmentRequestDto;
};
export type ListAssessmentsApiResponse = /** status 200 OK */ AssessmentsDto;
export type ListAssessmentsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type ListOrgsByNumberApiResponse =
  /** status 200 OK */ ListOrgsByNumberResponse;
export type ListOrgsByNumberApiArg = {
  country: string;
  number: string;
};
export type UpdateOrganizationApiResponse = /** status 200 OK */ OrgDto;
export type UpdateOrganizationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  editOrganizationRequest: EditOrganizationRequest;
};
export type ListAccessGrantsApiResponse =
  /** status 200 OK */ ListAccessGrantsResponse;
export type ListAccessGrantsApiArg = {
  queryPersonId?: string;
  departmentId?: string;
  cookie?: string;
  organizationId?: string;
  headerPersonId?: string;
  orgId: string;
};
export type GetOrganizationAiSkillsApiResponse =
  /** status 200 OK */ AiSkillsDto;
export type GetOrganizationAiSkillsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type RequestOrganizationAiSkillAccessApiResponse =
  /** status 200 OK */ AiSkillAccessRequestDto;
export type RequestOrganizationAiSkillAccessApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  skill: string;
};
export type ListAuditLogApiResponse = /** status 200 OK */ AuditLogPageDto;
export type ListAuditLogApiArg = {
  /** The first day of the period, in Norwegian time. */
  from?: string;
  /** The last day of the period, in Norwegian time. */
  to?: string;
  /** Only what this person did, or support did as them. */
  person?: string;
  /** Only entries of this event type. */
  eventType?: string;
  /** The nextPosition of the previous page. */
  after?: string;
  /** Entries per page, at most 1000. Defaults to 50. */
  limit?: number;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type GetAuditLogFiltersApiResponse =
  /** status 200 OK */ AuditLogFiltersDto;
export type GetAuditLogFiltersApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type DownloadAuditLogApiResponse = unknown;
export type DownloadAuditLogApiArg = {
  /** The file to write: XLSX (default), CSV (semicolon-separated, UTF-8) or PDF (with the selection and date on top). */
  format?: ListExportFormat;
  /** The first day of the period, in Norwegian time. */
  from?: string;
  /** The last day of the period, in Norwegian time. */
  to?: string;
  /** Only what this person did, or support did as them. */
  person?: string;
  /** Only entries of this event type. */
  eventType?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type ListDepartmentsApiResponse =
  /** status 200 OK */ ListDepartmentsResponse;
export type ListDepartmentsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type CreateDepartmentApiResponse =
  /** status 201 Created */ DepartmentDto;
export type CreateDepartmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  departmentNameRequest: DepartmentNameRequest;
};
export type RenameDepartmentApiResponse = /** status 200 OK */ DepartmentDto;
export type RenameDepartmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  departmentId: string;
  departmentNameRequest: DepartmentNameRequest;
};
export type ActivateDepartmentApiResponse = /** status 200 OK */ DepartmentDto;
export type ActivateDepartmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  departmentId: string;
};
export type DeactivateDepartmentApiResponse =
  /** status 200 OK */ DepartmentDto;
export type DeactivateDepartmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  departmentId: string;
};
export type AssignDepartmentRoleApiResponse = unknown;
export type AssignDepartmentRoleApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  departmentId: string;
  departmentRoleRequest: DepartmentRoleRequest;
};
export type RevokeDepartmentRoleApiResponse = unknown;
export type RevokeDepartmentRoleApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  departmentId: string;
  departmentRoleRequest: DepartmentRoleRequest;
};
export type ListDuplicateOrganizationsApiResponse =
  /** status 200 OK */ DuplicateOrganizationsDto;
export type ListDuplicateOrganizationsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type ListEntraConnectionsApiResponse =
  /** status 200 OK */ EntraConnectionsDto;
export type ListEntraConnectionsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type CreateEntraConnectionApiResponse =
  /** status 200 OK */ EntraConnectionDto;
export type CreateEntraConnectionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  createEntraConnectionRequest: CreateEntraConnectionRequest;
};
export type DeleteEntraConnectionApiResponse = unknown;
export type DeleteEntraConnectionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  connectionId: string;
};
export type UpdateEntraConnectionApiResponse =
  /** status 200 OK */ EntraConnectionDto;
export type UpdateEntraConnectionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  connectionId: string;
  updateEntraConnectionRequest: UpdateEntraConnectionRequest;
};
export type SaveEntraGroupMappingApiResponse =
  /** status 200 OK */ EntraGroupMappingDto;
export type SaveEntraGroupMappingApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  connectionId: string;
  saveEntraGroupMappingRequest: SaveEntraGroupMappingRequest;
};
export type DeleteEntraGroupMappingApiResponse = unknown;
export type DeleteEntraGroupMappingApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  connectionId: string;
  mappingId: string;
};
export type RequestOrganizationMergeApiResponse =
  /** status 200 OK */ OrganizationMergeRequestDto;
export type RequestOrganizationMergeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  requestOrganizationMergeRequest: RequestOrganizationMergeRequest;
};
export type AcceptOrganizationMergeApiResponse =
  /** status 200 OK */ OrganizationMergeRequestDto;
export type AcceptOrganizationMergeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  requestId: string;
};
export type DeclineOrganizationMergeApiResponse =
  /** status 200 OK */ OrganizationMergeRequestDto;
export type DeclineOrganizationMergeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  requestId: string;
};
export type GetOrganizationApiResponse =
  /** status 200 OK */ OrgPublicProfileDto;
export type GetOrganizationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type ListSupplierEmailInvitesApiResponse =
  /** status 200 OK */ ListOrganizationInvitesResponse;
export type ListSupplierEmailInvitesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type CreateSupplierEmailInviteApiResponse =
  /** status 200 OK */ SupplierEmailInviteDto;
export type CreateSupplierEmailInviteApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  createEmailInviteRequest: CreateEmailInviteRequest;
};
export type DeleteSupplierEmailInviteApiResponse = unknown;
export type DeleteSupplierEmailInviteApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  inviteId: string;
};
export type CreateSupplierEmailInviteReminderApiResponse = unknown;
export type CreateSupplierEmailInviteReminderApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  inviteId: string;
};
export type ListOrgUserEmailInvitesApiResponse =
  /** status 200 OK */ ListOrgUserEmailInvitesResponse;
export type ListOrgUserEmailInvitesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type CreateOrgUserEmailInviteApiResponse =
  /** status 200 OK */ SupplierEmailInviteDto;
export type CreateOrgUserEmailInviteApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  createOrgUserEmailInviteRequest: CreateOrgUserEmailInviteRequest;
};
export type DeleteOrgUserEmailInviteApiResponse = unknown;
export type DeleteOrgUserEmailInviteApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  inviteId: string;
};
export type DeleteOrgUserApiResponse = /** status 200 OK */ OrgDto;
export type DeleteOrgUserApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  userId: string;
};
export type UpdateOrgUserRoleApiResponse = /** status 200 OK */ OrgDto;
export type UpdateOrgUserRoleApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  userId: string;
  updateOrgUserRoleRequest: UpdateOrgUserRoleRequest;
};
export type GetContractTaskWorkloadApiResponse =
  /** status 200 OK */ ContractTaskWorkloadDto;
export type GetContractTaskWorkloadApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type ListContractTasksForOrganizationApiResponse =
  /** status 200 OK */ ListContractTasksResponseDto;
export type ListContractTasksForOrganizationApiArg = {
  /** Tasks per page, at most 1000, which is also the default. */
  limit?: number;
  /** The nextPosition of the previous page. */
  after?: number;
  statuses?: string;
  personIds?: string;
  contractIds?: string;
  /** Only tasks due before this date. */
  dueBefore?: string;
  /** Only tasks last changed on or after this date, in Norwegian time. */
  changedSince?: string;
  /** Which tasks a limit keeps: the next due (default) or the most recently changed. */
  sortBy?: ContractTaskSortDto;
  /** Also count the tasks the filters leave that the viewer may see, among at most 3000 matching tasks. */
  withCount?: boolean;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type ListContractTemplatesApiResponse =
  /** status 200 OK */ ListContractTemplatesResponseDto;
export type ListContractTemplatesApiArg = {
  contractId?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type CreateContractTemplateApiResponse =
  /** status 200 OK */ ContractTemplateDto;
export type CreateContractTemplateApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  upsertContractTemplateRequest: UpsertContractTemplateRequest;
};
export type GetTaskApiResponse = /** status 200 OK */ ContractTaskDto;
export type GetTaskApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  taskId: string;
};
export type UpdateContractTemplateApiResponse =
  /** status 200 OK */ ContractTemplateDto;
export type UpdateContractTemplateApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  templateId: string;
  upsertContractTemplateRequest: UpsertContractTemplateRequest;
};
export type DeleteContractDraftApiResponse = unknown;
export type DeleteContractDraftApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
};
export type GetContractApiResponse = /** status 200 OK */ ContractDto;
export type GetContractApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
};
export type UpdateContractApiResponse = /** status 200 OK */ ContractDto;
export type UpdateContractApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  updateContractRequest: UpdateContractRequest;
};
export type CopyContractApiResponse = /** status 200 OK */ ContractDto;
export type CopyContractApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
};
export type PublishContractApiResponse = /** status 200 OK */ ContractDto;
export type PublishContractApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
};
export type CreateSignedDocumentApiResponse = /** status 200 OK */ ContractDto;
export type CreateSignedDocumentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  createSignedDocumentRequest: CreateSignedDocumentRequest;
};
export type CreateSignedTextDocumentApiResponse =
  /** status 200 OK */ ContractDto;
export type CreateSignedTextDocumentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  createSignedTextDocumentRequest: CreateSignedTextDocumentRequest;
};
export type ListContractTasksApiResponse =
  /** status 200 OK */ ListContractTasksResponseDto;
export type ListContractTasksApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
};
export type CreateContractApiResponse = /** status 200 OK */ ContractDto;
export type CreateContractApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  depId: string;
  createContractRequest: CreateContractRequest;
};
export type ListPersonsApiResponse = /** status 200 OK */ ListPersonsResponse;
export type ListPersonsApiArg = {
  orgIds: string[];
  name?: string;
  capability?: PersonSearchCapability;
  roles?: (
    | "Owner"
    | "Admin"
    | "SourcingCreator"
    | "SourcingViewer"
    | "ContractCreator"
    | "ContractViewer"
    | "ProjectViewer"
    | "ProjectCreator"
  )[];
  departmentId?: string;
  unplaced?: boolean;
  limit: number;
  skip?: number;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type GetPersonsByIdsApiResponse =
  /** status 200 OK */ ListPersonsByIdsResponse;
export type GetPersonsByIdsApiArg = {
  personIds: string[];
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type GetMeApiResponse = /** status 200 OK */ MeDto;
export type GetMeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type UpdateMeApiResponse = /** status 200 OK */ MeDto;
export type UpdateMeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  editMeRequest: EditMeRequest;
};
export type GetBidApiResponse = /** status 200 OK */ BidDto;
export type GetBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
};
export type UpdateBidApiResponse = /** status 200 OK */ BidDto;
export type UpdateBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  bidPatchDto: BidPatchDto;
};
export type ListContributingEntitiesApiResponse =
  /** status 200 OK */ ContributingEntityListDto;
export type ListContributingEntitiesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
};
export type AddContributingEntityApiResponse =
  /** status 200 OK */ ContributingEntityDto;
export type AddContributingEntityApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  addContributingEntityRequestDto: AddContributingEntityRequestDto;
};
export type RemoveContributingEntityApiResponse = unknown;
export type RemoveContributingEntityApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  entityId: string;
};
export type GetContributingEntityResponseApiResponse =
  /** status 200 OK */ ContributingEntityDetailDto;
export type GetContributingEntityResponseApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  entityId: string;
};
export type UpdateContributingEntityApiResponse =
  /** status 200 OK */ ContributingEntityDto;
export type UpdateContributingEntityApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  entityId: string;
  updateContributingEntityRequestDto: UpdateContributingEntityRequestDto;
};
export type ResendContributingEntityInvitationApiResponse =
  /** status 200 OK */ ContributingEntityDto;
export type ResendContributingEntityInvitationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  entityId: string;
};
export type ReopenContributingEntityResponseApiResponse =
  /** status 200 OK */ ContributingEntityDto;
export type ReopenContributingEntityResponseApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  entityId: string;
};
export type PreviewBidReportApiResponse = unknown;
export type PreviewBidReportApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
};
export type StartBidSigningApiResponse =
  /** status 200 OK */ StartBidSigningResponseDto;
export type StartBidSigningApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  startBidSigningRequestDto: StartBidSigningRequestDto;
};
export type CancelBidSigningApiResponse =
  /** status 200 OK */ CancelBidSigningResponseDto;
export type CancelBidSigningApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  cancelBidSigningRequestDto: CancelBidSigningRequestDto;
};
export type GetBidSigningPreflightApiResponse =
  /** status 200 OK */ BidPreflightDto;
export type GetBidSigningPreflightApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
};
export type AcceptBidTermsApiResponse = /** status 200 OK */ BidDto;
export type AcceptBidTermsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
};
export type CreateUploadForBidApiResponse = /** status 200 OK */ UploadDto;
export type CreateUploadForBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type WithdrawBidApiResponse = /** status 200 OK */ BidDto;
export type WithdrawBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
};
export type GetContributingEntityApiResponse =
  /** status 200 OK */ ContributingEntityDetailDto;
export type GetContributingEntityApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  entityId: string;
};
export type UpdateContributingEntityResponseApiResponse =
  /** status 200 OK */ ContributingEntityDetailDto;
export type UpdateContributingEntityResponseApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  entityId: string;
  updateContributingEntityResponseRequestDto: UpdateContributingEntityResponseRequestDto;
};
export type UpdateContributingEntityCommitmentApiResponse =
  /** status 200 OK */ ContributingEntityDetailDto;
export type UpdateContributingEntityCommitmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  entityId: string;
  updateContributingEntityCommitmentRequestDto: UpdateContributingEntityCommitmentRequestDto;
};
export type UpdateContributingEntityQualificationResponsesApiResponse =
  /** status 200 OK */ ContributingEntityDetailDto;
export type UpdateContributingEntityQualificationResponsesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  entityId: string;
  updateContributingEntityQualificationResponsesRequestDto: UpdateContributingEntityQualificationResponsesRequestDto;
};
export type SubmitContributingEntityResponseApiResponse =
  /** status 200 OK */ ContributingEntityDetailDto;
export type SubmitContributingEntityResponseApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  entityId: string;
};
export type GetPortalSourcingEventsApiResponse =
  /** status 200 OK */ PortalSourcingEventsResponse;
export type GetPortalSourcingEventsApiArg = {
  cursor?: string;
  limit?: number;
  q?: string;
  lifecycle?: (
    | "OPEN"
    | "DEADLINE_PASSED"
    | "UNDER_EVALUATION"
    | "AWARDED"
    | "CANCELLED"
    | "CONCLUDED"
  )[];
};
export type GetPortalSourcingEventApiResponse =
  /** status 200 OK */ PortalSourcingEventDetailDto;
export type GetPortalSourcingEventApiArg = {
  eventId: string;
};
export type GetPortalSeAttachmentUploadApiResponse =
  /** status 200 OK */ SeAttachmentUploadDto;
export type GetPortalSeAttachmentUploadApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  uploadId: string;
};
export type GetPortalAwardLetterApiResponse =
  /** status 200 OK */ PortalAwardLetterDto;
export type GetPortalAwardLetterApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CreateBidApiResponse = /** status 201 Created */ BidDto;
export type CreateBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type GetPortalDocumentDownloadLinkApiResponse =
  /** status 200 OK */ PortalDocumentDownloadLinkResponse;
export type GetPortalDocumentDownloadLinkApiArg = {
  eventId: string;
  documentId: string;
};
export type GetPortalMyBidDocumentsApiResponse =
  /** status 200 OK */ PortalBidDocumentsResponse;
export type GetPortalMyBidDocumentsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CreateParticipationRequestApiResponse =
  /** status 201 Created */ ParticipationRequestDto;
export type CreateParticipationRequestApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type GetMyParticipationApiResponse =
  /** status 200 OK */ MyParticipationDto;
export type GetMyParticipationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CreateUploadForSeQuestionAttachmentApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForSeQuestionAttachmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type GetPortalSeQuestionsApiResponse =
  /** status 200 OK */ ListSeQuestionsResponse;
export type GetPortalSeQuestionsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type AskSeQuestionApiResponse = /** status 201 Created */ SeQuestionDto;
export type AskSeQuestionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  createSeQuestionRequest: CreateSeQuestionRequest;
};
export type SendSeClarificationMessageAsSupplierApiResponse =
  /** status 201 Created */ SeQuestionDto;
export type SendSeClarificationMessageAsSupplierApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  questionId: string;
  createSeQuestionMessageRequest: CreateSeQuestionMessageRequest;
};
export type RegisterPortalInterestApiResponse =
  /** status 200 OK */ PortalRegisterInterestResponse;
export type RegisterPortalInterestApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type GetPortalRegistrationStatusApiResponse =
  /** status 200 OK */ PortalRegistrationStatusResponse;
export type GetPortalRegistrationStatusApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type GetPortalSupplierInformationApiResponse =
  /** status 200 OK */ ListSupplierInformationResponse;
export type GetPortalSupplierInformationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type GetPortalMarketDialogueApiResponse =
  /** status 200 OK */ PortalMarketDialogueDto;
export type GetPortalMarketDialogueApiArg = {
  marketDialogueId: string;
};
export type GetPortalMarketDialogueDocumentDownloadLinkApiResponse =
  /** status 200 OK */ PortalDocumentDownloadLinkResponse;
export type GetPortalMarketDialogueDocumentDownloadLinkApiArg = {
  marketDialogueId: string;
  documentId: string;
};
export type GetAuthenticatedPortalSourcingEventsApiResponse =
  /** status 200 OK */ PortalSourcingEventsResponse;
export type GetAuthenticatedPortalSourcingEventsApiArg = {
  cursor?: string;
  limit?: number;
  q?: string;
  context?: PortalEventContextType;
  scope?: PortalEventScope;
  lifecycle?: (
    | "OPEN"
    | "DEADLINE_PASSED"
    | "UNDER_EVALUATION"
    | "AWARDED"
    | "CANCELLED"
    | "CONCLUDED"
  )[];
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type GetAuthenticatedPortalSourcingEventApiResponse =
  /** status 200 OK */ PortalSourcingEventDetailDto;
export type GetAuthenticatedPortalSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type AcceptPortalInviteApiResponse =
  /** status 200 OK */ AcceptPortalInviteResponse;
export type AcceptPortalInviteApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CreatePortalInitialBidApiResponse =
  /** status 201 Created */ PortalRoundBidCreatedDto;
export type CreatePortalInitialBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type SubmitPortalPrivateBidApiResponse =
  /** status 200 OK */ PortalRoundBidCreatedDto;
export type SubmitPortalPrivateBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
};
export type WithdrawPortalPrivateBidApiResponse =
  /** status 200 OK */ PortalRoundBidCreatedDto;
export type WithdrawPortalPrivateBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
};
export type DeclinePortalInviteApiResponse =
  /** status 200 OK */ DeclinePortalInviteResponse;
export type DeclinePortalInviteApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type GetPortalNegotiationRoundsApiResponse =
  /** status 200 OK */ ListPortalNegotiationRoundsResponse;
export type GetPortalNegotiationRoundsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CreatePortalRoundBidApiResponse =
  /** status 201 Created */ PortalRoundBidCreatedDto;
export type CreatePortalRoundBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
};
export type WithdrawPortalNegotiationRoundDeclineApiResponse = unknown;
export type WithdrawPortalNegotiationRoundDeclineApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
};
export type DeclinePortalNegotiationRoundApiResponse = unknown;
export type DeclinePortalNegotiationRoundApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
};
export type ConfirmPortalStandingBidApiResponse =
  /** status 201 Created */ PortalRoundBidCreatedDto;
export type ConfirmPortalStandingBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
};
export type GetPortalFrameworkAgreementsApiResponse =
  /** status 200 OK */ PortalFrameworkAgreementsDto;
export type GetPortalFrameworkAgreementsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type AcceptMarketDialogueInviteApiResponse =
  /** status 200 OK */ AcceptedMarketDialogueInviteDto;
export type AcceptMarketDialogueInviteApiArg = {
  secret: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  inviteId: string;
};
export type GetSupplierMarketDialogueApiResponse =
  /** status 200 OK */ SupplierMarketDialogueDto;
export type GetSupplierMarketDialogueApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
};
export type SaveMarketDialogueAnswerApiResponse =
  /** status 200 OK */ SupplierMarketDialogueDto;
export type SaveMarketDialogueAnswerApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
  saveMarketDialogueAnswerRequest: SaveMarketDialogueAnswerRequest;
};
export type RemoveMarketDialogueAnswerDocumentApiResponse =
  /** status 200 OK */ SupplierMarketDialogueDto;
export type RemoveMarketDialogueAnswerDocumentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
  documentId: string;
};
export type SendMarketDialogueAnswerApiResponse =
  /** status 200 OK */ SupplierMarketDialogueDto;
export type SendMarketDialogueAnswerApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
  saveMarketDialogueAnswerRequest: SaveMarketDialogueAnswerRequest;
};
export type CreateUploadForMarketDialogueAnswerApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForMarketDialogueAnswerApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
  uploadId: string;
  createMarketDialogueAnswerUploadRequestDto: CreateMarketDialogueAnswerUploadRequestDto;
};
export type GetSupplierMarketDialogueDocumentDownloadLinkApiResponse =
  /** status 200 OK */ PortalDocumentDownloadLinkResponse;
export type GetSupplierMarketDialogueDocumentDownloadLinkApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
  documentId: string;
};
export type AskMarketDialogueQuestionApiResponse =
  /** status 200 OK */ SupplierMarketDialogueDto;
export type AskMarketDialogueQuestionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  marketDialogueId: string;
  askSupplierQuestionRequest: AskSupplierQuestionRequest;
};
export type GetPortalMyBidsApiResponse =
  /** status 200 OK */ PortalMyBidsResponse;
export type GetPortalMyBidsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type ListMyContributionsApiResponse =
  /** status 200 OK */ ContributingEntityDetailListDto;
export type ListMyContributionsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type ListMyParticipationRequestsApiResponse =
  /** status 200 OK */ MyParticipationRequestsDto;
export type ListMyParticipationRequestsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type GetParticipationRequestApiResponse =
  /** status 200 OK */ ParticipationRequestDto;
export type GetParticipationRequestApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  requestId: string;
};
export type UpdateParticipationRequestApiResponse =
  /** status 200 OK */ ParticipationRequestDto;
export type UpdateParticipationRequestApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  requestId: string;
  participationRequestPatchDto: ParticipationRequestPatchDto;
};
export type SubmitParticipationRequestApiResponse =
  /** status 200 OK */ ParticipationRequestDto;
export type SubmitParticipationRequestApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  requestId: string;
};
export type WithdrawParticipationRequestApiResponse =
  /** status 200 OK */ ParticipationRequestDto;
export type WithdrawParticipationRequestApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  requestId: string;
};
export type EditProductGroupApiResponse = /** status 200 OK */ ProductGroupDto;
export type EditProductGroupApiArg = {
  editProductGroupDto: EditProductGroupDto;
};
export type CreateProductGroupApiResponse =
  /** status 201 Created */ ProductGroupDto;
export type CreateProductGroupApiArg = {
  createProductGroupDto: CreateProductGroupDto;
};
export type DeleteProductGroupApiResponse = unknown;
export type DeleteProductGroupApiArg = {
  productGroupId: string;
};
export type GetProductGroupsForProjectApiResponse =
  /** status 200 OK */ ProductGroupsDto;
export type GetProductGroupsForProjectApiArg = {
  projectId: string;
};
export type GetProductTemplatesApiResponse =
  /** status 200 OK */ ProductTemplatesDto;
export type GetProductTemplatesApiArg = void;
export type CreateProjectApiResponse = /** status 201 Created */ ProjectDto;
export type CreateProjectApiArg = {
  createProjectRequest: CreateProjectRequest;
};
export type CreateProjectTextDocumentApiResponse =
  /** status 201 Created */ TextDocumentDto;
export type CreateProjectTextDocumentApiArg = {
  createProjectTextDocumentRequest: CreateProjectTextDocumentRequest;
};
export type ListTextDocumentsForProjectApiResponse =
  /** status 200 OK */ TextDocumentsDto;
export type ListTextDocumentsForProjectApiArg = {
  projectId: string;
};
export type GetProjectApiResponse = /** status 200 OK */ ProjectDto;
export type GetProjectApiArg = {
  projectId: string;
};
export type UpdateProjectApiResponse = /** status 200 OK */ ProjectDto;
export type UpdateProjectApiArg = {
  projectId: string;
  projectPatchDto: ProjectPatchDto;
};
export type GetProjectsApiResponse = /** status 200 OK */ ProjectsDto;
export type GetProjectsApiArg = {
  name?: string;
  /** Filtrer på status, kommaseparert: NotStarted, Ongoing, Ended. */
  status?: string;
  limit?: number;
  skip?: number;
  /** Also count every project the filters leave that the viewer may see. */
  withCount?: boolean;
};
export type GetProjectsByIdsApiResponse = /** status 200 OK */ ProjectsDto;
export type GetProjectsByIdsApiArg = {
  projectIds: string[];
};
export type GetProjectOverviewApiResponse =
  /** status 200 OK */ ProjectOverviewDto;
export type GetProjectOverviewApiArg = {
  /** Which projects: ONGOING, NOT_STARTED, or ALL that have not ended. */
  scope?: ProjectOverviewScope;
  projectTypeId?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type CreateUploadForProjectDescriptionApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForProjectDescriptionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  projectId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type GetProjectProcurementSummaryApiResponse =
  /** status 200 OK */ ProjectProcurementSummaryDto;
export type GetProjectProcurementSummaryApiArg = {
  projectId: string;
};
export type DownloadProjectProcurementSummaryPdfApiResponse = unknown;
export type DownloadProjectProcurementSummaryPdfApiArg = {
  projectId: string;
};
export type CreateUploadForProjectApiResponse = /** status 200 OK */ UploadDto;
export type CreateUploadForProjectApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  projectId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type ListSavedReportsApiResponse =
  /** status 200 OK */ ListSavedReportsResponse;
export type ListSavedReportsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type CreateSavedReportApiResponse =
  /** status 201 Created */ SavedReportDto;
export type CreateSavedReportApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createSavedReportRequest: CreateSavedReportRequest;
};
export type DeleteSavedReportApiResponse = unknown;
export type DeleteSavedReportApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  savedReportId: string;
};
export type RenameSavedReportApiResponse = /** status 200 OK */ SavedReportDto;
export type RenameSavedReportApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  savedReportId: string;
  renameSavedReportRequest: RenameSavedReportRequest;
};
export type ReplaceSavedReportQueryApiResponse =
  /** status 200 OK */ SavedReportDto;
export type ReplaceSavedReportQueryApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  savedReportId: string;
  replaceSavedReportQueryRequest: ReplaceSavedReportQueryRequest;
};
export type ShareSavedReportApiResponse = /** status 200 OK */ SavedReportDto;
export type ShareSavedReportApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  savedReportId: string;
  shareSavedReportRequest: ShareSavedReportRequest;
};
export type StopSharingSavedReportApiResponse =
  /** status 200 OK */ SavedReportDto;
export type StopSharingSavedReportApiArg = {
  cookie?: string;
  organizationId?: string;
  headerPersonId?: string;
  savedReportId: string;
  pathPersonId: string;
};
export type GetGroupsApiResponse = /** status 200 OK */ GroupsDto;
export type GetGroupsApiArg = {
  authorization?: string;
};
export type CreateGroupApiResponse = /** status 200 OK */ GroupDto;
export type CreateGroupApiArg = {
  authorization?: string;
  createGroupDto: CreateGroupDto;
};
export type DeleteGroupApiResponse = unknown;
export type DeleteGroupApiArg = {
  authorization?: string;
  groupId: string;
};
export type GetGroupApiResponse = /** status 200 OK */ GroupDto;
export type GetGroupApiArg = {
  count?: number;
  startIndex?: number;
  authorization?: string;
  groupId: string;
};
export type UpdateGroupApiResponse = /** status 200 OK */ GroupDto;
export type UpdateGroupApiArg = {
  authorization?: string;
  groupId: string;
  updateGroupRequest: UpdateGroupRequest;
};
export type GetSchemasApiResponse = /** status 200 OK */ SchemasDto;
export type GetSchemasApiArg = void;
export type GetTokenApiResponse = /** status 200 OK */ TokenResponse;
export type GetTokenApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  authorization?: string;
};
export type GetTokenForConnectionApiResponse =
  /** status 200 OK */ TokenResponse;
export type GetTokenForConnectionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  authorization?: string;
  connectionId: string;
};
export type GetUsersApiResponse = /** status 200 OK */ UsersDto;
export type GetUsersApiArg = {
  authorization?: string;
};
export type CreateUserApiResponse = /** status 200 OK */ UserDto;
export type CreateUserApiArg = {
  authorization?: string;
  createUserDto: CreateUserDto;
};
export type DeleteUserApiResponse = unknown;
export type DeleteUserApiArg = {
  authorization?: string;
  userId: string;
};
export type GetUserApiResponse = /** status 200 OK */ UserDto;
export type GetUserApiArg = {
  authorization?: string;
  userId: string;
};
export type UpdateUserApiResponse = /** status 200 OK */ UserDto;
export type UpdateUserApiArg = {
  authorization?: string;
  userId: string;
};
export type SearchOrganizationsAndEntriesApiResponse =
  /** status 200 OK */ SearchOrganizationsAndEntriesResponse;
export type SearchOrganizationsAndEntriesApiArg = {
  name?: string;
  organizationNumber?: string;
  limit: number;
  skip?: number;
  type?: OrganizationType;
  excludeLinkedEntries?: boolean;
  /** Two-digit county numbers, comma separated */
  counties?: string;
  /** Municipality numbers, comma separated */
  municipalities?: string;
  /** NACE codes from Brønnøysund, comma separated */
  naceCodes?: string;
  /** SupplierRelationDto values, comma separated */
  relations?: string;
  withRelations?: boolean;
  /** SupplierRelationDto values to leave out, comma separated */
  withoutRelations?: string;
  withFacets?: boolean;
  /** Leaves out the organization the caller works in */
  excludeOwnOrganization?: boolean;
  /** A marked contract field and one value, as fieldId:value, once per value */
  contractField?: string[];
  /** A marked number, amount or percentage field and its lowest value, as fieldId:value; a percentage in percent */
  contractFieldAtLeast?: string[];
  /** A marked date field and a period, as fieldId:from:to with ISO dates; either end may be empty */
  contractFieldPeriod?: string[];
  /** Contracts whose end date is on or after this date */
  contractEndDateFrom?: string;
  /** Contracts whose end date is on or before this date */
  contractEndDateTo?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type UpdateSignedDocumentMetaApiResponse =
  /** status 200 OK */ SignedDocumentDto;
export type UpdateSignedDocumentMetaApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  docId: string;
  updateSignedDocumentMetaRequest: UpdateSignedDocumentMetaRequest;
};
export type GetSignedDocumentDownloadLinkApiResponse =
  /** status 200 OK */ GetDownloadLinkResponse;
export type GetSignedDocumentDownloadLinkApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  docId: string;
};
export type GetSignedAttachmentDownloadLinkApiResponse =
  /** status 200 OK */ GetDownloadLinkResponse;
export type GetSignedAttachmentDownloadLinkApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  docId: string;
  attachmentId: string;
};
export type ListSourcingEventTemplatesApiResponse =
  /** status 200 OK */ SourcingEventTemplatesDto;
export type ListSourcingEventTemplatesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type CreateSourcingEventTemplateApiResponse =
  /** status 201 Created */ SourcingEventTemplateDto;
export type CreateSourcingEventTemplateApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createSourcingEventTemplateRequest: CreateSourcingEventTemplateRequest;
};
export type UpdateSourcingEventTemplateApiResponse =
  /** status 200 OK */ SourcingEventTemplateDto;
export type UpdateSourcingEventTemplateApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  updateSourcingEventTemplateRequest: UpdateSourcingEventTemplateRequest;
};
export type DeleteSourcingEventTemplateApiResponse = unknown;
export type DeleteSourcingEventTemplateApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  id: string;
};
export type CreateSourcingEventTextDocumentApiResponse =
  /** status 201 Created */ TextDocumentDto;
export type CreateSourcingEventTextDocumentApiArg = {
  createSourcingEventTextDocumentRequest: CreateSourcingEventTextDocumentRequest;
};
export type ListTextDocumentsForSourcingEventApiResponse =
  /** status 200 OK */ TextDocumentsDto;
export type ListTextDocumentsForSourcingEventApiArg = {
  eventId: string;
};
export type GetProcurementCommentRoundsApiResponse =
  /** status 200 OK */ ProcurementCommentRoundsDto;
export type GetProcurementCommentRoundsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  sourcingEventId: string;
};
export type SendProcurementForCommentApiResponse =
  /** status 201 Created */ MarketDialogueDto;
export type SendProcurementForCommentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  sourcingEventId: string;
};
export type GetSeEmailInviteApiResponse = /** status 200 OK */ SeEmailInviteDto;
export type GetSeEmailInviteApiArg = {
  secret: string;
  inviteId: string;
};
export type AcceptSeEmailInviteApiResponse = unknown;
export type AcceptSeEmailInviteApiArg = {
  secret: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  inviteId: string;
};
export type GetProductGroupsAsSupplierApiResponse =
  /** status 200 OK */ SupplierProductGroupsDto;
export type GetProductGroupsAsSupplierApiArg = {
  sourcingEventId: string;
};
export type CreateUploadForBidAwardCriterionAttachmentApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForBidAwardCriterionAttachmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  uploadId: string;
  createBidAwardCriterionAttachmentUploadRequestDto: CreateBidAwardCriterionAttachmentUploadRequestDto;
};
export type CreateUploadForBidMinimumRequirementAttachmentApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForBidMinimumRequirementAttachmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  uploadId: string;
  createBidMinimumRequirementAttachmentUploadRequestDto: CreateBidMinimumRequirementAttachmentUploadRequestDto;
};
export type CreateUploadForBidQualificationEvidenceApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForBidQualificationEvidenceApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  uploadId: string;
  createBidQualificationEvidenceUploadRequestDto: CreateBidQualificationEvidenceUploadRequestDto;
};
export type UpdateTextDocumentApiResponse =
  /** status 201 Created */ TextDocumentDto;
export type UpdateTextDocumentApiArg = {
  updateTextDocumentRequest: UpdateTextDocumentRequest;
};
export type DeleteTextDocumentApiResponse = unknown;
export type DeleteTextDocumentApiArg = {
  id: string;
};
export type GetTextDocumentUploadStatusApiResponse =
  /** status 200 OK */ UploadStatusDto;
export type GetTextDocumentUploadStatusApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  textDocumentId: string;
  uploadId: string;
};
export type CreateUploadForTextDocumentApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForTextDocumentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  textDocumentId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type DeleteUploadApiResponse = /** status 200 OK */ UploadDto;
export type DeleteUploadApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  uploadId: string;
};
export type String = string;
export type AdminMigrateFencyFailure = {
  id: string;
  title: string;
  httpStatus?: number | null;
  reason: string;
};
export type AdminMigrateFencyResponse = {
  successCount: number;
  failureCount: number;
  failures?: AdminMigrateFencyFailure[];
};
export type AdminMigrateFencyRequest = {
  organizationId: string;
  documentType: MigrationDocumentType;
  limit: number;
};
export type AdminRestampFencyAccessRequest = {
  organizationId?: string | null;
  limit: number;
};
export type AdminMigrateFencyContractMetadataRequest = {
  organizationId: string;
  limit: number;
};
export type AdminFencyMigrationDocumentKindStats = {
  totalDocuments: number;
  missingFencyConfigCount: number;
  synchronizationErrorCount: number;
  missingAccessCount: number;
};
export type AdminFencyMigrationContractStats = {
  totalContracts: number;
  missingMemoryCount: number;
  synchronizationErrorCount: number;
  missingAccessCount: number;
};
export type AdminFencyMigrationStatsResponse = {
  regularDocuments: AdminFencyMigrationDocumentKindStats;
  signedDocuments: AdminFencyMigrationDocumentKindStats;
  contractMetadata: AdminFencyMigrationContractStats;
};
export type CallingCodeDto = {
  countryAlpha3Code: string;
  countryName: string;
  value: string;
};
export type PhoneNumberDto = {
  callingCode: CallingCodeDto;
  number: string;
};
export type PersonDto = {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  email: string;
  corporateTitle?: string | null;
  phoneNumber?: PhoneNumberDto | null;
};
export type CountryDto = {
  id: string;
  alpha3Code: string;
  name: string;
};
export type IndustryDto = {
  id: string;
  name: string;
};
export type SubscriptionDto = {
  hasBuyerAccess: boolean;
  hasContractAccess: boolean;
  hasSignatureAccess: boolean;
  hasBankIdAccess: boolean;
  hasProductAccess: boolean;
  hasProjectAccess: boolean;
  hasNegotiationAccess: boolean;
  hasAiAccess: boolean;
  hasDocumentTemplateAccess: boolean;
  hasIFRSAccess: boolean;
  hasOrganizationAssessmentAccess: boolean;
  hasFencyContractSearchAccess: boolean;
  hasAssistantAccess: boolean;
  hasAiBidInsightAccess: boolean;
  hasOutsideBidRegistrationAccess: boolean;
  hasNeedsAccess: boolean;
  fencySyncEnabled: boolean;
  devToolsEnabled?: boolean;
};
export type AvailabilityReasonDto = {
  code: AvailabilityReasonCodeDto;
  kind: ReasonKindDto;
};
export type OperationAvailabilityDto = {
  operation: string;
  allowed: boolean;
  reason?: AvailabilityReasonDto | null;
};
export type DepartmentDto = {
  id: string;
  name: string;
  isDefault: boolean;
  active: boolean;
  operations?: OperationAvailabilityDto[];
};
export type AdminOrgDto = {
  id: string;
  owner: PersonDto;
  name: string;
  country: CountryDto;
  industries: IndustryDto[];
  aboutUs?: string | null;
  specializations?: string | null;
  homePageUrl?: string | null;
  size?: OrganizationSize | null;
  subscription: SubscriptionDto;
  departments: DepartmentDto[];
  canSeeDeliveredBidsBeforeDeadline: boolean;
  buyerLegalType?: BuyerLegalType | null;
  aiEndpoints: AiEndpoint[];
  aiEndpointsAreDefault: boolean;
  aiFairUseNok?: string | null;
  organizationNumber?: string | null;
};
export type AiFeatureEndpointsDto = {
  feature: AiFeature;
  endpoints: AiEndpoint[];
};
export type AdminListOrganizationsResponse = {
  orgs: AdminOrgDto[];
  count: number;
  aiFeatureEndpoints?: AiFeatureEndpointsDto[];
};
export type DepartmentRoleDto = {
  departmentId: string;
  departmentName: string;
  role: GrantRole;
};
export type CustomAmountFieldDto = {
  type: "CustomAmount";
  id: string;
  name: string;
  isInternal: boolean;
  amount?: number | null;
  currency?: string | null;
};
export type CustomBooleanFieldDto = {
  type: "CustomBoolean";
  id: string;
  name: string;
  isInternal: boolean;
  isChecked?: boolean | null;
};
export type CustomDateFieldDto = {
  type: "CustomDate";
  id: string;
  name: string;
  isInternal: boolean;
  date?: string | null;
};
export type CustomEmailFieldDto = {
  type: "CustomEmail";
  id: string;
  name: string;
  isInternal: boolean;
  email?: string | null;
};
export type CustomEnumFieldDto = {
  type: "CustomEnum";
  id: string;
  name: string;
  isInternal: boolean;
  options?: string[] | null;
  value?: string | null;
};
export type CustomMultiEnumFieldDto = {
  type: "CustomMultiEnum";
  id: string;
  name: string;
  isInternal: boolean;
  options?: string[] | null;
  values?: string[] | null;
};
export type CustomNumberFieldDto = {
  type: "CustomNumber";
  id: string;
  name: string;
  isInternal: boolean;
  value?: number | null;
};
export type CustomPercentageFieldDto = {
  type: "CustomPercentage";
  id: string;
  name: string;
  isInternal: boolean;
  value?: number | null;
};
export type CustomPersonFieldDto = {
  type: "CustomPerson";
  id: string;
  name: string;
  isInternal: boolean;
  person?: PersonDto | null;
};
export type CustomPhoneFieldDto = {
  type: "CustomPhone";
  id: string;
  name: string;
  isInternal: boolean;
  number?: string | null;
  callingCode?: string | null;
};
export type CustomRichTextFieldDto = {
  type: "CustomRichText";
  id: string;
  name: string;
  isInternal: boolean;
  text?: string | null;
};
export type CustomTagFieldDto = {
  type: "CustomTag";
  id: string;
  name: string;
  isInternal: boolean;
  tag?: string | null;
};
export type CustomTextFieldDto = {
  type: "CustomText";
  id: string;
  name: string;
  isInternal: boolean;
  text?: string | null;
};
export type CustomUrlFieldDto = {
  type: "CustomUrl";
  id: string;
  name: string;
  isInternal: boolean;
  url?: string | null;
};
export type CustomContractDataFieldDto =
  | CustomAmountFieldDto
  | CustomBooleanFieldDto
  | CustomDateFieldDto
  | CustomEmailFieldDto
  | CustomEnumFieldDto
  | CustomMultiEnumFieldDto
  | CustomNumberFieldDto
  | CustomPercentageFieldDto
  | CustomPersonFieldDto
  | CustomPhoneFieldDto
  | CustomRichTextFieldDto
  | CustomTagFieldDto
  | CustomTextFieldDto
  | CustomUrlFieldDto;
export type ContractDataFieldSectionDto = {
  id: string;
  name: string;
  fields: CustomContractDataFieldDto[];
};
export type LeadTimeDto = {
  unit: LeadTimeUnit;
  amount: number;
};
export type ContractNotificationReceiversDto = {
  persons: PersonDto[];
  organizationRoles: OrganizationRoleType[];
  contractRoles: ContractRole[];
};
export type ContractDateReminderDto = {
  leadTime: LeadTimeDto;
  receivers: ContractNotificationReceiversDto;
};
export type ReminderIntervalDto = {
  unit: IntervalUnit;
  amount: number;
};
export type RecurringContractReminderDto = {
  interval: ReminderIntervalDto;
  receivers: ContractNotificationReceiversDto;
};
export type ContractNotificationSettingsDto = {
  startDateNotifications: ContractDateReminderDto[];
  endDateNotifications: ContractDateReminderDto[];
  warrantyExpirationNotifications: ContractDateReminderDto[];
  renewalDateNotifications: ContractDateReminderDto[];
  terminationDateNotifications: ContractDateReminderDto[];
  noticePeriodNotifications: ContractDateReminderDto[];
  optionExecutionDeadlineNotifications: ContractDateReminderDto[];
  optionStartDateNotifications: ContractDateReminderDto[];
  noEndDateNotifications: RecurringContractReminderDto[];
};
export type ContractTaskNotificationReceiversDto = {
  contractTaskRoles: ContractTaskRole[];
};
export type ContractTaskDateReminderDto = {
  leadTime: LeadTimeDto;
  receivers: ContractTaskNotificationReceiversDto;
};
export type ContractTaskNotificationSettingsDto = {
  dueDateNotifications: ContractTaskDateReminderDto[];
};
export type SourcingEventNotificationReceiversDto = {
  persons: PersonDto[];
  organizationRoles: OrganizationRoleType[];
  sourcingEventRoles: SourcingEventRole[];
};
export type SourcingEventDateReminderDto = {
  leadTime: LeadTimeDto;
  receivers: SourcingEventNotificationReceiversDto;
};
export type SourcingEventNotificationSettingsDto = {
  bidDeliveryDeadlineNotifications: SourcingEventDateReminderDto[];
};
export type SupplierNotificationReceiversDto = {
  persons: PersonDto[];
  organizationRoles: OrganizationRoleType[];
};
export type SupplierNotificationSettingsDto = {
  inviteReceivers: SupplierNotificationReceiversDto;
  messageReceivers: SupplierNotificationReceiversDto;
};
export type FrameworkAgreementNotificationReceiversDto = {
  persons: PersonDto[];
  organizationRoles: OrganizationRoleType[];
  frameworkAgreementRoles: FrameworkAgreementRole[];
};
export type FrameworkValueReminderDto = {
  percentage: number;
  receivers: FrameworkAgreementNotificationReceiversDto;
};
export type FrameworkAgreementNotificationSettingsDto = {
  valueNotifications: FrameworkValueReminderDto[];
};
export type DefaultNotificationSettingsDto = {
  contractNotificationSettings: ContractNotificationSettingsDto;
  contractTaskNotificationSettings: ContractTaskNotificationSettingsDto;
  sourcingEventNotificationSettings: SourcingEventNotificationSettingsDto;
  supplierNotificationSettings?: SupplierNotificationSettingsDto | null;
  frameworkAgreementNotificationSettings?: FrameworkAgreementNotificationSettingsDto | null;
};
export type MinimalOrgDto = {
  type: OrganizationType;
  id: string;
  name: string;
  organizationNumber?: string | null;
  country: CountryDto;
};
export type ScimGroupDto = {
  id: string;
  displayName: string;
  memberCount: number;
};
export type OrgDto = {
  id: string;
  owner: PersonDto;
  name: string;
  country: CountryDto;
  organizationNumber?: string | null;
  industries: IndustryDto[];
  aboutUs?: string | null;
  standardTerms?: string | null;
  specializations?: string | null;
  homePageUrl?: string | null;
  street?: string | null;
  city?: string | null;
  postCode?: string | null;
  contactEmail?: string | null;
  contactPhone?: PhoneNumberDto | null;
  buyerLegalType?: BuyerLegalType | null;
  buyerLegalTypeChoices?: BuyerLegalType[];
  defaultRegulation?: Regulation | null;
  authorityActivity?: AuthorityActivity | null;
  allowedAiEndpoints?: AiEndpoint[];
  aiFeatures?: AiFeature[];
  size?: OrganizationSize | null;
  subscription: SubscriptionDto;
  departments: DepartmentDto[];
  enforceEntraIDAuthentication?: boolean | null;
  canEdit: boolean;
  canEditDocumentTemplates: boolean;
  canConfigureContracts: boolean;
  canCreateContractTemplate: boolean;
  canLinkOrganizationEntry: boolean;
  canUpdateOrganizationEntries: boolean;
  canUpdateContactPersons: boolean;
  canCreateOrganizationAssessments: boolean;
  canManageSupplierInvites: boolean;
  canManageUsers: boolean;
  canViewAuditLog: boolean;
  canCreateEvent: boolean;
  canCreateContract: boolean;
  canCreateProject: boolean;
  canReportNeed: boolean;
  canTakeNeeds: boolean;
  canViewSourcingEvents: boolean;
  canViewContracts: boolean;
  receivesContractShares: boolean;
  canViewContractOverview: boolean;
  canViewProjects: boolean;
  hasProductAccess: boolean;
  hasProjectAccess: boolean;
  hasAiAccess: boolean;
  hasFencyContractSearchAccess: boolean;
  fencySyncEnabled: boolean;
  hasDocumentTemplateAccess: boolean;
  hasIFRSAccess: boolean;
  roles: OrganizationRoleType[];
  departmentRoles: DepartmentRoleDto[];
  canOnlySeeCreatedEvents: boolean;
  canOnlySeeCreatedContracts: boolean;
  canSeeDeliveredBidsBeforeDeadline: boolean;
  customContractSections?: {
    [key: string]: ContractDataFieldSectionDto;
  } | null;
  supplierFilterFieldIds?: string[];
  supplierFilterOnEndDate?: boolean;
  defaultNotificationSettings?: DefaultNotificationSettingsDto | null;
  internalParties?: MinimalOrgDto[] | null;
  scimGroups?: ScimGroupDto[] | null;
  contactPersons?: PersonDto[] | null;
};
export type EditBuyerLegalType = {
  value?: BuyerLegalType | null;
};
export type EditAiEndpoints = {
  value?: AiEndpoint[] | null;
};
export type EditAiFairUse = {
  value?: string | null;
};
export type AdminUpdateOrganizationRequest = {
  name?: string | null;
  hasContractAccess?: boolean | null;
  hasBuyerAccess?: boolean | null;
  hasSignatureAccess?: boolean | null;
  hasBankIdAccess?: boolean | null;
  hasProductAccess?: boolean | null;
  hasProjectAccess?: boolean | null;
  hasAiAccess?: boolean | null;
  hasDocumentTemplateAccess?: boolean | null;
  hasIFRSAccess?: boolean | null;
  hasOrganizationAssessmentAccess?: boolean | null;
  hasNegotiationAccess?: boolean | null;
  canSeeDeliveredBidsBeforeDeadline?: boolean | null;
  buyerLegalType?: EditBuyerLegalType | null;
  hasFencyContractSearchAccess?: boolean | null;
  hasAssistantAccess?: boolean | null;
  hasAiBidInsightAccess?: boolean | null;
  hasOutsideBidRegistrationAccess?: boolean | null;
  hasNeedsAccess?: boolean | null;
  fencySyncEnabled?: boolean | null;
  devToolsEnabled?: boolean | null;
  aiEndpoints?: EditAiEndpoints | null;
  aiFairUseNok?: EditAiFairUse | null;
};
export type AdminAiUsageFunctionDto = {
  function: AiUsageFunction;
  calls: number;
  callsWithoutTokens: number;
  inputTokens: number;
  outputTokens: number;
  costNok: string;
};
export type AdminAiUsageMonthDto = {
  month: string;
  costNok: string;
  overageNok?: string | null;
  functions: AdminAiUsageFunctionDto[];
};
export type AdminAiUsageDto = {
  months: AdminAiUsageMonthDto[];
};
export type AdminChangeOrganizationOwnerRequest = {
  newOwnerPersonId: string;
};
export type GptMessage = {
  role: GPTRole;
  content: string;
};
export type AiChatResponse = {
  messages: GptMessage[];
  unreadablePages?: number[];
  pageCount?: number | null;
};
export type JsonSchemaDto = {
  name: string;
  schema: string;
};
export type AiChatRequest = {
  messages: GptMessage[];
  reasoningEffort: string;
  responseFormat?: JsonSchemaDto | null;
};
export type AiCompletionDto = {
  content: string;
};
export type AiCompletionMessageDto = {
  role: string;
  content: string;
};
export type AiItemDto = {
  type: AiItemType;
  id: string;
};
export type CreateAiCompletionRequest = {
  purpose: AiCompletionPurpose;
  feature: string;
  messages: AiCompletionMessageDto[];
  jsonSchema?: string | null;
  item?: AiItemDto | null;
};
export type AiSuggestionInsertedRequest = {
  purpose: AiCompletionPurpose;
  itemType: AiSuggestionItemType;
  itemId: string;
};
export type ScoreRangeDto = {
  minValue: number;
  maxValue?: number | null;
  description?: string | null;
};
export type AssessmentCriterionDto = {
  id: string;
  name: string;
  description?: string | null;
  scoreRange: ScoreRangeDto;
  order: number;
};
export type AssessmentDimensionDto = {
  id: string;
  name: string;
  description?: string | null;
  weight: number;
  criteria: AssessmentCriterionDto[];
  order: number;
};
export type AssessmentTemplateDto = {
  id: string;
  templateId: string;
  name: string;
  description?: string | null;
  owner: string;
  dimensions: AssessmentDimensionDto[];
  isActive: boolean;
  templateVersion: number;
  createdAt: string;
  modifiedAt: string;
};
export type CreateAssessmentCriterionDto = {
  name: string;
  description?: string | null;
  scoreRange: ScoreRangeDto;
  order?: number;
};
export type CreateAssessmentDimensionDto = {
  name: string;
  description?: string | null;
  weight?: number;
  criteria?: CreateAssessmentCriterionDto[];
  order?: number;
};
export type CreateAssessmentTemplateRequestDto = {
  name: string;
  description?: string | null;
  dimensions?: CreateAssessmentDimensionDto[];
  templateFamilyId?: string | null;
};
export type AssessedEntityDto = {
  organizationId?: string | null;
  organizationEntryId?: string | null;
};
export type CriterionScoreDto = {
  criterionId: string;
  criterionName: string;
  score?: number | null;
  scoreRange: ScoreRangeDto;
  comment?: string | null;
  lastUpdated: string;
};
export type DimensionScoreDto = {
  dimensionId: string;
  dimensionName: string;
  criterionScores: CriterionScoreDto[];
  directScore?: number | null;
  scoreRange?: ScoreRangeDto | null;
  comment?: string | null;
  lastUpdated: string;
};
export type AssessmentDto = {
  id: string;
  name: string;
  description?: string | null;
  assessedEntity: AssessedEntityDto;
  owner: MinimalOrgDto;
  template: AssessmentTemplateDto;
  assessor: PersonDto;
  dimensionScores: DimensionScoreDto[];
  status: string;
  completedAt?: string | null;
  createdAt: string;
  modifiedAt: string;
};
export type CreateCriterionScoreDto = {
  criterionId: string;
  score?: number | null;
  comment?: string | null;
};
export type CreateDimensionScoreDto = {
  dimensionId: string;
  directScore?: number | null;
  scoreRange?: ScoreRangeDto | null;
  comment?: string | null;
  criterionScores?: CreateCriterionScoreDto[] | null;
};
export type CreateAssessmentRequestDto = {
  name: string;
  description?: string | null;
  assessedEntity: AssessedEntityDto;
  templateId: string;
  dimensionScores?: CreateDimensionScoreDto[];
};
export type ContractDataFieldDto = {
  type: ContractDataFieldType;
  name: ContractDataFieldNameDto;
};
export type BaseDataDto = {
  callingCodes: CallingCodeDto[];
  countries: CountryDto[];
  contractDataFields: ContractDataFieldDto[];
};
export type DocumentAddedClientEvent = {
  documentId: string;
};
export type FieldErrorDto = {
  field: string;
  code: string;
  params?: {
    [key: string]: string;
  };
};
export type ApiErrorDto = {
  errorCode: string;
  fieldErrors?: FieldErrorDto[] | null;
};
export type AllTypes = {
  documentAddedClientEvent: DocumentAddedClientEvent;
  apiError: ApiErrorDto;
  apiErrorCodes: string[];
};
export type AgentAuditEntryDto = {
  conversationId: string;
  turnId: string;
  eventId?: string | null;
  toolName: string;
  riskTier: string;
  outcome: AgentAuditOutcome;
  proposedArgs: string;
  deviationCode?: string | null;
  userInstruction: string;
  proposedValues?: string | null;
  confirmedValues?: string | null;
};
export type AgentDocumentTextDto = {
  documentName: string;
  text: string;
  fromPart: number;
  nextPart?: number | null;
  partCount: number;
  pageCount?: number | null;
  unreadablePages: number[];
};
export type UploadDto = {
  id: string;
  fileName: string;
  mimeType: string;
  fileExtension: string;
  url: string;
  renamedXAmzDate: string;
  renamedXAmzSignature: string;
  renamedXAmzAlgorithm: string;
  renamedXAmzCredential: string;
  policy: string;
  key: string;
  scanFailed?: boolean;
};
export type CreateUploadRequestDto = {
  fileName: string;
  fileSize: number;
  fileExtension: string;
  mimeType: string;
};
export type ConversationFileStatusDto = {
  status: UploadStatusValueDto;
  documentId?: string | null;
};
export type ConversationProcurementDto = {
  id: string;
  title: string;
};
export type AgentConversationSummaryDto = {
  id: string;
  title: string;
  modifiedAt: string;
  procurement?: ConversationProcurementDto | null;
};
export type ListAgentConversationsResponse = {
  conversations: AgentConversationSummaryDto[];
  hasMore?: boolean;
  nextBefore?: string | null;
};
export type PlanToolCallDto = {
  id: string;
  name: string;
  arguments: string;
};
export type PlanMessageDto = {
  role: string;
  content?: string | null;
  toolCalls?: PlanToolCallDto[] | null;
  toolCallId?: string | null;
};
export type AgentConversationDto = {
  id: string;
  title: string;
  messages: PlanMessageDto[];
  clientState: string;
  modifiedAt: string;
};
export type CreateAgentConversationRequest = {
  title: string;
};
export type UpdateAgentConversationRequest = {
  title: string;
  messages: PlanMessageDto[];
  clientState: string;
  procurementId?: string | null;
};
export type AgentDocumentSearchSessionDto = {
  clientToken?: string | null;
  indexedDocumentCount?: number | null;
  pendingDocumentCount?: number | null;
  failedDocumentCount?: number | null;
};
export type AgentDocumentSearchScopeDto = {
  entityType: AgentDocumentScopeTypeDto;
  entityId: string;
};
export type CreateAgentDocumentSearchSessionRequest = {
  scope?: AgentDocumentSearchScopeDto | null;
};
export type AgentDocumentOwnerDto = {
  entityType: AgentDocumentScopeTypeDto;
  entityId: string;
  entityTitle: string;
};
export type AgentDocumentSourceDto = {
  memoryId: string;
  documentName: string;
  downloadUrl: string;
  owner?: AgentDocumentOwnerDto | null;
};
export type AgentDocumentSourcesDto = {
  sources: AgentDocumentSourceDto[];
};
export type ResolveAgentDocumentSourcesRequest = {
  memoryIds: string[];
};
export type AgentSelectableModelDto = {
  id: string;
  label: string;
};
export type AgentModelsDto = {
  models: AgentSelectableModelDto[];
  defaultModelId: string;
  enabledTools: string[];
  toolsWithheldByAiSetting?: string[];
  addOnModules?: AgentModule[];
};
export type AgentPlanResponseDto = {
  content?: string | null;
  toolCalls?: PlanToolCallDto[];
  finishReason: string;
};
export type PlanToolDto = {
  name: string;
  description: string;
  parameters: string;
};
export type AgentPlanRequestDto = {
  messages: PlanMessageDto[];
  tools: PlanToolDto[];
};
export type ContactPersonDto = {
  email: string;
  name: string;
  language: EmailInviteLanguage;
  title?: string | null;
  phoneNumber?: PhoneNumberDto | null;
};
export type ListContactPersonsResponse = {
  subjectType: ContactSubjectType;
  subjectId: string;
  contacts: ContactPersonDto[];
};
export type AddContactPersonRequest = {
  contact: ContactPersonDto;
};
export type EditContactPersonRequest = {
  contact: ContactPersonDto;
};
export type ExclusionGroundsCriterionDto = {
  id: string;
  name: string;
  nameNorwegian?: string | null;
  description: string;
  descriptionNorwegian?: string | null;
  mandatory: boolean;
};
export type ExclusionGroundsCategoryDto = {
  code: EspdCriterionCategory;
  criteria: ExclusionGroundsCriterionDto[];
};
export type ExclusionGroundsTaxonomyResponse = {
  specVersion: string;
  categories: ExclusionGroundsCategoryDto[];
};
export type CreationInterviewDto = {
  saved: boolean;
  /** The caller's assistant conversation the interview is held in, once it is saved. */
  conversationId?: string | null;
};
export type MilestonePlanDto = {
  announcementDate?: string | null;
  questionDaysBeforeBid?: number | null;
  tenderPeriodOffsetDays?: number | null;
  evaluationOffsetDays?: number | null;
  awardOffsetDays?: number | null;
  contractSigningOffsetDays?: number | null;
};
export type ContractDurationDto = {
  type: ContractDurationType;
  startDate?: string | null;
  endDate?: string | null;
  periodMonths?: number | null;
};
export type LowestPriceDto = {
  selected?: boolean;
};
export type AwardCriterionWeightDto = {
  type: WeightType;
  number: number;
};
export type AwardSubCriterionDto = {
  id?: string | null;
  name?: string | null;
  description: string;
  weight?: AwardCriterionWeightDto | null;
  answerFormat?: AwardSubCriterionAnswerFormat;
  requiresDocumentation?: boolean;
};
export type AwardCriterionDto = {
  type: AwardCriterionType;
  id?: string | null;
  name?: string | null;
  description: string;
  weight?: AwardCriterionWeightDto | null;
  commonRationale?: string | null;
  subCriteria?: AwardSubCriterionDto[];
};
export type BestPriceQualityRatioDto = {
  criteria?: AwardCriterionDto[] | null;
  environmentWeightingJustification?: string | null;
  environmentWeightingJustificationIsStandardText?: boolean;
  unweightedReason?: string | null;
};
export type AwardCriteriaDto = {
  lowestPrice?: LowestPriceDto | null;
  bestPriceQualityRatio?: BestPriceQualityRatioDto | null;
};
export type SelectionCriterionDto = {
  type: SelectionCriterionType;
  name: string;
  description: string;
  requiresEvidence: boolean;
};
export type MinimumRequirementDto = {
  id?: string | null;
  title: string;
  description: string;
  responseType: MinimumRequirementResponseType;
};
export type PlaceOfPerformanceDto = {
  countryCode?: string | null;
  countrySubdivision?: string | null;
  servicesOther?: string | null;
};
export type ContractExtensionDto = {
  duration: number;
  unit: ExtensionDurationUnit;
  exerciseDeadlineMonths: number;
};
export type EventOptionsDto = {
  hasOptions: boolean;
  descriptions?: string[];
  extensions?: ContractExtensionDto[];
  renewalDescription?: string | null;
};
export type ProportionalPriceModelDto = {
  selected?: boolean;
};
export type LinearPriceModelDto = {
  selected?: boolean;
};
export type HybridPriceModelDto = {
  breakpointPercent: number;
};
export type PriceModelDto = {
  proportional?: ProportionalPriceModelDto | null;
  linear?: LinearPriceModelDto | null;
  hybrid?: HybridPriceModelDto | null;
};
export type ViewDocumentAsOwnerDto = {
  id: string;
  name: string;
  mimeType: string;
  fileExtension: string;
  size: number;
  uploadedAt: string;
  uploadedBy: PersonDto;
  s3Key: string;
  fromUploadId: string;
  tags: string[];
  fencyContentStatus?: FencyContentStatus | null;
  category?: DocumentCategory | null;
};
export type EventDataDto = {
  title: string;
  description?: string | null;
  bidSubmissionDeadline?: string | null;
  bidSubmissionDeadlineConfirmed?: boolean | null;
  tenderDeadlineAgreedWithCandidates?: boolean | null;
  requestDeadline?: string | null;
  requestDeadlineConfirmed?: boolean | null;
  milestonePlan?: MilestonePlanDto | null;
  contractDuration?: ContractDurationDto | null;
  awardCriteria?: AwardCriteriaDto | null;
  selectionCriteria: SelectionCriterionDto[];
  minimumRequirements: MinimumRequirementDto[];
  placeOfPerformance?: PlaceOfPerformanceDto | null;
  options?: EventOptionsDto | null;
  collectSupplierPrice: boolean;
  priceModel?: PriceModelDto | null;
  documents?: ViewDocumentAsOwnerDto[];
  uploads?: UploadDto[];
  projects?: string[] | null;
  referenceId?: string | null;
  includeProducts?: boolean | null;
  includeMinimumRequirements?: boolean | null;
  includeAwardCriteria?: boolean | null;
};
export type InvitedPersonDto = {
  id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  addedInChange?: boolean;
};
export type OrganizationEmailInviteDto = {
  email: string;
  language: EmailInviteLanguage;
  addedInChange?: boolean;
};
export type OrganizationInviteDto = {
  organizationId: string;
  organizationName?: string;
  persons?: InvitedPersonDto[];
  emailInvites?: OrganizationEmailInviteDto[];
  status?: OrganizationInviteStatusDto;
  remove?: OperationAvailabilityDto | null;
  addedInChange?: boolean;
  sameLegalEntityIds?: string[];
  registeredInterestOnOriginal?: boolean;
};
export type LinkDto = {
  linkedBy: PersonDto;
  linkedAt: string;
  organizationId: string;
  organizationName: string;
};
export type OrganizationEntryDto = {
  id: string;
  name: string;
  country: CountryDto;
  organizationNumber: string;
  street?: string | null;
  city?: string | null;
  postCode?: string | null;
  contactPersons?: ContactPersonDto[] | null;
  link?: LinkDto | null;
};
export type EmailInviteDto = {
  id: string;
  email: string;
  language: EmailInviteLanguage;
  lastReminderSentAt?: string | null;
  status: EmailInviteStatusDto;
  openedAt?: string | null;
  organizationEntry?: OrganizationEntryDto | null;
  addedInChange?: boolean;
};
export type EventValueDto = {
  value?: number | null;
  currency: Currency;
};
export type UninvitedPanelSupplierDto = {
  organizationEntryId: string;
  name: string;
};
export type MiniCompetition = {
  type: "MiniCompetition";
  frameworkAgreementId: string;
  organizationInvites: OrganizationInviteDto[];
  emailInvites?: EmailInviteDto[];
  estimatedValue?: EventValueDto | null;
  contractNature?: ContractNature | null;
  uninvitedPanelSuppliers?: UninvitedPanelSupplierDto[];
};
export type Private = {
  type: "Private";
  organizationInvites: OrganizationInviteDto[];
  emailInvites?: EmailInviteDto[];
  organizationInvitesRemovedInChange?: OrganizationInviteDto[];
  emailInvitesRemovedInChange?: EmailInviteDto[];
  estimatedValue?: EventValueDto | null;
  contractNature?: ContractNature | null;
  regulation?: Regulation | null;
  serviceCategory?: ServiceCategory | null;
};
export type EFormsNoticeDataDto = {
  electronicOrdering?: boolean | null;
  electronicInvoicing?: boolean | null;
  electronicPayment?: boolean | null;
  submissionElectronic?: boolean | null;
  submissionLanguages?: string[];
  submissionLanguagesChosenByBuyer?: boolean | null;
  electronicCatalogue?: boolean | null;
  documentsRestricted?: boolean | null;
  exclusionGroundsSource?: string | null;
  selectionCriteriaSource?: string | null;
  variants?: boolean | null;
  tenderValidityMonths?: number | null;
  publicOpeningDate?: string | null;
  publicOpeningPlace?: string | null;
  documentsUrl?: string | null;
  reviewDeadlineDescription?: string | null;
  submissionUrl?: string | null;
};
export type PublicationFailureDto = {
  doffinStatus: DoffinNoticeStatus;
  reportedAt: string;
};
export type PublicationDto = {
  id: string;
  channel: PublicationChannel;
  eFormType: EFormType;
  status: PublicationStatus;
  publishedAt?: string | null;
  externalId?: string | null;
  noticeVersion: string;
  failure?: PublicationFailureDto | null;
  endsQualificationScheme?: boolean;
};
export type EventInvitationDto = {
  invitedOrganizationIds: string[];
  confirmedAt: string;
  bidSubmissionDeadline: string;
  tenderValidityMonths?: number | null;
  confirmedByName?: string | null;
};
export type QualificationRoundDto = {
  status: QualificationRoundStatus;
  requestDeadline: string;
  invitation?: EventInvitationDto | null;
};
export type CandidateLimitsDto = {
  minCandidates: number;
  maxCandidates?: number | null;
  selectionCriteria: string;
};
export type ProcedureJustificationDto = {
  ground: NegotiatedProcedureGround;
  rationale: string;
};
export type NoCompetitionJustificationDto = {
  condition: NoCompetitionCondition;
  rationale: string;
  originalContractId?: string | null;
  repetitionForeseenInOriginalDocuments?: boolean | null;
  negotiationImpossibleCase?: NegotiationImpossibleCase | null;
  windingUpCase?: WindingUpCase | null;
};
export type NegotiationWithoutNoticeDto = {
  case?: NegotiationImpossibleCase | null;
  rationale?: string | null;
  precedingEventId?: string | null;
  invitedOrganizationIds?: string[];
  unchangedBasisConfirmed?: boolean | null;
};
export type DesignContestPrizeDto = {
  description?: string;
  value?: EventValueDto | null;
};
export type DesignContestJuryMemberDto = {
  name?: string;
  role?: string | null;
  holdsRequiredQualification?: boolean;
  independenceConfirmed?: boolean;
  personId?: string | null;
};
export type JuryRankedEntryDto = {
  bidId: string;
  assessment: string;
};
export type JuryReportDto = {
  rankedEntries: JuryRankedEntryDto[];
  remarks?: string | null;
  questionsToParticipants?: string | null;
  writtenAt: string;
};
export type JuryConfirmationDto = {
  memberIndex: number;
  confirmedAt: string;
  recordedOnBehalf: boolean;
};
export type EntryFlagDto = {
  bidId: string;
  reason: string;
  flaggedAt: string;
};
export type DesignContestClimateConsiderationDto = {
  type: AwardCriterionType;
  description?: string | null;
};
export type DesignContestDto = {
  leadsToServiceContract?: boolean | null;
  juryDecisionBinding?: boolean | null;
  prizes?: DesignContestPrizeDto[];
  juryCriteria?: string[];
  requiredParticipantQualification?: string | null;
  jury?: DesignContestJuryMemberDto[];
  juryReport?: JuryReportDto | null;
  juryConfirmations?: JuryConfirmationDto[];
  entryFlags?: EntryFlagDto[];
  followUpEventId?: string | null;
  climateConsideration?: DesignContestClimateConsiderationDto | null;
};
export type DesignContestFollowUpLinkDto = {
  contestId: string;
  contestBelowEeaTier: boolean;
};
export type DpsSchemeDto = {
  validFrom: string;
  validTo: string;
};
export type QualificationSchemeDto = {
  validFrom: string;
  validTo: string;
};
export type DpsCompetitionDto = {
  schemeId: string;
  schemeTitle?: string | null;
  invitedOrganizationIds?: string[];
  invitedAt?: string | null;
};
export type QualificationSchemeCompetitionDto = {
  schemeId: string;
  schemeTitle?: string | null;
  invitedOrganizationIds?: string[] | null;
  narrowingReason?: string | null;
};
export type PriorInformationCallDto = {
  plannedInvitationAt: string;
  noticeSentAt?: string | null;
  earliestInvitationAt?: string | null;
  latestInvitationAt?: string | null;
  interestInvitedAt?: string | null;
  interestDeadline?: string | null;
};
export type Public = {
  type: "Public";
  regulation?: Regulation | null;
  procedureType?: ProcedureType | null;
  buyerLegalType?: BuyerLegalType | null;
  utilityActivity?: UtilityActivity | null;
  contractNature?: ContractNature | null;
  foaPart?: FoaPart | null;
  estimatedValue?: EventValueDto | null;
  cpvCodes?: string[];
  frameworkAgreement?: FrameworkAgreementType | null;
  frameworkMaxParticipants?: number | null;
  frameworkMaximumValue?: EventValueDto | null;
  dynamicPurchasingSystem?: DynamicPurchasingSystemType | null;
  electronicAuction?: boolean | null;
  gpaCoverage?: boolean | null;
  euFunded?: boolean | null;
  reservedParticipation?: ReservedParticipationType | null;
  reservedExecution?: ReservedExecutionType | null;
  acceleratedProcedure?: boolean | null;
  acceleratedJustification?: string | null;
  shortRequestDeadlineJustification?: string | null;
  eFormsNoticeData?: EFormsNoticeDataDto | null;
  activeExclusionGroundIds: string[];
  publications?: PublicationDto[];
  qualificationRound?: QualificationRoundDto | null;
  candidateLimits?: CandidateLimitsDto | null;
  procedureJustification?: ProcedureJustificationDto | null;
  frameworkOverFourYearsJustification?: string | null;
  qualificationSchemeRules?: string | null;
  qualificationSchemeCategories?: string[];
  noCompetitionJustification?: NoCompetitionJustificationDto | null;
  negotiationWithoutNotice?: NegotiationWithoutNoticeDto | null;
  designContest?: DesignContestDto | null;
  designContestFollowUp?: DesignContestFollowUpLinkDto | null;
  noNegotiationNecessary?: boolean | null;
  reducesInSuccessiveStages?: boolean | null;
  dialoguePlanned?: boolean | null;
  dialogueDescription?: string | null;
  estimatedValueBasis?: string | null;
  specialServices?: boolean | null;
  serviceCategory?: ServiceCategory | null;
  announcedOnDoffin?: boolean | null;
  dialogueDepartureJustification?: string | null;
  espdEnabled?: boolean | null;
  dpsScheme?: DpsSchemeDto | null;
  qualificationScheme?: QualificationSchemeDto | null;
  dpsCompetition?: DpsCompetitionDto | null;
  qualificationSchemeCompetition?: QualificationSchemeCompetitionDto | null;
  governingSchemeId?: string | null;
  priorInformationCall?: PriorInformationCallDto | null;
};
export type Unclassified = {
  type: "Unclassified";
  estimatedValue?: EventValueDto | null;
  contractNature?: ContractNature | null;
};
export type EventContextDto = MiniCompetition | Private | Public | Unclassified;
export type MilestoneDatesDto = {
  announcement?: string | null;
  questionDeadline?: string | null;
  bidSubmissionDeadline?: string | null;
  plannedTenderDeadline?: string | null;
  evaluationTarget?: string | null;
  awardTarget?: string | null;
  karensDate?: string | null;
  contractSigningTarget?: string | null;
  tenderValidityEnd?: string | null;
  plannedRequestDeadline?: string | null;
};
export type WinnerDocumentationDto = {
  rule: WinnerDocumentationRule;
  recordBeforeAward: boolean;
  canRecord: boolean;
  checkedAt?: string | null;
  checkedByName?: string | null;
  note?: string | null;
};
export type RevokedAwardDecisionDto = {
  bidIds?: string[];
  internalNote?: string | null;
  awardedBy?: string | null;
  awardedAt: string;
  revokedBy?: string | null;
  revokedAt: string;
  revokeReason?: string | null;
  evaluationRevision: number;
  standstillDays?: number | null;
};
export type InjunctionSuspension = {
  rule: InjunctionSuspensionRule;
  period: InjunctionSuspensionPeriod;
};
export type ResultNoticeObligationDto = {
  duty: ResultNoticeDuty;
  form?: string | null;
  deadline?: string | null;
};
export type ExternalResultNoticeDto = {
  noticeId: string;
  recordedAt: string;
};
export type IntentionNoticeDto = {
  status: PublicationStatus;
  noticeNumber?: string | null;
  publishedOn?: string | null;
  contractFrom?: string | null;
};
export type AwardSavingDto = {
  bidId: string;
  supplierId: string;
  originalPrice: EventValueDto;
  finalPrice: EventValueDto;
  saving: EventValueDto;
  savingPercent?: number | null;
};
export type AwardDto = {
  winningBidIds?: string[];
  internalNote?: string | null;
  awardedBy?: string | null;
  awardedAt?: string | null;
  confirmedAt?: string | null;
  contractIds?: string[];
  standstillDays?: number | null;
  standstillExpiresAt?: string | null;
  standstillExemption?: StandstillExemption | null;
  decisionHistory?: RevokedAwardDecisionDto[];
  contractConcludedOn?: string | null;
  injunctionSuspension?: InjunctionSuspension | null;
  resultNotice?: ResultNoticeObligationDto | null;
  offersContractModificationNotice?: boolean;
  externalResultNotice?: ExternalResultNoticeDto | null;
  resultNoticeDeclinedAt?: string | null;
  intentionNotice?: IntentionNoticeDto | null;
  savings?: AwardSavingDto[];
  relativeAdvantages?: string | null;
  rankingDepartureJustification?: string | null;
};
export type CancellationDto = {
  at: string;
  reason?: string | null;
  nonAwardReason?: NonAwardReason | null;
  relaunch?: boolean | null;
  notifiedSuppliers?: number | null;
  changeNotice?: PublicationDto | null;
};
export type SupplierRegistrationDto = {
  organizationId: string;
  organizationName: string;
  registeredAt: string;
};
export type EventRevisionDto = {
  id: string;
  state: EventRevisionState;
  bidSubmissionDeadline?: string | null;
  description?: string | null;
  requestDocumentIds: string[];
  schemeValidTo?: string | null;
  estimatedValue?: number | null;
  frameworkMaximumValue?: number | null;
  requestDeadline?: string | null;
  changeDescription?: string | null;
  reasonCode?: ChangeReasonCode | null;
  changedAreas?: ChangedArea[];
  bidSealWasOpen?: boolean;
  createdAt: string;
  publishedAt?: string | null;
  supersededAt?: string | null;
};
export type AnnouncedOrganizationInviteDto = {
  organizationId: string;
  personIds: string[];
  emails: string[];
};
export type AnnouncedInvitationsDto = {
  organizationInvites: AnnouncedOrganizationInviteDto[];
  emailInviteIds: string[];
};
export type ViewingOrganizationDto = {
  organizationId: string;
  organizationName: string;
  lastViewedAt: string;
};
export type InternalMessageDto = {
  id: string;
  value: string;
  createdBy?: PersonDto | null;
  createdAt: string;
};
export type WinningProductBidsDto = {
  productId: string;
  bids: string[];
};
export type WinningProductGroupBidsDto = {
  productGroupId: string;
  bids: WinningProductBidsDto[];
};
export type CallOffCeilingDto = {
  currency: Currency;
  hasRoom: boolean;
  tendersOverCeiling: string[];
};
export type FrameworkAgreementLinkDto = {
  frameworkAgreementId: string;
  mayOpen: boolean;
  tendersFromEndedContracts?: string[];
  callOffRefusal?: CallOffRefusalDto | null;
  ceiling?: CallOffCeilingDto | null;
};
export type ApproachedThresholdDto = {
  thresholdNok: number;
  regulation: Regulation;
};
export type ClassificationBandDto = {
  fromNok?: number | null;
  belowNok?: number | null;
};
export type SourcingEventDto = {
  id: string;
  status: SourcingEventStatus;
  outsideProcurementAct?: boolean;
  /** Whether «Close the procurement» may end it without an award. False for a public procurement under the procurement act, and for a mini-competition under a public framework agreement, which end without a contract only by cancelling, with their reason. */
  canClose?: boolean;
  /** Whether «Cancel the procurement» may end it: from publication until award, and for a public procurement also after award, until its contract is concluded. */
  canCancel?: boolean;
  /** Set when the procurement was started in the assistant's creation interview. Until the interview saves it as a draft, `saved` is false and the procurement is left out of the procurement lists. */
  interview?: CreationInterviewDto | null;
  createdAt: string;
  modifiedAt: string;
  publishedAt?: string | null;
  responsiblePerson: PersonDto;
  homeDepartment?: DepartmentDto | null;
  eventData: EventDataDto;
  eventContext: EventContextDto;
  milestoneDates: MilestoneDatesDto;
  statedTenderValidityMonths?: number | null;
  competitionStage?: CompetitionStageDto | null;
  collectsEspdWithBid?: boolean;
  asksForEspd?: boolean;
  buyerSetsStandstill?: boolean;
  standstillWithoutProvision?: boolean;
  contractLastDay?: string | null;
  standstillUnderPartIV?: boolean;
  standstillUnderDps?: boolean;
  standstillUnderUtilitiesPartIII?: boolean;
  choosesVoluntaryStandstill?: boolean;
  winnerDocumentation?: WinnerDocumentationDto | null;
  entriesAnonymous?: boolean;
  minimumStandstillDays?: number;
  specialServicesAboveEea?: boolean;
  suggestedServiceCategory?: ServiceCategory | null;
  award?: AwardDto | null;
  eventValue?: EventValueDto | null;
  questionDeadline?: string | null;
  evaluationStartedAt?: string | null;
  cancellation?: CancellationDto | null;
  supplierRegistrations?: SupplierRegistrationDto[];
  changes?: EventRevisionDto[];
  changeDraftInvitations?: AnnouncedInvitationsDto | null;
  announcedBidSubmissionDeadline?: string | null;
  changeGovernedTerm: ChangeGovernedTerm;
  viewings?: ViewingOrganizationDto[];
  internalConversation?: InternalMessageDto[];
  selectedProductBids?: WinningProductGroupBidsDto[] | null;
  derivedPlaceOfPerformance?: string | null;
  derivedCountySubdivision?: string | null;
  operations?: OperationAvailabilityDto[];
  frameworkAgreementLink?: FrameworkAgreementLinkDto | null;
  hasCopiedInvitations?: boolean;
  devToolsAllowed?: boolean;
  awardCriteriaInOrderOfPriority?: boolean;
  approachedThreshold?: ApproachedThresholdDto | null;
  evaluationReopenedBySupplier?: boolean;
  classificationBand?: ClassificationBandDto | null;
  contractNoticeRoute?: NoticeRoute | null;
  supplierPortalUrl?: string | null;
  sourceClaimsNotKept?: string[];
  fromMarketDialogueId?: string | null;
  suggestedSuppliers?: MinimalOrgDto[];
};
export type FieldSourceDto = {
  kind: FieldSourceKind;
  documentId?: string | null;
  fileName?: string | null;
  page?: number | null;
  section?: string | null;
  libraryElementId?: string | null;
  libraryElementTitle?: string | null;
  sourcingEventId?: string | null;
  contractId?: string | null;
  needId?: string | null;
  title?: string | null;
  rule?: string | null;
};
export type FieldSourceClaimDto = {
  path: string;
  source: FieldSourceDto;
};
export type CreateSourcingEventRequest = {
  title: string;
  description?: string | null;
  homeDepartmentId?: string | null;
  /** Ids of the projects the new procurement belongs to. */
  projects?: string[] | null;
  /** Kilden til tittelen du gir anskaffelsen: én oppføring med path title. source.kind sier hvor verdien kom fra: USER_ANSWER (brukerens svar), UPLOADED_DOCUMENT (krever fileName og page eller section, gjerne også documentId), REQUIREMENT_LIBRARY (krever libraryElementId fra listLibraryElements), EARLIER_PROCUREMENT (krever sourcingEventId), EARLIER_CONTRACT (krever contractId), NEED (krever needId), PRODUCT_RULES (gjerne rule) eller ASSISTANT_SUGGESTION. Mangler en kilde det den krever, lagres feltets standardkilde. En kilde gjelder bare felt denne skrivingen endrer. */
  fieldSources?: FieldSourceClaimDto[] | null;
  /** True when the procurement is started in the assistant's creation interview. It is then left out of the procurement lists until the interview saves it as a draft. */
  inInterview?: boolean;
};
export type MilestonePlanPatchDto = {
  announcementDate?: string | null;
  questionDaysBeforeBid?: number | null;
  tenderPeriodOffsetDays?: number | null;
  evaluationOffsetDays?: number | null;
  awardOffsetDays?: number | null;
  contractSigningOffsetDays?: number | null;
};
export type ContractDurationPatchDto = {
  type?: ContractDurationType;
  startDate?: string | null;
  endDate?: string | null;
  periodMonths?: number | null;
};
export type LowestPricePatchDto = {
  selected?: boolean;
};
export type AwardCriterionWeightPatchDto = {
  type?: WeightType;
  number?: number;
};
export type AwardSubCriterionPatchDto = {
  id?: string;
  name?: string | null;
  description?: string;
  weight?: AwardCriterionWeightPatchDto | null;
  answerFormat?: AwardSubCriterionAnswerFormat;
  requiresDocumentation?: boolean;
};
export type AwardCriterionPatchDto = {
  type?: AwardCriterionType;
  id?: string;
  name?: string | null;
  description?: string;
  weight?: AwardCriterionWeightPatchDto | null;
  commonRationale?: string | null;
  subCriteria?: AwardSubCriterionPatchDto[];
};
export type BestPriceQualityRatioPatchDto = {
  criteria?: AwardCriterionPatchDto[];
  environmentWeightingJustification?: string | null;
  environmentWeightingJustificationIsStandardText?: boolean;
  unweightedReason?: string | null;
};
export type AwardCriteriaPatchDto = {
  lowestPrice?: LowestPricePatchDto | null;
  bestPriceQualityRatio?: BestPriceQualityRatioPatchDto | null;
};
export type SelectionCriterionPatchDto = {
  type?: SelectionCriterionType;
  name?: string;
  description?: string;
  requiresEvidence?: boolean;
};
export type MinimumRequirementPatchDto = {
  id?: string;
  title?: string;
  description?: string;
  responseType?: MinimumRequirementResponseType;
};
export type PlaceOfPerformancePatchDto = {
  countryCode?: string | null;
  countrySubdivision?: string | null;
  servicesOther?: string | null;
};
export type ContractExtensionPatchDto = {
  duration?: number;
  unit?: ExtensionDurationUnit;
  exerciseDeadlineMonths?: number;
};
export type EventOptionsPatchDto = {
  hasOptions?: boolean;
  descriptions?: string[];
  extensions?: ContractExtensionPatchDto[];
};
export type ProportionalPriceModelPatchDto = {
  selected?: boolean;
};
export type LinearPriceModelPatchDto = {
  selected?: boolean;
};
export type HybridPriceModelPatchDto = {
  breakpointPercent?: number;
};
export type PriceModelPatchDto = {
  proportional?: ProportionalPriceModelPatchDto | null;
  linear?: LinearPriceModelPatchDto | null;
  hybrid?: HybridPriceModelPatchDto | null;
};
export type EventDataPatchDto = {
  title?: string;
  description?: string | null;
  bidSubmissionDeadline?: string | null;
  bidSubmissionDeadlineConfirmed?: boolean | null;
  tenderDeadlineAgreedWithCandidates?: boolean | null;
  requestDeadline?: string | null;
  requestDeadlineConfirmed?: boolean | null;
  milestonePlan?: MilestonePlanPatchDto | null;
  contractDuration?: ContractDurationPatchDto | null;
  awardCriteria?: AwardCriteriaPatchDto | null;
  selectionCriteria?: SelectionCriterionPatchDto[];
  minimumRequirements?: MinimumRequirementPatchDto[];
  placeOfPerformance?: PlaceOfPerformancePatchDto | null;
  options?: EventOptionsPatchDto | null;
  collectSupplierPrice?: boolean;
  priceModel?: PriceModelPatchDto | null;
  documents?: ViewDocumentAsOwnerDto[];
  projects?: string[] | null;
  referenceId?: string | null;
  includeProducts?: boolean | null;
  includeMinimumRequirements?: boolean | null;
  includeAwardCriteria?: boolean | null;
};
export type EventValuePatchDto = {
  value?: number | null;
  currency?: Currency;
};
export type EventContextPatchDto = {
  estimatedValue?: EventValuePatchDto | null;
  contractNature?: ContractNature | null;
};
export type EFormsNoticeDataPatchDto = {
  electronicOrdering?: boolean | null;
  electronicInvoicing?: boolean | null;
  electronicPayment?: boolean | null;
  submissionElectronic?: boolean | null;
  submissionLanguages?: string[];
  electronicCatalogue?: boolean | null;
  documentsRestricted?: boolean | null;
  exclusionGroundsSource?: string | null;
  selectionCriteriaSource?: string | null;
  variants?: boolean | null;
  tenderValidityMonths?: number | null;
  publicOpeningDate?: string | null;
  publicOpeningPlace?: string | null;
  documentsUrl?: string | null;
  reviewDeadlineDescription?: string | null;
  submissionUrl?: string | null;
};
export type CandidateLimitsPatchDto = {
  minCandidates?: number;
  maxCandidates?: number | null;
  selectionCriteria?: string;
};
export type ProcedureJustificationPatchDto = {
  ground?: NegotiatedProcedureGround;
  rationale?: string;
};
export type NoCompetitionJustificationPatchDto = {
  condition?: NoCompetitionCondition;
  rationale?: string;
  originalContractId?: string | null;
  repetitionForeseenInOriginalDocuments?: boolean | null;
  negotiationImpossibleCase?: NegotiationImpossibleCase | null;
  windingUpCase?: WindingUpCase | null;
};
export type NegotiationWithoutNoticePatchDto = {
  case?: NegotiationImpossibleCase | null;
  rationale?: string | null;
  precedingEventId?: string | null;
  invitedOrganizationIds?: string[];
  unchangedBasisConfirmed?: boolean | null;
};
export type DesignContestClimateConsiderationPatchDto = {
  type?: AwardCriterionType;
  description?: string | null;
};
export type DesignContestPatchDto = {
  leadsToServiceContract?: boolean | null;
  juryDecisionBinding?: boolean | null;
  prizes?: DesignContestPrizeDto[];
  juryCriteria?: string[];
  requiredParticipantQualification?: string | null;
  jury?: DesignContestJuryMemberDto[];
  climateConsideration?: DesignContestClimateConsiderationPatchDto | null;
};
export type DpsSchemePatchDto = {
  validFrom?: string;
  validTo?: string;
};
export type QualificationSchemePatchDto = {
  validFrom?: string;
  validTo?: string;
};
export type PriorInformationCallPatchDto = {
  plannedInvitationAt?: string;
};
export type PublicContextPatchDto = {
  regulation?: Regulation | null;
  procedureType?: ProcedureType | null;
  buyerLegalType?: BuyerLegalType | null;
  utilityActivity?: UtilityActivity | null;
  foaPart?: FoaPart | null;
  cpvCodes?: string[];
  frameworkAgreement?: FrameworkAgreementType | null;
  frameworkMaxParticipants?: number | null;
  frameworkMaximumValue?: EventValuePatchDto | null;
  dynamicPurchasingSystem?: DynamicPurchasingSystemType | null;
  electronicAuction?: boolean | null;
  gpaCoverage?: boolean | null;
  euFunded?: boolean | null;
  reservedParticipation?: ReservedParticipationType | null;
  reservedExecution?: ReservedExecutionType | null;
  acceleratedProcedure?: boolean | null;
  acceleratedJustification?: string | null;
  shortRequestDeadlineJustification?: string | null;
  eFormsNoticeData?: EFormsNoticeDataPatchDto | null;
  activeExclusionGroundIds?: string[];
  candidateLimits?: CandidateLimitsPatchDto | null;
  procedureJustification?: ProcedureJustificationPatchDto | null;
  frameworkOverFourYearsJustification?: string | null;
  qualificationSchemeRules?: string | null;
  qualificationSchemeCategories?: string[];
  noCompetitionJustification?: NoCompetitionJustificationPatchDto | null;
  negotiationWithoutNotice?: NegotiationWithoutNoticePatchDto | null;
  designContest?: DesignContestPatchDto | null;
  noNegotiationNecessary?: boolean | null;
  reducesInSuccessiveStages?: boolean | null;
  dialoguePlanned?: boolean | null;
  dialogueDescription?: string | null;
  estimatedValueBasis?: string | null;
  espdEnabled?: boolean | null;
  specialServices?: boolean | null;
  serviceCategory?: ServiceCategory | null;
  dpsScheme?: DpsSchemePatchDto | null;
  qualificationScheme?: QualificationSchemePatchDto | null;
  priorInformationCall?: PriorInformationCallPatchDto | null;
};
export type InvitedPersonPatchDto = {
  id: string;
};
export type OrganizationEmailInvitePatchDto = {
  email: string;
  language: EmailInviteLanguage;
};
export type OrganizationInvitePatchDto = {
  organizationId: string;
  persons?: InvitedPersonPatchDto[];
  emailInvites?: OrganizationEmailInvitePatchDto[];
};
export type PrivateContextPatchDto = {
  organizationInvites?: OrganizationInvitePatchDto[];
};
export type MiniCompetitionContextPatchDto = {
  organizationInvites?: OrganizationInvitePatchDto[];
  estimatedValue?: EventValuePatchDto | null;
};
export type ExpectedCurrentValueDto = {
  path: string;
  value: string;
};
export type SourcingEventPatchDto = {
  eventData?: EventDataPatchDto;
  eventContext?: EventContextPatchDto;
  publicContext?: PublicContextPatchDto;
  privateContext?: PrivateContextPatchDto;
  miniCompetitionContext?: MiniCompetitionContextPatchDto;
  /** Kilden til hver verdi denne endringen setter: én oppføring per felt eller listeelement du fyller inn. path følger formen på endringen du sender, f.eks. eventData.title eller publicContext.procedureType. Et listeelement angis med posisjonen i lista du sender, f.eks. eventData.minimumRequirements[2]; en sti til hele lista gjelder hvert element denne endringen legger til eller endrer. source.kind sier hvor verdien kom fra: USER_ANSWER (brukerens svar), UPLOADED_DOCUMENT (krever fileName og page eller section, gjerne også documentId), REQUIREMENT_LIBRARY (krever libraryElementId fra listLibraryElements), EARLIER_PROCUREMENT (krever sourcingEventId), EARLIER_CONTRACT (krever contractId), NEED (krever needId), PRODUCT_RULES (gjerne rule) eller ASSISTANT_SUGGESTION. Mangler en kilde det den krever, lagres feltets standardkilde. En kilde gjelder bare felt denne skrivingen endrer. */
  fieldSources?: FieldSourceClaimDto[] | null;
  /** The values the change was proposed against, each at the path this patch writes it. The save is refused with zz_FieldErrorCode_ChangedSinceProposed for each path whose value has changed since. */
  expectedCurrent?: ExpectedCurrentValueDto[] | null;
};
export type SeAttachmentUploadDto = {
  documentId?: string | null;
};
export type WinnerDocumentationCheckedRequest = {
  note?: string | null;
};
export type AwardSourcingEventRequest = {
  winningBidIds: string[];
  internalNote?: string | null;
  eventValue?: EventValueDto | null;
  dialogueDepartureJustification?: string | null;
  juryDepartureJustification?: string | null;
  rankingDepartureJustification?: string | null;
  proceedDespiteFlaggedEntries?: boolean;
  standstillDays?: number | null;
  standstillExemption?: StandstillExemption | null;
  winnerDocumentationCheck?: WinnerDocumentationCheckedRequest | null;
  relativeAdvantages?: string | null;
};
export type AwardLetterContentDto = {
  criterionJustifications?: {
    [key: string]: string;
  };
  freeText?: string | null;
  rankingDepartureExplanation?: string | null;
};
export type SentStatutoryClausesDto = {
  standstill?: string | null;
  complaint?: string | null;
};
export type AwardLetterDto = {
  type: AwardLetterTypeDto;
  id: string;
  bidId: string;
  supplierName?: string | null;
  status: AwardLetterStatusDto;
  content: AwardLetterContentDto;
  approvedAt?: string | null;
  sentAt?: string | null;
  sentClauses?: SentStatutoryClausesDto | null;
  explainsRankingDeparture?: boolean;
  forRejectedTender?: boolean;
  chosenTenderAdvantages?: string | null;
};
export type AwardLetterCriterionDto = {
  id: string;
  name?: string | null;
  parentName?: string | null;
  isPrice?: boolean;
  weightPercent?: number | null;
};
export type AwardLetterScoreDto = {
  supplierPoints?: number | null;
  supplierWeightedPoints?: number | null;
  winnerPoints?: number | null;
  winnerWeightedPoints?: number | null;
};
export type AwardLetterEvaluationDto = {
  criteria?: AwardLetterCriterionDto[];
  scores?: {
    [key: string]: AwardLetterScoreDto;
  };
  supplierTotal?: number | null;
  supplierRank?: number | null;
  bidderCount?: number | null;
  winnerTotal?: number | null;
  supplierPrice?: EventValueDto | null;
  winnerPrice?: EventValueDto | null;
  priceModel?: PriceModelDto | null;
  comparedRoundNumber?: number | null;
  winnerPriceWithheld?: boolean;
};
export type WithdrawnAwardLettersRoundDto = {
  withdrawnAt: string;
  withdrawnBy?: string | null;
  letters: AwardLetterDto[];
  evaluations?: {
    [key: string]: AwardLetterEvaluationDto;
  };
};
export type AwardLettersDto = {
  letters: AwardLetterDto[];
  namesWinnerToOtherBidders: boolean;
  withdrawnRounds?: WithdrawnAwardLettersRoundDto[];
  evaluations?: {
    [key: string]: AwardLetterEvaluationDto;
  };
  criterionStandings?: {
    [key: string]: {
      [key: string]: AwardLetterScoreDto;
    };
  };
};
export type AwardLetterContentPatchDto = {
  criterionJustifications?: {
    [key: string]: string;
  };
  freeText?: string | null;
  rankingDepartureExplanation?: string | null;
};
export type AwardLetterPatchDto = {
  content?: AwardLetterContentPatchDto;
};
export type AwardWithoutCompetitionRequest = {
  supplierOrganizationId: string;
  offerDocumentIds?: string[];
  contractValue?: EventValueDto | null;
  winnerDocumentationCheck?: WinnerDocumentationCheckedRequest | null;
};
export type RecordWinnerDocumentationCheckRequest = {
  awardedBidIds: string[];
  note?: string | null;
};
export type InsightSourceDto = {
  documentId?: string | null;
  documentName?: string | null;
  page?: number | null;
  section?: string | null;
  sheet?: string | null;
  slide?: number | null;
  answerKind?: AnswerKind | null;
  answerTitle?: string | null;
};
export type MinimumRequirementInsightDto = {
  requirementId: string;
  title: string;
  supplierAnswer?: boolean | null;
  supplierComment?: string | null;
  reading: MinimumRequirementReading;
  reason?: string | null;
  sources: InsightSourceDto[];
};
export type InsightPointDto = {
  text: string;
  sources: InsightSourceDto[];
};
export type AwardCriterionInsightDto = {
  criterionId: string;
  title: string;
  summary: string;
  strengths: InsightPointDto[];
  weaknesses: InsightPointDto[];
};
export type CommunicationInsightDto = {
  threadCount: number;
  summary?: string | null;
  commitments: InsightPointDto[];
};
export type DocumentInsightDto = {
  documentId: string;
  name: string;
  readStatus: DocumentReadStatus;
  description?: string | null;
  unreadablePages?: number[];
};
export type MissingDocumentDto = {
  requiredFor: MissingDocumentFor;
  title: string;
};
export type BidInsightDto = {
  generatedAt: string;
  generatedByName: string;
  minimumRequirements: MinimumRequirementInsightDto[];
  awardCriteria: AwardCriterionInsightDto[];
  communication: CommunicationInsightDto;
  documents: DocumentInsightDto[];
  missingDocuments: MissingDocumentDto[];
};
export type BidInsightResponseDto = {
  status: BidInsightStatusDto;
  outdated: boolean;
  insight?: BidInsightDto | null;
};
export type CancelSourcingEventRequest = {
  reason?: string | null;
  nonAwardReason?: NonAwardReason | null;
  relaunch?: boolean | null;
};
export type CancellationScopeDto = {
  tendersReceived: number;
  suppliersRegisteredInterest: number;
  contradictedReasons: NonAwardReason[];
  draftContracts: number;
};
export type EventRevisionPatchDto = {
  bidSubmissionDeadline?: string | null;
  description?: string | null;
  requestDocumentIds?: string[];
  schemeValidTo?: string | null;
  estimatedValue?: number | null;
  frameworkMaximumValue?: number | null;
  requestDeadline?: string | null;
  changeDescription?: string | null;
  reasonCode?: ChangeReasonCode | null;
};
export type SeAttachmentDto = {
  documentId: string;
  fileName: string;
  mimeType: string;
  source: SeAttachmentSource;
};
export type SeQuestionAnswerDto = {
  content: string;
  answeredBy: PersonDto;
  answeredAt: string;
  attachments?: SeAttachmentDto[];
};
export type SeQuestionMessageDto = {
  content: string;
  sentBy: PersonDto;
  sentByOrganizationId: string;
  sentByOrgName: string;
  sentAt: string;
  attachments?: SeAttachmentDto[];
  late?: boolean;
};
export type SeQuestionDto = {
  id: string;
  eventId: string;
  createdAt: string;
  modifiedAt: string;
  kind: SeQuestionKind;
  status: SeQuestionStatus;
  subject: string;
  content: string;
  askedByPerson: PersonDto;
  askedByOrgName: string;
  supplierOrganizationId: string;
  supplierOrgName: string;
  attachments?: SeAttachmentDto[];
  answer?: SeQuestionAnswerDto | null;
  messages?: SeQuestionMessageDto[];
  publishedInformationId?: string | null;
  forNegotiationRound?: string | null;
  replyDeadline?: string | null;
  replyState?: ClarificationReplyState | null;
};
export type SeAttachmentInputDto = {
  documentId: string;
  source: SeAttachmentSource;
};
export type CreateSeClarificationRequest = {
  supplierOrganizationId: string;
  subject: string;
  content: string;
  attachments?: SeAttachmentInputDto[];
  replyDeadline?: string | null;
};
export type CloseSourcingEventRequest = {
  reason?: string | null;
};
export type ConfirmClassificationRequest = {
  announcePartIOnDoffin?: boolean | null;
};
export type ContractConcludedRequest = {
  contractConcludedOn: string;
  injunction?: InjunctionAnswer | null;
};
export type CopiedSourcingEventDto = {
  event: SourcingEventDto;
  copiedInvitations: number;
  skippedInvitations: number;
};
export type FlagEntryRequest = {
  bidId: string;
  reason: string;
};
export type RemoveJuryLinkRequest = {
  memberIndex: number;
};
export type StrandedJuryMembersDto = {
  memberIndexes: number[];
};
export type JuryRankedEntryRequest = {
  bidId: string;
  assessment?: string;
};
export type WriteJuryReportRequest = {
  rankedEntries: JuryRankedEntryRequest[];
  remarks?: string | null;
  questionsToParticipants?: string | null;
};
export type ConfirmJuryReportRequest = {
  memberIndex: number;
  reportWrittenAt: string;
};
export type DpsCompetitionRowDto = {
  eventId: string;
  title: string;
  status: SourcingEventStatus;
  bidSubmissionDeadline?: string | null;
  invitedCount: number;
  openedAt?: string | null;
};
export type DpsCompetitionsDto = {
  canStartCompetition: boolean;
  qualifiedMemberCount: number;
  rows?: DpsCompetitionRowDto[];
};
export type CreateDpsCompetitionRequestDto = {
  title: string;
  description?: string | null;
};
export type AddEmailInviteRequest = {
  email: string;
  language: EmailInviteLanguage;
  organizationEntryId: string;
};
export type EvalCriterionDto = {
  type: AwardCriterionType;
  id: string;
  name?: string | null;
  weightPercent?: number | null;
  isPrice: boolean;
  commonRationale?: string | null;
  parentId?: string | null;
  parentName?: string | null;
  effectiveWeightPercent?: number | null;
  answerFormat?: AwardSubCriterionAnswerFormat;
  requiresDocumentation?: boolean;
  disclosedWeightPercent?: number | null;
};
export type PriceOverrideDto = {
  value: EventValueDto;
  comment?: string | null;
  setBeforeLatestDelivery?: boolean;
};
export type EarlierAssessmentDto = {
  scoredCriteria: number;
  priceOverride?: EventValueDto | null;
};
export type EvalAttachmentDto = {
  id: string;
  fileName: string;
};
export type EvalSupplierAnswerDto = {
  text?: string | null;
  number?: number | null;
  choice?: AwardCriterionAnswerChoice | null;
  partialElaboration?: string | null;
  attachments?: EvalAttachmentDto[];
};
export type EvalCellDto = {
  criterionId: string;
  supplierAnswer?: EvalSupplierAnswerDto | null;
  points?: number | null;
  isAutoComputed: boolean;
  comment?: string | null;
  weightedPoints?: number | null;
  scoredBeforeLatestDelivery?: boolean;
};
export type EvalMinimumRequirementsDto = {
  outcome: MinimumRequirementOutcome;
  fulfilled: number;
  notFulfilled: number;
  total: number;
};
export type EvalBidDto = {
  bidId: string;
  supplierName: string;
  status: BidStatus;
  submittedAt?: string | null;
  price?: EventValueDto | null;
  effectivePrice?: EventValueDto | null;
  priceOverride?: PriceOverrideDto | null;
  originalPrice?: EventValueDto | null;
  previousPrice?: EventValueDto | null;
  earlierAssessment?: EarlierAssessmentDto | null;
  cells: EvalCellDto[];
  groupCells?: EvalCellDto[];
  weightedTotal: number;
  rank: number;
  minimumRequirements?: EvalMinimumRequirementsDto | null;
  notInRound?: boolean;
  awaitsExclusionGroundsAssessment?: boolean;
};
export type EvalProgressDto = {
  filled: number;
  total: number;
};
export type RestoredTenderNotReadyDto = {
  bidId: string;
  supplierName: string;
  leftOutOfRound: boolean;
};
export type EvaluationDto = {
  eventId: string;
  model: EvaluationModelDto;
  awardMethod?: AwardMethodDto | null;
  criteria: EvalCriterionDto[];
  bids: EvalBidDto[];
  selectedBidIds?: string[];
  progress: EvalProgressDto;
  revision?: number;
  rankedByJury?: boolean;
  restoredTendersNotReady?: RestoredTenderNotReadyDto[];
  disclosesTotalToSuppliers?: boolean;
};
export type UpsertPriceOverrideRequest = {
  bidId: string;
  value?: number | null;
  comment?: string | null;
  forDeliverySubmittedAt?: string | null;
};
export type PriceStageDto = {
  roundId?: string | null;
  roundNumber?: number | null;
};
export type SupplierPriceDevelopmentDto = {
  supplierId: string;
  supplierName: string;
  prices: (number | null)[];
  participated: boolean[];
};
export type PriceDevelopmentDto = {
  currency: Currency;
  stages: PriceStageDto[];
  suppliers: SupplierPriceDevelopmentDto[];
};
export type SetRationaleRequest = {
  criterionId: string;
  text: string;
};
export type UpsertScoreRequest = {
  criterionId: string;
  bidId: string;
  points?: number | null;
  comment?: string | null;
  forDeliverySubmittedAt?: string | null;
};
export type SetEvaluationSelectionRequest = {
  bidIds: string[];
};
export type UpdateSourcingEventValueRequest = {
  eventValue?: EventValueDto | null;
};
export type SourcingEventFieldSourceDto = {
  path: string;
  source: FieldSourceDto;
  confirmedByUser: boolean;
  recordedAt: string;
  changedByUser: boolean;
  changedByUserAt?: string | null;
  awaitsReview: boolean;
  reviewedByUserAt?: string | null;
};
export type SourcingEventFieldSourcesDto = {
  fields: SourcingEventFieldSourceDto[];
  canReview: boolean;
};
export type ReviewSourcingEventFieldSourcesRequest = {
  paths: string[];
};
export type PanelMemberDto = {
  organizationId: string;
  name: string;
  contractId?: string | null;
  contractState?: ContractStateDto | null;
  ranking?: number | null;
  status: PanelStatus;
  contractEnded?: boolean;
};
export type UnregisteredPanelMemberDto = {
  organizationEntryId: string;
  name: string;
  organizationNumber?: string | null;
  contractId?: string | null;
  contractState?: ContractStateDto | null;
  contractEnded?: boolean;
};
export type FrameworkAgreementSummaryDto = {
  miniCompetitionCount: number;
  supplierCount: number;
  calledOffValue?: string | null;
  remainingCeilingValue?: string | null;
  nextPartyContractEndDate?: string | null;
};
export type FrameworkAgreementDto = {
  id: string;
  sourcingEventId?: string | null;
  title: string;
  responsiblePersonId: string;
  responsiblePerson: PersonDto;
  status: FrameworkAgreementStatus;
  callOffMechanism: CallOffMechanism;
  ceilingValue?: EventValueDto | null;
  ceilingIsAnnouncedMaximum?: boolean;
  startDate?: string | null;
  endDate?: string | null;
  maxParticipants?: number | null;
  regulation?: Regulation | null;
  foaPart?: FoaPart | null;
  panel?: PanelMemberDto[];
  unregisteredSuppliers?: UnregisteredPanelMemberDto[];
  summary: FrameworkAgreementSummaryDto;
  allowsDirectAward: boolean;
  allowsMiniCompetitions: boolean;
  callOffRefusal?: CallOffRefusalDto | null;
  mayCreateCallOff: boolean;
  callOffNotInPlan?: boolean;
  mayManage?: boolean;
  mayOpenMiniCompetition?: boolean;
  mayAddSuppliers?: boolean;
  supplierAdditionRefusal?: SupplierAdditionRefusalDto | null;
  valueReminders?: FrameworkValueReminderDto[];
};
export type CreateFrameworkAgreementRequest = {
  title?: string | null;
  callOffMechanism?: CallOffMechanism | null;
};
export type MiniCompetitionPanelDto = {
  panel: PanelMemberDto[];
  unregisteredSuppliers: UnregisteredPanelMemberDto[];
};
export type SetHomeDepartmentRequest = {
  homeDepartmentId: string;
};
export type InterestInvitationRequestDto = {
  requestDeadline: string;
  shortDeadlineJustification?: string | null;
};
export type AddInternalMessageRequest = {
  value: string;
};
export type SaveInterviewDraftRequest = {
  conversationId?: string | null;
};
export type InvitationResultDto = {
  invitedOrganizationIds: string[];
  bidSubmissionDeadline: string;
  confirmedAt: string;
};
export type NotSelectedRequestDto = {
  requestId: string;
  reason: string;
};
export type ConfirmInvitationRequestDto = {
  bidSubmissionDeadline: string;
  tenderValidityMonths?: number | null;
  tenderDeadlineAgreedWithCandidates?: boolean | null;
  selectedRequestIds?: string[] | null;
  notSelected?: NotSelectedRequestDto[];
};
export type InviteEmailAccountOrganizationDto = {
  id: string;
  name: string;
};
export type InviteEmailAccountDto = {
  personId?: string | null;
  organizations: InviteEmailAccountOrganizationDto[];
};
export type NegotiationRoundPersonDto = {
  id: string;
  name: string;
};
export type NegotiationRoundEmailInviteDto = {
  id: string;
  email: string;
};
export type NegotiationRoundInviteDto = {
  organizationId: string;
  organizationName: string;
  persons: NegotiationRoundPersonDto[];
  emailInvites?: NegotiationRoundEmailInviteDto[];
  message?: string | null;
  declinedAt?: string | null;
};
export type NegotiationRoundInternalMessageDto = {
  id: string;
  message: string;
  createdAt: string;
};
export type NegotiationRoundDto = {
  id: string;
  eventId: string;
  roundNumber: number;
  isFinalRound?: boolean | null;
  status: NegotiationRoundStatus;
  publishedAt?: string | null;
  completedAt?: string | null;
  reopenedAt?: string | null;
  title?: string | null;
  description?: string | null;
  deadline: string;
  documents: ViewDocumentAsOwnerDto[];
  invites: NegotiationRoundInviteDto[];
  internalConversation: NegotiationRoundInternalMessageDto[];
  selectedProductBids?: WinningProductGroupBidsDto[] | null;
  viewingCount?: number;
  selectionJustification?: string | null;
};
export type ListNegotiationRoundsResponse = {
  rounds: NegotiationRoundDto[];
  rejectedOrganizationIds?: string[];
  reducedOrganizationIds?: string[];
  stillCompetingOrganizationIds?: string[];
  tenderersLeftOutOfFirstRound?: string[];
  didNotAnswerOrganizationIdsByRound?: {
    [key: string]: string[];
  };
};
export type CreateNegotiationRoundRequest = {
  deadline: string;
  isFinalRound?: boolean | null;
  dialogueDepartureJustification?: string | null;
};
export type NegotiationRoundPatchDto = {
  title?: string | null;
  description?: string | null;
  deadline?: string;
  isFinalRound?: boolean | null;
  documents?: string[];
  selectionJustification?: string | null;
};
export type AddNegotiationRoundInviteRequest = {
  organizationId: string;
  personIds?: string[];
  message?: string | null;
};
export type UpdateNegotiationRoundInviteMessageRequest = {
  message?: string | null;
};
export type SelectProductBidsRequest = {
  selectedProductBids: WinningProductGroupBidsDto[];
};
export type InvitedSupplierDto = {
  organizationId: string;
  name: string;
};
export type PrecedingCompetitionDto = {
  eventId: string;
  title: string;
  cancelledAt?: string | null;
  tenderers: InvitedSupplierDto[];
};
export type PrecedingDesignContestDto = {
  eventId: string;
  title: string;
  winnersChosenAt?: string | null;
  winners: InvitedSupplierDto[];
};
export type NegotiationWithoutNoticeOverviewDto = {
  invitees: InvitedSupplierDto[];
  precedingCompetitions: PrecedingCompetitionDto[];
  designContests?: PrecedingDesignContestDto[];
};
export type AddOrganizationInviteRequest = {
  organizationId: string;
  persons?: InvitedPersonPatchDto[];
  emailInvites?: OrganizationEmailInvitePatchDto[];
};
export type AddOrganizationInviteRecipientsRequest = {
  persons?: InvitedPersonPatchDto[];
  emailInvites?: OrganizationEmailInvitePatchDto[];
};
export type EspdRequirementResponseDto = {
  requirementId: string;
  instanceIndex?: number | null;
  indicator?: boolean | null;
  description?: string | null;
  date?: string | null;
  amount?: number | null;
  currencyId?: string | null;
  code?: string | null;
  percentage?: number | null;
  quantity?: number | null;
  quantityUnitCode?: string | null;
  period?: string | null;
  evidenceUrl?: string | null;
  evidenceName?: string | null;
};
export type EspdRepresentativeDto = {
  firstName: string;
  familyName: string;
  birthDate?: string | null;
  email?: string | null;
  telephone?: string | null;
  role?: string | null;
};
export type EspdEconomicOperatorDto = {
  smeIndicator?: boolean | null;
  representatives?: EspdRepresentativeDto[];
};
export type EspdFinalDeclarationDto = {
  confirmed?: boolean;
};
export type EspdResponseDto = {
  specVersion: string;
  responses: EspdRequirementResponseDto[];
  economicOperator?: EspdEconomicOperatorDto | null;
  finalDeclaration?: EspdFinalDeclarationDto;
};
export type BuyerParticipationQualificationResponseDto = {
  criterionKey: string;
  description?: string | null;
  evidenceDocumentIds?: string[];
  buyerVerdict?: boolean | null;
  buyerComment?: string | null;
  evidenceDocuments?: ViewDocumentAsOwnerDto[];
};
export type ExclusionGroundsAssessmentDto = {
  text: string;
  writtenByName?: string | null;
  writtenAt: string;
};
export type BuyerQualificationVerdictDto = {
  qualified: boolean;
  decidedAt: string;
  decidedByName?: string | null;
  exclusionGroundsAssessment?: ExclusionGroundsAssessmentDto | null;
};
export type SelectionOutcomeDto = {
  selected: boolean;
  reason?: string | null;
  decidedAt: string;
};
export type RejectionGroundDto = {
  key: string;
  label: string;
  foaReference: string;
  mandatory: boolean;
};
export type ParticipationRequestRejectionDto = {
  grounds?: RejectionGroundDto[];
  message: string;
  attachmentIds?: string[];
  attachments?: ViewDocumentAsOwnerDto[];
};
export type SelectionDraftDto = {
  deselected: boolean;
  reason?: string | null;
  editedByName?: string | null;
  editedAt: string;
};
export type WithdrawnRejectionDto = {
  rejectedAt: string;
  rejectedByName?: string | null;
  rejectionReason?: string | null;
  rejection?: ParticipationRequestRejectionDto | null;
  withdrawnAt: string;
  withdrawnByName?: string | null;
  reason: string;
};
export type BuyerParticipationRequestDto = {
  id: string;
  organizationId: string;
  organizationName?: string | null;
  organizationNumber?: string | null;
  status: ParticipationRequestStatus;
  submittedAt?: string | null;
  espdResponse?: EspdResponseDto | null;
  qualificationResponses?: BuyerParticipationQualificationResponseDto[];
  qualificationVerdict?: BuyerQualificationVerdictDto | null;
  selectionOutcome?: SelectionOutcomeDto | null;
  internalNote?: string | null;
  rejectionReason?: string | null;
  exclusionGroundsAssessment?: string | null;
  rejection?: ParticipationRequestRejectionDto | null;
  selectionDraft?: SelectionDraftDto | null;
  assessmentDeadline?: string | null;
  assessmentWorkingDaysRemaining?: number | null;
  assessmentExtended?: boolean;
  membershipEndedAt?: string | null;
  membershipEndReason?: string | null;
  membershipEndedByName?: string | null;
  membershipEndsAt?: string | null;
  admitted?: boolean;
  categories?: string[];
  withdrawnRejections?: WithdrawnRejectionDto[];
};
export type BuyerParticipationRequestsDto = {
  requestDeadline?: string | null;
  identitiesVisible: boolean;
  count: number;
  requests?: BuyerParticipationRequestDto[];
  invitationConfirmed?: boolean;
};
export type BuyerBidEspdRequirementValueDto = {
  indicator?: boolean | null;
  description?: string | null;
  date?: string | null;
  amount?: number | null;
  currencyId?: string | null;
  code?: string | null;
  percentage?: number | null;
  quantity?: number | null;
  quantityUnitCode?: string | null;
  period?: string | null;
  evidenceUrl?: string | null;
  evidenceName?: string | null;
};
export type BuyerBidEspdRequirementDto = {
  id: string;
  label: string;
  labelSource?: string | null;
  labelTranslation?: string | null;
  responseDataType: EspdResponseDataType;
  optional: boolean;
  value?: BuyerBidEspdRequirementValueDto | null;
};
export type BuyerBidEspdRequirementGroupInstanceDto = {
  instanceIndex?: number | null;
  requirements: BuyerBidEspdRequirementDto[];
  subGroups: BuyerBidEspdRequirementGroupDto[];
};
export type BuyerBidEspdRequirementGroupDto = {
  id: string;
  repeatable: boolean;
  instances: BuyerBidEspdRequirementGroupInstanceDto[];
};
export type BuyerBidEspdCriterionDto = {
  id: string;
  name: string;
  nameSource?: string | null;
  nameTranslation?: string | null;
  answer: BuyerBidEspdAnswerDto;
  description?: string | null;
  descriptionSource?: string | null;
  descriptionTranslation?: string | null;
  responseGroups: BuyerBidEspdRequirementGroupDto[];
};
export type BuyerBidEspdCategoryDto = {
  code: string;
  name: string;
  okCount: number;
  deviationCount: number;
  unansweredCount: number;
  criteria: BuyerBidEspdCriterionDto[];
};
export type BuyerBidEspdDto = {
  hasResponse: boolean;
  okCount: number;
  deviationCount: number;
  unansweredCount: number;
  categories: BuyerBidEspdCategoryDto[];
};
export type BuyerBidNamedEntityDto = {
  name: string;
  organizationNumber?: string | null;
  groupRole?: string | null;
};
export type BuyerBidDeclarationDto = {
  id: string;
  typeCode: string;
  question: string;
  questionSource?: string | null;
  questionTranslation?: string | null;
  answer?: boolean | null;
  responseGroups: BuyerBidEspdRequirementGroupDto[];
  namedEntities?: BuyerBidNamedEntityDto[];
};
export type BuyerBidDeclarationsDto = {
  hasResponse: boolean;
  declarations: BuyerBidDeclarationDto[];
};
export type DeclaredExclusionGroundDto = {
  criterionId: string;
  name: string;
  answeredYes: boolean;
  obligation: ExclusionObligation;
  label: string;
  lawfulIf: string;
};
export type BuyerParticipationRequestDetailDto = {
  request: BuyerParticipationRequestDto;
  eventTitle?: string | null;
  requestDeadline?: string | null;
  invitationConfirmed?: boolean;
  selectionCriteria?: SelectionCriterionDto[];
  espd?: BuyerBidEspdDto | null;
  declarations?: BuyerBidDeclarationsDto | null;
  declaredExclusionGrounds?: DeclaredExclusionGroundDto[];
  exclusionGroundsAssessmentRequired?: boolean;
  foaPart?: FoaPart | null;
  verdictClearable?: boolean;
  admissionEndsByRemoval?: boolean;
  admissionRemovalGivesNotice?: boolean;
};
export type ExtendAssessmentRequestDto = {
  reason: string;
};
export type SchemeMemberCategoriesRequestDto = {
  categories: string[];
};
export type BuyerQualificationReviewResponsePatchDto = {
  criterionKey: string;
  buyerVerdict?: boolean | null;
  buyerComment?: string | null;
};
export type BuyerQualificationReviewPatchDto = {
  responses?: BuyerQualificationReviewResponsePatchDto[];
  forDeliverySubmittedAt?: string | null;
};
export type ParticipationRequestRejectionDocumentsDto = {
  documents?: ViewDocumentAsOwnerDto[];
};
export type RemoveFromSchemeRequestDto = {
  reason: string;
  effectiveAt?: string | null;
};
export type BuyerReviewNotesPatchDto = {
  internalNote?: string | null;
  rejectionReason?: string | null;
  exclusionGroundsAssessment?: string | null;
};
export type SelectionDraftPatchDto = {
  deselected?: boolean;
  reason?: string | null;
};
export type RejectionGroundTextDto = {
  key: string;
  text: string;
};
export type SetParticipationRequestRejectionDto = {
  grounds?: RejectionGroundDto[];
  message?: string;
  groundTexts?: RejectionGroundTextDto[];
  supplierName?: string;
  attachmentIds?: string[];
};
export type SetQualificationVerdictRequestDto = {
  qualified?: boolean | null;
  rejectionReason?: string | null;
  rejection?: SetParticipationRequestRejectionDto | null;
  withdrawalReason?: string | null;
};
export type PortalLinkShareDto = {
  email: string;
  sentAt: string;
  sentBy: string;
  status: EmailInviteStatusDto;
  openedAt?: string | null;
};
export type PortalLinkSharesDto = {
  shares: PortalLinkShareDto[];
};
export type SharePortalLinkRequest = {
  emails: string[];
  language?: EmailInviteLanguage;
};
export type ProtocolFieldDto = {
  label: string;
  value?: string | null;
};
export type NarrativeBasisDto = {
  procedureType?: string | null;
  defaultText?: string | null;
  winningBidIds?: string[];
};
export type ProtocolBlockDto = {
  kind: string;
  label?: string | null;
  value?: string | null;
  editableKey?: string | null;
  columns?: string[];
  rows?: (string | null)[][];
  emphasizeFirstRow?: boolean;
  numericColumns?: number[];
  emptyText?: string | null;
  badge?: string | null;
  rankColumn?: number | null;
  fields?: ProtocolFieldDto[];
  draftWarning?: string | null;
  writtenAgainst?: NarrativeBasisDto | null;
};
export type ProtocolSectionDto = {
  number: number;
  heading: string;
  blocks: ProtocolBlockDto[];
  internal?: boolean;
};
export type ProtocolDocumentDto = {
  sections: ProtocolSectionDto[];
  differsFromLatestVersion?: boolean;
  canFinalise: boolean;
};
export type ProtocolDraftPatchDto = {
  editableKey: string;
  value: string;
  writtenAgainst?: NarrativeBasisDto | null;
};
export type ProtocolVersionDto = {
  versionNumber: number;
  finalisedAt: string;
  downloadUrl: string;
};
export type ProtocolVersionListDto = {
  versions: ProtocolVersionDto[];
};
export type BidQualificationResponseDto = {
  criterionKey: string;
  description?: string | null;
  evidenceDocumentIds?: string[] | null;
  evidenceDocuments?: ViewDocumentAsOwnerDto[] | null;
  buyerVerdict?: boolean | null;
  buyerComment?: string | null;
  verdictBy?: string | null;
  verdictAt?: string | null;
};
export type BidMinimumRequirementResponseDto = {
  minimumRequirementId: string;
  answer: boolean;
  comment?: string | null;
  attachmentIds?: string[] | null;
  attachments?: ViewDocumentAsOwnerDto[] | null;
  buyerVerdict?: boolean | null;
  buyerComment?: string | null;
  verdictBy?: string | null;
  verdictAt?: string | null;
};
export type NumberFieldDto = {
  type: "Number";
  id: string;
  name: string;
  populatedBy: Populater;
  isRequired: boolean;
  value?: number | null;
};
export type BooleanFieldDto = {
  type: "Boolean";
  id: string;
  name: string;
  populatedBy: Populater;
  isRequired: boolean;
  value?: boolean | null;
};
export type TextFieldDto = {
  type: "Text";
  id: string;
  name: string;
  populatedBy: Populater;
  isRequired: boolean;
  value?: string | null;
};
export type ProductFieldDto = BooleanFieldDto | NumberFieldDto | TextFieldDto;
export type ProductBidDto = {
  productId: string;
  unitPrice: NumberFieldDto;
  productFields: ProductFieldDto[];
};
export type ProductGroupBidDto = {
  productGroupId: string;
  productBids: ProductBidDto[];
};
export type ReceivedBidDto = {
  id: string;
  owner: string;
  ownerName: string;
  status: BidStatus;
  submittedAt?: string | null;
  contractId?: string | null;
  contractState?: ContractStateDto | null;
  documents?: ViewDocumentAsOwnerDto[];
  qualificationResponses?: BidQualificationResponseDto[];
  minimumRequirementResponses?: BidMinimumRequirementResponseDto[];
  forNegotiationRound?: string | null;
  confirmsStandingBid?: boolean;
  products?: ProductGroupBidDto[] | null;
  qualifiedAt?: string | null;
};
export type ListBidsResponse = {
  bids: ReceivedBidDto[];
};
export type BidStatusTransitionDto = {
  type: BidStatusTransitionTypeDto;
  at: string;
};
export type BidAwardCriterionResponseDto = {
  criterionId: string;
  text?: string | null;
  number?: number | null;
  choice?: AwardCriterionAnswerChoice | null;
  partialElaboration?: string | null;
  attachmentIds?: string[] | null;
  attachments?: ViewDocumentAsOwnerDto[] | null;
};
export type BidRejectionDto = {
  grounds: RejectionGroundDto[];
  reason: string;
  message: string;
  rejectedAt?: string | null;
  rejectedBy?: string | null;
  attachmentIds?: string[];
  attachments?: ViewDocumentAsOwnerDto[];
};
export type BidRejectionRevocationDto = {
  at: string;
  by: string;
  reason?: string | null;
};
export type BuyerBidDto = {
  id: string;
  forEvent: string;
  status: BidStatus;
  forNegotiationRound?: string | null;
  submittedAt?: string | null;
  statusHistory?: BidStatusTransitionDto[];
  espdResponse?: EspdResponseDto | null;
  qualificationResponses?: BidQualificationResponseDto[];
  minimumRequirementResponses?: BidMinimumRequirementResponseDto[];
  awardCriterionResponses?: BidAwardCriterionResponseDto[];
  price?: EventValueDto | null;
  coverLetter?: string | null;
  signedDocumentId?: string | null;
  documents?: ViewDocumentAsOwnerDto[];
  rejection?: BidRejectionDto | null;
  rejectionRevocations?: BidRejectionRevocationDto[];
  products?: ProductGroupBidDto[] | null;
  comment?: string | null;
  commentDocuments?: ViewDocumentAsOwnerDto[];
};
export type BidQualificationDto = {
  decidedAt: string;
  decidedByName?: string | null;
};
export type AdmissionDeclarationDto = {
  schemeId: string;
  schemeTitle: string;
  participationRequestId: string;
  submittedAt: string;
};
export type BuyerBidDetailDto = {
  bid: BuyerBidDto;
  ownerOrganizationId: string;
  ownerName: string;
  ownerOrganizationNumber?: string | null;
  eventTitle?: string | null;
  foaPart?: FoaPart | null;
  selectionCriteria?: SelectionCriterionDto[];
  minimumRequirements?: MinimumRequirementDto[];
  awardCriteria?: AwardCriterionDto[];
  bidOpenedAt?: string | null;
  espd?: BuyerBidEspdDto | null;
  declarations?: BuyerBidDeclarationsDto | null;
  qualification?: BidQualificationDto | null;
  declaredExclusionGrounds?: DeclaredExclusionGroundDto[];
  exclusionGroundsAssessmentRequired?: boolean;
  exclusionGroundsAssessment?: ExclusionGroundsAssessmentDto | null;
  qualificationReopenedAfterJuryDecision?: boolean;
  admissionDeclaration?: AdmissionDeclarationDto | null;
  submittedBy?: PersonDto | null;
  replacedByLaterBid?: boolean;
  replacedByRoundNumber?: number | null;
};
export type OrganizationEntryPitchDto = {
  id: string;
  name: string;
  contactPersons?: ContactPersonDto[] | null;
};
export type OrgPublicProfileDto = {
  id: string;
  owner: PersonDto;
  name: string;
  country: CountryDto;
  organizationNumber?: string | null;
  industries: IndustryDto[];
  aboutUs?: string | null;
  specializations?: string | null;
  homePageUrl?: string | null;
  size?: OrganizationSize | null;
  contactPersons?: PersonDto[] | null;
  linkedEntries: OrganizationEntryPitchDto[];
  sameLegalEntityIds?: string[];
};
export type CounterpartyDto = {
  organization?: OrgPublicProfileDto | null;
  organizationEntry?: OrganizationEntryDto | null;
};
export type ContractTemplateMinDto = {
  id: string;
  name?: string | null;
  commonType?: CommonTemplateType | null;
};
export type ContractEditingMetaFieldsDto = {
  uploads: UploadDto[];
  descriptionUploads: UploadDto[];
};
export type CustomFieldIdentifierDto = {
  sectionId: string;
  fieldId: string;
};
export type CounterpartyContactPersonDto = {
  fullName?: string | null;
  email?: string | null;
  phoneNumber?: PhoneNumberDto | null;
  person?: PersonDto | null;
};
export type ContractEndDateDto = {
  date?: string | null;
  hasNoEndDate: boolean;
};
export type LinkedContractDto = {
  id: string;
  title: string;
};
export type OriginSourcingEventDetailsDto = {
  type: "SourcingEventV2";
  id: string;
  title: string;
  procedureType?: ProcedureType | null;
  noCompetitionCondition?: NoCompetitionCondition | null;
  regulation?: Regulation | null;
  followsDesignContestBelowEeaTier?: boolean;
};
export type OriginSourcingEventDto = OriginSourcingEventDetailsDto;
export type TerminationDateDto = {
  date: string;
  reason: string;
};
export type IfrsAdjustmentDto = {
  type: IfrsAdjustmentType;
  monthNumber: number;
  value: number;
};
export type IfrsValuesDto = {
  startDate?: string | null;
  startDateSecondPeriod?: string | null;
  monthlyPayment?: number | null;
  paymentIntervalInMonths?: number | null;
  contractLengthInMonths?: number | null;
  interestRate?: number | null;
  adjustments: IfrsAdjustmentDto[];
  filled: boolean;
};
export type InternalPartyDto = {
  organizationId: string;
  organizationName: string;
};
export type InternalPartiesDto = {
  parties: InternalPartyDto[];
};
export type SupplierInfoDto = {
  isClimateCommitted: boolean;
  hasSignedCodeOfConduct: boolean;
  hasCustomerContact: boolean;
};
export type OptionDto = {
  id?: string;
  name?: string;
  description?: string;
  startDate?: string | null;
  deadline?: string | null;
  endDate?: string | null;
  duration?: number | null;
  isExecuted?: boolean;
  isDeclined?: boolean;
  isLapsed?: boolean;
  extension?: ContractExtensionDto | null;
  datesSetByHand?: boolean;
  decidedAt?: string | null;
  decidedByName?: string | null;
  waitsForOptionId?: string | null;
  doesNotExtendContract?: boolean;
  lapsedBecauseOfOptionId?: string | null;
};
export type ParentProjectDto = {
  id: string;
  createdAt: string;
  modifiedAt: string;
  externalId?: string | null;
  name: string;
  startDate?: string | null;
  endDate?: string | null;
};
export type ChildProjectDto = {
  id: string;
  createdAt: string;
  modifiedAt: string;
  externalId?: string | null;
  name: string;
  startDate?: string | null;
  endDate?: string | null;
};
export type ProjectTypeDto = {
  id: string;
  name: ProjectTypeName;
};
export type ProjectDocumentDto = {
  id: string;
  name: string;
  mimeType: string;
  fileExtension: string;
  size: number;
  uploadedAt: string;
  uploadedBy: PersonDto;
  s3Key: string;
  fromUploadId: string;
  tags: string[];
};
export type ProjectDto = {
  id: string;
  createdAt: string;
  modifiedAt: string;
  status: ProjectStatus;
  homeDepartment?: DepartmentDto | null;
  externalId?: string | null;
  name: string;
  description?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  parentId?: string | null;
  parent?: ParentProjectDto | null;
  children?: ChildProjectDto[] | null;
  projectResponsibleId?: string | null;
  projectResponsible?: PersonDto | null;
  sourcingResponsibleId?: string | null;
  sourcingResponsible?: PersonDto | null;
  projectTypeId?: string | null;
  projectType?: ProjectTypeDto | null;
  documents?: ProjectDocumentDto[] | null;
  canEdit?: boolean;
  uploads?: UploadDto[] | null;
  descriptionDocuments?: ProjectDocumentDto[] | null;
};
export type ContractDataFieldsDto = {
  missingDataFields: ContractDataFieldNameDto[];
  requiredDataFields: ContractDataFieldDto[];
  addedDataFields: ContractDataFieldDto[];
  customFields?: {
    [key: string]: ContractDataFieldSectionDto;
  } | null;
  missingCustomFields?: CustomFieldIdentifierDto[] | null;
  requiredCustomFields?: CustomFieldIdentifierDto[] | null;
  awardDate?: string | null;
  renewalDate?: string | null;
  counterpartyContactPerson?: CounterpartyContactPersonDto | null;
  deliveryTerms?: string | null;
  estimatedValue?: number | null;
  endDate?: ContractEndDateDto | null;
  externalLink?: string | null;
  industries?: IndustryDto[] | null;
  internalReferenceNumber?: string | null;
  linkedContracts?: LinkedContractDto[] | null;
  originSourcingEvent?: OriginSourcingEventDto | null;
  paymentTermsInDays?: number | null;
  pricePerMonth?: number | null;
  pricePerYear?: number | null;
  priority?: ContractPriority | null;
  purchasingPolicy?: string | null;
  risk?: ContractRisk | null;
  startDate?: string | null;
  totalLiability?: number | null;
  totalPrice?: number | null;
  warrantyExpirationDate?: string | null;
  terminationDate?: TerminationDateDto | null;
  ifrsValues?: IfrsValuesDto | null;
  internalParties?: InternalPartiesDto | null;
  supplierInfo?: SupplierInfoDto | null;
  supplierCategory?: Category | null;
  noticePeriod?: number | null;
  options?: OptionDto[] | null;
  projects?: ProjectDto[] | null;
};
export type DocumentSignerDto = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  status: DocumentSignerStatusDto;
  statusTimestamp?: string | null;
};
export type SignedAttachmentDto = {
  id: string;
  title?: string | null;
  description?: string | null;
  fileName?: string | null;
};
export type MergedDocumentDto = {
  id: string;
  name: string;
};
export type MergedTextDocumentDto = {
  id: string;
  name: string;
};
export type MergedAttachmentDto = {
  type: string;
  id: string;
  name: string;
};
export type MergedDocumentsDto = {
  mainDocument?: MergedDocumentDto | null;
  mainTextDocument?: MergedTextDocumentDto | null;
  attachments?: MergedAttachmentDto[];
};
export type SignedDocumentDto = {
  id: string;
  name: string;
  uploadedAt: string;
  sentForSigningBy: PersonDto;
  status: SignedDocumentStatus;
  signers: DocumentSignerDto[];
  signicatDocumentId: string;
  signingCompleted: boolean;
  deadline?: string | null;
  attachments?: SignedAttachmentDto[] | null;
  mergedDocuments?: MergedDocumentsDto | null;
  tags: string[];
  fencyContentStatus?: FencyContentStatus | null;
  mainDocumentId?: string | null;
  mainTextDocumentId?: string | null;
  attachedDocumentIds: string[];
  resendOfSignedDocumentId?: string | null;
  resentAsSignedDocumentId?: string | null;
};
export type ContractDocumentFieldsDto = {
  documents: ViewDocumentAsOwnerDto[];
  signedDocuments: SignedDocumentDto[];
  descriptionDocuments: ViewDocumentAsOwnerDto[];
};
export type NotificationInAdvanceConfigDto = {
  durationType: ContractNotificationDurationType;
  amount: number;
};
export type ContractNotificationDto = {
  type: ContractNotificationTypeDto;
  id: string;
  inAdvanceConfig?: NotificationInAdvanceConfigDto | null;
  receivers: PersonDto[];
};
export type ContractNotificationFieldsDto = {
  notifications: ContractNotificationDto[];
};
export type ContractDto = {
  id: string;
  owningOrganizationId: string;
  department?: DepartmentDto | null;
  createdAt: string;
  modifiedAt: string;
  createdBy: PersonDto;
  state: ContractStateDto;
  status?: ContractStatusDto | null;
  title: string;
  description?: string | null;
  timezone: string;
  currency: Currency;
  counterparty?: CounterpartyDto | null;
  counterpartyAsSeen?: CounterpartyDto | null;
  counterpartyCopiedFromOriginal?: boolean;
  contactPersonCopiedFromOriginal?: boolean;
  frameworkAgreementId?: string | null;
  frameworkRole?: FrameworkRole | null;
  frameworkAgreementMayOpen?: boolean;
  internalOwner: PersonDto;
  template?: ContractTemplateMinDto | null;
  editingMetaFields?: ContractEditingMetaFieldsDto | null;
  dataFields?: ContractDataFieldsDto | null;
  documentFields?: ContractDocumentFieldsDto | null;
  notificationFields?: ContractNotificationFieldsDto | null;
  canEditEverything: boolean;
  canViewDataFields: boolean;
  canViewDocuments: boolean;
  canViewNotifications: boolean;
  canViewTasks: boolean;
  canCreateTasks: boolean;
  canCopy: boolean;
  canDiscardDraft?: boolean;
  originProcurementCancelled?: boolean;
  canViewParticipants: boolean;
  canUpdateParticipants: boolean;
  owningOrgHasSignatureAccess: boolean;
};
export type CreateContractFromBidRequest = {
  title?: string | null;
  templateId?: string | null;
  documentIds?: string[];
};
export type BuyerMinimumRequirementReviewResponsePatchDto = {
  minimumRequirementId: string;
  buyerVerdict?: boolean | null;
  buyerComment?: string | null;
};
export type BuyerMinimumRequirementReviewPatchDto = {
  responses?: BuyerMinimumRequirementReviewResponsePatchDto[];
  forDeliverySubmittedAt?: string | null;
};
export type SetBidQualificationRequestDto = {
  qualified: boolean;
  exclusionGroundsAssessment?: string | null;
};
export type RejectBidRequestDto = {
  grounds: RejectionGroundDto[];
  reason: string;
  message?: string;
  groundTexts?: RejectionGroundTextDto[];
  supplierName?: string;
  attachmentIds?: string[];
};
export type BidRejectionDocumentsDto = {
  documents?: ViewDocumentAsOwnerDto[];
};
export type RevokeBidRejectionRequest = {
  reason: string;
};
export type AdmittedSupplierDto = {
  organizationId: string;
  name: string;
};
export type QualificationSchemeCompetitionRowDto = {
  eventId: string;
  title: string;
  status: SourcingEventStatus;
  procedureType: ProcedureType;
  bidSubmissionDeadline?: string | null;
  invitedCount: number;
  openedAt?: string | null;
};
export type QualificationSchemeCompetitionsDto = {
  canStartCompetition: boolean;
  startBlock?: QualificationSchemeStartBlock | null;
  endedAt?: string | null;
  admittedSuppliers?: AdmittedSupplierDto[];
  rows?: QualificationSchemeCompetitionRowDto[];
};
export type CreateQualificationSchemeCompetitionRequestDto = {
  title: string;
  description?: string | null;
  procedureType: ProcedureType;
  invitedOrganizationIds?: string[] | null;
  narrowingReason?: string | null;
};
export type QualificationSchemeInviteesDto = {
  invitees: AdmittedSupplierDto[];
  noLongerAdmitted?: AdmittedSupplierDto[];
  admittedSinceCreation?: AdmittedSupplierDto[];
  frozen: boolean;
};
export type ListSeQuestionsResponse = {
  questions: SeQuestionDto[];
};
export type SeQuestionPatchDto = {
  answer?: string;
  attachments?: SeAttachmentInputDto[];
};
export type CreateSeQuestionMessageRequest = {
  content: string;
  attachments?: SeAttachmentInputDto[];
};
export type FieldStatusDto = {
  fieldKey: FieldKeys;
  gate: Gate;
  satisfied: boolean;
  error?: FieldErrorDto | null;
};
export type ValidationReadinessDto = {
  fields: FieldStatusDto[];
  refusedProcedure?: ProcedureType | null;
};
export type SetResponsiblePersonRequest = {
  responsiblePersonId: string;
};
export type RevokeAwardRequest = {
  reason: string;
};
export type SharedByDto = {
  personId: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
};
export type EventShareRowDto = {
  personId: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  sharedAt: string;
  sharedBy: SharedByDto;
  dormant: boolean;
  revoke: OperationAvailabilityDto;
};
export type EventSharesDto = {
  shares: EventShareRowDto[];
};
export type EventShareDto = {
  personId: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  sharedAt: string;
};
export type ShareEventRequest = {
  personId: string;
};
export type SupplierInformationDto = {
  id: string;
  createdAt: string;
  modifiedAt: string;
  createdBy: PersonDto;
  title: string;
  content: string;
  question?: string | null;
  attachments?: SeAttachmentDto[];
};
export type ListSupplierInformationResponse = {
  supplierInformation: SupplierInformationDto[];
};
export type CreateInformationRequest = {
  title: string;
  content: string;
  fromQuestionId?: string | null;
  question?: string | null;
  attachments?: SeAttachmentInputDto[];
};
export type FrameworkAgreementsDto = {
  frameworkAgreements?: FrameworkAgreementDto[];
  someWithheld?: boolean;
};
export type RegisterFrameworkAgreementRequest = {
  departmentId: string;
  title: string;
  callOffMechanism: CallOffMechanism;
  ceilingValue?: EventValueDto | null;
  startDate?: string | null;
  endDate?: string | null;
  maxParticipants?: number | null;
  regulation?: Regulation | null;
  foaPart?: FoaPart | null;
};
export type PanelMemberPatchDto = {
  organizationId: string;
  ranking?: number | null;
  status?: PanelStatus;
};
export type FrameworkAgreementPatchDto = {
  title?: string;
  responsiblePersonId?: string;
  panel?: PanelMemberPatchDto[];
  valueReminders?: FrameworkValueReminderDto[];
  regulation?: Regulation | null;
  foaPart?: FoaPart | null;
};
export type FrameworkCallOffDto = {
  contractId: string;
  title: string;
  supplierOrganizationId?: string | null;
  supplierName?: string | null;
  miniCompetitionId?: string | null;
  state: ContractStateDto;
  status?: ContractStatusDto | null;
  value?: string | null;
  currency?: Currency | null;
  endDate?: string | null;
};
export type FrameworkCallOffsDto = {
  callOffs?: FrameworkCallOffDto[];
  totalCount: number;
  totalValue?: string | null;
  ceilingValue?: string | null;
};
export type CreateDirectCallOffRequest = {
  supplierOrganizationId: string;
  title: string;
  estimatedValue?: EventValueDto | null;
  templateId?: string | null;
};
export type MiniCompetitionSummaryDto = {
  eventId: string;
  title: string;
  status: PublicEventStatusDto;
  bidSubmissionDeadline?: string | null;
  invitedSupplierCount: number;
  contractId?: string | null;
  callOffValue?: string | null;
  mayOpen?: boolean;
};
export type MiniCompetitionsDto = {
  miniCompetitions?: MiniCompetitionSummaryDto[];
};
export type OpenMiniCompetitionRequest = {
  title?: string | null;
};
export type AddFrameworkSupplierRequest = {
  organizationId?: string | null;
  organizationEntryId?: string | null;
};
export type FrameworkUsageDto = {
  id: string;
  title: string;
  endDate?: string | null;
  maxValue?: string | null;
  currency: Currency;
  calledOffValue?: string | null;
  spendWithheld: boolean;
  callOffCount: number;
  expiresSoon: boolean;
};
export type CallOffFollowUpDto = {
  contractId?: string | null;
  miniCompetitionId?: string | null;
  title: string;
  frameworkAgreementId: string;
  frameworkAgreementTitle: string;
  supplierName?: string | null;
  value?: string | null;
  currency: Currency;
  awardedAt: string;
  reasons: CallOffFollowUpReasonDto[];
};
export type FrameworkOverviewDto = {
  frameworkAgreements: FrameworkUsageDto[];
  followUp: CallOffFollowUpDto[];
  followUpCount: number;
};
export type ProductTemplateFieldDto = {
  type: ProductFieldType;
  id: string;
  name: string;
  populatedBy: Populater;
  isRequired: boolean;
};
export type ProductCommentDto = {
  comment: string;
  createdBy?: PersonDto | null;
  createdAt: string;
  modifiedAt: string;
};
export type ProductDto = {
  id: string;
  quantity: NumberFieldDto;
  productFields: ProductFieldDto[];
  conversation?: ProductCommentDto[] | null;
};
export type ProductGroupDto = {
  id: string;
  sourcingEventId?: string | null;
  projectId?: string | null;
  name: string;
  originProductGroupId?: string | null;
  productFields: ProductTemplateFieldDto[];
  products: ProductDto[];
};
export type ProductGroupsDto = {
  productGroups: ProductGroupDto[];
};
export type CopiedFromDto = {
  eventId: string;
  title: string;
  copiedAt: string;
};
export type EventListItemDto = {
  id: string;
  title: string;
  publicStatus?: PublicEventStatusDto | null;
  negotiationRound?: number | null;
  createdAt: string;
  modifiedAt: string;
  createdBy: PersonDto;
  responsible: PersonDto;
  contractNature?: ContractNature | null;
  deadline?: string | null;
  unansweredQuestionsCount: number;
  referenceId?: string | null;
  projects?: ProjectDto[] | null;
  canEdit: boolean;
  canView: boolean;
  copiedFrom?: CopiedFromDto | null;
  procedureType?: ProcedureType | null;
  regulation?: RegulationBucket | null;
  namesNoProcedure?: boolean;
};
export type SupplierEventListItemDto = {
  event: EventListItemDto;
  bidSubmitted: boolean;
  standing?: SupplierStanding | null;
};
export type ListBuyerEventsWithSupplierResponse = {
  events: SupplierEventListItemDto[];
  count: number;
};
export type ListBuyerEventsResponse = {
  events: EventListItemDto[];
  count: number;
  notVisible?: number | null;
};
export type BuyerEventFilterOptionsResponse = {
  responsiblePersons: PersonDto[];
  contractNatures: ContractNature[];
  statuses: SourcingEventStatus[];
  procedureTypes: ListedProcedure[];
  regulationBuckets: RegulationBucket[];
};
export type CellDto = {
  text?: string | null;
  number?: number | null;
  percent?: number | null;
  date?: string | null;
  dateTime?: string | null;
  contractId?: string | null;
  eventId?: string | null;
};
export type Row = {
  cells: (CellDto | null)[];
};
export type ListExportRequest = {
  columns: string[];
  rows: Row[];
  selection?: string | null;
  filteredOn?: string | null;
  fileName?: string | null;
};
export type ProcurementFigureFilterDto = {
  publishedFrom?: string | null;
  publishedTo?: string | null;
  awardedFrom?: string | null;
  awardedTo?: string | null;
  bidDeadlineFrom?: string | null;
  bidDeadlineTo?: string | null;
  deadlinePassed?: boolean | null;
  minDeliveredBids?: number | null;
  maxDeliveredBids?: number | null;
  procedureTypes?: ListedProcedure[] | null;
  regulationBuckets?: RegulationBucket[] | null;
};
export type ProcurementFigureDto = {
  figure: ProcurementOverviewFigure;
  value?: number | null;
  procurements: number;
  leftOut: number;
  filter: ProcurementFigureFilterDto;
};
export type CyclePhaseDto = {
  phase: CyclePhase;
  procurements: number;
  medianDays?: number | null;
  slowestDays?: number | null;
};
export type ProcedureBarDto = {
  procedureType: ListedProcedure;
  procurements: number;
  filter: ProcurementFigureFilterDto;
};
export type RegulationBarDto = {
  bucket: RegulationBucket;
  procurements: number;
  filter: ProcurementFigureFilterDto;
};
export type ClimateWeightingCountDto = {
  group: ClimateWeightingGroup;
  procurements: number;
};
export type ClimateWeightingDto = {
  groups: ClimateWeightingCountDto[];
  withoutWeightedCriteria: number;
};
export type ProcurementOverviewScopeDto = {
  organizationWide: boolean;
  departmentNames: string[];
  onlyOwnProcurements: boolean;
  projects: number;
  sharedProcurements: number;
};
export type ProcurementOverviewDto = {
  from: string;
  to: string;
  figures: ProcurementFigureDto[];
  phases: CyclePhaseDto[];
  deliveredBids: number;
  byProcedure: ProcedureBarDto[];
  withoutProcedure: number;
  byRegulation: RegulationBarDto[];
  climateWeighting?: ClimateWeightingDto | null;
  scope: ProcurementOverviewScopeDto;
};
export type ClimateWeightingRowDto = {
  id: string;
  title: string;
  referenceId?: string | null;
  firstPublishedAt?: string | null;
  environmentWeightPercent?: number | null;
  environmentRank?: number | null;
  exemption?: AwardCriterionType | null;
  justification?: string | null;
  justificationIsUnfinishedStandardText?: boolean;
};
export type ClimateWeightingListDto = {
  group: ClimateWeightingGroup;
  from: string;
  to: string;
  procurements: number;
  newestFirst: ClimateWeightingRowDto[];
};
export type CyclePhaseRowDto = {
  id: string;
  title: string;
  referenceId?: string | null;
  days: number;
};
export type CyclePhaseListDto = {
  phase: CyclePhase;
  from: string;
  to: string;
  procurements: number;
  slowestFirst: CyclePhaseRowDto[];
};
export type PlannedEventDto = {
  id: string;
  title: string;
  publicStatus?: PublicEventStatusDto | null;
  negotiationRound?: number | null;
  deadline?: string | null;
  responsible: PersonDto;
  procedureType?: ProcedureType | null;
  regulation?: RegulationBucket | null;
  namesNoProcedure?: boolean;
};
export type PlannedProcurementDto = {
  event: PlannedEventDto;
  phase: ProcurementPhaseDto;
  department?: DepartmentDto | null;
  estimatedValue?: EventValueDto | null;
  desiredDelivery?: string | null;
};
export type ProcurementPlanDto = {
  procurements: PlannedProcurementDto[];
  responsibles: PersonDto[];
};
export type BuyerEventStatusCountDto = {
  publicStatus: PublicEventStatusDto;
  count: number;
};
export type BuyerEventStatusCountsResponse = {
  counts: BuyerEventStatusCountDto[];
};
export type PersonProcurementWorkloadDto = {
  personId: string;
  name: string;
  email: string;
  active: boolean;
  needs?: number | null;
  activeProcurements: number;
  activeContracts?: number | null;
  deadlines: number;
};
export type ContractOverviewScopeDto = {
  organizationWide: boolean;
  departmentNames: string[];
  onlyOwnContracts: boolean;
  onlySharedContracts: boolean;
  alsoSharedContracts: boolean;
};
export type NeedWorkloadScopeDto = {
  organizationWide: boolean;
  departmentNames: string[];
};
export type ProcurementWorkloadScopeDto = {
  procurements: ProcurementOverviewScopeDto;
  contracts?: ContractOverviewScopeDto | null;
  needs?: NeedWorkloadScopeDto | null;
};
export type ProcurementWorkloadDto = {
  people: PersonProcurementWorkloadDto[];
  deadlinesUntil: string;
  scope: ProcurementWorkloadScopeDto;
};
export type UpcomingDeadlineDto = {
  subject: DeadlineSubject;
  subjectId: string;
  subjectTitle: string;
  kind: DeadlineKind;
  dueAt: string;
  detail?: string | null;
  parentId?: string | null;
  openCount?: number | null;
};
export type ProcurementWorkloadDeadlinesDto = {
  deadlines: UpcomingDeadlineDto[];
};
export type ProjectDetailDto = {
  projectId: string;
  projectName: string;
  externalId?: string | null;
};
export type LinkedContract = {
  id: string;
  title?: string | null;
};
export type ContractReportDto = {
  id: string;
  createdAt?: string | null;
  modifiedAt?: string | null;
  version: number;
  contractId: string;
  title: string;
  description?: string | null;
  templateId?: string | null;
  templateName?: string | null;
  timezone?: string | null;
  currency?: string | null;
  owningOrganizationId?: string | null;
  owningOrganizationName?: string | null;
  departmentName?: string | null;
  createdById?: string | null;
  createdByEmail?: string | null;
  createdByName?: string | null;
  internalOwnerId?: string | null;
  internalOwnerEmail?: string | null;
  internalOwnerName?: string | null;
  counterpartyId?: string | null;
  counterpartyName?: string | null;
  counterpartyType?: string | null;
  frameworkRole: FrameworkRole;
  frameworkAgreementId?: string | null;
  frameworkAgreementMayOpen?: boolean;
  miniCompetitionId?: string | null;
  state: ContractStateDto;
  status?: ContractStatusDto | null;
  counterpartyContactFullName?: string | null;
  counterpartyContactEmail?: string | null;
  counterpartyContactPhoneNumber?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  hasNoEndDate?: boolean | null;
  totalPrice?: number | null;
  estimatedValue?: number | null;
  priority?: string | null;
  risk?: string | null;
  renewalDate?: string | null;
  referenceNumber?: string | null;
  originSourcingEventId?: string | null;
  originSourcingEventName?: string | null;
  publishedById?: string | null;
  publishedByName?: string | null;
  publishedAt?: string | null;
  noticePeriod?: number | null;
  documentIds?: string[] | null;
  signedDocumentIds?: string[] | null;
  industryIds?: string[] | null;
  projectIds?: string[] | null;
  projectDetails?: ProjectDetailDto[] | null;
  terminationDate?: string | null;
  terminatedById?: string | null;
  terminatedByName?: string | null;
  terminationReason?: string | null;
  externalLink?: string | null;
  linkedContracts?: LinkedContract[] | null;
  paymentTermsInDays?: number | null;
  pricePerMonth?: number | null;
  pricePerYear?: number | null;
  annualValue?: number | null;
  purchasingPolicy?: string | null;
  supplierInfo?: SupplierInfoDto | null;
  internalParties?: InternalPartyDto[] | null;
  totalLiability?: number | null;
  warrantyExpirationDate?: string | null;
  supplierCategory?: string | null;
  options?: OptionDto[] | null;
  customFields?: {
    [key: string]: ContractDataFieldSectionDto;
  } | null;
  canUpdate?: boolean;
};
export type ListContractReportsResponseDto = {
  reports: ContractReportDto[];
  count: number;
};
export type ContractReportFilterOptionDto = {
  value: string;
  label: string;
};
export type ListContractReportOptionsResponseDto = {
  options: ContractReportFilterOptionDto[];
  count: number;
};
export type CustomFieldSearchConfigDto = {
  fieldId: string;
  searchTerm: string;
};
export type CustomFieldSelectConfigDto = {
  fieldId: string;
  selected: boolean;
};
export type CustomFieldValuesDto = {
  fieldId: string;
  values: string[];
};
export type ContractReportQueryDto = {
  titleFilter?: string | null;
  templateIds?: string[] | null;
  templateNameSearchTerm?: string | null;
  owningOrganizationId: string;
  owningOrganizationIds?: string[] | null;
  owningOrganizationName?: string | null;
  projectIds?: string[] | null;
  projectSearchTerm?: string | null;
  internalPartyIds?: string[] | null;
  internalPartySearchTerm?: string | null;
  visibleCustomFields?: {
    [key: string]: ContractDataFieldSectionDto;
  } | null;
  visibleCustomFieldIds?: string[] | null;
  startDateFrom?: string | null;
  startDateTo?: string | null;
  endDateFrom?: string | null;
  endDateTo?: string | null;
  hasNoEndDate?: boolean | null;
  createdAtFrom?: string | null;
  createdAtTo?: string | null;
  modifiedAtFrom?: string | null;
  modifiedAtTo?: string | null;
  publishedAtFrom?: string | null;
  publishedAtTo?: string | null;
  renewalDateFrom?: string | null;
  renewalDateTo?: string | null;
  terminationDateFrom?: string | null;
  terminationDateTo?: string | null;
  warrantyExpirationDateFrom?: string | null;
  warrantyExpirationDateTo?: string | null;
  datePresets?: {
    [key: string]: ContractDatePresetDto;
  } | null;
  internalOwnerIds?: string[] | null;
  internalOwnerSearchTerm?: string | null;
  counterpartyIds?: string[] | null;
  counterpartyName?: string | null;
  counterpartyContactFullName?: string | null;
  counterpartyContactFullNames?: string[] | null;
  counterpartyContactEmail?: string | null;
  counterpartyContactEmails?: string[] | null;
  counterpartyContactPhoneNumber?: string | null;
  counterpartyContactPhoneNumbers?: string[] | null;
  statuses?: ContractStatusDto[] | null;
  state?: string | null;
  originSourcingEventIds?: string[] | null;
  originSourcingEventName?: string | null;
  riskLevels?: ContractRisk[] | null;
  frameworkRoles?: FrameworkRole[] | null;
  priorityLevels?: ContractPriority[] | null;
  supplierCategories?: Category[] | null;
  referenceNumberSearchTerm?: string | null;
  quickSearchTerm?: string | null;
  tableSearchTerm?: string | null;
  referenceNumbers?: string[] | null;
  descriptionSearchTerm?: string | null;
  currencies?: string[] | null;
  publishedByIds?: string[] | null;
  publishedBySearchTerm?: string | null;
  terminatedByIds?: string[] | null;
  terminatedBySearchTerm?: string | null;
  terminationReasons?: string[] | null;
  linkedContractIds?: string[] | null;
  linkedContractTitleSearchTerm?: string | null;
  noticePeriodFrom?: number | null;
  noticePeriodTo?: number | null;
  paymentTermsInDaysFrom?: number | null;
  paymentTermsInDaysTo?: number | null;
  pricePerMonthFrom?: number | null;
  pricePerMonthTo?: number | null;
  pricePerYearFrom?: number | null;
  pricePerYearTo?: number | null;
  totalLiabilityFrom?: number | null;
  totalLiabilityTo?: number | null;
  estimatedValueFrom?: number | null;
  estimatedValueTo?: number | null;
  totalPriceFrom?: number | null;
  totalPriceTo?: number | null;
  externalLinkSearchTerm?: string | null;
  externalLinks?: string[] | null;
  purchasingPolicySearchTerm?: string | null;
  purchasingPolicies?: string[] | null;
  documentIds?: string[] | null;
  signedDocumentIds?: string[] | null;
  industryIds?: string[] | null;
  isClimateCommitted?: boolean | null;
  hasSignedCodeOfConduct?: boolean | null;
  hasCustomerContact?: boolean | null;
  customFieldSearch?: CustomFieldSearchConfigDto[] | null;
  customFieldSelect?: CustomFieldSelectConfigDto[] | null;
  customFieldValues?: CustomFieldValuesDto[] | null;
  optionNameSearchTerm?: string | null;
  optionNames?: string[] | null;
  withoutActiveOwner?: boolean | null;
  missingRequiredData?: boolean | null;
  activeFrameworkAgreement?: boolean | null;
  withAnnualValueIn?: string | null;
  awaitingSignature?: boolean | null;
  signingDeadlinePassed?: boolean | null;
  signedFrom?: string | null;
  signedTo?: string | null;
  optionDeadlineFrom?: string | null;
  optionDeadlineTo?: string | null;
  optionDecisionDue?: boolean | null;
  optionDecisionWithoutDeadline?: boolean | null;
  limit?: number | null;
  skip?: number | null;
};
export type ContractFigureAnnualValueDto = {
  value: number;
  notCounted: number;
};
export type ContractOverviewFigureDto = {
  figure: ContractOverviewFigure;
  value: number;
  lastMonth?: number | null;
  filter: ContractReportQueryDto;
  drafts?: number | null;
  annualValue?: ContractFigureAnnualValueDto | null;
};
export type SupplierValueDto = {
  counterpartyId?: string | null;
  name?: string | null;
  annualValue: number;
  contracts: number;
  filter?: ContractReportQueryDto | null;
};
export type ValuePerSupplierDto = {
  top: SupplierValueDto[];
  others?: SupplierValueDto | null;
};
export type MissingContractDataDto = {
  contracts: number;
  filter: ContractReportQueryDto;
};
export type ContractExpiryMonthDto = {
  month: string;
  withOption: number;
  withoutOption: number;
  annualValue: number;
  withoutAnnualValue: number;
  filter: ContractReportQueryDto;
};
export type UpcomingOptionDeadlineDto = {
  contractId: string;
  title: string;
  supplierName?: string | null;
  responsibleName?: string | null;
  deadline?: string | null;
  daysLeft?: number | null;
};
export type UndatedOptionDecisionsDto = {
  hidden: number;
  filter: ContractReportQueryDto;
};
export type UpcomingOptionDeadlinesDto = {
  rows: UpcomingOptionDeadlineDto[];
  total: number;
  filter: ContractReportQueryDto;
  undated: UndatedOptionDecisionsDto;
};
export type ContractOverviewDto = {
  figures: ContractOverviewFigureDto[];
  valuePerSupplier: ValuePerSupplierDto;
  missingData: MissingContractDataDto;
  expiryTimeline: ContractExpiryMonthDto[];
  upcomingOptionDeadlines: UpcomingOptionDeadlinesDto;
  awaitingSignaturePastDeadline: number;
  activeWithoutEndDate: number;
  annualValueContracts: number;
  activeWithoutAnnualValue: number;
  activeInOtherCurrency: number;
  annualValueCurrency: string;
  scope: ContractOverviewScopeDto;
};
export type SavingsFigureDto = {
  list: SavingsList;
  amount?: number | null;
  share?: number | null;
  procurements: number;
  contracts: number;
};
export type LargestSavingDto = {
  contractId: string;
  title: string;
  supplierName?: string | null;
  baseline: number;
  awarded: number;
  saved: number;
  share?: number | null;
  contractsFromProcurement: number;
};
export type LargestSavingsDto = {
  measure: SavingsMeasure;
  measured: number;
  contracts: LargestSavingDto[];
};
export type ContractSavingDto = {
  contractId: string;
  title: string;
  supplierName?: string | null;
  procurementId?: string | null;
  procurementTitle?: string | null;
  lists: SavingsList[];
  estimatedValue?: number | null;
  awardedValue?: number | null;
  estimateDifference?: number | null;
  firstBid?: number | null;
  lastRound?: number | null;
  savedInNegotiation?: number | null;
  estimateShare?: number | null;
  negotiationShare?: number | null;
  withoutSaving?: WithoutSavingReason[];
  missingBaseline?: MissingBaseline | null;
};
export type ListedSavingsDto = {
  list: SavingsList;
  total: number;
  contracts: ContractSavingDto[];
};
export type ContractSavingsDto = {
  from: string;
  to: string;
  currency: Currency;
  figures: SavingsFigureDto[];
  scope: ContractOverviewScopeDto;
  largest: LargestSavingsDto[];
  listed?: ListedSavingsDto | null;
};
export type AwaitingSignatureDto = {
  contractId: string;
  contractTitle: string;
  documentName: string;
  sentAt: string;
  requiredSigned: number;
  required: number;
  deadline?: string | null;
  deadlinePassed: boolean;
  status: SignedDocumentStatus;
};
export type RecentlySignedDto = {
  contractId: string;
  contractTitle: string;
  supplier?: string | null;
  responsible?: string | null;
  signedAt: string;
  frameworkAgreement: boolean;
};
export type ContractSigningDto = {
  awaiting: AwaitingSignatureDto[];
  awaitingCount: number;
  recentlySigned: RecentlySignedDto[];
  recentlySignedCount: number;
  signedFrom: string;
  signedTo: string;
  activeWithoutSigning: number;
};
export type DeleteCustomFieldDto = {
  sectionId: string;
  fieldId: string;
};
export type UpsertCustomContractFieldDto = {
  field: CustomContractDataFieldDto;
  sectionId: string;
};
export type MarkSupplierFilterFieldDto = {
  fieldId: string;
  marked: boolean;
};
export type MarkSupplierFilterEndDateDto = {
  marked: boolean;
};
export type ContractTaskCommentDto = {
  id: string;
  text?: string | null;
  createdBy: PersonDto;
  createdAt: string;
  modifiedAt: string;
  deletedAt?: string | null;
  canUpdate: boolean;
};
export type UpdateContractTaskCommentRequest = {
  text: string;
};
export type ResponsibleOrganizationDto = {
  id: string;
  name: string;
};
export type ContractTaskDto = {
  id: string;
  createdAt: string;
  modifiedAt: string;
  status: ContractTaskStatus;
  displayStatus: ContractTaskStatusDto;
  owningOrganizationName: string;
  owningOrganizationId: string;
  title: string;
  description: string;
  dueDate: string;
  responsibleOrganization: ResponsibleOrganizationDto;
  responsiblePerson: PersonDto;
  responsibleParty: ContractTaskResponsiblePartyDto;
  contractId: string;
  contractTitle: string;
  canEdit: boolean;
  canChangeStatus: boolean;
  canDelete: boolean;
};
export type UpdateTaskRequest = {
  title?: string | null;
  description?: string | null;
  dueDate?: string | null;
  status?: ContractTaskStatus | null;
  responsiblePerson?: string | null;
};
export type ContractTaskChangeDto = {
  type: ContractTaskChangeType;
  id: string;
  createdAt: string;
  changedByFullName: string;
  oldValue: string;
  newValue: string;
};
export type ListChangesForContractTaskResponse = {
  changes: ContractTaskChangeDto[];
};
export type ListCommentsForContractTaskResponse = {
  comments: ContractTaskCommentDto[];
  canComment: boolean;
};
export type CreateContractTaskCommentRequest = {
  text: string;
};
export type TextDocumentDto = {
  id: string;
  createdAt: string;
  modifiedAt: string;
  owner: string;
  createdBy?: PersonDto | null;
  modifiedBy?: PersonDto | null;
  name: string;
  text: string;
  tags: string[];
  documents: ViewDocumentAsOwnerDto[];
  category?: DocumentCategory | null;
  internal?: boolean;
};
export type CreateContractTextDocumentRequest = {
  name: string;
  text: string;
  tags: string[];
  contractId: string;
};
export type TextDocumentsDto = {
  documents: TextDocumentDto[];
};
export type FencyConversationResponse = {
  id: string;
};
export type FencySessionResponse = {
  clientToken: string;
};
export type CreateExploreMemoriesSessionRequest = {
  conversationId?: string | null;
};
export type CreateFencyFileDownloadSessionRequest = {
  agentTaskFileId: string;
};
export type ChosenIfrsReportRequest = {
  contractIds: string[];
  periodFrom?: string | null;
  periodTo?: string | null;
};
export type IfrsReportContractDto = {
  id: string;
  title: string;
};
export type IfrsReportInternalPartyDto = {
  id: string;
  name: string;
};
export type IfrsReportCandidateDto = {
  id: string;
  title: string;
  internalParties: IfrsReportInternalPartyDto[];
  ifrsStart: string;
  ifrsEnd: string;
};
export type IfrsReportPreviewDto = {
  includedCount: number;
  missingIfrsValues: IfrsReportContractDto[];
  outsidePeriodCount?: number;
  candidates: IfrsReportCandidateDto[];
};
export type CreateMemoryChatSessionRequest = {
  memoryId: string;
};
export type FencyDownloadLinkResponse = {
  downloadLink: string;
};
export type CreateMemoryDownloadLinkRequest = {
  memoryId: string;
};
export type ContractStatisticsDto = {
  numberOfContracts: number;
  numberOfActiveContracts: number;
  annualValueOfActiveContracts: number;
  numberOfContractsExpiringThisYear: number;
  annualValueOfContractsExpiringThisYear: number;
};
export type AutofillOrganizationDto = {
  name?: string | null;
  organizationNumber?: string | null;
  street?: string | null;
  city?: string | null;
  postCode?: string | null;
  country?: string | null;
  contactEmail?: string | null;
  contactPhone?: PhoneNumberDto | null;
  contactPersons?: PersonDto[] | null;
};
export type ContractAutofillContextDto = {
  contractId: string;
  title: string;
  description?: string | null;
  currency: Currency;
  timezone: string;
  state: ContractStateDto;
  status?: ContractStatusDto | null;
  createdBy: PersonDto;
  internalOwner: PersonDto;
  owningOrganization: AutofillOrganizationDto;
  counterparty?: CounterpartyDto | null;
  dataFields: ContractDataFieldsDto;
};
export type CancelSignedDocumentRequest = {
  documentId: string;
  reason: string;
};
export type ContractMessageAttachmentUploadDto = {
  documentId?: string | null;
};
export type ContractMessageAttachmentDto = {
  documentId: string;
  fileName: string;
  mimeType: string;
  savedToContract: boolean;
};
export type ContractMessageDto = {
  id: string;
  contractId: string;
  createdAt: string;
  side: ContractMessageSide;
  author: PersonDto;
  text: string;
  attachments: ContractMessageAttachmentDto[];
  readByMe: boolean;
  readByOtherPartyAt?: string | null;
};
export type ListContractMessagesResponse = {
  messages: ContractMessageDto[];
  canPostMessage: boolean;
  isSharedWithCounterparty: boolean;
};
export type CreateContractMessageRequest = {
  text: string;
  attachmentDocumentIds?: string[];
};
export type SaveMessageAttachmentResponse = {
  savedToContract: boolean;
  alreadyPresent: boolean;
};
export type SaveMessageAttachmentRequest = {
  messageId: string;
  documentId: string;
};
export type ContractOriginCommunicationDto = {
  sourcingEventV2Id?: string | null;
  supplierInformation: SupplierInformationDto[];
  questions: SeQuestionDto[];
};
export type DeleteContractParticipantRequest = {
  organizationId: string;
  personId?: string | null;
};
export type ContractOwningOrgDto = {
  id: string;
  name: string;
};
export type ContractOrgParticipantDto = {
  id: string;
  roleType: ContractRoleType;
  name: string;
};
export type ContractPersonParticipantDto = {
  id: string;
  roleType?: ContractRoleType | null;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  organizationId: string;
  organizationName: string;
};
export type ListParticipantsForContractResponse = {
  owningOrganization: ContractOwningOrgDto;
  organizationParticipants: ContractOrgParticipantDto[];
  personParticipants: ContractPersonParticipantDto[];
};
export type CreateContractParticipantRequest = {
  organizationId: string;
  personId?: string | null;
  roleType: ContractRoleType;
  shouldNotifyByEmail: boolean;
};
export type ChangeSignedDocumentDeadlineRequest = {
  deadline: string;
};
export type TaskDelegationDto = {
  keepsAccess: boolean;
  actingOrganizationName: string;
};
export type CreateContractTaskRequest = {
  title: string;
  description: string;
  dueDate: string;
  responsiblePersonId: string;
};
export type ContributingEntityInviteDto = {
  inviteId: string;
  status: ContributingEntityStatus;
  role: ContributingEntityRole;
  entityName: string;
  organizationNumber: string;
  invitedEmailMasked: string;
  eventTitle: string;
  eventReference?: string | null;
  buyerOrganizationName: string;
  leadSupplierName: string;
  bidSubmissionDeadline?: string | null;
};
export type ContributingEntityDto = {
  id: string;
  bidId: string;
  eventId: string;
  role: ContributingEntityRole;
  status: ContributingEntityStatus;
  name: string;
  organizationNumber: string;
  groupRole?: string | null;
  contactEmail: string;
  contactFirstName?: string | null;
  contactLastName?: string | null;
  invitedAt?: string | null;
  respondedAt?: string | null;
  supportedCriterionKeys?: string[];
  validationIssues?: ContributingEntityValidationIssueDto[];
};
export type ResolvedEspdRequirementDto = {
  id: string;
  responseDataType: EspdResponseDataType;
  optional: boolean;
  supplierDeclarationField?: SupplierDeclarationField | null;
  label: string;
  labelNorwegian?: string | null;
};
export type ResolvedEspdRequirementGroupDto = {
  id: string;
  processingInstruction?: string | null;
  optionalFields?: boolean;
  repeatable: boolean;
  requirements: ResolvedEspdRequirementDto[];
  subGroups: ResolvedEspdRequirementGroupDto[];
};
export type ResolvedEspdCriterionDto = {
  id: string;
  typeCode: string;
  category: string;
  name: string;
  nameNorwegian?: string | null;
  description: string;
  descriptionNorwegian?: string | null;
  mandatory: boolean;
  requiresSeparateEspd?: boolean;
  requirementGroups: ResolvedEspdRequirementGroupDto[];
};
export type ContributingEntityContextDto = {
  eventTitle: string;
  eventReference?: string | null;
  buyerOrganizationName: string;
  leadSupplierName: string;
  bidSubmissionDeadline?: string | null;
  exclusionCriteria: ResolvedEspdCriterionDto[];
  selectionCriteria?: SelectionCriterionDto[];
  groupName?: string | null;
  otherParticipants?: string[];
};
export type ContributingEntityQualificationResponseDto = {
  criterionKey: string;
  description?: string | null;
};
export type ContributingEntityCommitmentDto = {
  confirmed?: boolean;
  resources?: string | null;
};
export type ContributingEntityDetailDto = {
  entity: ContributingEntityDto;
  context: ContributingEntityContextDto;
  espdResponse?: EspdResponseDto | null;
  qualificationResponses?: ContributingEntityQualificationResponseDto[];
  commitment?: ContributingEntityCommitmentDto | null;
  commitmentRequired?: boolean;
  responseEditable: boolean;
  responseReopenable?: boolean;
};
export type DeclineContributingEntityInviteRequestDto = {
  reason?: string | null;
};
export type CpvCodeDto = {
  code: string;
  nameEn: string;
  nameNb: string;
};
export type MainCpvRuleDto = {
  contractNature: ContractNature;
  prefixes: string[];
};
export type GetCpvCodesResponse = {
  codes: CpvCodeDto[];
  mainCodeRules: MainCpvRuleDto[];
};
export type FilterOptionDto = {
  id: string;
  name: string;
};
export type ContractFilterOptionsDto = {
  counterparties: FilterOptionDto[];
  internalParties: FilterOptionDto[];
  persons: FilterOptionDto[];
  projects: ProjectDto[];
};
export type OrgPitchDto = {
  id: string;
  owner: PersonDto;
  name: string;
  country: CountryDto;
  aboutUs?: string | null;
  specializations?: string | null;
  homePageUrl?: string | null;
  size?: OrganizationSize | null;
};
export type ContractListItemDto = {
  id: string;
  status?: ContractStatusDto | null;
  state: ContractStateDto;
  title: string;
  timezone: string;
  currency: Currency;
  counterparty?: CounterpartyDto | null;
  internalParties?: InternalPartyDto[] | null;
  endDate?: string | null;
  hasNoEndDate?: boolean | null;
  estimatedValue?: number | null;
  template?: ContractTemplateMinDto | null;
  owningOrganization: OrgPitchDto;
  internalOwner: PersonDto;
  containsIfrsValues: boolean;
  iamParticipant: boolean;
  canView: boolean;
  canUpdate: boolean;
  projects?: ProjectDto[] | null;
};
export type ListContractsResponseDto = {
  contracts: ContractListItemDto[];
};
export type ForceDeliverBidResponseDto = {
  status: BidStatus;
};
export type ForcePublishResponseDto = {
  status: SourcingEventStatus;
};
export type SkipPastGateResponseDto = {
  gate: SkippableGateDto;
  skewSeconds: number;
  gateDeadline: string;
};
export type SkipPastGateRequestDto = {
  gate: SkippableGateDto;
};
export type StartDocumentChatRequest = {
  documentId?: string | null;
  signedDocumentId?: string | null;
  purpose?: DocumentChatPurpose;
  messages: GptMessage[];
  reasoningEffort: string;
  responseFormat?: JsonSchemaDto | null;
};
export type UpdateDocumentMetaRequest = {
  name?: string | null;
  tags?: string[] | null;
  category?: DocumentCategory | null;
};
export type GetDownloadLinkResponse = {
  url: string;
};
export type CreateDocumentTemplateRequest = {
  name: string;
  text: string;
  tags: string[];
};
export type DoffinSubmissionResponseDto = {
  status: string;
};
export type WinnerNoticeValuesDto = {
  bidId: string;
  contractValue?: number | null;
  size?: EconomicOperatorSize | null;
};
export type WithheldFieldDto = {
  field: WithheldNoticeField;
  reason: NonPublicationReason;
  publishFrom?: string | null;
};
export type SubmitContractAwardNoticeRequest = {
  contractConcludedOn?: string | null;
  winners?: WinnerNoticeValuesDto[];
  injunction?: InjunctionAnswer | null;
  withheldFields?: WithheldFieldDto[];
  noMoreContractsUnderPriorNotice?: boolean;
};
export type ContractAwardNoticeWinnerDto = {
  bidId: string;
  supplierId: string;
  supplierName: string;
  contractValue?: EventValueDto | null;
  size?: EconomicOperatorSize | null;
};
export type MissingNoticeValueDto = {
  businessTerm: string;
  ruleId: string;
  supplierId: string;
  text: string;
};
export type ContractAwardNoticePreviewDto = {
  form: string;
  winners: ContractAwardNoticeWinnerDto[];
  missing: MissingNoticeValueDto[];
  registerUnavailableSupplierIds?: string[];
  withholdableFields?: WithheldNoticeField[];
  asksWhetherPriorNoticeEnds?: boolean;
  priorNoticeRuleUnderUtilities?: boolean;
};
export type SubmitContractModificationNoticeRequest = {
  bidId?: string | null;
  ground: ContractModificationGround;
  description: string;
  reason: string;
  valueBefore: number;
  valueAfter: number;
  conditionsConfirmed: boolean;
  originalValue?: number | null;
};
export type ModifiableContractDto = {
  bidId: string;
  supplierName: string;
  currentValue?: EventValueDto | null;
  originalValue?: EventValueDto | null;
};
export type ContractModificationNoticeDto = {
  id: string;
  submittedAt?: string | null;
  ground: ContractModificationGround;
  status: PublicationStatus;
  noticeNumber?: string | null;
  supplierName?: string | null;
  valueAfter: EventValueDto;
};
export type ContractModificationPreviewDto = {
  form: string;
  capsPriceIncrease: boolean;
  contracts: ModifiableContractDto[];
  modifications: ContractModificationNoticeDto[];
};
export type SubmitNoWinnerNoticeRequest = {
  reason: NonAwardReason;
  relaunch: boolean;
};
export type DownloadTextDocumentRequest = {
  fileName: string;
  content: string;
};
export type SeAttachmentDownloadLinkResponse = {
  url: string;
};
export type SearchIndustriesResponse = {
  industries: IndustryDto[];
};
export type LibraryElementOwnerDto = {
  global: boolean;
  organizationId?: string | null;
};
export type LibraryAwardSubCriterionDto = {
  criterionType: AwardCriterionType;
  name: string;
  description: string;
  id?: string | null;
  answerFormat?: AwardSubCriterionAnswerFormat;
  requiresDocumentation?: boolean;
};
export type LibraryElementContentDto = {
  type: LibraryElementTypeDto;
  minimum?: MinimumRequirementDto | null;
  selection?: SelectionCriterionDto | null;
  award?: AwardCriterionDto | null;
  awardSubCriterion?: LibraryAwardSubCriterionDto | null;
};
export type LibraryElementDto = {
  id: string;
  owner: LibraryElementOwnerDto;
  tags: string[];
  content: LibraryElementContentDto;
  createdAt: string;
  modifiedAt: string;
};
export type LibraryElementsDto = {
  elements: LibraryElementDto[];
};
export type CreateLibraryElementRequest = {
  content: LibraryElementContentDto;
  tags?: string[];
  global?: boolean;
};
export type UpdateLibraryElementRequest = {
  id: string;
  content: LibraryElementContentDto;
  tags?: string[];
};
export type MarketDialogueInviteDto = {
  inviteId: string;
  marketDialogueId: string;
  title: string;
  buyerOrganizationName: string;
  answerDeadline?: string | null;
  invitedEmail: string;
  accepted?: boolean;
};
export type MarketDialogueNeedDto = {
  id: string;
  title?: string | null;
};
export type MarketDialogueProcurementDto = {
  id: string;
  title: string;
  status: SourcingEventStatus;
};
export type MarketDialogueSummaryDto = {
  id: string;
  title: string;
  status: MarketDialogueStatus;
  answerDeadline?: string | null;
  noticeSubType?: string | null;
  modifiedAt: string;
  answersReceived: number;
  need?: MarketDialogueNeedDto | null;
  canLinkNeed?: boolean;
  procurements?: MarketDialogueProcurementDto[];
  reachedThrough?: MarketDialogueReach[];
};
export type MarketDialogueListDto = {
  items: MarketDialogueSummaryDto[];
};
export type CommentSubjectDto = {
  kind: CommentSubjectKind;
  ref?: string | null;
  description?: string | null;
  documentId?: string | null;
};
export type MarketDialogueQuestionDto = {
  id?: string | null;
  text: string;
  answerType?: MarketDialogueAnswerType;
  allowsAttachments?: boolean;
  subject?: CommentSubjectDto | null;
};
export type MarketDialogueInvitationDto = {
  id: string;
  organizationId?: string | null;
  organizationName?: string | null;
  email?: string | null;
  invitedAt: string;
  sentAt?: string | null;
  canWithdraw: boolean;
};
export type MarketDialogueRoundDto = {
  number: number;
  firstRoundId: string;
  procurementId?: string | null;
};
export type SharedItemDto = {
  id: string;
  kind: SharedItemKind;
  sharedAt: string;
  title?: string | null;
  text?: string | null;
  question?: string | null;
  documentId?: string | null;
};
export type MarketDialogueDto = {
  id: string;
  createdAt: string;
  modifiedAt: string;
  contentRevision: number;
  title: string;
  description?: string | null;
  questions: MarketDialogueQuestionDto[];
  answerDeadline?: string | null;
  regulation?: Regulation | null;
  contractNature?: ContractNature | null;
  serviceCategory?: ServiceCategory | null;
  estimatedValueNok?: number | null;
  cpvCodes: string[];
  utilityActivity?: UtilityActivity | null;
  expectedContractNoticeDate?: string | null;
  documents: ViewDocumentAsOwnerDto[];
  needId?: string | null;
  createdFromNeed?: boolean;
  homeDepartmentId?: string | null;
  status: MarketDialogueStatus;
  foaPart?: FoaPart | null;
  noticeSubType?: string | null;
  expectedContractNoticeDateRequired?: boolean;
  blockers: MarketDialogueBlocker[];
  submittedAt?: string | null;
  publishedAt?: string | null;
  doffinReference?: string | null;
  dialogueUrl: string;
  canEdit: boolean;
  canPublish: boolean;
  canDelete?: boolean;
  canStartCompetition?: boolean;
  announceOnDoffin: boolean;
  invitations?: MarketDialogueInvitationDto[];
  canInvite?: boolean;
  round: MarketDialogueRoundDto;
  canAnnounceOnDoffin: boolean;
  buyerLegalTypeMissing?: boolean;
  shared?: SharedItemDto[];
  canShare?: boolean;
  canAddDocuments?: boolean;
  procurements?: MarketDialogueProcurementDto[];
};
export type CreateMarketDialogueRequest = {
  title?: string;
  homeDepartmentId?: string | null;
};
export type UpdateMarketDialogueRequest = {
  contentRevision: number;
  title: string;
  description?: string | null;
  questions?: MarketDialogueQuestionDto[];
  answerDeadline?: string | null;
  regulation?: Regulation | null;
  contractNature?: ContractNature | null;
  serviceCategory?: ServiceCategory | null;
  estimatedValueNok?: number | null;
  cpvCodes?: string[];
  utilityActivity?: UtilityActivity | null;
  expectedContractNoticeDate?: string | null;
  announceOnDoffin?: boolean;
};
export type SecretDocumentDto = {
  documentId: string;
  reason: string;
};
export type AnsweredQuestionDto = {
  questionId: string;
  text?: string;
  choice?: boolean | null;
  documents?: ViewDocumentAsOwnerDto[];
  secretReason?: string | null;
  secretDocuments?: SecretDocumentDto[];
  withheld?: boolean;
  marked?: boolean;
};
export type MarketDialogueAnswerCommentDto = {
  id: string;
  text: string;
  authorName: string;
  at: string;
};
export type ReceivedMarketDialogueAnswerDto = {
  id: string;
  supplierOrganizationId: string;
  supplierName: string;
  sentAt: string;
  answers: AnsweredQuestionDto[];
  otherDocuments?: ViewDocumentAsOwnerDto[];
  comments?: MarketDialogueAnswerCommentDto[];
};
export type InsightSummaryDto = {
  text: string;
  writtenBy: string;
  writtenAt: string;
};
export type ReceivedMarketDialogueAnswersDto = {
  answers: ReceivedMarketDialogueAnswerDto[];
  canComment?: boolean;
  canMark?: boolean;
  canSeeInsights?: boolean;
  summary?: InsightSummaryDto | null;
};
export type AddMarketDialogueAnswerCommentRequest = {
  text: string;
};
export type StartCompetitionRequest = {
  supplierIds?: string[];
  documentIds?: string[] | null;
  insightReport?: boolean;
  libraryElementIds?: string[];
};
export type CompetitionPlanSupplierDto = {
  organizationId: string;
  name: string;
  answered: boolean;
  asked: boolean;
  invited: boolean;
};
export type CompetitionPlanDocumentDto = {
  id: string;
  name: string;
};
export type CompetitionPlanDto = {
  suppliers: CompetitionPlanSupplierDto[];
  documents: CompetitionPlanDocumentDto[];
  insightReportAvailable: boolean;
};
export type MarkMarketDialogueAnswerRequest = {
  answerId: string;
  questionId: string;
  marked: boolean;
};
export type SummariseMarketDialogueRequest = {
  text: string;
};
export type InviteEmailToMarketDialogueRequest = {
  email: string;
  language?: EmailInviteLanguage;
};
export type InviteOrganizationToMarketDialogueRequest = {
  organizationId: string;
};
export type LinkMarketDialogueNeedRequest = {
  needId: string;
};
export type PublishMarketDialogueRequest = {
  contentRevision: number;
};
export type SupplierQuestionReplyDto = {
  text: string;
  reach: ReplyReach;
  at: string;
};
export type SupplierQuestionDto = {
  id: string;
  text: string;
  askedAt: string;
  reply?: SupplierQuestionReplyDto | null;
};
export type AskedQuestionDto = {
  answerId: string;
  question: SupplierQuestionDto;
  supplierName: string;
};
export type SupplierQuestionsDto = {
  questions: AskedQuestionDto[];
  canReply: boolean;
};
export type ReplyToSupplierQuestionRequest = {
  text: string;
  reach?: ReplyReach;
  sharedQuestion?: string | null;
};
export type ShareWithParticipantsRequest = {
  title: string;
  text: string;
};
export type SuggestedSupplierDto = {
  organizationId: string;
  name: string;
  organizationNumber?: string | null;
  matchingProcurements: number;
};
export type SuggestedSuppliersDto = {
  suppliers: SuggestedSupplierDto[];
};
export type MarketDialogueTeamPersonDto = {
  personId: string;
  name: string;
  email: string;
};
export type MarketDialogueTeamMemberDto = {
  person: MarketDialogueTeamPersonDto;
  addedAt: string;
};
export type MarketDialogueTeamDto = {
  responsible: MarketDialogueTeamPersonDto;
  subjectExperts: MarketDialogueTeamMemberDto[];
  needReporter?: MarketDialogueTeamPersonDto | null;
  canChangeTeam: boolean;
};
export type AddMarketDialogueTeamMemberRequest = {
  personId: string;
};
export type MarkNotificationsRequest = {
  notificationIds?: string[];
  all?: boolean;
};
export type WaitingNeedDto = {
  id: string;
  title?: string | null;
  deliveryDate?: string | null;
  deliveryPassed: boolean;
};
export type NeedsWaitingDto = {
  canTakeNeeds: boolean;
  queueCount?: number;
  oldestWaitDays?: number | null;
  mine?: WaitingNeedDto[];
  mineCount?: number;
};
export type SourcingEventNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
  supplierOrganizationName?: string | null;
  changedAreas?: ChangedArea[];
  bidDeliveryKind?: SeBidDeliveryKind | null;
  deadline?: string | null;
  roundDeadline?: string | null;
  isFinalRound?: boolean;
};
export type SourcingEventQuestionNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  questionId: string;
  questionSubject: string;
  receiverRole: ReceiverRoleDto;
  replyDeadline?: string | null;
};
export type SourcingEventAnnouncementNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  announcementId: string;
  announcementTitle: string;
};
export type ContractNotificationMetaDto = {
  triggeredByFirstName?: string | null;
  contractName: string;
  contractId: string;
  organizationName?: string | null;
  counterpartyName?: string | null;
  value?: string | null;
  currency?: string | null;
};
export type ContractReminderNotificationMetaDto = {
  contractName: string;
  contractId: string;
  contractTimezone: string;
  reminderType: ContractDateReminderType;
  date: string;
};
export type ContractTaskNotificationMetaDto = {
  triggeredByFirstName?: string | null;
  taskId: string;
  taskName: string;
  contractName: string;
  contractId: string;
  projectName?: string | null;
  counterpartyName?: string | null;
};
export type ContractDocumentNotificationMetaDto = {
  documentId: string;
  documentName: string;
  contractName: string;
  contractId: string;
};
export type SeResponsibleBuyerChangedNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
  previousResponsibleName: string;
  newResponsibleName: string;
};
export type SeJuryConfirmationRequestedNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
};
export type SeInvitedToTenderNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
  bidSubmissionDeadline: string;
};
export type SeInvitedToConfirmInterestNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
  requestDeadline: string;
};
export type SeOrganizationInviteNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
  bidSubmissionDeadline: string;
};
export type SeRequestNotQualifiedNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
  verdictComment?: string | null;
};
export type SeBidRejectedNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
  rejectionReason?: string | null;
};
export type SeRequestNotSelectedNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  selectionReason?: string | null;
};
export type SeDpsAdmittedNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
};
export type SeQualificationSchemeAdmittedNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
};
export type SeQualificationSchemeRemovedNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
  removalReason: string;
  removalEffectiveAt?: string | null;
};
export type SeQualificationSchemeRemovalWithdrawnNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
};
export type SeDpsRemovedNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
  removalReason: string;
};
export type SeDoffinPublishedNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
  doffinReference: string;
  isChangeNotice: boolean;
};
export type SeDoffinPublicationFailedNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
  isChangeNotice: boolean;
};
export type OrganizationMergeNotificationMetaDto = {
  requestId: string;
  status: OrganizationMergeRequestStatus;
  counterpartOrganizationName: string;
};
export type NeedReportedNotificationMetaDto = {
  needId: string;
  needTitle: string;
  reporterName: string;
};
export type PlannedStartDto = {
  year: number;
  month: number;
};
export type NeedStatusChangedNotificationMetaDto = {
  needId: string;
  needTitle: string;
  status: NeedStatus;
  comment?: string | null;
  plannedStart?: PlannedStartDto | null;
};
export type SeMiniCompetitionInviteNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  frameworkAgreementId: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
  bidSubmissionDeadline: string;
};
export type FrameworkPanelJoinedNotificationMetaDto = {
  frameworkAgreementId: string;
  frameworkAgreementTitle: string;
  buyerOrganizationId: string;
  buyerOrganizationName: string;
  contractId?: string | null;
};
export type FrameworkPanelStatusChangedNotificationMetaDto = {
  frameworkAgreementId: string;
  frameworkAgreementTitle: string;
  buyerOrganizationId: string;
  buyerOrganizationName: string;
  status: PanelStatus;
};
export type FrameworkValueReminderNotificationMetaDto = {
  frameworkAgreementId: string;
  frameworkAgreementTitle: string;
  percentage: number;
  percentUsed: number;
  usedValue: string;
  remainingValue: string;
  currency: Currency;
};
export type NotificationTypeMetaDto = {
  sourcingEvent?: SourcingEventNotificationMetaDto | null;
  negotiationRoundId?: string | null;
  sourcingEventQuestion?: SourcingEventQuestionNotificationMetaDto | null;
  sourcingEventAnnouncement?: SourcingEventAnnouncementNotificationMetaDto | null;
  contract?: ContractNotificationMetaDto | null;
  contractReminder?: ContractReminderNotificationMetaDto | null;
  contractTask?: ContractTaskNotificationMetaDto | null;
  contractDocument?: ContractDocumentNotificationMetaDto | null;
  seV2ResponsibleBuyerChanged?: SeResponsibleBuyerChangedNotificationMetaDto | null;
  seV2JuryConfirmationRequested?: SeJuryConfirmationRequestedNotificationMetaDto | null;
  seV2InvitedToTender?: SeInvitedToTenderNotificationMetaDto | null;
  seV2InvitedToConfirmInterest?: SeInvitedToConfirmInterestNotificationMetaDto | null;
  seV2OrganizationInvite?: SeOrganizationInviteNotificationMetaDto | null;
  seV2RequestNotQualified?: SeRequestNotQualifiedNotificationMetaDto | null;
  seV2BidRejected?: SeBidRejectedNotificationMetaDto | null;
  seV2RequestNotSelected?: SeRequestNotSelectedNotificationMetaDto | null;
  seV2DpsAdmitted?: SeDpsAdmittedNotificationMetaDto | null;
  seV2QualificationSchemeAdmitted?: SeQualificationSchemeAdmittedNotificationMetaDto | null;
  seV2QualificationSchemeRemoved?: SeQualificationSchemeRemovedNotificationMetaDto | null;
  seV2QualificationSchemeRemovalWithdrawn?: SeQualificationSchemeRemovalWithdrawnNotificationMetaDto | null;
  seV2DpsRemoved?: SeDpsRemovedNotificationMetaDto | null;
  seV2DoffinPublished?: SeDoffinPublishedNotificationMetaDto | null;
  seV2DoffinPublicationFailed?: SeDoffinPublicationFailedNotificationMetaDto | null;
  organizationMerge?: OrganizationMergeNotificationMetaDto | null;
  needReported?: NeedReportedNotificationMetaDto | null;
  needStatusChanged?: NeedStatusChangedNotificationMetaDto | null;
  seV2MiniCompetitionInvite?: SeMiniCompetitionInviteNotificationMetaDto | null;
  frameworkPanelJoined?: FrameworkPanelJoinedNotificationMetaDto | null;
  frameworkPanelStatusChanged?: FrameworkPanelStatusChangedNotificationMetaDto | null;
  frameworkValueReminder?: FrameworkValueReminderNotificationMetaDto | null;
};
export type NotificationDto = {
  type: NotificationTypeDto;
  id: string;
  createdAt: string;
  peeked: boolean;
  viewed: boolean;
  meta: NotificationTypeMetaDto;
};
export type ListNotificationsResponse = {
  notifications: NotificationDto[];
};
export type OrgUserDto = {
  person: PersonDto;
  roles: OrganizationRoleType[];
};
export type ListOrganizationUsersResponse = {
  users: OrgUserDto[];
  count: number;
};
export type ListOrganizationsForMeResponse = {
  orgs: OrgDto[];
};
export type EmailInviteContextDto = {
  emailInviteId: string;
  emailInviteType: EmailInviteTypeDto;
  secret: string;
};
export type CreateOrgRequest = {
  companyName: string;
  countryId: string;
  organizationNumber?: string | null;
  emailInviteContext?: EmailInviteContextDto | null;
};
export type RecentlyViewedContractDto = {
  id: string;
  title: string;
  state: ContractStateDto;
  status?: ContractStatusDto | null;
  endDate?: string | null;
  counterpartyName?: string | null;
  viewedAt: string;
};
export type ListRecentlyViewedContractsResponse = {
  contracts: RecentlyViewedContractDto[];
};
export type RecentlyViewedEventDto = {
  event: EventListItemDto;
  viewedAt: string;
};
export type ListRecentlyViewedEventsResponse = {
  events: RecentlyViewedEventDto[];
};
export type ListUpcomingDeadlinesResponse = {
  deadlines: UpcomingDeadlineDto[];
  upcomingCutShortAt?: string | null;
  moreOverdueTasks?: number;
  nextUpcomingPosition?: string | null;
  nextOverduePosition?: string | null;
  overdueCount?: number | null;
};
export type NeedValueDto = {
  value?: number | null;
  currency?: Currency;
  unknown?: boolean;
};
export type NeedHistoryEntryDto = {
  toStatus: NeedStatus;
  at: string;
  by: PersonDto;
  comment?: string | null;
};
export type ProcurementSummaryDto = {
  id: string;
  title?: string | null;
  status: SourcingEventStatus;
  /** True while the procurement is a draft the creation interview has not saved. Lists hide it, and starting the interview from the need again resumes it. */
  unsavedInterview?: boolean;
};
export type CallOffSummaryDto = {
  id: string;
  title?: string | null;
};
export type NeedProcurerAssessmentDto = {
  cpvCodes?: string[];
  value?: number | null;
  canEdit?: boolean;
};
export type NeedDto = {
  id: string;
  createdAt: string;
  modifiedAt: string;
  status: NeedStatus;
  title?: string | null;
  description?: string | null;
  estimatedValue?: NeedValueDto | null;
  valueAssessment?: string | null;
  budgetLine?: string | null;
  recurrence?: NeedRecurrence | null;
  periodMonths?: number | null;
  quantity?: string | null;
  deliveryDate?: string | null;
  departmentId?: string | null;
  priority?: NeedPriority | null;
  procurementType?: ContractNature | null;
  category?: string | null;
  deliveryPlace?: string | null;
  foaPart?: FoaPart | null;
  contactPersonId?: string | null;
  contactPerson?: PersonDto | null;
  responsibleBuyerId?: string | null;
  responsibleBuyer?: PersonDto | null;
  documents?: ViewDocumentAsOwnerDto[] | null;
  createdBy: PersonDto;
  department?: DepartmentDto | null;
  history?: NeedHistoryEntryDto[];
  procurement?: ProcurementSummaryDto | null;
  callOff?: CallOffSummaryDto | null;
  canEdit?: boolean;
  canTake?: boolean;
  canChangeResponsible?: boolean;
  canPlan?: boolean;
  canAttach?: boolean;
  canStartMarketDialogue?: boolean;
  plannedStart?: PlannedStartDto | null;
  plannedStartHasPassed?: boolean;
  decisionComment?: string | null;
  procurerAssessment?: NeedProcurerAssessmentDto | null;
};
export type CreateNeedRequest = {
  title?: string | null;
  departmentId?: string | null;
};
export type CreateNeedTextDocumentRequest = {
  name: string;
  text: string;
  tags: string[];
  needId: string;
};
export type NeedValuePatchDto = {
  value?: number | null;
  currency?: Currency;
  unknown?: boolean;
};
export type NeedProcurerAssessmentPatchDto = {
  cpvCodes?: string[];
  value?: number | null;
};
export type NeedPatchDto = {
  title?: string;
  description?: string | null;
  estimatedValue?: NeedValuePatchDto | null;
  valueAssessment?: string | null;
  budgetLine?: string | null;
  recurrence?: NeedRecurrence | null;
  periodMonths?: number | null;
  quantity?: string | null;
  deliveryDate?: string | null;
  departmentId?: string | null;
  priority?: NeedPriority | null;
  procurementType?: ContractNature | null;
  category?: string | null;
  deliveryPlace?: string | null;
  contactPersonId?: string | null;
  responsibleBuyerId?: string | null;
  documents?: ViewDocumentAsOwnerDto[];
  status?: NeedStatus;
  decisionComment?: string | null;
  plannedStart?: PlannedStartDto | null;
  procurerAssessment?: NeedProcurerAssessmentPatchDto;
};
export type StartCallOffForNeedRequest = {
  frameworkAgreementId: string;
  supplierOrganizationId: string;
  estimatedValue?: EventValueDto | null;
};
export type CreateProcurementForNeedRequest = {
  attachmentIds?: string[];
  /** True when the procurement is started in the assistant's creation interview. It is then left out of the procurement lists until the interview saves it as a draft. */
  inInterview?: boolean;
};
export type StartMiniCompetitionForNeedRequest = {
  frameworkAgreementId: string;
  attachmentIds?: string[];
};
export type ListNeedsResponse = {
  needs: NeedDto[];
  count?: number | null;
};
export type ProcurementNeedDto = {
  need?: NeedDto | null;
};
export type NeedStatusCountDto = {
  status: NeedStatus;
  needs: number;
};
export type NeedFigureDto = {
  figure: NeedOverviewFigure;
  needs: number;
  byStatus: NeedStatusCountDto[];
  estimatedValue: number;
  valueUnknown: number;
  days?: number | null;
  samePeriodLastYear?: number | null;
  deliveryPassed?: number | null;
};
export type NeedStatusBarDto = {
  status: NeedStatus;
  needs: number;
  estimatedValue: number;
  valueUnknown: number;
  medianDaysInStatus?: number | null;
};
export type NeedDepartmentBarDto = {
  departmentId?: string | null;
  departmentName?: string | null;
  retired: boolean;
  needs: number;
  estimatedValue: number;
  valueUnknown: number;
};
export type NeedProcurementPhaseBarDto = {
  phase: ProcurementPhaseDto;
  needs: number;
  estimatedValue: number;
  valueUnknown: number;
};
export type PlannedQuarterBarDto = {
  year: number;
  quarter: number;
  from: string;
  to: string;
  needs: number;
  estimatedValue: number;
  valueUnknown: number;
};
export type QueuedNeedDto = {
  id: string;
  title?: string | null;
  departmentName?: string | null;
  value?: number | null;
  priority?: NeedPriority | null;
  sentAt?: string | null;
  daysInQueue: number;
  deliveryDate?: string | null;
};
export type NeedOverviewScopeDto = {
  organizationWide: boolean;
  departmentNames: string[];
};
export type NeedOverviewDto = {
  from: string;
  to: string;
  figures: NeedFigureDto[];
  byStatus: NeedStatusBarDto[];
  byDepartment: NeedDepartmentBarDto[];
  byProcurementPhase: NeedProcurementPhaseBarDto[];
  plannedPerQuarter: PlannedQuarterBarDto[];
  queue: QueuedNeedDto[];
  queueCount: number;
  scope: NeedOverviewScopeDto;
};
export type AccessTokenDto = {
  accessToken: string;
  expiresIn: number;
  scope: string;
  tokenType: string;
};
export type GetAccessTokenRequest = {
  organizationId: string;
  personId: string;
};
export type BrregAddressDto = {
  streetLines: string[];
  postCode?: string | null;
  city?: string | null;
  countryCode?: string | null;
};
export type BrregOrgDto = {
  organizationNumber: string;
  name: string;
  organizationForm?: string | null;
  businessAddress?: BrregAddressDto | null;
  isActive: boolean;
};
export type SearchBrregOrgsByNameResponse = {
  orgs: BrregOrgDto[];
};
export type CreateApiClientResponse = {
  clientId: string;
  secret: string;
};
export type CreateOrganizationEntryRequest = {
  name: string;
  industryIds: string[];
  countryId: string;
  organizationNumber: string;
  street?: string | null;
  city?: string | null;
  postCode?: string | null;
};
export type UpdateOrganizationEntryRequest = {
  name?: string | null;
  countryId?: string | null;
  organizationNumber?: string | null;
};
export type LinkOrganizationEntryRequest = {
  organizationId: string;
};
export type AcceptedInfoDto = {
  acceptedAt: string;
  organizationName: string;
  personFirstName?: string | null;
  personLastName?: string | null;
  personEmail: string;
};
export type SupplierEmailInviteDto = {
  id: string;
  sentAt: string;
  sentBy: PersonDto;
  email: string;
  organizationName: string;
  personFirstName: string;
  personLastName: string;
  acceptedInfo?: AcceptedInfoDto | null;
};
export type OrgUserEmailInviteDto = {
  id: string;
  sentAt: string;
  sentBy: PersonDto;
  email: string;
  role: OrgUserInviteRole;
  organizationName: string;
};
export type AssessmentTemplatesDto = {
  templates: AssessmentTemplateDto[];
  count: number;
};
export type UpdateCriterionScoreDto = {
  criterionId: string;
  score?: number | null;
  comment?: string | null;
};
export type UpdateDimensionScoreDto = {
  dimensionId: string;
  directScore?: number | null;
  scoreRange?: ScoreRangeDto | null;
  comment?: string | null;
  criterionScores?: UpdateCriterionScoreDto[] | null;
};
export type UpdateAssessmentRequestDto = {
  name?: string | null;
  description?: string | null;
  dimensionScores?: UpdateDimensionScoreDto[] | null;
  status?: string | null;
};
export type AssessmentsDto = {
  assessments: AssessmentDto[];
  count: number;
};
export type OrgWithOwnerDto = {
  organizationId: string;
  organizationName: string;
  ownerName: string;
  ownerEmail: string;
};
export type ListOrgsByNumberResponse = {
  orgs: OrgWithOwnerDto[];
};
export type EditName = {
  value: string;
};
export type EditCountry = {
  countryId: string;
};
export type EditAboutUs = {
  value?: string | null;
};
export type EditStandardTerms = {
  value?: string | null;
};
export type EditSpecializations = {
  value?: string | null;
};
export type EditHomePageUrl = {
  url?: string | null;
};
export type EditIndustries = {
  value: string[];
};
export type EditSize = {
  size?: OrganizationSize | null;
};
export type EditAdmins = {
  value: string[];
};
export type EditInternalParties = {
  parties?: string[] | null;
  selfRegisteredParties?: string[] | null;
};
export type EditContactPersons = {
  persons?: string[] | null;
};
export type EditStreet = {
  value?: string | null;
};
export type EditCity = {
  value?: string | null;
};
export type EditPostCode = {
  value?: string | null;
};
export type EditContactEmail = {
  value?: string | null;
};
export type EditContactPhone = {
  value?: PhoneNumberDto | null;
};
export type EditDefaultRegulation = {
  value?: Regulation | null;
};
export type EditAuthorityActivity = {
  value?: AuthorityActivity | null;
};
export type EditOrganizationRequest = {
  name?: EditName | null;
  country?: EditCountry | null;
  organizationNumber?: string | null;
  aboutUs?: EditAboutUs | null;
  standardTerms?: EditStandardTerms | null;
  specializations?: EditSpecializations | null;
  homePageUrl?: EditHomePageUrl | null;
  industries?: EditIndustries | null;
  size?: EditSize | null;
  admins?: EditAdmins | null;
  enforceEntraIDAuthentication?: boolean | null;
  canOnlySeeCreatedContracts?: boolean | null;
  canOnlySeeCreatedEvents?: boolean | null;
  defaultNotificationSettings?: DefaultNotificationSettingsDto | null;
  internalParties?: EditInternalParties | null;
  contactPersons?: EditContactPersons | null;
  street?: EditStreet | null;
  city?: EditCity | null;
  postCode?: EditPostCode | null;
  contactEmail?: EditContactEmail | null;
  contactPhone?: EditContactPhone | null;
  buyerLegalType?: EditBuyerLegalType | null;
  defaultRegulation?: EditDefaultRegulation | null;
  authorityActivity?: EditAuthorityActivity | null;
};
export type AccessGrantDto = {
  personId: string;
  firstName?: string | null;
  lastName?: string | null;
  email: string;
  role: GrantRole;
  scope: AccessScopeDto;
  departmentId?: string | null;
  departmentName?: string | null;
  eventId?: string | null;
  eventName?: string | null;
  contractId?: string | null;
  contractName?: string | null;
  source: AccessGrantSourceDto;
  fromEntraDefaultRole: boolean;
  issuedAt: string;
};
export type ListAccessGrantsResponse = {
  grants: AccessGrantDto[];
};
export type AiSkillDto = {
  skill: AgentModule;
  included: boolean;
  accessRequestedAt?: string | null;
};
export type AiUsageShareDto = {
  month: string;
  fairUsePercent?: number | null;
};
export type AiSkillsDto = {
  skills: AiSkillDto[];
  usage: AiUsageShareDto;
};
export type AiSkillAccessRequestDto = {
  skill: AgentModule;
  requestedAt: string;
};
export type AuditLogActorDto = {
  kind: AuditLogActorKind;
  personId?: string | null;
  name?: string | null;
};
export type AuditLogItemDto = {
  type: string;
  id: string;
  name?: string | null;
};
export type AuditLogDetailsDto = {
  belongsTo?: AuditLogItemDto | null;
  role?: string | null;
  scopeType?: string | null;
  scopeName?: string | null;
  reason?: string | null;
  proposed?: string | null;
  confirmed?: string | null;
  feature?: AiUsageFunction | null;
};
export type AuditLogEntryDto = {
  id: string;
  occurredAt: string;
  actor: AuditLogActorDto;
  bySupport: boolean;
  eventType: string;
  item?: AuditLogItemDto | null;
  fromHistory: boolean;
  details?: AuditLogDetailsDto | null;
};
export type AuditLogPageDto = {
  entries: AuditLogEntryDto[];
  nextPosition?: string | null;
};
export type AuditLogPersonDto = {
  id: string;
  name: string;
  email: string;
};
export type AuditLogFiltersDto = {
  people: AuditLogPersonDto[];
  eventTypes: string[];
  targets: AuditLogPersonDto[];
};
export type DepartmentAdministrationDto = {
  id: string;
  name: string;
  isDefault: boolean;
  active: boolean;
  events: number;
  contracts: number;
  projects: number;
  needs: number;
};
export type ListDepartmentsResponse = {
  departments: DepartmentAdministrationDto[];
};
export type DepartmentNameRequest = {
  name: string;
};
export type DepartmentRoleRequest = {
  personId: string;
  role: GrantRole;
};
export type AdminContactDto = {
  firstName?: string | null;
  lastName?: string | null;
  email: string;
  role: OrganizationRoleType;
};
export type JoiningRoleDto = {
  role: GrantRole;
  scope: AccessScopeDto;
  departmentName?: string | null;
};
export type JoiningMemberDto = {
  firstName?: string | null;
  lastName?: string | null;
  email: string;
  roles: JoiningRoleDto[];
};
export type DuplicateOrganizationDetailsDto = {
  memberCount: number;
  procurementCount: number;
  contractCount: number;
  admins: AdminContactDto[];
  joiningMembers?: JoiningMemberDto[];
};
export type OrganizationMergeRequestDto = {
  id: string;
  direction: MergeRequestDirection;
  requestingOrganizationId: string;
  receivingOrganizationId: string;
  winningOrganizationId: string;
  status: OrganizationMergeRequestStatus;
  createdAt: string;
  expiresAt: string;
};
export type DuplicateOrganizationDto = {
  id: string;
  name: string;
  createdAt: string;
  details?: DuplicateOrganizationDetailsDto | null;
  pendingRequest?: OrganizationMergeRequestDto | null;
};
export type DuplicateOrganizationsDto = {
  ownCreatedAt: string;
  duplicates: DuplicateOrganizationDto[];
};
export type EntraGroupMappingDto = {
  id: string;
  role: OrganizationRoleType;
  departmentId?: string | null;
};
export type EntraGroupDto = {
  userGroupId: string;
  displayName: string;
  objectId?: string | null;
  memberCount: number;
  mapping?: EntraGroupMappingDto | null;
  suggestedRole?: OrganizationRoleType | null;
};
export type EntraConnectionDto = {
  id: string;
  tenantId: string;
  status: EntraConnectionStatus;
  jitEnabled: boolean;
  jitDefaultRole: OrgUserInviteRole;
  jitDefaultRoleScope: EntraDefaultRoleScope;
  jitDefaultRoleHolders: number;
  groups: EntraGroupDto[];
};
export type EntraConnectionsDto = {
  connections: EntraConnectionDto[];
};
export type CreateEntraConnectionRequest = {
  tenantId: string;
  defaultRoleScope?: EntraDefaultRoleScope;
};
export type UpdateEntraConnectionRequest = {
  defaultRole?: OrgUserInviteRole | null;
  defaultRoleScope?: EntraDefaultRoleScope | null;
  jitEnabled?: boolean | null;
};
export type SaveEntraGroupMappingRequest = {
  userGroupId: string;
  role: OrganizationRoleType;
  departmentId?: string | null;
};
export type RequestOrganizationMergeRequest = {
  otherOrganizationId: string;
  winningOrganizationId: string;
};
export type ListOrganizationInvitesResponse = {
  invitations: SupplierEmailInviteDto[];
};
export type SupplierInviteParams = {
  personFirstName: string;
  personLastName: string;
  organizationName: string;
};
export type CreateEmailInviteRequest = {
  email: string;
  supplierInvite: SupplierInviteParams;
  language: EmailInviteLanguage;
};
export type ListOrgUserEmailInvitesResponse = {
  invitations: OrgUserEmailInviteDto[];
};
export type CreateOrgUserEmailInviteRequest = {
  email: string;
  role: OrgUserInviteRole;
  language: EmailInviteLanguage;
  emailInviteSecretOverride?: string | null;
};
export type UpdateOrgUserRoleRequest = {
  newRoles: OrganizationRoleType[];
};
export type PersonTaskWorkloadDto = {
  personId: string;
  name: string;
  email: string;
  active: boolean;
  external: boolean;
  open: number;
  overdue: number;
  completedRecently: number;
};
export type ContractTaskWorkloadDto = {
  people: PersonTaskWorkloadDto[];
  today: string;
  completedSince: string;
  scope: ContractOverviewScopeDto;
};
export type ListContractTasksResponseDto = {
  tasks: ContractTaskDto[];
  nextPosition?: number | null;
  count?: number | null;
  countIsLowerBound?: boolean | null;
};
export type ContractTemplateDto = {
  id: string;
  name?: string | null;
  description?: string | null;
  commonType?: CommonTemplateType | null;
  ownerType: ContractOwnerContextType;
  createdAt: string;
  createdBy?: PersonDto | null;
  requiredFields: ContractDataFieldDto[];
  requiredCustomDataFields?: {
    [key: string]: ContractDataFieldSectionDto;
  } | null;
};
export type ListContractTemplatesResponseDto = {
  templates: ContractTemplateDto[];
};
export type UpsertContractTemplateRequest = {
  name: string;
  description?: string | null;
  requiredDataFields: ContractDataFieldNameDto[];
  requiredCustomDataFields: CustomFieldIdentifierDto[];
};
export type CounterpartyInputDto = {
  organizationId?: string | null;
  organizationEntryId?: string | null;
};
export type EditCounterparty = {
  counterparty: CounterpartyInputDto;
};
export type EditTemplate = {
  templateId?: string | null;
};
export type EditInternalOwner = {
  personId: string;
};
export type EditCounterpartyContactPerson = {
  fullName?: string | null;
  email?: string | null;
  phone?: PhoneNumberDto | null;
  personId?: string | null;
};
export type EditDeliveryTerms = {
  terms?: string | null;
};
export type EditPurchasingPolicy = {
  policy?: string | null;
};
export type EditOriginSourcingEvent = {
  eventId?: string | null;
};
export type EditIndustryIds = {
  industryIds: string[];
};
export type EditInternalReferenceNumber = {
  number?: string | null;
};
export type EditExternalLink = {
  link?: string | null;
};
export type EditRisk = {
  risk: ContractRisk;
};
export type EditPriority = {
  priority: ContractPriority;
};
export type EditLinkedContracts = {
  contractIds: string[];
};
export type EditPricePerYear = {
  amount?: number | null;
};
export type EditPricePerMonth = {
  amount?: number | null;
};
export type EditTotalPrice = {
  amount?: number | null;
};
export type EditTotalLiability = {
  amount?: number | null;
};
export type EditPaymentTermsInDays = {
  days?: number | null;
};
export type EditEndDate = {
  date?: string | null;
  hasNoEndDate: boolean;
};
export type EditStartDate = {
  date?: string | null;
};
export type EditAwardDate = {
  date?: string | null;
};
export type EditRenewalDate = {
  date?: string | null;
};
export type EditWarrantyExpirationDate = {
  date?: string | null;
};
export type EditTimezone = {
  value: string;
};
export type EditValueAmount = {
  amount?: number | null;
};
export type EditIfrsValues = {
  startDate?: string | null;
  startDateSecondPeriod?: string | null;
  monthlyPayment?: number | null;
  paymentIntervalInMonths?: number | null;
  contractLengthInMonths?: number | null;
  interestRate?: number | null;
};
export type EditSupplierInfo = {
  isClimateCommitted: boolean;
  hasSignedCodeOfConduct: boolean;
  hasCustomerContact: boolean;
};
export type EditCurrency = {
  currency: Currency;
};
export type AddTerminationDate = {
  date: string;
  reason: string;
};
export type AddDateReminderNotification = {
  inAdvanceUnit: ContractNotificationDurationType;
  inAdvanceAmount: number;
  receiverIds: string[];
  dateReminderType: ContractDateReminderType;
};
export type AddAdjustment = {
  date: string;
  value: number;
};
export type EditSupplierCategory = {
  category?: Category | null;
};
export type EditNoticePeriod = {
  duration: number;
};
export type LastSeenOption = {
  name?: string;
  description?: string;
  startDate?: string | null;
  deadline?: string | null;
  endDate?: string | null;
  duration?: number | null;
  extension?: ContractExtensionDto | null;
  datesSetByHand?: boolean;
};
export type EditOption = {
  id: string;
  name?: string;
  description?: string;
  startDate?: string | null;
  deadline?: string | null;
  endDate?: string | null;
  duration?: number | null;
  isExecuted?: boolean;
  extension?: ContractExtensionDto | null;
  datesSetByHand?: boolean;
  lastSeen?: LastSeenOption | null;
};
export type ExecuteOption = {
  id: string;
};
export type DeclineOption = {
  id: string;
};
export type RemoveOption = {
  id: string;
};
export type UpdateContractRequest = {
  title?: string | null;
  description?: string | null;
  removeDocument?: string | null;
  removeDescriptionDocument?: string | null;
  counterparty?: EditCounterparty | null;
  template?: EditTemplate | null;
  editProjects?: string[] | null;
  internalOwner?: EditInternalOwner | null;
  counterpartyContactPerson?: EditCounterpartyContactPerson | null;
  deliveryTerms?: EditDeliveryTerms | null;
  purchasingPolicy?: EditPurchasingPolicy | null;
  originSourcingEvent?: EditOriginSourcingEvent | null;
  industry?: EditIndustryIds | null;
  internalReferenceNumber?: EditInternalReferenceNumber | null;
  externalLink?: EditExternalLink | null;
  risk?: EditRisk | null;
  priority?: EditPriority | null;
  linkedContracts?: EditLinkedContracts | null;
  pricePerYear?: EditPricePerYear | null;
  pricePerMonth?: EditPricePerMonth | null;
  totalPrice?: EditTotalPrice | null;
  totalLiability?: EditTotalLiability | null;
  paymentTermsInDays?: EditPaymentTermsInDays | null;
  endDate?: EditEndDate | null;
  startDate?: EditStartDate | null;
  awardDate?: EditAwardDate | null;
  renewalDate?: EditRenewalDate | null;
  warrantyExpirationDate?: EditWarrantyExpirationDate | null;
  timezone?: EditTimezone | null;
  valueAmount?: EditValueAmount | null;
  ifrsValues?: EditIfrsValues | null;
  supplierInfo?: EditSupplierInfo | null;
  internalParties?: EditInternalParties | null;
  currency?: EditCurrency | null;
  terminationDate?: AddTerminationDate | null;
  addDateReminderNotification?: AddDateReminderNotification | null;
  removeNotification?: string | null;
  addDataFields?: ContractDataFieldNameDto[] | null;
  editCustomFields?: {
    [key: string]: ContractDataFieldSectionDto;
  } | null;
  removeDataField?: ContractDataFieldNameDto | null;
  addMonetaryValueAdjustment?: AddAdjustment | null;
  removeMonetaryValueAdjustment?: string | null;
  addPercentageValueAdjustment?: AddAdjustment | null;
  removePercentageValueAdjustment?: string | null;
  editSupplierCategory?: EditSupplierCategory | null;
  editNoticePeriod?: EditNoticePeriod | null;
  editOption?: EditOption | null;
  executeOption?: ExecuteOption | null;
  declineOption?: DeclineOption | null;
  removeOption?: RemoveOption | null;
};
export type TextDocumentAttachmentInputDto = {
  textDocumentId: string;
  htmlContent: string;
};
export type AttachmentInputDto = {
  documentId?: string | null;
  textDocument?: TextDocumentAttachmentInputDto | null;
};
export type SignerDto = {
  firstName: string;
  lastName: string;
  email: string;
  signatureMethod: DocumentSignerMethod;
};
export type CreateSignedDocumentRequest = {
  mainDocumentId: string;
  attachments?: AttachmentInputDto[] | null;
  signers: SignerDto[];
  language: EmailInviteLanguage;
  deadline?: string | null;
  messageToSigners?: string | null;
  resendOfSignedDocumentId?: string | null;
};
export type CreateSignedTextDocumentRequest = {
  textDocumentId: string;
  htmlContent: string;
  attachments?: AttachmentInputDto[] | null;
  signers: SignerDto[];
  language: EmailInviteLanguage;
  deadline?: string | null;
  messageToSigners?: string | null;
  resendOfSignedDocumentId?: string | null;
};
export type CreateContractRequest = {
  title: string;
  timezone: string;
  templateId?: string | null;
  projects?: string[] | null;
};
export type ListPersonsResponse = {
  persons: PersonDto[];
  count: number;
};
export type ListPersonsByIdsResponse = {
  persons: PersonDto[];
};
export type MeDto = {
  id: string;
  identityId?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email: string;
  emailVerified: boolean;
  corporateTitle?: string | null;
  phoneNumber?: PhoneNumberDto | null;
  canCreateOrg: boolean;
  intercomSecretHash: string;
  isSystemAdmin: boolean;
  systemAdminAwaitingSecondFactor: boolean;
  canOpenAdminDashboard: boolean;
};
export type EditPhoneNumber = {
  value?: PhoneNumberDto | null;
};
export type EditMeRequest = {
  firstName?: string | null;
  lastName?: string | null;
  corporateTitle?: string | null;
  phoneNumber?: EditPhoneNumber | null;
};
export type SupplierBidQualificationResponseDto = {
  criterionKey: string;
  description?: string | null;
  evidenceDocumentIds?: string[] | null;
  evidenceDocuments?: ViewDocumentAsOwnerDto[] | null;
};
export type SupplierBidMinimumRequirementResponseDto = {
  minimumRequirementId: string;
  answer: boolean;
  comment?: string | null;
  attachmentIds?: string[] | null;
  attachments?: ViewDocumentAsOwnerDto[] | null;
};
export type PortalDocumentDto = {
  id: string;
  name: string;
  mimeType: string;
  fileExtension: string;
  size: number;
  uploadedAt: string;
  category?: DocumentCategory | null;
};
export type SupplierBidRejectionDto = {
  grounds: RejectionGroundDto[];
  reason: string;
  message: string;
  rejectedAt?: string | null;
  attachmentIds?: string[];
  attachments?: PortalDocumentDto[];
};
export type BidDto = {
  id: string;
  forEvent: string;
  status: BidStatus;
  isContentEditable?: boolean;
  submissionDeadlinePassed?: boolean;
  submissionDeadline?: string | null;
  forNegotiationRound?: string | null;
  submittedAt?: string | null;
  statusHistory?: BidStatusTransitionDto[];
  espdResponse?: EspdResponseDto | null;
  derivedEspdAnswers?: EspdRequirementResponseDto[];
  qualificationResponses?: SupplierBidQualificationResponseDto[];
  minimumRequirementResponses?: SupplierBidMinimumRequirementResponseDto[];
  awardCriterionResponses?: BidAwardCriterionResponseDto[];
  price?: EventValueDto | null;
  coverLetter?: string | null;
  signedDocumentId?: string | null;
  documents?: ViewDocumentAsOwnerDto[];
  previousSigningOutcome?: PreviousSigningOutcome | null;
  rejection?: SupplierBidRejectionDto | null;
  termsToAccept?: string | null;
  termsAccepted?: boolean;
  products?: ProductGroupBidDto[] | null;
  comment?: string | null;
  commentDocuments?: ViewDocumentAsOwnerDto[];
  espd?: BuyerBidEspdDto | null;
  declarations?: BuyerBidDeclarationsDto | null;
  ownerName?: string | null;
  ownerOrganizationNumber?: string | null;
};
export type BidPatchDto = {
  espdResponse?: EspdResponseDto;
  qualificationResponses?: SupplierBidQualificationResponseDto[];
  minimumRequirementResponses?: SupplierBidMinimumRequirementResponseDto[];
  awardCriterionResponses?: BidAwardCriterionResponseDto[];
  price?: EventValueDto;
  products?: ProductGroupBidDto[] | null;
  coverLetter?: string;
  documents?: ViewDocumentAsOwnerDto[];
};
export type ContributingEntityListDto = {
  items: ContributingEntityDto[];
};
export type AddContributingEntityRequestDto = {
  role: ContributingEntityRole;
  organizationNumber: string;
  name: string;
  groupRole?: string | null;
  contactEmail: string;
  contactFirstName?: string | null;
  contactLastName?: string | null;
  language?: EmailInviteLanguage;
  supportedCriterionKeys?: string[];
};
export type UpdateContributingEntityRequestDto = {
  role: ContributingEntityRole;
  name: string;
  groupRole?: string | null;
  contactEmail: string;
  contactFirstName?: string | null;
  contactLastName?: string | null;
  supportedCriterionKeys: string[];
};
export type StartBidSigningResponseDto = {
  signingUrl: string;
  signedDocumentId: string;
};
export type StartBidSigningRequestDto = {
  successUrl: string;
  cancelUrl: string;
  errorUrl: string;
};
export type CancelBidSigningResponseDto = {
  bidId: string;
  outcome: CancelBidSigningOutcome;
};
export type CancelBidSigningRequestDto = {
  reason?: string | null;
};
export type BidPreflightDto = {
  ready: boolean;
  remaining: PreflightRequirementDto[];
  warnings?: PreflightWarningDto[];
};
export type UpdateContributingEntityResponseRequestDto = {
  espdResponse?: EspdResponseDto | null;
};
export type UpdateContributingEntityCommitmentRequestDto = {
  commitment: ContributingEntityCommitmentDto;
};
export type UpdateContributingEntityQualificationResponsesRequestDto = {
  responses?: ContributingEntityQualificationResponseDto[];
};
export type PortalLifecycleDto = {
  status: PortalLifecycleStatus;
  cancelledReason?: string | null;
  resultNoticeNumber?: string | null;
};
export type PortalSourcingEventSummaryDto = {
  id: string;
  title: string;
  description?: string | null;
  bidSubmissionDeadline: string;
  competitionStage?: CompetitionStageDto | null;
  lifecycle: PortalLifecycleDto;
  buyerName: string;
  contextType: PortalEventContextType;
  referenceId?: string | null;
  procedureType?: ProcedureType | null;
  namesNoProcedure?: boolean;
  estimatedValue?: EventValueDto | null;
  cpvCodes?: CpvCodeDto[];
  publishedAt?: string | null;
  frameworkAgreementNoLongerActive?: boolean;
  dpsValidTo?: string | null;
  viewerMayTakeNextStep?: boolean | null;
  viewerInvited?: boolean;
};
export type PortalLifecycleCountDto = {
  status: PortalLifecycleStatus;
  count: number;
};
export type PortalSourcingEventsResponse = {
  events: PortalSourcingEventSummaryDto[];
  totalCount: number;
  nextCursor?: string | null;
  lifecycleCounts?: PortalLifecycleCountDto[];
};
export type PortalAwardCriteriaDto = {
  model: PortalAwardModel;
  criteria?: AwardCriterionDto[];
  inOrderOfPriority?: boolean;
  weightsWithheld?: boolean;
};
export type PortalDesignContestPrizeDto = {
  description: string;
  value?: EventValueDto | null;
};
export type PortalDesignContestJuryMemberDto = {
  name: string;
  role?: string | null;
};
export type PortalDesignContestDto = {
  juryCriteria: string[];
  prizes: PortalDesignContestPrizeDto[];
  jury: PortalDesignContestJuryMemberDto[];
  requiredParticipantQualification?: string | null;
  leadsToServiceContract?: boolean | null;
};
export type PortalPriceModelDto = {
  type: PortalPriceModelType;
  breakpointPercent?: number | null;
};
export type PortalTextDocumentDto = {
  id: string;
  name: string;
  text: string;
  createdAt: string;
  documents?: PortalDocumentDto[];
};
export type PortalSourcingEventDetailDto = {
  id: string;
  title: string;
  description?: string | null;
  bidSubmissionDeadline?: string | null;
  questionDeadline?: string | null;
  requestDeadline?: string | null;
  competitionStage?: CompetitionStageDto | null;
  collectsEspdWithBid?: boolean;
  asksForEspd?: boolean;
  dpsValidFrom?: string | null;
  dpsValidTo?: string | null;
  qualificationSchemeValidFrom?: string | null;
  qualificationSchemeValidTo?: string | null;
  qualificationSchemeRules?: string | null;
  qualificationSchemeCategories?: string[];
  plannedInterestInvitationAt?: string | null;
  submissionDeadlinePassed?: boolean;
  lifecycle: PortalLifecycleDto;
  buyerName: string;
  contextType: PortalEventContextType;
  buyerRunsPublicProcurements?: boolean;
  outsideProcurementAct?: boolean;
  myInviteStatus?: PortalInviteStatusDto;
  frameworkAgreementTitle?: string | null;
  frameworkAgreementNoLongerActive?: boolean;
  tenderCurrency?: Currency;
  awardCannotBecomeCallOff?: boolean;
  buyerOrganizationNumber?: string | null;
  buyerCity?: string | null;
  buyerContactName?: string | null;
  buyerContactTitle?: string | null;
  referenceId?: string | null;
  procedureType?: ProcedureType | null;
  namesNoProcedure?: boolean;
  dialoguePlanned?: boolean | null;
  dialogueDescription?: string | null;
  contractNature?: ContractNature | null;
  placeOfPerformanceCounty?: string | null;
  placeOfPerformanceDetail?: string | null;
  estimatedValue?: EventValueDto | null;
  frameworkAgreement?: FrameworkAgreementType | null;
  frameworkMaxParticipants?: number | null;
  frameworkMaximumValue?: EventValueDto | null;
  cpvCodes?: CpvCodeDto[];
  publishedAt?: string | null;
  contractStartDate?: string | null;
  contractEndDate?: string | null;
  selectionCriteria?: SelectionCriterionDto[];
  minimumRequirements?: MinimumRequirementDto[];
  awardCriteria?: PortalAwardCriteriaDto | null;
  designContest?: PortalDesignContestDto | null;
  priceModel?: PortalPriceModelDto | null;
  collectSupplierPrice?: boolean;
  documents?: PortalDocumentDto[];
  textDocuments?: PortalTextDocumentDto[];
  applicableSupplierDeclarationCriteria?: ResolvedEspdCriterionDto[];
  participationRequestSupplierDeclarationCriteria?: ResolvedEspdCriterionDto[];
  applicableExclusionCriteria?: ResolvedEspdCriterionDto[];
  applicableQualificationCriteria?: ResolvedEspdCriterionDto[];
  changeLog?: EventRevisionDto[];
  devToolsAllowed?: boolean;
  viewerOwnsProcurement?: boolean;
};
export type WithdrawnPortalAwardLetterDto = {
  letter: AwardLetterDto;
  winnerNames?: string[];
  signerName?: string | null;
  evaluation?: AwardLetterEvaluationDto | null;
  standstillDays?: number | null;
  justifiedCriteria?: AwardLetterCriterionDto[];
};
export type PortalAwardLetterDto = {
  letter?: AwardLetterDto | null;
  standstillExpiresAt?: string | null;
  buyerSetsStandstill?: boolean;
  standstillWithoutProvision?: boolean;
  standstillUnderPartIV?: boolean;
  standstillUnderDps?: boolean;
  standstillUnderUtilitiesPartIII?: boolean;
  choosesVoluntaryStandstill?: boolean;
  standstillDays?: number | null;
  standstillExemption?: StandstillExemption | null;
  regulation?: Regulation | null;
  winnerNames?: string[];
  evaluation?: AwardLetterEvaluationDto | null;
  signerName?: string | null;
  outcome?: PortalAwardOutcomeDto | null;
  letterPending?: boolean;
  outcomeAwaitsLetter?: boolean;
  awardAwaitsLetters?: boolean;
  myRank?: number | null;
  bidderCount?: number | null;
  rejectionMessage?: string | null;
  withdrawnLetter?: WithdrawnPortalAwardLetterDto | null;
  justifiedCriteria?: AwardLetterCriterionDto[];
};
export type PortalDocumentDownloadLinkResponse = {
  url: string;
};
export type PortalBidDocumentDto = {
  documentId: string;
  fileName: string;
};
export type PortalBidDocumentsResponse = {
  documents: PortalBidDocumentDto[];
};
export type ParticipationQualificationResponseDto = {
  criterionKey: string;
  description?: string | null;
  evidenceDocumentIds?: string[];
};
export type QualificationVerdictDto = {
  qualified: boolean;
  decidedAt: string;
  rejectionReason?: string | null;
  rejection?: ParticipationRequestRejectionDto | null;
};
export type ParticipationRequestDto = {
  id: string;
  sourcingEventId: string;
  status: ParticipationRequestStatus;
  submittedAt?: string | null;
  espdResponse?: EspdResponseDto | null;
  qualificationResponses?: ParticipationQualificationResponseDto[];
  qualificationVerdict?: QualificationVerdictDto | null;
  selectionOutcome?: SelectionOutcomeDto | null;
  stillAdmittedUntil?: string | null;
  removalReason?: string | null;
};
export type MyParticipationDto = {
  request?: ParticipationRequestDto | null;
  invited?: boolean;
  mayRequestToParticipate?: boolean;
};
export type CreateSeQuestionRequest = {
  subject: string;
  content: string;
  attachments?: SeAttachmentInputDto[];
};
export type PortalRegisterInterestResponse = {
  hasRegistered: boolean;
};
export type PortalRegistrationStatusResponse = {
  hasRegistered: boolean;
  currentBidId?: string | null;
  currentBidStatus?: BidStatus | null;
};
export type PortalMarketDialogueRoundDto = {
  number: number;
  isCommentRound: boolean;
};
export type PortalMarketDialogueDto = {
  id: string;
  title: string;
  description?: string | null;
  questions: MarketDialogueQuestionDto[];
  answerDeadline?: string | null;
  deadlinePassed: boolean;
  buyerName: string;
  cpvCodes: string[];
  documents: PortalDocumentDto[];
  publishedAt?: string | null;
  doffinReference?: string | null;
  round: PortalMarketDialogueRoundDto;
  shared?: SharedItemDto[];
};
export type AcceptPortalInviteResponse = {
  accepted: boolean;
};
export type PortalRoundBidCreatedDto = {
  bidId: string;
  forNegotiationRound?: string | null;
  status: string;
};
export type DeclinePortalInviteResponse = {
  declined: boolean;
};
export type PortalRoundBidDto = {
  bidId: string;
  status: BidStatus;
  confirmsStandingBid?: boolean;
};
export type PortalStandingBidDto = {
  bidId: string;
  deliveredAt?: string | null;
  fromRoundNumber?: number | null;
};
export type PortalNegotiationRoundDto = {
  id: string;
  roundNumber: number;
  isFinalRound?: boolean | null;
  status: NegotiationRoundStatus;
  deadline: string;
  title?: string | null;
  description?: string | null;
  publishedAt?: string | null;
  completedAt?: string | null;
  documents: PortalDocumentDto[];
  isCallerInvited: boolean;
  inviteMessage?: string | null;
  myBid?: PortalRoundBidDto | null;
  isCallerRejected?: boolean;
  standingBid?: PortalStandingBidDto | null;
  declinedAt?: string | null;
  missingLeavesCompetition?: boolean;
};
export type PortalStageReductionDto = {
  reason: string;
  reducedAt: string;
};
export type ListPortalNegotiationRoundsResponse = {
  rounds: PortalNegotiationRoundDto[];
  reduction?: PortalStageReductionDto | null;
};
export type PortalCallOffDto = {
  contractId: string;
  title: string;
};
export type PortalFrameworkAgreementDto = {
  id: string;
  title: string;
  buyerOrganizationName: string;
  status: FrameworkAgreementStatus;
  panelStatus: PanelStatus;
  ranking?: number | null;
  endDate?: string | null;
  callOffs?: PortalCallOffDto[];
};
export type PortalFrameworkAgreementsDto = {
  frameworkAgreements?: PortalFrameworkAgreementDto[];
};
export type AcceptedMarketDialogueInviteDto = {
  marketDialogueId: string;
};
export type MarketDialogueAnswerDto = {
  id: string;
  status: MarketDialogueAnswerStatus;
  answers: AnsweredQuestionDto[];
  otherDocuments?: ViewDocumentAsOwnerDto[];
  sentAt?: string | null;
};
export type SupplierMarketDialogueDto = {
  dialogue: PortalMarketDialogueDto;
  answer?: MarketDialogueAnswerDto | null;
  viewerOwnsDialogue: boolean;
  canAnswer: boolean;
  questions?: SupplierQuestionDto[];
};
export type QuestionAnswerDto = {
  questionId: string;
  text?: string;
  choice?: boolean | null;
  secretReason?: string | null;
  secretDocuments?: SecretDocumentDto[];
};
export type SaveMarketDialogueAnswerRequest = {
  answers?: QuestionAnswerDto[];
};
export type CreateMarketDialogueAnswerUploadRequestDto = {
  fileName: string;
  fileSize: number;
  fileExtension: string;
  mimeType: string;
  questionId: string;
};
export type AskSupplierQuestionRequest = {
  text: string;
};
export type PortalMyBidDto = {
  eventId: string;
  bidId: string;
  status: BidStatus;
  event: PortalSourcingEventSummaryDto;
  awardOutcome?: PortalAwardOutcomeDto | null;
  awardedTo?: string[];
  standstillExpiresAt?: string | null;
  deliveredBidId?: string | null;
  deliveredBidStatus?: BidStatus | null;
};
export type PortalMyBidsResponse = {
  bids: PortalMyBidDto[];
};
export type ContributingEntityDetailListDto = {
  items: ContributingEntityDetailDto[];
};
export type MyParticipationRequestRowDto = {
  request: ParticipationRequestDto;
  eventId: string;
  eventTitle?: string | null;
  buyerOrganizationName?: string | null;
  requestDeadline?: string | null;
};
export type MyParticipationRequestsDto = {
  rows?: MyParticipationRequestRowDto[];
};
export type ParticipationRequestPatchDto = {
  espdResponse?: EspdResponseDto;
  qualificationResponses?: ParticipationQualificationResponseDto[];
};
export type CreateProductDto = {
  id?: string | null;
  quantity: NumberFieldDto;
  productFields: ProductFieldDto[];
};
export type AddProductDto = {
  product: CreateProductDto;
};
export type AddProductCommentDto = {
  comment: string;
};
export type EditProductDto = {
  id: string;
  quantity?: NumberFieldDto | null;
  productFields?: ProductFieldDto[] | null;
  comment?: AddProductCommentDto | null;
};
export type DeleteProductDto = {
  productId: string;
};
export type EditProductGroupDto = {
  id: string;
  addProduct?: AddProductDto | null;
  editProduct?: EditProductDto | null;
  upsertProducts?: ProductDto[] | null;
  deleteProduct?: DeleteProductDto | null;
};
export type CreateProductGroupDto = {
  sourcingEventId?: string | null;
  projectId?: string | null;
  name: string;
  originProductGroupId?: string | null;
  productFields: ProductTemplateFieldDto[];
  products: CreateProductDto[];
};
export type ProductTemplateDto = {
  id: string;
  name: string;
  createdAt: string;
  modifiedAt: string;
  productFields: ProductTemplateFieldDto[];
};
export type ProductTemplatesDto = {
  templates: ProductTemplateDto[];
};
export type CreateProjectRequest = {
  id?: string | null;
  homeDepartmentId?: string | null;
  externalId?: string | null;
  name: string;
  description?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  parent?: string | null;
  projectResponsible?: string | null;
  sourcingResponsible?: string | null;
  projectType?: string | null;
  documents?: string[] | null;
};
export type CreateProjectTextDocumentRequest = {
  name: string;
  text: string;
  tags: string[];
  projectId: string;
};
export type ProjectPatchDto = {
  externalId?: string | null;
  name?: string;
  description?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  parentId?: string | null;
  projectResponsibleId?: string | null;
  sourcingResponsibleId?: string | null;
  projectTypeId?: string | null;
  documents?: ProjectDocumentDto[];
  descriptionDocuments?: ProjectDocumentDto[];
};
export type ProjectsDto = {
  projects: ProjectDto[];
  count?: number | null;
};
export type CurrencyAmountDto = {
  currency: string;
  amount: number;
};
export type ContractValueDto = {
  contracts: number;
  withoutTotalPrice: number;
  totals: CurrencyAmountDto[];
  drafts?: number;
};
export type ProjectOverviewFiguresDto = {
  ongoing: number;
  startingSoon: number;
  startingSoonWithNothingUnderway: number;
  withoutSourcingResponsible: number;
  contractValue?: ContractValueDto | null;
  contractsEndingBeforeProjectEnd?: number | null;
  productsWithoutProcurement: number;
  products: number;
};
export type ProductCoverageDto = {
  total: number;
  withProcurement: number;
};
export type ProjectOverviewRowDto = {
  id: string;
  visible: boolean;
  externalId?: string | null;
  name?: string | null;
  projectType?: ProjectTypeName | null;
  status: ProjectStatus;
  startDate?: string | null;
  endDate?: string | null;
  sourcingResponsible?: PersonDto | null;
  withoutSourcingResponsible: boolean;
  startsSoon: boolean;
  startsSoonWithoutSourcingResponsible: boolean;
  contracts?: ContractValueDto | null;
  contractsEndingBeforeProjectEnd?: number | null;
  ongoingProcurements?: number | null;
  products: ProductCoverageDto;
};
export type ProjectValueDto = {
  id: string;
  visible: boolean;
  name?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  subprojectIds: string[];
  contracts: number;
  value: number;
  inProject: number;
  inSubprojects: number;
};
export type OtherProjectsValueDto = {
  projects: number;
  contracts: number;
  value: number;
};
export type ValuePerProjectDto = {
  currency: string;
  top: ProjectValueDto[];
  others?: OtherProjectsValueDto | null;
  contractsNotInBars: number;
};
export type ProjectTypeFigureDto = {
  projectType?: ProjectTypeName | null;
  projectTypeId?: string | null;
  ongoing: number;
  contracts?: number | null;
  contractValue?: number | null;
};
export type ProjectOverviewDto = {
  startsSoonUntil: string;
  figures: ProjectOverviewFiguresDto;
  projects: ProjectOverviewRowDto[];
  valuePerProject?: ValuePerProjectDto | null;
  perProjectType: ProjectTypeFigureDto[];
};
export type ExpiringContractsDto = {
  count: number;
  endingOnOrBefore: string;
};
export type ProjectContractFiguresDto = {
  inProject: ContractValueDto;
  inSubprojects: ContractValueDto;
  subprojectIds: string[];
  expiringBeforeProjectEnd?: ExpiringContractsDto | null;
  withoutTotalPrice?: number;
  drafts?: number;
};
export type ProcurementPhaseCountDto = {
  phase: ProcurementPhaseDto;
  count: number;
};
export type ProjectProcurementSummaryDto = {
  contracts?: ProjectContractFiguresDto | null;
  procurementsByPhase?: ProcurementPhaseCountDto[] | null;
  products: ProductCoverageDto;
};
export type SavedReportDto = {
  id: string;
  name: string;
  list: SavedReportListDto;
  query: string;
  createdAt: string;
  modifiedAt: string;
  sharedBy?: PersonDto | null;
  sharedWith: PersonDto[];
  kind: SavedReportKindDto;
  canChange: boolean;
  canShare: boolean;
  systemKey?: SavedReportSystemKeyDto | null;
};
export type ListSavedReportsResponse = {
  reports: SavedReportDto[];
  canSaveFirmReports: boolean;
};
export type CreateSavedReportRequest = {
  name: string;
  list: SavedReportListDto;
  query: string;
  firmReport?: boolean;
};
export type RenameSavedReportRequest = {
  name: string;
};
export type ReplaceSavedReportQueryRequest = {
  query: string;
};
export type ShareSavedReportRequest = {
  personId: string;
};
export type ScimMember = {
  value: string;
  display?: string | null;
};
export type GroupDto = {
  id: string;
  displayName: string;
  schemas: string[];
  members?: ScimMember[] | null;
};
export type GroupsDto = {
  Resources: GroupDto[];
  totalResults: number;
  schemas: string[];
};
export type MetaDto = {
  resourceType: string;
  location?: string | null;
};
export type CreateGroupDto = {
  schemas: string[];
  externalId?: string | null;
  displayName: string;
  members?: ScimMember[] | null;
  meta?: MetaDto | null;
};
export type OperationValueObject = {
  userName?: string | null;
  givenName?: string | null;
  familyName?: string | null;
  title?: string | null;
  active?: boolean | null;
  displayName?: string | null;
  members?: ScimMember[] | null;
  roles?: string | null;
};
export type ObjectPatchOperation = {
  op: PatchOperationType;
  value: OperationValueObject;
};
export type StringPatchOperation = {
  op: PatchOperationType;
  path: string;
  value: string;
};
export type BooleanPatchOperation = {
  op: PatchOperationType;
  path: string;
  value: boolean;
};
export type ListPatchOperationValue = {
  value: string;
};
export type ListPatchOperation = {
  op: PatchOperationType;
  path: string;
  value: ListPatchOperationValue[];
};
export type UpdateGroupRequest = {
  schemas: string[];
  Operations: (
    | ObjectPatchOperation
    | StringPatchOperation
    | BooleanPatchOperation
    | ListPatchOperation
  )[];
};
export type SchemaSubAttributeDto = {
  type: SchemaAttributeType;
  name: string;
  description: string;
  required: boolean;
  caseExact: boolean;
  mutability: SchemaAttributeMutability;
  returned: string;
  uniqueness: SchemaAttributeUniqueness;
  referenceTypes?: ScimResourceType[] | null;
  canonicalValues?: ScimResourceType[] | null;
  multiValued: boolean;
};
export type SchemaAttributeDto = {
  type: SchemaAttributeType;
  name: string;
  multiValued: boolean;
  description: string;
  required: boolean;
  subAttributes?: SchemaSubAttributeDto[] | null;
  caseExact: boolean;
  mutability: SchemaAttributeMutability;
  returned: string;
  uniqueness: SchemaAttributeUniqueness;
};
export type SchemaDto = {
  schemas: string[];
  id: string;
  name: string;
  description: string;
  attributes: SchemaAttributeDto[];
  meta: MetaDto;
};
export type SchemasDto = {
  schemas: string[];
  itemsPerPage: number;
  startIndex: number;
  totalResults: number;
  Resources: SchemaDto[];
};
export type TokenResponse = {
  token: string;
};
export type NameDto = {
  givenName?: string | null;
  familyName?: string | null;
};
export type RoleResponse = {
  value: string;
};
export type UserDto = {
  id: string;
  userName: string;
  name: NameDto;
  title?: string | null;
  roles: RoleResponse[];
  schemas: string[];
  active?: boolean;
};
export type UsersDto = {
  Resources: UserDto[];
  totalResults: number;
  schemas: string[];
};
export type RoleValueContent = {
  id?: string | null;
  value?: string | null;
  displayName?: string | null;
};
export type CreateUserDto = {
  userName: string;
  name?: NameDto | null;
  title?: string | null;
  roles?: RoleValueContent[] | null;
  active?: boolean | null;
};
export type SupplierRelationsDto = {
  organizationId: string;
  relations: SupplierRelationDto[];
};
export type MunicipalityDto = {
  number: string;
  name?: string | null;
  countyNumber: string;
};
export type NaceCodeDto = {
  code: string;
  description?: string | null;
};
export type ClassificationFacetsDto = {
  municipalities: MunicipalityDto[];
  naceCodes: NaceCodeDto[];
};
export type ContractFieldFacetDto = {
  fieldId: string;
  name: string;
  kind: ContractFieldFilterKindDto;
  values: string[];
};
export type SearchOrganizationsAndEntriesResponse = {
  organizations: MinimalOrgDto[];
  count: number;
  relations?: SupplierRelationsDto[];
  facets?: ClassificationFacetsDto | null;
  contractFieldFacets?: ContractFieldFacetDto[];
  filtersOnContractEndDate?: boolean;
};
export type UpdateSignedDocumentMetaRequest = {
  tags: string[];
};
export type TemplateOwnerDto = {
  global: boolean;
  organizationId?: string | null;
};
export type TemplateContentDto = {
  minimumRequirements?: MinimumRequirementDto[];
  selectionCriteria?: SelectionCriterionDto[];
  awardCriteria?: AwardCriteriaDto | null;
  priceModel?: PriceModelDto | null;
};
export type SourcingEventTemplateDto = {
  id: string;
  owner: TemplateOwnerDto;
  name: string;
  category?: string | null;
  description?: string | null;
  content: TemplateContentDto;
  createdAt: string;
  modifiedAt: string;
};
export type SourcingEventTemplatesDto = {
  templates: SourcingEventTemplateDto[];
};
export type CreateSourcingEventTemplateRequest = {
  name: string;
  category?: string | null;
  description?: string | null;
  content?: TemplateContentDto;
  global?: boolean;
};
export type UpdateSourcingEventTemplateRequest = {
  id: string;
  name: string;
  category?: string | null;
  description?: string | null;
  content?: TemplateContentDto;
};
export type CreateSourcingEventTextDocumentRequest = {
  name: string;
  text: string;
  tags: string[];
  eventId: string;
  category?: DocumentCategory | null;
};
export type SendForCommentRefusalDto = {
  reason: SendForCommentRefusalReason;
  roundNumber?: number | null;
  dialogueId?: string | null;
};
export type ProcurementCommentRoundDto = {
  dialogueId: string;
  number: number;
  status: MarketDialogueStatus;
  answerDeadline?: string | null;
};
export type SubjectCommentDocumentDto = {
  name: string;
  secretReason?: string | null;
};
export type SubjectCommentDto = {
  kind: CommentSubjectKind;
  ref: string;
  dialogueId: string;
  roundNumber: number;
  supplierName: string;
  sentAt: string;
  text: string;
  choice?: boolean | null;
  secretReason?: string | null;
  documents?: SubjectCommentDocumentDto[];
  withheld?: boolean;
};
export type ProcurementCommentRoundsDto = {
  canSendForComment: boolean;
  sendForCommentRefusal?: SendForCommentRefusalDto | null;
  rounds: ProcurementCommentRoundDto[];
  comments: SubjectCommentDto[];
};
export type SeEmailInviteDto = {
  id: string;
  sentAt: string;
  sentByPersonFirstName?: string | null;
  sentByPersonLastName?: string | null;
  owningOrganizationName: string;
  eventTitle: string;
  eventDeadline?: string | null;
};
export type SupplierProductDto = {
  id: string;
  quantity: NumberFieldDto;
  productFields: ProductFieldDto[];
};
export type SupplierProductGroupDto = {
  id: string;
  sourcingEventId: string;
  name: string;
  productFields: ProductTemplateFieldDto[];
  products: SupplierProductDto[];
};
export type SupplierProductGroupsDto = {
  productGroups: SupplierProductGroupDto[];
};
export type CreateBidAwardCriterionAttachmentUploadRequestDto = {
  fileName: string;
  fileSize: number;
  fileExtension: string;
  mimeType: string;
  criterionId: string;
};
export type CreateBidMinimumRequirementAttachmentUploadRequestDto = {
  fileName: string;
  fileSize: number;
  fileExtension: string;
  mimeType: string;
  minimumRequirementId: string;
};
export type CreateBidQualificationEvidenceUploadRequestDto = {
  fileName: string;
  fileSize: number;
  fileExtension: string;
  mimeType: string;
  criterionKey: string;
};
export type UpdateTextDocumentRequest = {
  id: string;
  name?: string | null;
  text?: string | null;
  tags?: string[] | null;
  category?: DocumentCategory | null;
  removeEmbeddedDocument?: string | null;
};
export type UploadStatusDto = {
  status: UploadStatusValueDto;
};
export enum AdminEntityType {
  Bid = "Bid",
  Contract = "Contract",
  Document = "Document",
  EmailInvite = "EmailInvite",
  EmailOutboxItem = "EmailOutboxItem",
  Organization = "Organization",
  Person = "Person",
  SourcingEvent = "SourcingEvent",
  Upload = "Upload",
}
export enum MigrationDocumentType {
  Regular = "Regular",
  Signed = "Signed",
}
export enum OrganizationSize {
  OneToTen = "ONE_TO_TEN",
  TenToFifty = "TEN_TO_FIFTY",
  FiftyToTwoHundredAndFifty = "FIFTY_TO_TWO_HUNDRED_AND_FIFTY",
  TwoHundredAndFiftyToThousand = "TWO_HUNDRED_AND_FIFTY_TO_THOUSAND",
  ThousandToTenThousand = "THOUSAND_TO_TEN_THOUSAND",
  TenThousandPlus = "TEN_THOUSAND_PLUS",
}
export enum AvailabilityReasonCodeDto {
  MissingCapability = "MissingCapability",
  ScopeNotCovered = "ScopeNotCovered",
  CreatedOnlyRestriction = "CreatedOnlyRestriction",
  GrantResolutionFailed = "GrantResolutionFailed",
  BidsAreSealed = "BidsAreSealed",
  OrganizationHasDeliveredBid = "OrganizationHasDeliveredBid",
  NotInPlan = "NotInPlan",
  JuryReportNotConfirmed = "JuryReportNotConfirmed",
  JuryAssessmentMissing = "JuryAssessmentMissing",
}
export enum ReasonKindDto {
  Authority = "authority",
  State = "state",
}
export enum BuyerLegalType {
  PublicLawBody = "PUBLIC_LAW_BODY",
  PublicLawBodyCentral = "PUBLIC_LAW_BODY_CENTRAL",
  PublicLawBodyRegional = "PUBLIC_LAW_BODY_REGIONAL",
  PublicLawBodyLocal = "PUBLIC_LAW_BODY_LOCAL",
  CentralGovernment = "CENTRAL_GOVERNMENT",
  DefenceContractor = "DEFENCE_CONTRACTOR",
  EuInstitution = "EU_INSTITUTION",
  EuInternationalOrg = "EU_INTERNATIONAL_ORG",
  GroupOfPublicAuthorities = "GROUP_OF_PUBLIC_AUTHORITIES",
  InternationalOrg = "INTERNATIONAL_ORG",
  Municipality = "MUNICIPALITY",
  OrganisationPart = "ORGANISATION_PART",
  OrganisationPartCentral = "ORGANISATION_PART_CENTRAL",
  OrganisationPartRegional = "ORGANISATION_PART_REGIONAL",
  OrganisationPartLocal = "ORGANISATION_PART_LOCAL",
  PublicUndertaking = "PUBLIC_UNDERTAKING",
  PublicUndertakingCentral = "PUBLIC_UNDERTAKING_CENTRAL",
  PublicUndertakingRegional = "PUBLIC_UNDERTAKING_REGIONAL",
  PublicUndertakingLocal = "PUBLIC_UNDERTAKING_LOCAL",
  County = "COUNTY",
  RegionalOrLocal = "REGIONAL_OR_LOCAL",
  SpecialRightsEntity = "SPECIAL_RIGHTS_ENTITY",
  Private = "PRIVATE",
}
export enum AiEndpoint {
  BedrockEu = "BEDROCK_EU",
  OpenaiGlobal = "OPENAI_GLOBAL",
  FencyGlobal = "FENCY_GLOBAL",
}
export enum AiFeature {
  Assistant = "ASSISTANT",
  CpvSuggestions = "CPV_SUGGESTIONS",
  NeedTypeSuggestion = "NEED_TYPE_SUGGESTION",
  AwardLetterDraft = "AWARD_LETTER_DRAFT",
  TextDraft = "TEXT_DRAFT",
  Autofill = "AUTOFILL",
  DocumentReading = "DOCUMENT_READING",
  CreateFromDocument = "CREATE_FROM_DOCUMENT",
  BidInsight = "BID_INSIGHT",
}
export enum Regulation {
  Foa = "FOA",
  Forsyningsforskriften = "FORSYNINGSFORSKRIFTEN",
  Konsesjonskontraktforskriften = "KONSESJONSKONTRAKTFORSKRIFTEN",
}
export enum AuthorityActivity {
  GeneralPublicServices = "GENERAL_PUBLIC_SERVICES",
  Defence = "DEFENCE",
  PublicOrderAndSafety = "PUBLIC_ORDER_AND_SAFETY",
  EconomicAffairs = "ECONOMIC_AFFAIRS",
  EnvironmentalProtection = "ENVIRONMENTAL_PROTECTION",
  HousingAndCommunityAmenities = "HOUSING_AND_COMMUNITY_AMENITIES",
  Health = "HEALTH",
  RecreationCultureAndReligion = "RECREATION_CULTURE_AND_RELIGION",
  Education = "EDUCATION",
  SocialProtection = "SOCIAL_PROTECTION",
}
export enum OrganizationRoleType {
  Owner = "Owner",
  Admin = "Admin",
  SourcingCreator = "SourcingCreator",
  SourcingViewer = "SourcingViewer",
  ContractCreator = "ContractCreator",
  ContractViewer = "ContractViewer",
  ProjectViewer = "ProjectViewer",
  ProjectCreator = "ProjectCreator",
}
export enum GrantRole {
  Owner = "Owner",
  Admin = "Admin",
  SourcingCreator = "SourcingCreator",
  SourcingViewer = "SourcingViewer",
  ContractCreator = "ContractCreator",
  ContractViewer = "ContractViewer",
  ProjectCreator = "ProjectCreator",
  ProjectViewer = "ProjectViewer",
}
export enum LeadTimeUnit {
  Days = "Days",
  Months = "Months",
}
export enum ContractRole {
  InternalOwner = "InternalOwner",
  CounterParty = "CounterParty",
  InvitedParty = "InvitedParty",
}
export enum IntervalUnit {
  Days = "Days",
  Months = "Months",
}
export enum ContractTaskRole {
  Responsible = "Responsible",
}
export enum SourcingEventRole {
  Publisher = "Publisher",
  InvitedSupplier = "InvitedSupplier",
}
export enum FrameworkAgreementRole {
  Responsible = "Responsible",
}
export enum OrganizationType {
  Organization = "Organization",
  OrganizationEntry = "OrganizationEntry",
}
export enum AiUsageFunction {
  Assistant = "ASSISTANT",
  CpvSuggestions = "CPV_SUGGESTIONS",
  NeedTypeSuggestion = "NEED_TYPE_SUGGESTION",
  AwardLetterDraft = "AWARD_LETTER_DRAFT",
  TextDraft = "TEXT_DRAFT",
  Autofill = "AUTOFILL",
  DocumentReading = "DOCUMENT_READING",
  CreateFromDocument = "CREATE_FROM_DOCUMENT",
  BidInsight = "BID_INSIGHT",
  DocumentChat = "DOCUMENT_CHAT",
  DocumentSearch = "DOCUMENT_SEARCH",
  ContractSearch = "CONTRACT_SEARCH",
  Unknown = "UNKNOWN",
}
export enum GPTRole {
  System = "system",
  Assistant = "assistant",
  User = "user",
  Function = "function",
  Tool = "tool",
}
export enum AiCompletionPurpose {
  CpvSuggestions = "CPV_SUGGESTIONS",
  NeedTypeSuggestion = "NEED_TYPE_SUGGESTION",
  AwardLetterDraft = "AWARD_LETTER_DRAFT",
  Autofill = "AUTOFILL",
  TextDraft = "TEXT_DRAFT",
}
export enum AiItemType {
  Procurement = "PROCUREMENT",
  Need = "NEED",
  Tender = "TENDER",
  Contract = "CONTRACT",
}
export enum AiSuggestionItemType {
  Procurement = "PROCUREMENT",
  Need = "NEED",
}
export enum ContractDataFieldType {
  Date = "Date",
  Financial = "Financial",
  Commercial = "Commercial",
  TermsAndConditions = "TermsAndConditions",
  Other = "Other",
}
export enum ContractDataFieldNameDto {
  StartDate = "StartDate",
  EndDate = "EndDate",
  AwardDate = "AwardDate",
  WarrantyExpirationDate = "WarrantyExpirationDate",
  RenewalDate = "RenewalDate",
  CounterpartyContactPerson = "CounterpartyContactPerson",
  DeliveryTerms = "DeliveryTerms",
  EstimatedValue = "EstimatedValue",
  ExternalLink = "ExternalLink",
  InternalReferenceNumber = "InternalReferenceNumber",
  LinkedContracts = "LinkedContracts",
  OriginSourcingEvent = "OriginSourcingEvent",
  PaymentTermsInDays = "PaymentTermsInDays",
  PricePerMonth = "PricePerMonth",
  PricePerYear = "PricePerYear",
  Priority = "Priority",
  PurchasingPolicy = "PurchasingPolicy",
  Risk = "Risk",
  TotalLiability = "TotalLiability",
  TotalPrice = "TotalPrice",
  TerminationDate = "TerminationDate",
  IfrsValues = "IfrsValues",
  SupplierInfo = "SupplierInfo",
  InternalParties = "InternalParties",
  SupplierCategory = "SupplierCategory",
  NoticePeriod = "NoticePeriod",
  Options = "Options",
  Projects = "Projects",
}
export enum AgentAuditOutcome {
  Proposed = "PROPOSED",
  Confirmed = "CONFIRMED",
  Rejected = "REJECTED",
  Executed = "EXECUTED",
  Failed = "FAILED",
}
export enum UploadStatusValueDto {
  Processing = "Processing",
  Confirmed = "Confirmed",
  Failed = "Failed",
}
export enum AgentDocumentScopeTypeDto {
  Contract = "CONTRACT",
  SourcingEventV2 = "SOURCING_EVENT_V2",
  SourcingEventV2Bids = "SOURCING_EVENT_V2_BIDS",
}
export enum AgentModule {
  Assistant = "assistant",
  DocumentChat = "documentChat",
  BidInsight = "bidInsight",
  ContractSearch = "contractSearch",
}
export enum ContactSubjectType {
  RegisteredOrganization = "RegisteredOrganization",
  OrganizationEntry = "OrganizationEntry",
}
export enum EmailInviteLanguage {
  En = "En",
  No = "No",
}
export enum EspdCriterionCategory {
  ExclusionConvictions = "EXCLUSION_CONVICTIONS",
  ExclusionContributions = "EXCLUSION_CONTRIBUTIONS",
  ExclusionSocial = "EXCLUSION_SOCIAL",
  ExclusionBusiness = "EXCLUSION_BUSINESS",
  ExclusionMisconduct = "EXCLUSION_MISCONDUCT",
  ExclusionConflict = "EXCLUSION_CONFLICT",
  ExclusionNational = "EXCLUSION_NATIONAL",
  SelectionSuitability = "SELECTION_SUITABILITY",
  SelectionEconomic = "SELECTION_ECONOMIC",
  SelectionTechnical = "SELECTION_TECHNICAL",
  SelectionQuality = "SELECTION_QUALITY",
  OtherEoData = "OTHER_EO_DATA",
}
export enum SourcingEventStatus {
  Draft = "DRAFT",
  PublicationPending = "PUBLICATION_PENDING",
  Published = "PUBLISHED",
  PublicationFailed = "PUBLICATION_FAILED",
  Evaluation = "EVALUATION",
  Evaluated = "EVALUATED",
  AwardDecision = "AWARD_DECISION",
  Awarded = "AWARDED",
  Cancelled = "CANCELLED",
  Closed = "CLOSED",
  Completed = "COMPLETED",
}
export enum ContractDurationType {
  FixedDates = "FIXED_DATES",
  PeriodBased = "PERIOD_BASED",
  OpenEnded = "OPEN_ENDED",
}
export enum AwardCriterionType {
  Price = "PRICE",
  Cost = "COST",
  Quality = "QUALITY",
  QualityEnvironmentalCriteria = "QUALITY_ENVIRONMENTAL_CRITERIA",
  QualityEnvironmentalSpecification = "QUALITY_ENVIRONMENTAL_SPECIFICATION",
  QualityEnvironmentalExemptInsignificant = "QUALITY_ENVIRONMENTAL_EXEMPT_INSIGNIFICANT",
  QualityEnvironmentalExemptCriticalInterest = "QUALITY_ENVIRONMENTAL_EXEMPT_CRITICAL_INTEREST",
  QualityEnvironmentalExemptNationalMinimum = "QUALITY_ENVIRONMENTAL_EXEMPT_NATIONAL_MINIMUM",
}
export enum WeightType {
  Percentage = "PERCENTAGE",
  Decimal = "DECIMAL",
  PointsOfRange = "POINTS_OF_RANGE",
  OrderOfImportance = "ORDER_OF_IMPORTANCE",
}
export enum AwardSubCriterionAnswerFormat {
  FreeText = "FREE_TEXT",
  Document = "DOCUMENT",
  Number = "NUMBER",
  YesNoPartial = "YES_NO_PARTIAL",
}
export enum SelectionCriterionType {
  EconomicFinancial = "ECONOMIC_FINANCIAL",
  TechnicalProfessional = "TECHNICAL_PROFESSIONAL",
  Suitability = "SUITABILITY",
  QualityEnvironment = "QUALITY_ENVIRONMENT",
  Other = "OTHER",
}
export enum MinimumRequirementResponseType {
  YesNo = "YES_NO",
  YesNoComment = "YES_NO_COMMENT",
  YesNoDocument = "YES_NO_DOCUMENT",
}
export enum ExtensionDurationUnit {
  Years = "YEARS",
  Months = "MONTHS",
}
export enum FencyContentStatus {
  Empty = "EMPTY",
  Synchronizing = "SYNCHRONIZING",
  Synchronized = "SYNCHRONIZED",
  SynchronizationError = "SYNCHRONIZATION_ERROR",
}
export enum DocumentCategory {
  CompetitionBasis = "COMPETITION_BASIS",
  PriceSheet = "PRICE_SHEET",
  RequirementsSpec = "REQUIREMENTS_SPEC",
  Contract = "CONTRACT",
  Other = "OTHER",
}
export enum OrganizationInviteStatusDto {
  Invited = "INVITED",
  Accepted = "ACCEPTED",
  Declined = "DECLINED",
}
export enum EmailInviteStatusDto {
  Pending = "Pending",
  Sent = "Sent",
  Opened = "Opened",
  SendingFailed = "SendingFailed",
}
export enum Currency {
  Nok = "NOK",
  Usd = "USD",
  Eur = "EUR",
  Dkk = "DKK",
}
export enum ContractNature {
  Works = "WORKS",
  Supplies = "SUPPLIES",
  Services = "SERVICES",
  Combined = "COMBINED",
}
export enum ServiceCategory {
  Ordinary = "ORDINARY",
  SpecialServices = "SPECIAL_SERVICES",
  HealthSocialEducation = "HEALTH_SOCIAL_EDUCATION",
}
export enum ProcedureType {
  Open = "OPEN",
  OpenTenderCompetition = "OPEN_TENDER_COMPETITION",
  Restricted = "RESTRICTED",
  RestrictedTenderCompetition = "RESTRICTED_TENDER_COMPETITION",
  NegotiatedWithPriorCall = "NEGOTIATED_WITH_PRIOR_CALL",
  NegotiatedWithoutPriorCall = "NEGOTIATED_WITHOUT_PRIOR_CALL",
  CompetitiveDialogue = "COMPETITIVE_DIALOGUE",
  InnovationPartnership = "INNOVATION_PARTNERSHIP",
  CompetitiveNegotiation = "COMPETITIVE_NEGOTIATION",
  OtherSingleStage = "OTHER_SINGLE_STAGE",
  DynamicPurchasingSystem = "DYNAMIC_PURCHASING_SYSTEM",
  DpsCompetition = "DPS_COMPETITION",
  QualificationScheme = "QUALIFICATION_SCHEME",
  WithoutCompetition = "WITHOUT_COMPETITION",
  DesignContestOpen = "DESIGN_CONTEST_OPEN",
  DesignContestRestricted = "DESIGN_CONTEST_RESTRICTED",
}
export enum UtilityActivity {
  Airport = "AIRPORT",
  Electricity = "ELECTRICITY",
  GasHeat = "GAS_HEAT",
  GasOil = "GAS_OIL",
  Port = "PORT",
  Post = "POST",
  Rail = "RAIL",
  SolidFuel = "SOLID_FUEL",
  UrbanTransport = "URBAN_TRANSPORT",
  Water = "WATER",
}
export enum FoaPart {
  OutsideFoa = "OUTSIDE_FOA",
  PartI = "PART_I",
  PartIi = "PART_II",
  PartIii = "PART_III",
  PartIv = "PART_IV",
}
export enum FrameworkAgreementType {
  None = "NONE",
  WithReopening = "WITH_REOPENING",
  WithoutReopening = "WITHOUT_REOPENING",
  Mixed = "MIXED",
}
export enum DynamicPurchasingSystemType {
  None = "NONE",
  OnlyListedBuyers = "ONLY_LISTED_BUYERS",
  AlsoUnlistedBuyers = "ALSO_UNLISTED_BUYERS",
}
export enum ReservedParticipationType {
  None = "NONE",
  ShelteredWorkshop = "SHELTERED_WORKSHOP",
  PublicServiceMission = "PUBLIC_SERVICE_MISSION",
}
export enum ReservedExecutionType {
  None = "NONE",
  ShelteredEmployment = "SHELTERED_EMPLOYMENT",
  NotKnown = "NOT_KNOWN",
}
export enum PublicationChannel {
  Doffin = "DOFFIN",
  Ted = "TED",
}
export enum EFormType {
  Cn16 = "CN_16",
  Can29 = "CAN_29",
  Pin7 = "PIN_7",
  Veat25 = "VEAT_25",
  DesignContest23 = "DESIGN_CONTEST_23",
  DesignContestResult36 = "DESIGN_CONTEST_RESULT_36",
  ContractModification38 = "CONTRACT_MODIFICATION_38",
}
export enum PublicationStatus {
  Pending = "PENDING",
  Published = "PUBLISHED",
  Failed = "FAILED",
}
export enum DoffinNoticeStatus {
  Submitted = "SUBMITTED",
  Stopped = "STOPPED",
  Publishing = "PUBLISHING",
  Published = "PUBLISHED",
  Deleted = "DELETED",
  NotPublished = "NOT_PUBLISHED",
  Archived = "ARCHIVED",
  ValidationFailed = "VALIDATION_FAILED",
}
export enum QualificationRoundStatus {
  Open = "OPEN",
  Completed = "COMPLETED",
}
export enum NegotiatedProcedureGround {
  NeedsAdaptationOfAvailableSolutions = "NEEDS_ADAPTATION_OF_AVAILABLE_SOLUTIONS",
  DesignOrInnovation = "DESIGN_OR_INNOVATION",
  NatureComplexityLegalOrFinancialCircumstances = "NATURE_COMPLEXITY_LEGAL_OR_FINANCIAL_CIRCUMSTANCES",
  SpecificationsCannotBeEstablishedPrecisely = "SPECIFICATIONS_CANNOT_BE_ESTABLISHED_PRECISELY",
  OnlyUnacceptableTendersInPriorCompetition = "ONLY_UNACCEPTABLE_TENDERS_IN_PRIOR_COMPETITION",
}
export enum NoCompetitionCondition {
  NegotiatedProcedureImpossible = "NEGOTIATED_PROCEDURE_IMPOSSIBLE",
  UniqueArtisticWork = "UNIQUE_ARTISTIC_WORK",
  TechnicalReasons = "TECHNICAL_REASONS",
  ExclusiveRights = "EXCLUSIVE_RIGHTS",
  AdditionalDeliveries = "ADDITIONAL_DELIVERIES",
  RepetitionOfSimilarWorks = "REPETITION_OF_SIMILAR_WORKS",
  CommodityMarket = "COMMODITY_MARKET",
  BargainPurchase = "BARGAIN_PURCHASE",
  WindingUpTerms = "WINDING_UP_TERMS",
  DesignContestWinner = "DESIGN_CONTEST_WINNER",
}
export enum NegotiationImpossibleCase {
  OnlyUnacceptableTenders = "ONLY_UNACCEPTABLE_TENDERS",
  NoSuitableTenders = "NO_SUITABLE_TENDERS",
  ResearchAndDevelopment = "RESEARCH_AND_DEVELOPMENT",
  DesignContestWinners = "DESIGN_CONTEST_WINNERS",
  ExtremeUrgency = "EXTREME_URGENCY",
  CoverPurchase = "COVER_PURCHASE",
}
export enum WindingUpCase {
  SupplierStoppedTrading = "SUPPLIER_STOPPED_TRADING",
  InsolvencyAdministrator = "INSOLVENCY_ADMINISTRATOR",
}
export enum CompetitionStageDto {
  InterestOpen = "INTEREST_OPEN",
  RequestsOpen = "REQUESTS_OPEN",
  Qualification = "QUALIFICATION",
  Tendering = "TENDERING",
}
export enum WinnerDocumentationRule {
  Foa8102 = "FOA_8_10_2",
  Foa1715 = "FOA_17_1_5",
}
export enum StandstillExemption {
  SoleConcernedSupplier = "SOLE_CONCERNED_SUPPLIER",
  FrameworkAgreementCallOff = "FRAMEWORK_AGREEMENT_CALL_OFF",
}
export enum InjunctionSuspensionRule {
  Foa253 = "FOA_25_3",
  Foa103 = "FOA_10_3",
  Foa3010 = "FOA_30_10",
  Forsyning213 = "FORSYNING_21_3",
  Forsyning269 = "FORSYNING_26_9",
}
export enum InjunctionSuspensionPeriod {
  Standstill = "STANDSTILL",
  IntentionNotice = "INTENTION_NOTICE",
}
export enum ResultNoticeDuty {
  Required = "REQUIRED",
  Voluntary = "VOLUNTARY",
  None = "NONE",
}
export enum NonAwardReason {
  NoTendersReceived = "NO_TENDERS_RECEIVED",
  AllRejected = "ALL_REJECTED",
  OneAdmissible = "ONE_ADMISSIBLE",
  ChangedNeed = "CHANGED_NEED",
  InsufficientFunds = "INSUFFICIENT_FUNDS",
  NoContractSigned = "NO_CONTRACT_SIGNED",
  ReviewBodyDecision = "REVIEW_BODY_DECISION",
  BuyerReview = "BUYER_REVIEW",
  TechnicalOrProceduralError = "TECHNICAL_OR_PROCEDURAL_ERROR",
  Other = "OTHER",
}
export enum EventRevisionState {
  Draft = "Draft",
  PublicationPending = "PublicationPending",
  Published = "Published",
  Failed = "Failed",
  Canceled = "Canceled",
}
export enum ChangeReasonCode {
  UpdateAdd = "UPDATE_ADD",
  CorrectionBuyer = "CORRECTION_BUYER",
}
export enum ChangedArea {
  Title = "TITLE",
  Deadline = "DEADLINE",
  RequestDeadline = "REQUEST_DEADLINE",
  Description = "DESCRIPTION",
  Documents = "DOCUMENTS",
  ReferenceId = "REFERENCE_ID",
  AwardCriteria = "AWARD_CRITERIA",
  MinimumRequirements = "MINIMUM_REQUIREMENTS",
  PriceModel = "PRICE_MODEL",
  ContractTerms = "CONTRACT_TERMS",
  Products = "PRODUCTS",
  DpsValidity = "DPS_VALIDITY",
  Invitations = "INVITATIONS",
  Value = "VALUE",
}
export enum ChangeGovernedTerm {
  SchemeValidity = "SCHEME_VALIDITY",
  RequestDeadline = "REQUEST_DEADLINE",
  BidSubmissionDeadline = "BID_SUBMISSION_DEADLINE",
}
export enum CallOffRefusalDto {
  NotActive = "NotActive",
  TermNotStarted = "TermNotStarted",
  TermEnded = "TermEnded",
}
export enum NoticeRoute {
  National = "NATIONAL",
  Eu = "EU",
}
export enum FieldSourceKind {
  UserAnswer = "USER_ANSWER",
  UploadedDocument = "UPLOADED_DOCUMENT",
  RequirementLibrary = "REQUIREMENT_LIBRARY",
  EarlierProcurement = "EARLIER_PROCUREMENT",
  EarlierContract = "EARLIER_CONTRACT",
  Need = "NEED",
  ProductRules = "PRODUCT_RULES",
  AssistantSuggestion = "ASSISTANT_SUGGESTION",
}
export enum AwardLetterTypeDto {
  Winner = "WINNER",
  Rejection = "REJECTION",
}
export enum AwardLetterStatusDto {
  Draft = "DRAFT",
  Approved = "APPROVED",
  Sent = "SENT",
}
export enum BidInsightStatusDto {
  NotRequested = "NOT_REQUESTED",
  Pending = "PENDING",
  Running = "RUNNING",
  Succeeded = "SUCCEEDED",
  Failed = "FAILED",
}
export enum MinimumRequirementReading {
  SeemsMet = "SEEMS_MET",
  PossibleDeviation = "POSSIBLE_DEVIATION",
  MissingAnswer = "MISSING_ANSWER",
}
export enum AnswerKind {
  CoverLetter = "COVER_LETTER",
  Price = "PRICE",
  Products = "PRODUCTS",
  MinimumRequirement = "MINIMUM_REQUIREMENT",
  Qualification = "QUALIFICATION",
  AwardCriterion = "AWARD_CRITERION",
  Communication = "COMMUNICATION",
}
export enum DocumentReadStatus {
  Read = "READ",
  PartlyRead = "PARTLY_READ",
  NotReadOverLimit = "NOT_READ_OVER_LIMIT",
  UnsupportedFormat = "UNSUPPORTED_FORMAT",
  Unreadable = "UNREADABLE",
}
export enum MissingDocumentFor {
  Qualification = "QUALIFICATION",
  AwardCriterion = "AWARD_CRITERION",
}
export enum SeQuestionKind {
  Question = "QUESTION",
  Clarification = "CLARIFICATION",
}
export enum SeQuestionStatus {
  Unanswered = "UNANSWERED",
  Answered = "ANSWERED",
  Published = "PUBLISHED",
}
export enum SeAttachmentSource {
  Request = "REQUEST",
  Offer = "OFFER",
  Upload = "UPLOAD",
}
export enum ClarificationReplyState {
  Unanswered = "UNANSWERED",
  Answered = "ANSWERED",
  Expired = "EXPIRED",
}
export enum InjunctionAnswer {
  NoneWithinStandstill = "NONE_WITHIN_STANDSTILL",
  NotRefused = "NOT_REFUSED",
  RefusedOrWithdrawn = "REFUSED_OR_WITHDRAWN",
}
export enum EvaluationModelDto {
  Criteria = "CRITERIA",
  Price = "PRICE",
}
export enum AwardMethodDto {
  LowestPrice = "LOWEST_PRICE",
  BestPriceQualityRatio = "BEST_PRICE_QUALITY_RATIO",
}
export enum BidStatus {
  Draft = "DRAFT",
  Submitted = "SUBMITTED",
  Awarded = "AWARDED",
  Rejected = "REJECTED",
}
export enum AwardCriterionAnswerChoice {
  Yes = "YES",
  No = "NO",
  Partial = "PARTIAL",
}
export enum MinimumRequirementOutcome {
  Fulfilled = "FULFILLED",
  NotFulfilled = "NOT_FULFILLED",
  Pending = "PENDING",
}
export enum FrameworkAgreementStatus {
  Active = "Active",
  Terminated = "Terminated",
}
export enum CallOffMechanism {
  DirectAward = "DirectAward",
  MiniCompetition = "MiniCompetition",
  DirectAwardAndMiniCompetition = "DirectAwardAndMiniCompetition",
}
export enum ContractStateDto {
  Draft = "Draft",
  Published = "Published",
}
export enum PanelStatus {
  Active = "Active",
  Suspended = "Suspended",
}
export enum SupplierAdditionRefusalDto {
  FixedByAward = "FixedByAward",
  NotActive = "NotActive",
  PanelFull = "PanelFull",
  NotInPlan = "NotInPlan",
}
export enum NegotiationRoundStatus {
  Draft = "DRAFT",
  Published = "PUBLISHED",
  Completed = "COMPLETED",
}
export enum ParticipationRequestStatus {
  Draft = "DRAFT",
  Submitted = "SUBMITTED",
  Qualified = "QUALIFIED",
  Rejected = "REJECTED",
  Withdrawn = "WITHDRAWN",
  Removed = "REMOVED",
}
export enum BuyerBidEspdAnswerDto {
  Ok = "OK",
  Deviation = "DEVIATION",
  Unanswered = "UNANSWERED",
}
export enum EspdResponseDataType {
  Indicator = "INDICATOR",
  Date = "DATE",
  Description = "DESCRIPTION",
  Amount = "AMOUNT",
  Code = "CODE",
  CodeCountry = "CODE_COUNTRY",
  Percentage = "PERCENTAGE",
  Period = "PERIOD",
  QuantityInteger = "QUANTITY_INTEGER",
  QuantityYear = "QUANTITY_YEAR",
  Quantity = "QUANTITY",
  EvidenceUrl = "EVIDENCE_URL",
}
export enum ExclusionObligation {
  Mandatory = "MANDATORY",
  Voluntary = "VOLUNTARY",
  Conditional = "CONDITIONAL",
}
export enum Populater {
  Buyer = "Buyer",
  Supplier = "Supplier",
}
export enum BidStatusTransitionTypeDto {
  Submitted = "SUBMITTED",
  Withdrawn = "WITHDRAWN",
  Awarded = "AWARDED",
  Rejected = "REJECTED",
  AwardRevoked = "AWARD_REVOKED",
  RejectionRevoked = "REJECTION_REVOKED",
}
export enum ContractStatusDto {
  Awarded = "Awarded",
  Active = "Active",
  Expired = "Expired",
  Terminated = "Terminated",
}
export enum FrameworkRole {
  Standalone = "Standalone",
  FrameworkSupplierContract = "FrameworkSupplierContract",
  CallOff = "CallOff",
}
export enum CommonTemplateType {
  ExpirationDate = "ExpirationDate",
}
export enum ContractPriority {
  VeryLow = "VeryLow",
  BelowAverage = "BelowAverage",
  Average = "Average",
  AboveAverage = "AboveAverage",
  VeryHigh = "VeryHigh",
}
export enum ContractRisk {
  VeryLow = "VeryLow",
  BelowAverage = "BelowAverage",
  Average = "Average",
  AboveAverage = "AboveAverage",
  VeryHigh = "VeryHigh",
}
export enum IfrsAdjustmentType {
  Monetary = "Monetary",
  Percentage = "Percentage",
}
export enum Category {
  A = "A",
  B = "B",
  C = "C",
  D = "D",
  E = "E",
}
export enum ProjectStatus {
  NotStarted = "NotStarted",
  Ongoing = "Ongoing",
  Ended = "Ended",
}
export enum ProjectTypeName {
  BidCalculation = "BidCalculation",
  Other = "Other",
}
export enum SignedDocumentStatus {
  Unsigned = "Unsigned",
  WaitingForAttachments = "WaitingForAttachments",
  PartiallySigned = "PartiallySigned",
  Signed = "Signed",
  Canceled = "Canceled",
  Expired = "Expired",
}
export enum DocumentSignerStatusDto {
  DocumentEmailNotOpened = "DocumentEmailNotOpened",
  DocumentEmailOpened = "DocumentEmailOpened",
  DocumentLinkOpened = "DocumentLinkOpened",
  DocumentRead = "DocumentRead",
  DocumentSigned = "DocumentSigned",
  EmailSendingFailed = "EmailSendingFailed",
}
export enum ContractNotificationTypeDto {
  EndDateReminder = "EndDateReminder",
  RenewalDateReminder = "RenewalDateReminder",
  WarrantyExpirationDateReminder = "WarrantyExpirationDateReminder",
  StartDateReminder = "StartDateReminder",
  TerminationDateReminder = "TerminationDateReminder",
  NoticePeriodReminder = "NoticePeriodReminder",
  OptionExecutionDeadlineReminder = "OptionExecutionDeadlineReminder",
  OptionStartDateReminder = "OptionStartDateReminder",
  NoEndDateReminder = "NoEndDateReminder",
}
export enum ContractNotificationDurationType {
  Days = "Days",
  Months = "Months",
}
export enum QualificationSchemeStartBlock {
  NotPublished = "NOT_PUBLISHED",
  Ended = "ENDED",
  NotYetOpen = "NOT_YET_OPEN",
  Closed = "CLOSED",
  NoAdmittedSuppliers = "NO_ADMITTED_SUPPLIERS",
}
export enum FieldKeys {
  ClassificationConfirmed = "ClassificationConfirmed",
  TitlePresent = "TitlePresent",
  TitleWithinNoticeLimit = "TitleWithinNoticeLimit",
  HomeDepartmentPresent = "HomeDepartmentPresent",
  DescriptionPresent = "DescriptionPresent",
  BidSubmissionDeadlinePresent = "BidSubmissionDeadlinePresent",
  BidSubmissionDeadlineInFuture = "BidSubmissionDeadlineInFuture",
  QuestionDeadlineBetweenAnnouncementAndBidDeadline = "QuestionDeadlineBetweenAnnouncementAndBidDeadline",
  BidSubmissionDeadlinePassed = "BidSubmissionDeadlinePassed",
  BidSubmissionDeadlinePassedUnlessEarlyBidAccess = "BidSubmissionDeadlinePassedUnlessEarlyBidAccess",
  BidSubmissionDeadlineAboveMinimum = "BidSubmissionDeadlineAboveMinimum",
  BidSubmissionDeadlineConfirmed = "BidSubmissionDeadlineConfirmed",
  RequestDeadlinePresent = "RequestDeadlinePresent",
  RequestDeadlineAboveMinimum = "RequestDeadlineAboveMinimum",
  ShortRequestDeadlineJustified = "ShortRequestDeadlineJustified",
  RequestDeadlineConfirmed = "RequestDeadlineConfirmed",
  ProcedureSupportedByProfile = "ProcedureSupportedByProfile",
  ProcedureRequiresEeaTier = "ProcedureRequiresEeaTier",
  TenderCompetitionRequiresPartIi = "TenderCompetitionRequiresPartII",
  CandidateMinimumAboveFloor = "CandidateMinimumAboveFloor",
  CandidateMaximumNotBelowMinimum = "CandidateMaximumNotBelowMinimum",
  CandidateSelectionCriteriaPresent = "CandidateSelectionCriteriaPresent",
  ProcedureJustificationPresent = "ProcedureJustificationPresent",
  DialoguePlanStated = "DialoguePlanStated",
  EstimatedValueBasisPresent = "EstimatedValueBasisPresent",
  AcceleratedProcedureJustified = "AcceleratedProcedureJustified",
  DialogueDescriptionPresent = "DialogueDescriptionPresent",
  DpsUsageSet = "DpsUsageSet",
  DpsValidityPresent = "DpsValidityPresent",
  DpsValidityOrdered = "DpsValidityOrdered",
  DpsFirstIntakeWithinValidity = "DpsFirstIntakeWithinValidity",
  QualificationSchemeValidityPresent = "QualificationSchemeValidityPresent",
  QualificationSchemeRulesPresent = "QualificationSchemeRulesPresent",
  QualificationSchemeValidityOrdered = "QualificationSchemeValidityOrdered",
  WithoutCompetitionAtEeaTier = "WithoutCompetitionAtEeaTier",
  NoCompetitionConditionSet = "NoCompetitionConditionSet",
  NoCompetitionRationalePresent = "NoCompetitionRationalePresent",
  NoCompetitionConditionInRegulation = "NoCompetitionConditionInRegulation",
  NoCompetitionOriginalContractPresent = "NoCompetitionOriginalContractPresent",
  NoCompetitionRepetitionForeseen = "NoCompetitionRepetitionForeseen",
  NoCompetitionNegotiationCaseSet = "NoCompetitionNegotiationCaseSet",
  NoCompetitionWindingUpCaseSet = "NoCompetitionWindingUpCaseSet",
  NegotiationWithoutNoticeAtEeaTier = "NegotiationWithoutNoticeAtEeaTier",
  DesignContestWithinPartV = "DesignContestWithinPartV",
  DesignContestClimateConsiderationStated = "DesignContestClimateConsiderationStated",
  DesignContestFollowUpStated = "DesignContestFollowUpStated",
  DesignContestJuryCriteriaPresent = "DesignContestJuryCriteriaPresent",
  DesignContestJuryPresent = "DesignContestJuryPresent",
  DesignContestJuryIndependent = "DesignContestJuryIndependent",
  DesignContestJuryQualifiedShare = "DesignContestJuryQualifiedShare",
  DesignContestPrizesDescribed = "DesignContestPrizesDescribed",
  NegotiationWithoutNoticeCaseSet = "NegotiationWithoutNoticeCaseSet",
  NegotiationWithoutNoticeRationalePresent = "NegotiationWithoutNoticeRationalePresent",
  NegotiationWithoutNoticePrecedingCompetitionSet = "NegotiationWithoutNoticePrecedingCompetitionSet",
  NegotiationWithoutNoticeBasisUnchanged = "NegotiationWithoutNoticeBasisUnchanged",
  NegotiationWithoutNoticeHasInvitees = "NegotiationWithoutNoticeHasInvitees",
  ProcedureRequiresUtilitiesRegulation = "ProcedureRequiresUtilitiesRegulation",
  PriorInformationCallOffered = "PriorInformationCallOffered",
  PlannedInvitationWithinNoticeWindow = "PlannedInvitationWithinNoticeWindow",
  DpsCompetitionHasMembers = "DpsCompetitionHasMembers",
  QualificationSchemeCompetitionHasInvitees = "QualificationSchemeCompetitionHasInvitees",
  QualificationSchemeOpen = "QualificationSchemeOpen",
  DpsSchemeOpen = "DpsSchemeOpen",
  DpsFirstIntakeComplete = "DpsFirstIntakeComplete",
  AwardCriterionModelSet = "AwardCriterionModelSet",
  AwardCriteriaWeightsValid = "AwardCriteriaWeightsValid",
  AwardSubCriteriaWeightsValid = "AwardSubCriteriaWeightsValid",
  AwardSubCriteriaDescribed = "AwardSubCriteriaDescribed",
  AwardCriteriaDescriptionsPresent = "AwardCriteriaDescriptionsPresent",
  AwardCriteriaPresentWhenIncluded = "AwardCriteriaPresentWhenIncluded",
  MinimumRequirementsPresentWhenIncluded = "MinimumRequirementsPresentWhenIncluded",
  ProductsPresentWhenIncluded = "ProductsPresentWhenIncluded",
  AwardPriceCriterionUnique = "AwardPriceCriterionUnique",
  EnvironmentCriterionWeightingJustified = "EnvironmentCriterionWeightingJustified",
  AtLeastOneInvitation = "AtLeastOneInvitation",
  RegulationSet = "RegulationSet",
  RegulationSupportsPublishing = "RegulationSupportsPublishing",
  ProcedureTypeSet = "ProcedureTypeSet",
  BuyerLegalTypeSet = "BuyerLegalTypeSet",
  UtilityActivitySet = "UtilityActivitySet",
  EstimatedValueSet = "EstimatedValueSet",
  ContractNatureSet = "ContractNatureSet",
  FoaPartSet = "FoaPartSet",
  FoaPartUsesPublicFlow = "FoaPartUsesPublicFlow",
  MainCpvCodeSet = "MainCpvCodeSet",
  MainCpvCodeValid = "MainCpvCodeValid",
  OrganizationCityPresent = "OrganizationCityPresent",
  OrganizationPostCodePresent = "OrganizationPostCodePresent",
  BuyerNutsResolvable = "BuyerNutsResolvable",
  PlaceOfPerformanceNutsResolvable = "PlaceOfPerformanceNutsResolvable",
  SubmissionLanguagesValid = "SubmissionLanguagesValid",
  SelectionCriteriaPresent = "SelectionCriteriaPresent",
  SelectionCriteriaUnique = "SelectionCriteriaUnique",
  EuFundedSet = "EuFundedSet",
  ReservedParticipationSet = "ReservedParticipationSet",
  ReservedExecutionSet = "ReservedExecutionSet",
  FrameworkAgreementSet = "FrameworkAgreementSet",
  FrameworkMaxParticipantsRequiredWhenSet = "FrameworkMaxParticipantsRequiredWhenSet",
  FrameworkMaximumValueValid = "FrameworkMaximumValueValid",
  FrameworkOverFourYearsReasoned = "FrameworkOverFourYearsReasoned",
  PublicationContactPhonePresent = "PublicationContactPhonePresent",
  DynamicPurchasingSystemSet = "DynamicPurchasingSystemSet",
  ElectronicAuctionSet = "ElectronicAuctionSet",
  GpaCoverageSet = "GpaCoverageSet",
  SubmissionElectronicSet = "SubmissionElectronicSet",
  SubmissionLanguagesSet = "SubmissionLanguagesSet",
  ElectronicCatalogueSet = "ElectronicCatalogueSet",
  ElectronicInvoicingSet = "ElectronicInvoicingSet",
  DocumentsRestrictedSet = "DocumentsRestrictedSet",
  ExclusionGroundsSourceSet = "ExclusionGroundsSourceSet",
  SelectionCriteriaSourceSet = "SelectionCriteriaSourceSet",
  TenderValidityMonthsSet = "TenderValidityMonthsSet",
  ContractDurationTypeSet = "ContractDurationTypeSet",
  OpenEndedStartDatePresent = "OpenEndedStartDatePresent",
  ContractStartBeforeEnd = "ContractStartBeforeEnd",
  ContractEndsAfterBidSubmissionDeadline = "ContractEndsAfterBidSubmissionDeadline",
  ContractStartsAfterBidSubmissionDeadline = "ContractStartsAfterBidSubmissionDeadline",
  ExtensionDeadlinesWithinContract = "ExtensionDeadlinesWithinContract",
  ExtensionsPresentWithOptions = "ExtensionsPresentWithOptions",
  MainCpvCodeMatchesReservedParticipation = "MainCpvCodeMatchesReservedParticipation",
  ReservedParticipationDurationWithinThreeYears = "ReservedParticipationDurationWithinThreeYears",
  MainCpvCodeMatchesContractNature = "MainCpvCodeMatchesContractNature",
  HealthSocialServicesNotUnderPartIi = "HealthSocialServicesNotUnderPartII",
  HealthSocialServicesNotUnderPartIii = "HealthSocialServicesNotUnderPartIII",
}
export enum Gate {
  Publish = "PUBLISH",
  CloseSubmissions = "CLOSE_SUBMISSIONS",
  Award = "AWARD",
  ConfirmAward = "CONFIRM_AWARD",
  SignContract = "SIGN_CONTRACT",
}
export enum PublicEventStatusDto {
  Draft = "DRAFT",
  PublicationPending = "PUBLICATION_PENDING",
  Published = "PUBLISHED",
  PublicationFailed = "PUBLICATION_FAILED",
  Evaluation = "EVALUATION",
  Evaluated = "EVALUATED",
  AwardDecision = "AWARD_DECISION",
  Awarded = "AWARDED",
  Cancelled = "CANCELLED",
  Closed = "CLOSED",
  Completed = "COMPLETED",
}
export enum CallOffFollowUpReasonDto {
  AfterEnd = "AfterEnd",
  OverMaxValue = "OverMaxValue",
}
export enum ProductFieldType {
  Text = "Text",
  Number = "Number",
  Boolean = "Boolean",
}
export enum RegulationBucket {
  FoaPartI = "FOA_PART_I",
  FoaPartIi = "FOA_PART_II",
  FoaPartIii = "FOA_PART_III",
  FoaPartIv = "FOA_PART_IV",
  Utilities = "UTILITIES",
  Concessions = "CONCESSIONS",
  OutsideRegulation = "OUTSIDE_REGULATION",
  NotStated = "NOT_STATED",
  NotClassified = "NOT_CLASSIFIED",
  Private = "PRIVATE",
}
export enum SupplierStanding {
  NewBid = "NEW_BID",
  ConfirmedStandingBid = "CONFIRMED_STANDING_BID",
  Declined = "DECLINED",
  NoAnswer = "NO_ANSWER",
  Awaiting = "AWAITING",
  Rejected = "REJECTED",
  Awarded = "AWARDED",
  NotSelected = "NOT_SELECTED",
  Submitted = "SUBMITTED",
  NotDelivered = "NOT_DELIVERED",
}
export enum ContractDatePresetDto {
  ThisYear = "THIS_YEAR",
  Next90Days = "NEXT_90_DAYS",
  NextYear = "NEXT_YEAR",
  Passed = "PASSED",
}
export enum SourcingEventSortField {
  Title = "TITLE",
  ReferenceNumber = "REFERENCE_NUMBER",
  Deadline = "DEADLINE",
  CreatedAt = "CREATED_AT",
  ModifiedAt = "MODIFIED_AT",
  Procedure = "PROCEDURE",
  Regulation = "REGULATION",
  Status = "STATUS",
  Responsible = "RESPONSIBLE",
  ContractType = "CONTRACT_TYPE",
  CreatedBy = "CREATED_BY",
}
export enum SortDirection {
  Asc = "ASC",
  Desc = "DESC",
}
export enum ListedProcedure {
  AnnouncedCompetition = "ANNOUNCED_COMPETITION",
  Open = "OPEN",
  OpenTenderCompetition = "OPEN_TENDER_COMPETITION",
  Restricted = "RESTRICTED",
  RestrictedTenderCompetition = "RESTRICTED_TENDER_COMPETITION",
  NegotiatedWithPriorCall = "NEGOTIATED_WITH_PRIOR_CALL",
  NegotiatedWithoutPriorCall = "NEGOTIATED_WITHOUT_PRIOR_CALL",
  CompetitiveDialogue = "COMPETITIVE_DIALOGUE",
  InnovationPartnership = "INNOVATION_PARTNERSHIP",
  CompetitiveNegotiation = "COMPETITIVE_NEGOTIATION",
  OtherSingleStage = "OTHER_SINGLE_STAGE",
  DynamicPurchasingSystem = "DYNAMIC_PURCHASING_SYSTEM",
  DpsCompetition = "DPS_COMPETITION",
  QualificationScheme = "QUALIFICATION_SCHEME",
  WithoutCompetition = "WITHOUT_COMPETITION",
  DesignContestOpen = "DESIGN_CONTEST_OPEN",
  DesignContestRestricted = "DESIGN_CONTEST_RESTRICTED",
}
export enum ListExportFormat {
  Xlsx = "XLSX",
  Csv = "CSV",
  Pdf = "PDF",
}
export enum ProcurementOverviewFigure {
  Published = "PUBLISHED",
  Awarded = "AWARDED",
  MedianCycleDays = "MEDIAN_CYCLE_DAYS",
  AverageBids = "AVERAGE_BIDS",
  OneBidShare = "ONE_BID_SHARE",
  NoBids = "NO_BIDS",
}
export enum CyclePhase {
  Bidding = "BIDDING",
  Evaluation = "EVALUATION",
  Award = "AWARD",
  Contract = "CONTRACT",
}
export enum ClimateWeightingGroup {
  Weighted = "WEIGHTED",
  SpecificationInstead = "SPECIFICATION_INSTEAD",
  Exemption = "EXEMPTION",
  MissingJustification = "MISSING_JUSTIFICATION",
}
export enum ProcurementPhaseDto {
  InProgress = "IN_PROGRESS",
  Announced = "ANNOUNCED",
  Evaluation = "EVALUATION",
  Award = "AWARD",
  Completed = "COMPLETED",
  Cancelled = "CANCELLED",
}
export enum DeadlineSubject {
  SourcingEventV2 = "SOURCING_EVENT_V2",
  Contract = "CONTRACT",
  ContractTask = "CONTRACT_TASK",
}
export enum DeadlineKind {
  BidSubmission = "BID_SUBMISSION",
  QuestionDeadline = "QUESTION_DEADLINE",
  ContractTask = "CONTRACT_TASK",
  RequestToParticipate = "REQUEST_TO_PARTICIPATE",
  NegotiationRound = "NEGOTIATION_ROUND",
  StandstillExpiry = "STANDSTILL_EXPIRY",
  ContractStart = "CONTRACT_START",
  ContractEnd = "CONTRACT_END",
  ContractRenewal = "CONTRACT_RENEWAL",
  ContractTermination = "CONTRACT_TERMINATION",
  ContractNoticeDeadline = "CONTRACT_NOTICE_DEADLINE",
  ContractWarrantyExpiration = "CONTRACT_WARRANTY_EXPIRATION",
  ContractOptionDeadline = "CONTRACT_OPTION_DEADLINE",
  ContractOptionStart = "CONTRACT_OPTION_START",
}
export enum ContractReportSortColumn {
  Id = "ID",
  Title = "TITLE",
  TemplateName = "TEMPLATE_NAME",
  CreatedAt = "CREATED_AT",
  ModifiedAt = "MODIFIED_AT",
  OwningOrganizationName = "OWNING_ORGANIZATION_NAME",
  InternalOwnerName = "INTERNAL_OWNER_NAME",
  CounterpartyName = "COUNTERPARTY_NAME",
  CounterpartyContactFullName = "COUNTERPARTY_CONTACT_FULL_NAME",
  CounterpartyContactEmail = "COUNTERPARTY_CONTACT_EMAIL",
  CounterpartyContactPhoneNumber = "COUNTERPARTY_CONTACT_PHONE_NUMBER",
  Status = "STATUS",
  State = "STATE",
  StartDate = "START_DATE",
  EndDate = "END_DATE",
  TotalPrice = "TOTAL_PRICE",
  EstimatedValue = "ESTIMATED_VALUE",
  Priority = "PRIORITY",
  Risk = "RISK",
  RenewalDate = "RENEWAL_DATE",
  PublishedAt = "PUBLISHED_AT",
  SupplierCategory = "SUPPLIER_CATEGORY",
  ReferenceNumber = "REFERENCE_NUMBER",
  Description = "DESCRIPTION",
  Currency = "CURRENCY",
  OriginSourcingEventName = "ORIGIN_SOURCING_EVENT_NAME",
  PublishedByName = "PUBLISHED_BY_NAME",
  TerminatedByName = "TERMINATED_BY_NAME",
  TerminationReason = "TERMINATION_REASON",
  WarrantyExpirationDate = "WARRANTY_EXPIRATION_DATE",
  NoticePeriod = "NOTICE_PERIOD",
  PaymentTermsInDays = "PAYMENT_TERMS_IN_DAYS",
  PricePerMonth = "PRICE_PER_MONTH",
  PricePerYear = "PRICE_PER_YEAR",
  TotalLiability = "TOTAL_LIABILITY",
  ExternalLink = "EXTERNAL_LINK",
  PurchasingPolicy = "PURCHASING_POLICY",
  FrameworkRole = "FRAMEWORK_ROLE",
  HasNoEndDate = "HAS_NO_END_DATE",
  Version = "VERSION",
  Timezone = "TIMEZONE",
  CreatedByName = "CREATED_BY_NAME",
  DocumentCount = "DOCUMENT_COUNT",
  SignedDocumentCount = "SIGNED_DOCUMENT_COUNT",
  TerminationDate = "TERMINATION_DATE",
  AnnualValue = "ANNUAL_VALUE",
  OptionCount = "OPTION_COUNT",
}
export enum ContractReportOptionParameter {
  ProjectName = "PROJECT_NAME",
  ProjectId = "PROJECT_ID",
  InternalPartyName = "INTERNAL_PARTY_NAME",
  InternalPartyId = "INTERNAL_PARTY_ID",
  LinkedContractTitle = "LINKED_CONTRACT_TITLE",
  LinkedContractId = "LINKED_CONTRACT_ID",
  TemplateName = "TEMPLATE_NAME",
  TemplateId = "TEMPLATE_ID",
  OwningOrganizationName = "OWNING_ORGANIZATION_NAME",
  OwningOrganizationId = "OWNING_ORGANIZATION_ID",
  InternalOwnerName = "INTERNAL_OWNER_NAME",
  InternalOwnerId = "INTERNAL_OWNER_ID",
  CounterpartyName = "COUNTERPARTY_NAME",
  CounterpartyId = "COUNTERPARTY_ID",
  CounterpartyContactFullName = "COUNTERPARTY_CONTACT_FULL_NAME",
  CounterpartyContactEmail = "COUNTERPARTY_CONTACT_EMAIL",
  CounterpartyContactPhoneNumber = "COUNTERPARTY_CONTACT_PHONE_NUMBER",
  Status = "STATUS",
  Risk = "RISK",
  Priority = "PRIORITY",
  SupplierCategory = "SUPPLIER_CATEGORY",
  ReferenceNumber = "REFERENCE_NUMBER",
  Description = "DESCRIPTION",
  Currency = "CURRENCY",
  OriginSourcingEventName = "ORIGIN_SOURCING_EVENT_NAME",
  OriginSourcingEventId = "ORIGIN_SOURCING_EVENT_ID",
  PublishedByName = "PUBLISHED_BY_NAME",
  PublishedById = "PUBLISHED_BY_ID",
  TerminatedByName = "TERMINATED_BY_NAME",
  TerminatedById = "TERMINATED_BY_ID",
  TerminationReason = "TERMINATION_REASON",
  StartDate = "START_DATE",
  EndDate = "END_DATE",
  CreatedAt = "CREATED_AT",
  ModifiedAt = "MODIFIED_AT",
  PublishedAt = "PUBLISHED_AT",
  RenewalDate = "RENEWAL_DATE",
  TerminationDate = "TERMINATION_DATE",
  WarrantyExpirationDate = "WARRANTY_EXPIRATION_DATE",
  NoticePeriod = "NOTICE_PERIOD",
  PaymentTermsInDays = "PAYMENT_TERMS_IN_DAYS",
  PricePerMonth = "PRICE_PER_MONTH",
  PricePerYear = "PRICE_PER_YEAR",
  TotalLiability = "TOTAL_LIABILITY",
  ExternalLink = "EXTERNAL_LINK",
  PurchasingPolicy = "PURCHASING_POLICY",
  DocumentId = "DOCUMENT_ID",
  SignedDocumentId = "SIGNED_DOCUMENT_ID",
  IndustryId = "INDUSTRY_ID",
  IsClimateCommitted = "IS_CLIMATE_COMMITTED",
  HasSignedCodeOfConduct = "HAS_SIGNED_CODE_OF_CONDUCT",
  HasCustomerContact = "HAS_CUSTOMER_CONTACT",
  OptionName = "OPTION_NAME",
}
export enum ContractOverviewFigure {
  Active = "ACTIVE",
  AnnualValue = "ANNUAL_VALUE",
  SignedLast30Days = "SIGNED_LAST_30_DAYS",
  AwaitingSignature = "AWAITING_SIGNATURE",
  ExpiringWithin90Days = "EXPIRING_WITHIN_90_DAYS",
  OptionDeadlineWithin90Days = "OPTION_DEADLINE_WITHIN_90_DAYS",
  WithoutActiveOwner = "WITHOUT_ACTIVE_OWNER",
}
export enum SavingsList {
  BelowEstimate = "BELOW_ESTIMATE",
  Negotiation = "NEGOTIATION",
  AboveEstimate = "ABOVE_ESTIMATE",
  WithoutSaving = "WITHOUT_SAVING",
  WithoutBaseline = "WITHOUT_BASELINE",
}
export enum SavingsMeasure {
  EstimatedValue = "ESTIMATED_VALUE",
  FirstBid = "FIRST_BID",
}
export enum WithoutSavingReason {
  AboveEstimate = "ABOVE_ESTIMATE",
  AtEstimate = "AT_ESTIMATE",
  UnchangedInNegotiation = "UNCHANGED_IN_NEGOTIATION",
  AboveFirstBid = "ABOVE_FIRST_BID",
}
export enum MissingBaseline {
  NoProcurement = "NO_PROCUREMENT",
  ProcurementNotVisible = "PROCUREMENT_NOT_VISIBLE",
  NotAwarded = "NOT_AWARDED",
  NoEstimatedValue = "NO_ESTIMATED_VALUE",
  NoAwardValue = "NO_AWARD_VALUE",
  NegativeAwardValue = "NEGATIVE_AWARD_VALUE",
  OtherCurrency = "OTHER_CURRENCY",
}
export enum ContractTaskStatus {
  Open = "Open",
  Completed = "Completed",
}
export enum ContractTaskStatusDto {
  Open = "Open",
  Completed = "Completed",
  Overdue = "Overdue",
}
export enum ContractTaskResponsiblePartyDto {
  Organization = "Organization",
  PersonInOrganization = "PersonInOrganization",
}
export enum ContractTaskChangeType {
  Description = "Description",
  DueDate = "DueDate",
  ResponsibleParty = "ResponsibleParty",
  Status = "Status",
  Title = "Title",
}
export enum ContractMessageSide {
  Owner = "Owner",
  Counterparty = "Counterparty",
}
export enum ContractRoleType {
  Editor = "Editor",
  Viewer = "Viewer",
  Counterparty = "Counterparty",
}
export enum ContributingEntityStatus {
  NotSent = "NOT_SENT",
  InvitationSent = "INVITATION_SENT",
  InvitationAccepted = "INVITATION_ACCEPTED",
  InvitationDeclined = "INVITATION_DECLINED",
  ResponseSubmitted = "RESPONSE_SUBMITTED",
  ResponseNotApproved = "RESPONSE_NOT_APPROVED",
  ResponseValidated = "RESPONSE_VALIDATED",
}
export enum ContributingEntityRole {
  ConsortiumMember = "CONSORTIUM_MEMBER",
  CapacityProvider = "CAPACITY_PROVIDER",
  Subcontractor = "SUBCONTRACTOR",
}
export enum ContributingEntityValidationIssueDto {
  EntityInfoIncomplete = "ENTITY_INFO_INCOMPLETE",
  ExclusionGroundsIncomplete = "EXCLUSION_GROUNDS_INCOMPLETE",
  QualificationAnswerMissing = "QUALIFICATION_ANSWER_MISSING",
  CommitmentMissing = "COMMITMENT_MISSING",
  ExclusionGroundApplies = "EXCLUSION_GROUND_APPLIES",
  FinalDeclarationMissing = "FINAL_DECLARATION_MISSING",
  ResponseNotSubmitted = "RESPONSE_NOT_SUBMITTED",
}
export enum SupplierDeclarationField {
  GroupRole = "GROUP_ROLE",
  GroupName = "GROUP_NAME",
  ParticipantList = "PARTICIPANT_LIST",
}
export enum SkippableGateDto {
  RequestDeadline = "REQUEST_DEADLINE",
  DpsSchemeStart = "DPS_SCHEME_START",
  BidSubmissionDeadline = "BID_SUBMISSION_DEADLINE",
  NegotiationRoundDeadline = "NEGOTIATION_ROUND_DEADLINE",
  Standstill = "STANDSTILL",
}
export enum DocumentChatPurpose {
  Reading = "READING",
  Creating = "CREATING",
}
export enum EconomicOperatorSize {
  Micro = "MICRO",
  Small = "SMALL",
  Medium = "MEDIUM",
  Large = "LARGE",
}
export enum WithheldNoticeField {
  ContractValue = "CONTRACT_VALUE",
  ReceivedTenders = "RECEIVED_TENDERS",
}
export enum NonPublicationReason {
  LawEnforcement = "LAW_ENFORCEMENT",
  PublicInterest = "PUBLIC_INTEREST",
  CommercialInterests = "COMMERCIAL_INTERESTS",
  FairCompetition = "FAIR_COMPETITION",
}
export enum ContractModificationGround {
  AdditionalDeliveries = "ADDITIONAL_DELIVERIES",
  UnforeseenCircumstances = "UNFORESEEN_CIRCUMSTANCES",
}
export enum LibraryElementTypeDto {
  Minimum = "MINIMUM",
  Selection = "SELECTION",
  Award = "AWARD",
  AwardSubCriterion = "AWARD_SUB_CRITERION",
}
export enum MarketDialogueStatus {
  Draft = "DRAFT",
  PublicationPending = "PUBLICATION_PENDING",
  Published = "PUBLISHED",
  PublicationFailed = "PUBLICATION_FAILED",
  AnswerDeadlinePassed = "ANSWER_DEADLINE_PASSED",
}
export enum MarketDialogueReach {
  Doffin = "DOFFIN",
  Invitation = "INVITATION",
}
export enum MarketDialogueAnswerType {
  FreeText = "FREE_TEXT",
  YesNoComment = "YES_NO_COMMENT",
  Document = "DOCUMENT",
}
export enum CommentSubjectKind {
  MinimumRequirement = "MINIMUM_REQUIREMENT",
  QualificationRequirement = "QUALIFICATION_REQUIREMENT",
  AwardCriterion = "AWARD_CRITERION",
  PriceForm = "PRICE_FORM",
  Document = "DOCUMENT",
}
export enum MarketDialogueBlocker {
  TitleMissing = "TITLE_MISSING",
  DescriptionMissing = "DESCRIPTION_MISSING",
  QuestionsMissing = "QUESTIONS_MISSING",
  AnswerDeadlineMissing = "ANSWER_DEADLINE_MISSING",
  AnswerDeadlinePassed = "ANSWER_DEADLINE_PASSED",
  ExpectedContractNoticeDateMissing = "EXPECTED_CONTRACT_NOTICE_DATE_MISSING",
  ExpectedContractNoticeDateNotInFuture = "EXPECTED_CONTRACT_NOTICE_DATE_NOT_IN_FUTURE",
  RegulationMissing = "REGULATION_MISSING",
  ContractNatureMissing = "CONTRACT_NATURE_MISSING",
  ServiceCategoryMissing = "SERVICE_CATEGORY_MISSING",
  EstimatedValueMissing = "ESTIMATED_VALUE_MISSING",
  CpvCodeMissing = "CPV_CODE_MISSING",
  UtilityActivityMissing = "UTILITY_ACTIVITY_MISSING",
  BuyerLegalTypeMissing = "BUYER_LEGAL_TYPE_MISSING",
  BuyerLegalTypeTooGeneral = "BUYER_LEGAL_TYPE_TOO_GENERAL",
  OutsideMarketDialogueScope = "OUTSIDE_MARKET_DIALOGUE_SCOPE",
  BuyerOrganizationNumberMissing = "BUYER_ORGANIZATION_NUMBER_MISSING",
  BuyerPostCodeMissing = "BUYER_POST_CODE_MISSING",
  ContactPhoneMissing = "CONTACT_PHONE_MISSING",
  InvitationsMissing = "INVITATIONS_MISSING",
}
export enum SharedItemKind {
  Notice = "NOTICE",
  Document = "DOCUMENT",
  Answer = "ANSWER",
}
export enum ReplyReach {
  Asker = "ASKER",
  AllParticipants = "ALL_PARTICIPANTS",
}
export enum NotificationTypeDto {
  ContractTaskCommentAdded = "ContractTaskCommentAdded",
  ContractTaskDelegated = "ContractTaskDelegated",
  ContractTaskDeleted = "ContractTaskDeleted",
  ContractTaskDueDateUpdated = "ContractTaskDueDateUpdated",
  ContractTaskStatusUpdated = "ContractTaskStatusUpdated",
  ContractTaskDueDateReminder = "ContractTaskDueDateReminder",
  ContractSharedWithOrg = "ContractSharedWithOrg",
  CallOffCompletedByOutsideOrg = "CallOffCompletedByOutsideOrg",
  ContractSharedWithDepartment = "ContractSharedWithDepartment",
  ContractSharedWithPerson = "ContractSharedWithPerson",
  ContractDocumentCompletedSigning = "ContractDocumentCompletedSigning",
  ContractMessageReceived = "ContractMessageReceived",
  ContractSignatureDeadlineExpired = "ContractSignatureDeadlineExpired",
  ContractDateReminder = "ContractDateReminder",
  SeV2NewQuestion = "SeV2NewQuestion",
  SeV2QuestionAnswered = "SeV2QuestionAnswered",
  SeV2ClarificationMessageToSupplier = "SeV2ClarificationMessageToSupplier",
  SeV2ClarificationMessageToBuyer = "SeV2ClarificationMessageToBuyer",
  SeV2ClarificationReplyDeadlineReminder = "SeV2ClarificationReplyDeadlineReminder",
  SeV2InformationPublished = "SeV2InformationPublished",
  SeV2AwardLetterDispatched = "SeV2AwardLetterDispatched",
  SeV2AwardDecided = "SeV2AwardDecided",
  SeV2BidRejected = "SeV2BidRejected",
  SeV2InvitedToTender = "SeV2InvitedToTender",
  SeV2InvitedToConfirmInterest = "SeV2InvitedToConfirmInterest",
  SeV2OrganizationInvite = "SeV2OrganizationInvite",
  SeV2RequestNotQualified = "SeV2RequestNotQualified",
  SeV2RequestNotSelected = "SeV2RequestNotSelected",
  SeV2DpsAdmitted = "SeV2DpsAdmitted",
  SeV2QualificationSchemeAdmitted = "SeV2QualificationSchemeAdmitted",
  SeV2QualificationSchemeRemoved = "SeV2QualificationSchemeRemoved",
  SeV2QualificationSchemeRemovalWithdrawn = "SeV2QualificationSchemeRemovalWithdrawn",
  SeV2DpsRemoved = "SeV2DpsRemoved",
  SeV2AwardDecisionRevoked = "SeV2AwardDecisionRevoked",
  SeV2BidRejectionRevoked = "SeV2BidRejectionRevoked",
  SeV2BidDeadlineReminder = "SeV2BidDeadlineReminder",
  SeV2ResultNoticeDeadlineReminder = "SeV2ResultNoticeDeadlineReminder",
  SeV2ResponsibleBuyerChanged = "SeV2ResponsibleBuyerChanged",
  SeV2JuryConfirmationRequested = "SeV2JuryConfirmationRequested",
  SeV2EventChanged = "SeV2EventChanged",
  SeV2EventCancelled = "SeV2EventCancelled",
  SeV2BidDelivered = "SeV2BidDelivered",
  SeV2RoundPublished = "SeV2RoundPublished",
  SeV2MiniCompetitionInvite = "SeV2MiniCompetitionInvite",
  FrameworkPanelJoined = "FrameworkPanelJoined",
  FrameworkPanelStatusChanged = "FrameworkPanelStatusChanged",
  FrameworkValueReminder = "FrameworkValueReminder",
  SeV2EventClosed = "SeV2EventClosed",
  SeV2DoffinPublished = "SeV2DoffinPublished",
  SeV2DoffinPublicationFailed = "SeV2DoffinPublicationFailed",
  OrganizationMerge = "OrganizationMerge",
  NeedReported = "NeedReported",
  NeedStatusChanged = "NeedStatusChanged",
}
export enum SeBidDeliveryKind {
  First = "FIRST",
  Revised = "REVISED",
  Round = "ROUND",
}
export enum ReceiverRoleDto {
  Supplier = "Supplier",
  Buyer = "Buyer",
}
export enum ContractDateReminderType {
  EndDateReminder = "EndDateReminder",
  WarrantyExpirationDateReminder = "WarrantyExpirationDateReminder",
  RenewalDateReminder = "RenewalDateReminder",
  StartDateReminder = "StartDateReminder",
  TerminationDateReminder = "TerminationDateReminder",
  NoticePeriodReminder = "NoticePeriodReminder",
  OptionExecutionDeadlineReminder = "OptionExecutionDeadlineReminder",
  OptionStartDateReminder = "OptionStartDateReminder",
  NoEndDateReminder = "NoEndDateReminder",
}
export enum OrganizationMergeRequestStatus {
  Pending = "Pending",
  Merged = "Merged",
  Declined = "Declined",
  Expired = "Expired",
  Cancelled = "Cancelled",
}
export enum NeedStatus {
  Draft = "DRAFT",
  Reported = "REPORTED",
  SentBack = "SENT_BACK",
  Approved = "APPROVED",
  Planned = "PLANNED",
  FrameworkRecommended = "FRAMEWORK_RECOMMENDED",
  ProcurementCreated = "PROCUREMENT_CREATED",
  UnderProcurement = "UNDER_PROCUREMENT",
  UnderCallOff = "UNDER_CALL_OFF",
  Completed = "COMPLETED",
  Rejected = "REJECTED",
  Withdrawn = "WITHDRAWN",
}
export enum EmailInviteTypeDto {
  Supplier = "Supplier",
  SourcingEvent = "SourcingEvent",
  OrgUser = "OrgUser",
  ContributingEntity = "ContributingEntity",
  MarketDialogue = "MarketDialogue",
}
export enum DeadlineSubjects {
  All = "ALL",
  Contracts = "CONTRACTS",
  SourcingEvents = "SOURCING_EVENTS",
}
export enum NeedRecurrence {
  OneOff = "ONE_OFF",
  Ongoing = "ONGOING",
}
export enum NeedPriority {
  High = "HIGH",
  Medium = "MEDIUM",
  Low = "LOW",
}
export enum NeedWaitingListDto {
  Queue = "Queue",
  Mine = "Mine",
}
export enum NeedFigureListDto {
  Reported = "REPORTED",
  MedianQueueDays = "MEDIAN_QUEUE_DAYS",
  WithProcurerNothingStarted = "WITH_PROCURER_NOTHING_STARTED",
  DeliverySoon = "DELIVERY_SOON",
  BecameProcurement = "BECAME_PROCUREMENT",
}
export enum NeedOverviewFigure {
  Reported = "REPORTED",
  InQueue = "IN_QUEUE",
  MedianQueueDays = "MEDIAN_QUEUE_DAYS",
  WithProcurerNothingStarted = "WITH_PROCURER_NOTHING_STARTED",
  DeliverySoon = "DELIVERY_SOON",
  BecameProcurement = "BECAME_PROCUREMENT",
}
export enum OrgUserInviteRole {
  Admin = "Admin",
  SourcingCreator = "SourcingCreator",
  SourcingViewer = "SourcingViewer",
  ContractCreator = "ContractCreator",
  ContractViewer = "ContractViewer",
  ProjectViewer = "ProjectViewer",
  ProjectCreator = "ProjectCreator",
}
export enum AccessScopeDto {
  Organization = "Organization",
  Department = "Department",
  Event = "Event",
  Contract = "Contract",
}
export enum AccessGrantSourceDto {
  Manual = "Manual",
  Entra = "Entra",
  Share = "Share",
}
export enum AuditLogActorKind {
  Person = "Person",
  SourceMagnetSupport = "SourceMagnetSupport",
  ApiKey = "ApiKey",
  EntraConnection = "EntraConnection",
  System = "System",
}
export enum MergeRequestDirection {
  Outgoing = "Outgoing",
  Incoming = "Incoming",
}
export enum EntraConnectionStatus {
  Active = "Active",
  Disabled = "Disabled",
}
export enum EntraDefaultRoleScope {
  Organization = "Organization",
  DefaultDepartment = "DefaultDepartment",
}
export enum ContractTaskSortDto {
  DueDate = "DueDate",
  RecentlyChanged = "RecentlyChanged",
}
export enum ContractOwnerContextType {
  Common = "Common",
  OrganizationOwner = "OrganizationOwner",
}
export enum DocumentSignerMethod {
  NoBankId = "NoBankId",
  Handwritten = "Handwritten",
}
export enum PersonSearchCapability {
  ManageSourcingEvent = "ManageSourcingEvent",
  ViewSourcingEvent = "ViewSourcingEvent",
  ViewProject = "ViewProject",
  ManageProject = "ManageProject",
}
export enum PreviousSigningOutcome {
  Canceled = "Canceled",
  Expired = "Expired",
  Failed = "Failed",
}
export enum CancelBidSigningOutcome {
  Canceled = "Canceled",
  CompletedInstead = "CompletedInstead",
}
export enum PreflightRequirementDto {
  NotDraft = "NOT_DRAFT",
  SigningInProgress = "SIGNING_IN_PROGRESS",
  DeadlinePassed = "DEADLINE_PASSED",
  SupplierInfoIncomplete = "SUPPLIER_INFO_INCOMPLETE",
  EspdResponseIncomplete = "ESPD_RESPONSE_INCOMPLETE",
  QualificationResponseIncomplete = "QUALIFICATION_RESPONSE_INCOMPLETE",
  MinimumRequirementResponseIncomplete = "MINIMUM_REQUIREMENT_RESPONSE_INCOMPLETE",
  EspdFinalDeclarationIncomplete = "ESPD_FINAL_DECLARATION_INCOMPLETE",
  ContributingEntityMissing = "CONTRIBUTING_ENTITY_MISSING",
  UnsupportedSeparateEspdRequired = "UNSUPPORTED_SEPARATE_ESPD_REQUIRED",
  TermsNotAccepted = "TERMS_NOT_ACCEPTED",
  PriceNotInTenderCurrency = "PRICE_NOT_IN_TENDER_CURRENCY",
}
export enum PreflightWarningDto {
  PriceMissing = "PRICE_MISSING",
  ProductPricesIncomplete = "PRODUCT_PRICES_INCOMPLETE",
  AwardCriteriaIncomplete = "AWARD_CRITERIA_INCOMPLETE",
  ContributingEntityNotValidated = "CONTRIBUTING_ENTITY_NOT_VALIDATED",
}
export enum PortalLifecycleStatus {
  Open = "OPEN",
  DeadlinePassed = "DEADLINE_PASSED",
  UnderEvaluation = "UNDER_EVALUATION",
  Awarded = "AWARDED",
  Cancelled = "CANCELLED",
  Concluded = "CONCLUDED",
}
export enum PortalEventContextType {
  Public = "PUBLIC",
  Private = "PRIVATE",
  MiniCompetition = "MINI_COMPETITION",
}
export enum PortalInviteStatusDto {
  NotInvited = "NOT_INVITED",
  Invited = "INVITED",
  Accepted = "ACCEPTED",
  Declined = "DECLINED",
}
export enum PortalAwardModel {
  LowestPrice = "LOWEST_PRICE",
  BestPriceQualityRatio = "BEST_PRICE_QUALITY_RATIO",
}
export enum PortalPriceModelType {
  Proportional = "PROPORTIONAL",
  Linear = "LINEAR",
  Hybrid = "HYBRID",
}
export enum PortalAwardOutcomeDto {
  Winner = "WINNER",
  NotSelected = "NOT_SELECTED",
  Rejected = "REJECTED",
  Withdrawn = "WITHDRAWN",
}
export enum PortalEventScope {
  All = "ALL",
  ActiveInvitations = "ACTIVE_INVITATIONS",
  InvitationsIncludingExpired = "INVITATIONS_INCLUDING_EXPIRED",
}
export enum MarketDialogueAnswerStatus {
  Draft = "DRAFT",
  Sent = "SENT",
  ChangedSinceSent = "CHANGED_SINCE_SENT",
}
export enum ProjectOverviewScope {
  Ongoing = "ONGOING",
  NotStarted = "NOT_STARTED",
  All = "ALL",
}
export enum SavedReportListDto {
  Contracts = "CONTRACTS",
  Procurements = "PROCUREMENTS",
  ContractTasks = "CONTRACT_TASKS",
}
export enum SavedReportKindDto {
  Firm = "FIRM",
  Own = "OWN",
  Shared = "SHARED",
}
export enum SavedReportSystemKeyDto {
  ActiveContracts = "ACTIVE_CONTRACTS",
  AwardedContracts = "AWARDED_CONTRACTS",
  ExpiredContracts = "EXPIRED_CONTRACTS",
  ExpiringThisYear = "EXPIRING_THIS_YEAR",
  TerminatedContracts = "TERMINATED_CONTRACTS",
}
export enum PatchOperationType {
  Replace = "Replace",
  Add = "Add",
  Remove = "Remove",
}
export enum SchemaAttributeType {
  String = "string",
  Boolean = "boolean",
  Complex = "complex",
  Reference = "reference",
}
export enum SchemaAttributeMutability {
  ReadWrite = "readWrite",
  ReadOnly = "readOnly",
  Immutable = "immutable",
}
export enum SchemaAttributeUniqueness {
  None = "none",
  Server = "server",
}
export enum ScimResourceType {
  User = "User",
  Group = "Group",
}
export enum SupplierRelationDto {
  ActiveContract = "ActiveContract",
  EarlierContract = "EarlierContract",
  InvitedBefore = "InvitedBefore",
  DeliveredBid = "DeliveredBid",
  Won = "Won",
}
export enum ContractFieldFilterKindDto {
  SingleChoice = "SingleChoice",
  MultipleChoice = "MultipleChoice",
  YesNo = "YesNo",
  Number = "Number",
  Amount = "Amount",
  Percentage = "Percentage",
  Date = "Date",
}
export enum SendForCommentRefusalReason {
  NotDraft = "NotDraft",
  NotPermitted = "NotPermitted",
  RoundInPreparation = "RoundInPreparation",
  RoundOpen = "RoundOpen",
}
export const {
  useAdminListAllEntitiesQuery,
  useAdminMigrateFencyDocumentsMutation,
  useAdminRestampFencyAccessMutation,
  useAdminMigrateFencyContractMetadataMutation,
  useAdminGetFencyMigrationStatsQuery,
  useAdminListOrganizationsQuery,
  useAdminUpdateOrganizationMutation,
  useAdminGetOrganizationAiUsageQuery,
  useAdminChangeOrganizationOwnerMutation,
  useSendAiChatMessageMutation,
  useCreateAiCompletionMutation,
  useRecordAiSuggestionInsertedMutation,
  useCreateAssessmentTemplateMutation,
  useGetAssessmentTemplateQuery,
  useCreateAssessmentMutation,
  useGetAssessmentQuery,
  useGetBaseDataQuery,
  useGetTypesQuery,
  useRecordAgentAuditEntryMutation,
  useReadConversationFileQuery,
  useCreateConversationFileUploadMutation,
  useGetConversationFileStatusQuery,
  useListAgentConversationsQuery,
  useCreateAgentConversationMutation,
  useDeleteAgentConversationMutation,
  useGetAgentConversationQuery,
  useUpdateAgentConversationMutation,
  useCreateAgentDocumentSearchSessionMutation,
  useResolveAgentDocumentSourcesMutation,
  useReadDocumentTextQuery,
  useGetAgentModelsQuery,
  usePlanAgentTurnMutation,
  useRemoveContactPersonMutation,
  useListContactPersonsQuery,
  useAddContactPersonMutation,
  useEditContactPersonMutation,
  useGetExclusionGroundsTaxonomyQuery,
  useCreateSourcingEventMutation,
  useDeleteSourcingEventMutation,
  useGetSourcingEventQuery,
  useUpdateSourcingEventMutation,
  useCreateUploadForSeAnnouncementAttachmentMutation,
  useGetBuyerSeAttachmentUploadQuery,
  useAwardSourcingEventMutation,
  useGetAwardLettersQuery,
  useDispatchAwardLettersMutation,
  useUpdateAwardLetterMutation,
  useApproveAwardLetterMutation,
  useReopenAwardLetterMutation,
  useAwardWithoutCompetitionMutation,
  useRecordWinnerDocumentationCheckedMutation,
  useBeginEvaluationMutation,
  useGetBidInsightQuery,
  useRequestBidInsightMutation,
  useCancelSourcingEventMutation,
  useGetCancellationScopeQuery,
  useCreateEventChangeMutation,
  useUpdateEventChangeMutation,
  useCancelEventChangeMutation,
  useSubmitEventChangeMutation,
  useStartSeClarificationMutation,
  useCloseSourcingEventMutation,
  useCompleteSourcingEventMutation,
  useConfirmAwardMutation,
  useConfirmSourcingEventClassificationMutation,
  useRecordContractConcludedMutation,
  useCopySourcingEventMutation,
  useFlagIdentifyingEntryMutation,
  useStartDesignContestFollowUpMutation,
  useRemoveJuryLinkMutation,
  useListStrandedJuryMembersQuery,
  useWriteJuryReportMutation,
  useConfirmJuryReportMutation,
  useGetDpsCompetitionsQuery,
  useCreateDpsCompetitionMutation,
  useAddEmailInviteToPrivateSourcingEventMutation,
  useRemoveEmailInviteFromPrivateSourcingEventMutation,
  useCreateEmailInviteReminderForPrivateSourcingEventMutation,
  useGetEvaluationQuery,
  useUpsertPriceOverrideMutation,
  useGetPriceDevelopmentQuery,
  useSetCriterionRationaleMutation,
  useUpsertCriterionScoreMutation,
  useSetEvaluationSelectionMutation,
  useUpdateSourcingEventValueMutation,
  useListSourcingEventFieldSourcesQuery,
  useReviewSourcingEventFieldSourcesMutation,
  useCreateFrameworkAgreementMutation,
  useGetMiniCompetitionPanelQuery,
  useSetHomeDepartmentMutation,
  useInviteToConfirmInterestMutation,
  useAddInternalMessageToSeMutation,
  useSaveInterviewDraftMutation,
  useConfirmInvitationMutation,
  useLookUpInviteEmailAccountQuery,
  useListNegotiationRoundsQuery,
  useCreateNegotiationRoundMutation,
  usePatchNegotiationRoundMutation,
  useCompleteNegotiationRoundMutation,
  useAddNegotiationRoundInviteMutation,
  useRemoveNegotiationRoundInviteMutation,
  useUpdateNegotiationRoundInviteMessageMutation,
  useSelectNegotiationRoundProductBidsMutation,
  usePublishNegotiationRoundMutation,
  useReopenNegotiationRoundMutation,
  useCreateUploadForNegotiationRoundMutation,
  useGetNegotiationWithoutNoticeQuery,
  useOpenNegotiationWithoutNoticeMutation,
  useAddOrganizationInviteToPrivateSourcingEventMutation,
  useRemoveOrganizationInviteFromPrivateSourcingEventMutation,
  useAddOrganizationInviteRecipientsMutation,
  useRestoreOrganizationInviteRemovedInChangeMutation,
  useListParticipationRequestsForBuyerQuery,
  useGetParticipationRequestForBuyerQuery,
  useExtendDpsAssessmentWindowMutation,
  useSetQualificationSchemeMemberCategoriesMutation,
  useUpdateParticipationRequestReviewMutation,
  useGetParticipationRequestRejectionDocumentsQuery,
  useCreateUploadForParticipationRequestRejectionMutation,
  useWithdrawSchemeRemovalMutation,
  useRemoveFromDpsSchemeMutation,
  useUpdateParticipationRequestNotesMutation,
  useUpdateParticipationRequestSelectionDraftMutation,
  useSetQualificationVerdictMutation,
  useListPortalLinkSharesQuery,
  useSharePortalLinkMutation,
  useSelectSourcingEventProductBidsMutation,
  useGetProtocolDraftQuery,
  usePatchProtocolNarrativeMutation,
  useFinaliseProtocolMutation,
  useListProtocolVersionsQuery,
  useDownloadProtocolVersionQuery,
  useListBidsForEventQuery,
  useGetBidForBuyerQuery,
  useCreateContractFromBidMutation,
  useUpdateBuyerMinimumRequirementReviewMutation,
  useSetBidQualificationMutation,
  useUpdateBuyerQualificationReviewMutation,
  useRejectBidMutation,
  useGetBidRejectionDocumentsQuery,
  useCreateUploadForBidRejectionMutation,
  useRevokeBidRejectionMutation,
  usePublishDpsCompetitionMutation,
  usePublishPrivateSourcingEventMutation,
  usePublishQualificationSchemeCompetitionMutation,
  useDownloadSeQaReportQuery,
  useGetQualificationSchemeCompetitionsQuery,
  useCreateQualificationSchemeCompetitionMutation,
  useGetQualificationSchemeInviteesQuery,
  useGetBuyerSeQuestionsQuery,
  useAnswerSeQuestionMutation,
  useCreateUploadForSeAnswerAttachmentMutation,
  useSendSeClarificationMessageAsBuyerMutation,
  useGetSourcingEventReadinessQuery,
  useReopenCompletedSourcingEventMutation,
  useSetResponsiblePersonMutation,
  useDeclineResultNoticeMutation,
  useRevokeAwardMutation,
  useGetEventSharesQuery,
  useShareEventMutation,
  useUnshareEventMutation,
  useGetBuyerSupplierInformationQuery,
  usePublishInformationMutation,
  useCreateUploadForSourcingEventMutation,
  useListFrameworkAgreementsQuery,
  useRegisterFrameworkAgreementMutation,
  useGetFrameworkAgreementQuery,
  useUpdateFrameworkAgreementMutation,
  useListFrameworkCallOffsQuery,
  useCreateDirectCallOffMutation,
  useListMiniCompetitionsQuery,
  useOpenMiniCompetitionMutation,
  useAddFrameworkSupplierMutation,
  useTerminateFrameworkAgreementMutation,
  useGetFrameworkOverviewQuery,
  useGetProductGroupsForSourcingEventQuery,
  useListCombinedEventsWithSupplierQuery,
  useListBuyerEventsQuery,
  useListBuyerEventFilterOptionsQuery,
  useDownloadProcurementListMutation,
  useGetProcurementOverviewQuery,
  useGetProcurementClimateWeightingListQuery,
  useGetProcurementPhaseListQuery,
  useGetProcurementPlanQuery,
  useDownloadProcurementPlanMutation,
  useCountBuyerEventsByStatusQuery,
  useListBuyerEventsWithSupplierQuery,
  useGetProcurementWorkloadQuery,
  useListProcurementWorkloadDeadlinesQuery,
  useListContractReportsQuery,
  useListContractReportOptionsQuery,
  useGetContractOverviewQuery,
  useGetContractSavingsQuery,
  useGetContractSigningQuery,
  useDownloadContractTaskListMutation,
  useDeleteCustomContractDataFieldMutation,
  useUpsertCustomContractDataFieldMutation,
  useMarkSupplierFilterContractFieldMutation,
  useMarkSupplierFilterContractEndDateMutation,
  useUpsertContractDataFieldsSectionMutation,
  useContractReportQueryDummyMutation,
  useSignatureWebhookMutation,
  useDeleteContractTaskCommentMutation,
  useUpdateContractTaskCommentMutation,
  useDeleteContractTaskMutation,
  useUpdateContractTaskMutation,
  useListChangesForContractTaskQuery,
  useListCommentsForContractTaskQuery,
  useCreateContractTaskCommentMutation,
  useCreateContractTextDocumentMutation,
  useListTextDocumentsForContractQuery,
  useCreateFencyConversationMutation,
  useCreateExploreMemoriesSessionMutation,
  useCreateFencyFileDownloadSessionMutation,
  useDownloadMultiIfrsReportQuery,
  useDownloadChosenIfrsReportMutation,
  useDownloadFilteredIfrsReportQuery,
  useGetFilteredIfrsReportPreviewQuery,
  useDownloadContractListMutation,
  useCreateMemoryChatSessionMutation,
  useCreateMemoryDownloadLinkMutation,
  useCreateContractSearchSessionMutation,
  useGetContractStatisticsQuery,
  useGetContractAutofillContextQuery,
  useCancelSignedDocumentMutation,
  useCreateUploadForContractDescriptionMutation,
  useDownloadIfrsReportQuery,
  useGetContractMessageAttachmentUploadQuery,
  useCreateUploadForContractMessageAttachmentMutation,
  useListContractMessagesQuery,
  useCreateContractMessageMutation,
  useSaveContractMessageAttachmentMutation,
  useGetContractOriginCommunicationQuery,
  useDeleteContractParticipantMutation,
  useListParticipantsForContractsQuery,
  useCreateContractParticipantMutation,
  useDeleteSignedDocumentMutation,
  useChangeSignedDocumentDeadlineMutation,
  useGetContractTaskDelegationQuery,
  useCreateContractTaskMutation,
  useCreateUploadForContractMutation,
  useGetContributingEntityInviteQuery,
  useAcceptContributingEntityInviteMutation,
  useDeclineContributingEntityInviteMutation,
  useGetCpvCodesQuery,
  useListContractFilterOptionsQuery,
  useListContractsQuery,
  useForceDeliverBidMutation,
  useForcePublishEventMutation,
  useSkipPastGateMutation,
  useStartDocumentChatMutation,
  useUpdateDocumentMetaMutation,
  useGetDownloadLinkQuery,
  useListDocumentTemplatesQuery,
  useCreateDocumentTemplateMutation,
  useCreateFencyStreamSessionMutation,
  useSubmitCancellationNoticeMutation,
  useSubmitContractAwardNoticeMutation,
  usePreviewContractAwardNoticeQuery,
  useSubmitContractModificationNoticeMutation,
  usePreviewContractModificationNoticeQuery,
  useSubmitIntentionNoticeMutation,
  useSubmitNoWinnerNoticeMutation,
  useSubmitQualificationSchemeEndNoticeMutation,
  useSubmitDoffinNoticeMutation,
  useValidateDoffinNoticeMutation,
  useDownloadTextDocumentMutation,
  useUpdateEmailStatusMutation,
  useGetSeAttachmentDownloadLinkQuery,
  useConfirmFencyEventMutation,
  useMarkUploadFailedMutation,
  useConfirmUploadMutation,
  useSearchIndustriesQuery,
  useListLibraryElementsQuery,
  useCreateLibraryElementMutation,
  useUpdateLibraryElementMutation,
  useDeleteLibraryElementMutation,
  useGetMarketDialogueInviteQuery,
  useListMarketDialoguesQuery,
  useCreateMarketDialogueMutation,
  useDeleteMarketDialogueMutation,
  useGetMarketDialogueQuery,
  useUpdateMarketDialogueMutation,
  useListMarketDialogueAnswersQuery,
  useCommentOnMarketDialogueAnswerMutation,
  useStartCompetitionFromMarketDialogueMutation,
  useGetCompetitionPlanQuery,
  useRemoveMarketDialogueDocumentMutation,
  useMarkMarketDialogueAnswerMutation,
  useSummariseMarketDialogueMutation,
  useInviteEmailToMarketDialogueMutation,
  useInviteOrganizationToMarketDialogueMutation,
  useWithdrawMarketDialogueInvitationMutation,
  useLinkMarketDialogueToNeedMutation,
  usePublishMarketDialogueMutation,
  useListMarketDialogueQuestionsQuery,
  useReplyToMarketDialogueQuestionMutation,
  useShareWithMarketDialogueParticipantsMutation,
  useListMarketDialogueSupplierSuggestionsQuery,
  useGetMarketDialogueTeamQuery,
  useAddMarketDialogueTeamMemberMutation,
  useRemoveMarketDialogueTeamMemberMutation,
  useCreateUploadForMarketDialogueMutation,
  useDismissNotificationsMutation,
  useGetMyNeedsWaitingQuery,
  useListMyNotificationsQuery,
  useListOrganizationUsersQuery,
  useListOrganizationsForMeQuery,
  useCreateOrganizationForMeMutation,
  useMarkNotificationsAsPeekedMutation,
  useListMyRecentlyViewedContractsQuery,
  useListMyRecentlyViewedSourcingEventsQuery,
  useListMyUpcomingDeadlinesQuery,
  useMarkNotificationsAsViewedMutation,
  useCreateNeedMutation,
  useCreateNeedTextDocumentMutation,
  useListTextDocumentsForNeedQuery,
  useDeleteNeedDraftMutation,
  useGetNeedQuery,
  useUpdateNeedMutation,
  useStartCallOffForNeedMutation,
  useCreateProcurementForNeedMutation,
  useStartMiniCompetitionForNeedMutation,
  useSubmitNeedMutation,
  useListNeedsQuery,
  useGetNeedForProcurementQuery,
  useGetNeedOverviewQuery,
  useCreateMarketDialogueForNeedMutation,
  useCreateUploadForNeedMutation,
  useGetAccessTokenMutation,
  useSearchBrregOrgsByNameQuery,
  useLookupBrregOrgQuery,
  useListContractsForOrgQuery,
  useCreateApiClientMutation,
  useCreateOrganizationEntryMutation,
  useGetOrganizationEntryQuery,
  useUpdateOrganizationEntryMutation,
  useLinkOrganizationEntryMutation,
  useGetSupplierEmailInviteQuery,
  useGetOrgUserEmailInviteQuery,
  useAcceptOrgUserEmailInviteMutation,
  useListAssessmentTemplatesQuery,
  useUpdateAssessmentMutation,
  useListAssessmentsQuery,
  useListOrgsByNumberQuery,
  useUpdateOrganizationMutation,
  useListAccessGrantsQuery,
  useGetOrganizationAiSkillsQuery,
  useRequestOrganizationAiSkillAccessMutation,
  useListAuditLogQuery,
  useGetAuditLogFiltersQuery,
  useDownloadAuditLogMutation,
  useListDepartmentsQuery,
  useCreateDepartmentMutation,
  useRenameDepartmentMutation,
  useActivateDepartmentMutation,
  useDeactivateDepartmentMutation,
  useAssignDepartmentRoleMutation,
  useRevokeDepartmentRoleMutation,
  useListDuplicateOrganizationsQuery,
  useListEntraConnectionsQuery,
  useCreateEntraConnectionMutation,
  useDeleteEntraConnectionMutation,
  useUpdateEntraConnectionMutation,
  useSaveEntraGroupMappingMutation,
  useDeleteEntraGroupMappingMutation,
  useRequestOrganizationMergeMutation,
  useAcceptOrganizationMergeMutation,
  useDeclineOrganizationMergeMutation,
  useGetOrganizationQuery,
  useListSupplierEmailInvitesQuery,
  useCreateSupplierEmailInviteMutation,
  useDeleteSupplierEmailInviteMutation,
  useCreateSupplierEmailInviteReminderMutation,
  useListOrgUserEmailInvitesQuery,
  useCreateOrgUserEmailInviteMutation,
  useDeleteOrgUserEmailInviteMutation,
  useDeleteOrgUserMutation,
  useUpdateOrgUserRoleMutation,
  useGetContractTaskWorkloadQuery,
  useListContractTasksForOrganizationQuery,
  useListContractTemplatesQuery,
  useCreateContractTemplateMutation,
  useGetTaskQuery,
  useUpdateContractTemplateMutation,
  useDeleteContractDraftMutation,
  useGetContractQuery,
  useUpdateContractMutation,
  useCopyContractMutation,
  usePublishContractMutation,
  useCreateSignedDocumentMutation,
  useCreateSignedTextDocumentMutation,
  useListContractTasksQuery,
  useCreateContractMutation,
  useListPersonsQuery,
  useGetPersonsByIdsQuery,
  useGetMeQuery,
  useUpdateMeMutation,
  useGetBidQuery,
  useUpdateBidMutation,
  useListContributingEntitiesQuery,
  useAddContributingEntityMutation,
  useRemoveContributingEntityMutation,
  useGetContributingEntityResponseQuery,
  useUpdateContributingEntityMutation,
  useResendContributingEntityInvitationMutation,
  useReopenContributingEntityResponseMutation,
  usePreviewBidReportQuery,
  useStartBidSigningMutation,
  useCancelBidSigningMutation,
  useGetBidSigningPreflightQuery,
  useAcceptBidTermsMutation,
  useCreateUploadForBidMutation,
  useWithdrawBidMutation,
  useGetContributingEntityQuery,
  useUpdateContributingEntityResponseMutation,
  useUpdateContributingEntityCommitmentMutation,
  useUpdateContributingEntityQualificationResponsesMutation,
  useSubmitContributingEntityResponseMutation,
  useGetPortalSourcingEventsQuery,
  useGetPortalSourcingEventQuery,
  useGetPortalSeAttachmentUploadQuery,
  useGetPortalAwardLetterQuery,
  useCreateBidMutation,
  useGetPortalDocumentDownloadLinkQuery,
  useGetPortalMyBidDocumentsQuery,
  useCreateParticipationRequestMutation,
  useGetMyParticipationQuery,
  useCreateUploadForSeQuestionAttachmentMutation,
  useGetPortalSeQuestionsQuery,
  useAskSeQuestionMutation,
  useSendSeClarificationMessageAsSupplierMutation,
  useRegisterPortalInterestMutation,
  useGetPortalRegistrationStatusQuery,
  useGetPortalSupplierInformationQuery,
  useGetPortalMarketDialogueQuery,
  useGetPortalMarketDialogueDocumentDownloadLinkQuery,
  useGetAuthenticatedPortalSourcingEventsQuery,
  useGetAuthenticatedPortalSourcingEventQuery,
  useAcceptPortalInviteMutation,
  useCreatePortalInitialBidMutation,
  useSubmitPortalPrivateBidMutation,
  useWithdrawPortalPrivateBidMutation,
  useDeclinePortalInviteMutation,
  useGetPortalNegotiationRoundsQuery,
  useCreatePortalRoundBidMutation,
  useWithdrawPortalNegotiationRoundDeclineMutation,
  useDeclinePortalNegotiationRoundMutation,
  useConfirmPortalStandingBidMutation,
  useGetPortalFrameworkAgreementsQuery,
  useAcceptMarketDialogueInviteMutation,
  useGetSupplierMarketDialogueQuery,
  useSaveMarketDialogueAnswerMutation,
  useRemoveMarketDialogueAnswerDocumentMutation,
  useSendMarketDialogueAnswerMutation,
  useCreateUploadForMarketDialogueAnswerMutation,
  useGetSupplierMarketDialogueDocumentDownloadLinkQuery,
  useAskMarketDialogueQuestionMutation,
  useGetPortalMyBidsQuery,
  useListMyContributionsQuery,
  useListMyParticipationRequestsQuery,
  useGetParticipationRequestQuery,
  useUpdateParticipationRequestMutation,
  useSubmitParticipationRequestMutation,
  useWithdrawParticipationRequestMutation,
  useEditProductGroupMutation,
  useCreateProductGroupMutation,
  useDeleteProductGroupMutation,
  useGetProductGroupsForProjectQuery,
  useGetProductTemplatesQuery,
  useCreateProjectMutation,
  useCreateProjectTextDocumentMutation,
  useListTextDocumentsForProjectQuery,
  useGetProjectQuery,
  useUpdateProjectMutation,
  useGetProjectsQuery,
  useGetProjectsByIdsQuery,
  useGetProjectOverviewQuery,
  useCreateUploadForProjectDescriptionMutation,
  useGetProjectProcurementSummaryQuery,
  useDownloadProjectProcurementSummaryPdfQuery,
  useCreateUploadForProjectMutation,
  useListSavedReportsQuery,
  useCreateSavedReportMutation,
  useDeleteSavedReportMutation,
  useRenameSavedReportMutation,
  useReplaceSavedReportQueryMutation,
  useShareSavedReportMutation,
  useStopSharingSavedReportMutation,
  useGetGroupsQuery,
  useCreateGroupMutation,
  useDeleteGroupMutation,
  useGetGroupQuery,
  useUpdateGroupMutation,
  useGetSchemasQuery,
  useGetTokenQuery,
  useGetTokenForConnectionQuery,
  useGetUsersQuery,
  useCreateUserMutation,
  useDeleteUserMutation,
  useGetUserQuery,
  useUpdateUserMutation,
  useSearchOrganizationsAndEntriesQuery,
  useUpdateSignedDocumentMetaMutation,
  useGetSignedDocumentDownloadLinkQuery,
  useGetSignedAttachmentDownloadLinkQuery,
  useListSourcingEventTemplatesQuery,
  useCreateSourcingEventTemplateMutation,
  useUpdateSourcingEventTemplateMutation,
  useDeleteSourcingEventTemplateMutation,
  useCreateSourcingEventTextDocumentMutation,
  useListTextDocumentsForSourcingEventQuery,
  useGetProcurementCommentRoundsQuery,
  useSendProcurementForCommentMutation,
  useGetSeEmailInviteQuery,
  useAcceptSeEmailInviteMutation,
  useGetProductGroupsAsSupplierQuery,
  useCreateUploadForBidAwardCriterionAttachmentMutation,
  useCreateUploadForBidMinimumRequirementAttachmentMutation,
  useCreateUploadForBidQualificationEvidenceMutation,
  useUpdateTextDocumentMutation,
  useDeleteTextDocumentMutation,
  useGetTextDocumentUploadStatusQuery,
  useCreateUploadForTextDocumentMutation,
  useDeleteUploadMutation,
} = injectedRtkApi;
